(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1105"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1105"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eR31A", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ad085c918dafbc60$export$ffb0004e005737fa; }, function (v) { return $ad085c918dafbc60$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ad085c918dafbc60$export$34b9dba7ce09269b; }, function (v) { return $ad085c918dafbc60$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ad085c918dafbc60$export$25062201e9e25d76; }, function (v) { return $ad085c918dafbc60$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ad085c918dafbc60$export$ffb0004e005737fa;
var $ad085c918dafbc60$export$34b9dba7ce09269b;
var $ad085c918dafbc60$export$25062201e9e25d76;
'use strict';

var $Oecye = parcelRequire("Oecye");
var $ad085c918dafbc60$var$k = Symbol.for("react.element"), $ad085c918dafbc60$var$l = Symbol.for("react.fragment"), $ad085c918dafbc60$var$m = Object.prototype.hasOwnProperty, $ad085c918dafbc60$var$n = $Oecye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ad085c918dafbc60$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ad085c918dafbc60$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ad085c918dafbc60$var$m.call(a, b) && !$ad085c918dafbc60$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ad085c918dafbc60$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ad085c918dafbc60$var$n.current
    };
}
$ad085c918dafbc60$export$ffb0004e005737fa = $ad085c918dafbc60$var$l;
$ad085c918dafbc60$export$34b9dba7ce09269b = $ad085c918dafbc60$var$q;
$ad085c918dafbc60$export$25062201e9e25d76 = $ad085c918dafbc60$var$q;

});
parcelRegister("Oecye", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dgNIA"));

});
parcelRegister("dgNIA", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $9a9355faaa809b2c$export$dca3b0875bd9a954; }, function (v) { return $9a9355faaa809b2c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $9a9355faaa809b2c$export$16fa2f45be04daa8; }, function (v) { return $9a9355faaa809b2c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9a9355faaa809b2c$export$ffb0004e005737fa; }, function (v) { return $9a9355faaa809b2c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $9a9355faaa809b2c$export$e2c29f18771995cb; }, function (v) { return $9a9355faaa809b2c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $9a9355faaa809b2c$export$221d75b3f55bb0bd; }, function (v) { return $9a9355faaa809b2c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9a9355faaa809b2c$export$5f8d39834fd61797; }, function (v) { return $9a9355faaa809b2c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9a9355faaa809b2c$export$74bf444e3cd11ea5; }, function (v) { return $9a9355faaa809b2c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9a9355faaa809b2c$export$ae55be85d98224ed; }, function (v) { return $9a9355faaa809b2c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $9a9355faaa809b2c$export$3ba232387fd5d6dd; }, function (v) { return $9a9355faaa809b2c$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $9a9355faaa809b2c$export$e530037191fcd5d7; }, function (v) { return $9a9355faaa809b2c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $9a9355faaa809b2c$export$fd42f52fd3ae1109; }, function (v) { return $9a9355faaa809b2c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $9a9355faaa809b2c$export$c8a8987d4410bf2d; }, function (v) { return $9a9355faaa809b2c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $9a9355faaa809b2c$export$d38cd72104c1f0e9; }, function (v) { return $9a9355faaa809b2c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $9a9355faaa809b2c$export$7d1e3a5e95ceca43; }, function (v) { return $9a9355faaa809b2c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $9a9355faaa809b2c$export$257a8862b851cb5b; }, function (v) { return $9a9355faaa809b2c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $9a9355faaa809b2c$export$a8257692ac88316c; }, function (v) { return $9a9355faaa809b2c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $9a9355faaa809b2c$export$488013bae63b21da; }, function (v) { return $9a9355faaa809b2c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $9a9355faaa809b2c$export$7c73462e0d25e514; }, function (v) { return $9a9355faaa809b2c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $9a9355faaa809b2c$export$7568632d0d33d16d; }, function (v) { return $9a9355faaa809b2c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $9a9355faaa809b2c$export$88948ce120ea2619; }, function (v) { return $9a9355faaa809b2c$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $9a9355faaa809b2c$export$35808ee640e87ca7; }, function (v) { return $9a9355faaa809b2c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $9a9355faaa809b2c$export$fae74005e78b1a27; }, function (v) { return $9a9355faaa809b2c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $9a9355faaa809b2c$export$dc8fbce3eb94dc1e; }, function (v) { return $9a9355faaa809b2c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $9a9355faaa809b2c$export$6a7bc4e911dc01cf; }, function (v) { return $9a9355faaa809b2c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $9a9355faaa809b2c$export$6d9c69b0de29b591; }, function (v) { return $9a9355faaa809b2c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $9a9355faaa809b2c$export$f680877a34711e37; }, function (v) { return $9a9355faaa809b2c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $9a9355faaa809b2c$export$d5a552a76deda3c2; }, function (v) { return $9a9355faaa809b2c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $9a9355faaa809b2c$export$aaabe4eda9ed9969; }, function (v) { return $9a9355faaa809b2c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $9a9355faaa809b2c$export$e5c5a5f917a5871c; }, function (v) { return $9a9355faaa809b2c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $9a9355faaa809b2c$export$1538c33de8887b59; }, function (v) { return $9a9355faaa809b2c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $9a9355faaa809b2c$export$13e3392192263954; }, function (v) { return $9a9355faaa809b2c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $9a9355faaa809b2c$export$b8f5890fc79d6aca; }, function (v) { return $9a9355faaa809b2c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $9a9355faaa809b2c$export$60241385465d0a34; }, function (v) { return $9a9355faaa809b2c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $9a9355faaa809b2c$export$306c0aa65ff9ec16; }, function (v) { return $9a9355faaa809b2c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $9a9355faaa809b2c$export$7b286972b8d8ccbf; }, function (v) { return $9a9355faaa809b2c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $9a9355faaa809b2c$export$83d89fbfd8236492; }, function (v) { return $9a9355faaa809b2c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9a9355faaa809b2c$export$dca3b0875bd9a954;
var $9a9355faaa809b2c$export$16fa2f45be04daa8;
var $9a9355faaa809b2c$export$ffb0004e005737fa;
var $9a9355faaa809b2c$export$e2c29f18771995cb;
var $9a9355faaa809b2c$export$221d75b3f55bb0bd;
var $9a9355faaa809b2c$export$5f8d39834fd61797;
var $9a9355faaa809b2c$export$74bf444e3cd11ea5;
var $9a9355faaa809b2c$export$ae55be85d98224ed;
var $9a9355faaa809b2c$export$3ba232387fd5d6dd;
var $9a9355faaa809b2c$export$e530037191fcd5d7;
var $9a9355faaa809b2c$export$fd42f52fd3ae1109;
var $9a9355faaa809b2c$export$c8a8987d4410bf2d;
var $9a9355faaa809b2c$export$d38cd72104c1f0e9;
var $9a9355faaa809b2c$export$7d1e3a5e95ceca43;
var $9a9355faaa809b2c$export$257a8862b851cb5b;
var $9a9355faaa809b2c$export$a8257692ac88316c;
var $9a9355faaa809b2c$export$488013bae63b21da;
var $9a9355faaa809b2c$export$7c73462e0d25e514;
var $9a9355faaa809b2c$export$7568632d0d33d16d;
var $9a9355faaa809b2c$export$88948ce120ea2619;
var $9a9355faaa809b2c$export$35808ee640e87ca7;
var $9a9355faaa809b2c$export$fae74005e78b1a27;
var $9a9355faaa809b2c$export$dc8fbce3eb94dc1e;
var $9a9355faaa809b2c$export$6a7bc4e911dc01cf;
var $9a9355faaa809b2c$export$6d9c69b0de29b591;
var $9a9355faaa809b2c$export$f680877a34711e37;
var $9a9355faaa809b2c$export$d5a552a76deda3c2;
var $9a9355faaa809b2c$export$aaabe4eda9ed9969;
var $9a9355faaa809b2c$export$e5c5a5f917a5871c;
var $9a9355faaa809b2c$export$1538c33de8887b59;
var $9a9355faaa809b2c$export$13e3392192263954;
var $9a9355faaa809b2c$export$b8f5890fc79d6aca;
var $9a9355faaa809b2c$export$60241385465d0a34;
var $9a9355faaa809b2c$export$306c0aa65ff9ec16;
var $9a9355faaa809b2c$export$7b286972b8d8ccbf;
var $9a9355faaa809b2c$export$83d89fbfd8236492;
'use strict';
var $9a9355faaa809b2c$var$l = Symbol.for("react.element"), $9a9355faaa809b2c$var$n = Symbol.for("react.portal"), $9a9355faaa809b2c$var$p = Symbol.for("react.fragment"), $9a9355faaa809b2c$var$q = Symbol.for("react.strict_mode"), $9a9355faaa809b2c$var$r = Symbol.for("react.profiler"), $9a9355faaa809b2c$var$t = Symbol.for("react.provider"), $9a9355faaa809b2c$var$u = Symbol.for("react.context"), $9a9355faaa809b2c$var$v = Symbol.for("react.forward_ref"), $9a9355faaa809b2c$var$w = Symbol.for("react.suspense"), $9a9355faaa809b2c$var$x = Symbol.for("react.memo"), $9a9355faaa809b2c$var$y = Symbol.for("react.lazy"), $9a9355faaa809b2c$var$z = Symbol.iterator;
function $9a9355faaa809b2c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9a9355faaa809b2c$var$z && a[$9a9355faaa809b2c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9a9355faaa809b2c$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $9a9355faaa809b2c$var$C = Object.assign, $9a9355faaa809b2c$var$D = {};
function $9a9355faaa809b2c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $9a9355faaa809b2c$var$D;
    this.updater = e || $9a9355faaa809b2c$var$B;
}
$9a9355faaa809b2c$var$E.prototype.isReactComponent = {};
$9a9355faaa809b2c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$9a9355faaa809b2c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $9a9355faaa809b2c$var$F() {}
$9a9355faaa809b2c$var$F.prototype = $9a9355faaa809b2c$var$E.prototype;
function $9a9355faaa809b2c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $9a9355faaa809b2c$var$D;
    this.updater = e || $9a9355faaa809b2c$var$B;
}
var $9a9355faaa809b2c$var$H = $9a9355faaa809b2c$var$G.prototype = new $9a9355faaa809b2c$var$F;
$9a9355faaa809b2c$var$H.constructor = $9a9355faaa809b2c$var$G;
$9a9355faaa809b2c$var$C($9a9355faaa809b2c$var$H, $9a9355faaa809b2c$var$E.prototype);
$9a9355faaa809b2c$var$H.isPureReactComponent = !0;
var $9a9355faaa809b2c$var$I = Array.isArray, $9a9355faaa809b2c$var$J = Object.prototype.hasOwnProperty, $9a9355faaa809b2c$var$K = {
    current: null
}, $9a9355faaa809b2c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $9a9355faaa809b2c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$9a9355faaa809b2c$var$J.call(b, d) && !$9a9355faaa809b2c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $9a9355faaa809b2c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $9a9355faaa809b2c$var$K.current
    };
}
function $9a9355faaa809b2c$var$N(a, b) {
    return {
        $$typeof: $9a9355faaa809b2c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $9a9355faaa809b2c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9a9355faaa809b2c$var$l;
}
function $9a9355faaa809b2c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $9a9355faaa809b2c$var$P = /\/+/g;
function $9a9355faaa809b2c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $9a9355faaa809b2c$var$escape("" + a.key) : b.toString(36);
}
function $9a9355faaa809b2c$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $9a9355faaa809b2c$var$l:
                case $9a9355faaa809b2c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $9a9355faaa809b2c$var$Q(h, 0) : d, $9a9355faaa809b2c$var$I(c) ? (e = "", null != a && (e = a.replace($9a9355faaa809b2c$var$P, "$&/") + "/"), $9a9355faaa809b2c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($9a9355faaa809b2c$var$O(c) && (c = $9a9355faaa809b2c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($9a9355faaa809b2c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($9a9355faaa809b2c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $9a9355faaa809b2c$var$Q(k, g);
        h += $9a9355faaa809b2c$var$R(k, b, e, f, c);
    }
    else if (f = $9a9355faaa809b2c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $9a9355faaa809b2c$var$Q(k, g++), h += $9a9355faaa809b2c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $9a9355faaa809b2c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $9a9355faaa809b2c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $9a9355faaa809b2c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $9a9355faaa809b2c$var$U = {
    current: null
}, $9a9355faaa809b2c$var$V = {
    transition: null
}, $9a9355faaa809b2c$var$W = {
    ReactCurrentDispatcher: $9a9355faaa809b2c$var$U,
    ReactCurrentBatchConfig: $9a9355faaa809b2c$var$V,
    ReactCurrentOwner: $9a9355faaa809b2c$var$K
};
function $9a9355faaa809b2c$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$9a9355faaa809b2c$export$dca3b0875bd9a954 = {
    map: $9a9355faaa809b2c$var$S,
    forEach: function(a, b, e) {
        $9a9355faaa809b2c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $9a9355faaa809b2c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $9a9355faaa809b2c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$9a9355faaa809b2c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$9a9355faaa809b2c$export$16fa2f45be04daa8 = $9a9355faaa809b2c$var$E;
$9a9355faaa809b2c$export$ffb0004e005737fa = $9a9355faaa809b2c$var$p;
$9a9355faaa809b2c$export$e2c29f18771995cb = $9a9355faaa809b2c$var$r;
$9a9355faaa809b2c$export$221d75b3f55bb0bd = $9a9355faaa809b2c$var$G;
$9a9355faaa809b2c$export$5f8d39834fd61797 = $9a9355faaa809b2c$var$q;
$9a9355faaa809b2c$export$74bf444e3cd11ea5 = $9a9355faaa809b2c$var$w;
$9a9355faaa809b2c$export$ae55be85d98224ed = $9a9355faaa809b2c$var$W;
$9a9355faaa809b2c$export$3ba232387fd5d6dd = $9a9355faaa809b2c$var$X;
$9a9355faaa809b2c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $9a9355faaa809b2c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $9a9355faaa809b2c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$9a9355faaa809b2c$var$J.call(b, f) && !$9a9355faaa809b2c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $9a9355faaa809b2c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$9a9355faaa809b2c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $9a9355faaa809b2c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $9a9355faaa809b2c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$9a9355faaa809b2c$export$c8a8987d4410bf2d = $9a9355faaa809b2c$var$M;
$9a9355faaa809b2c$export$d38cd72104c1f0e9 = function(a) {
    var b = $9a9355faaa809b2c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$9a9355faaa809b2c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$9a9355faaa809b2c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $9a9355faaa809b2c$var$v,
        render: a
    };
};
$9a9355faaa809b2c$export$a8257692ac88316c = $9a9355faaa809b2c$var$O;
$9a9355faaa809b2c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $9a9355faaa809b2c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $9a9355faaa809b2c$var$T
    };
};
$9a9355faaa809b2c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $9a9355faaa809b2c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$9a9355faaa809b2c$export$7568632d0d33d16d = function(a) {
    var b = $9a9355faaa809b2c$var$V.transition;
    $9a9355faaa809b2c$var$V.transition = {};
    try {
        a();
    } finally{
        $9a9355faaa809b2c$var$V.transition = b;
    }
};
$9a9355faaa809b2c$export$88948ce120ea2619 = $9a9355faaa809b2c$var$X;
$9a9355faaa809b2c$export$35808ee640e87ca7 = function(a, b) {
    return $9a9355faaa809b2c$var$U.current.useCallback(a, b);
};
$9a9355faaa809b2c$export$fae74005e78b1a27 = function(a) {
    return $9a9355faaa809b2c$var$U.current.useContext(a);
};
$9a9355faaa809b2c$export$dc8fbce3eb94dc1e = function() {};
$9a9355faaa809b2c$export$6a7bc4e911dc01cf = function(a) {
    return $9a9355faaa809b2c$var$U.current.useDeferredValue(a);
};
$9a9355faaa809b2c$export$6d9c69b0de29b591 = function(a, b) {
    return $9a9355faaa809b2c$var$U.current.useEffect(a, b);
};
$9a9355faaa809b2c$export$f680877a34711e37 = function() {
    return $9a9355faaa809b2c$var$U.current.useId();
};
$9a9355faaa809b2c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $9a9355faaa809b2c$var$U.current.useImperativeHandle(a, b, e);
};
$9a9355faaa809b2c$export$aaabe4eda9ed9969 = function(a, b) {
    return $9a9355faaa809b2c$var$U.current.useInsertionEffect(a, b);
};
$9a9355faaa809b2c$export$e5c5a5f917a5871c = function(a, b) {
    return $9a9355faaa809b2c$var$U.current.useLayoutEffect(a, b);
};
$9a9355faaa809b2c$export$1538c33de8887b59 = function(a, b) {
    return $9a9355faaa809b2c$var$U.current.useMemo(a, b);
};
$9a9355faaa809b2c$export$13e3392192263954 = function(a, b, e) {
    return $9a9355faaa809b2c$var$U.current.useReducer(a, b, e);
};
$9a9355faaa809b2c$export$b8f5890fc79d6aca = function(a) {
    return $9a9355faaa809b2c$var$U.current.useRef(a);
};
$9a9355faaa809b2c$export$60241385465d0a34 = function(a) {
    return $9a9355faaa809b2c$var$U.current.useState(a);
};
$9a9355faaa809b2c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $9a9355faaa809b2c$var$U.current.useSyncExternalStore(a, b, e);
};
$9a9355faaa809b2c$export$7b286972b8d8ccbf = function() {
    return $9a9355faaa809b2c$var$U.current.useTransition();
};
$9a9355faaa809b2c$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("bxv6G", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $866ae7eda648604d$export$ae55be85d98224ed; }, function (v) { return $866ae7eda648604d$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $866ae7eda648604d$export$d39a5bbd09211389; }, function (v) { return $866ae7eda648604d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $866ae7eda648604d$export$882461b6382ed46c; }, function (v) { return $866ae7eda648604d$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $866ae7eda648604d$export$466bfc07425424d5; }, function (v) { return $866ae7eda648604d$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $866ae7eda648604d$export$cd75ccfd720a3cd4; }, function (v) { return $866ae7eda648604d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $866ae7eda648604d$export$fa8d919ba61d84db; }, function (v) { return $866ae7eda648604d$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $866ae7eda648604d$export$757ceba2d55c277e; }, function (v) { return $866ae7eda648604d$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $866ae7eda648604d$export$b3890eb0ae9dca99; }, function (v) { return $866ae7eda648604d$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $866ae7eda648604d$export$502457920280e6be; }, function (v) { return $866ae7eda648604d$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $866ae7eda648604d$export$c78a37762a8d58e1; }, function (v) { return $866ae7eda648604d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $866ae7eda648604d$export$dc54d992c10e8a18; }, function (v) { return $866ae7eda648604d$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $866ae7eda648604d$export$83d89fbfd8236492; }, function (v) { return $866ae7eda648604d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $866ae7eda648604d$export$ae55be85d98224ed;
var $866ae7eda648604d$export$d39a5bbd09211389;
var $866ae7eda648604d$export$882461b6382ed46c;
var $866ae7eda648604d$export$466bfc07425424d5;
var $866ae7eda648604d$export$cd75ccfd720a3cd4;
var $866ae7eda648604d$export$fa8d919ba61d84db;
var $866ae7eda648604d$export$757ceba2d55c277e;
var $866ae7eda648604d$export$b3890eb0ae9dca99;
var $866ae7eda648604d$export$502457920280e6be;
var $866ae7eda648604d$export$c78a37762a8d58e1;
var $866ae7eda648604d$export$dc54d992c10e8a18;
var $866ae7eda648604d$export$83d89fbfd8236492;
'use strict';

var $Oecye = parcelRequire("Oecye");

var $f65uV = parcelRequire("f65uV");
function $866ae7eda648604d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $866ae7eda648604d$var$da = new Set, $866ae7eda648604d$var$ea = {};
function $866ae7eda648604d$var$fa(a, b) {
    $866ae7eda648604d$var$ha(a, b);
    $866ae7eda648604d$var$ha(a + "Capture", b);
}
function $866ae7eda648604d$var$ha(a, b) {
    $866ae7eda648604d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$866ae7eda648604d$var$da.add(b[a]);
}
var $866ae7eda648604d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $866ae7eda648604d$var$ja = Object.prototype.hasOwnProperty, $866ae7eda648604d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $866ae7eda648604d$var$la = {}, $866ae7eda648604d$var$ma = {};
function $866ae7eda648604d$var$oa(a) {
    if ($866ae7eda648604d$var$ja.call($866ae7eda648604d$var$ma, a)) return !0;
    if ($866ae7eda648604d$var$ja.call($866ae7eda648604d$var$la, a)) return !1;
    if ($866ae7eda648604d$var$ka.test(a)) return $866ae7eda648604d$var$ma[a] = !0;
    $866ae7eda648604d$var$la[a] = !0;
    return !1;
}
function $866ae7eda648604d$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $866ae7eda648604d$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $866ae7eda648604d$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $866ae7eda648604d$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $866ae7eda648604d$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $866ae7eda648604d$var$z[b] = new $866ae7eda648604d$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $866ae7eda648604d$var$ra = /[\-:]([a-z])/g;
function $866ae7eda648604d$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($866ae7eda648604d$var$ra, $866ae7eda648604d$var$sa);
    $866ae7eda648604d$var$z[b] = new $866ae7eda648604d$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($866ae7eda648604d$var$ra, $866ae7eda648604d$var$sa);
    $866ae7eda648604d$var$z[b] = new $866ae7eda648604d$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($866ae7eda648604d$var$ra, $866ae7eda648604d$var$sa);
    $866ae7eda648604d$var$z[b] = new $866ae7eda648604d$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$866ae7eda648604d$var$z.xlinkHref = new $866ae7eda648604d$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $866ae7eda648604d$var$z[a] = new $866ae7eda648604d$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $866ae7eda648604d$var$ta(a, b, c, d) {
    var e = $866ae7eda648604d$var$z.hasOwnProperty(b) ? $866ae7eda648604d$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $866ae7eda648604d$var$qa(b, c, e, d) && (c = null), d || null === e ? $866ae7eda648604d$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $866ae7eda648604d$var$ua = $Oecye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $866ae7eda648604d$var$va = Symbol.for("react.element"), $866ae7eda648604d$var$wa = Symbol.for("react.portal"), $866ae7eda648604d$var$ya = Symbol.for("react.fragment"), $866ae7eda648604d$var$za = Symbol.for("react.strict_mode"), $866ae7eda648604d$var$Aa = Symbol.for("react.profiler"), $866ae7eda648604d$var$Ba = Symbol.for("react.provider"), $866ae7eda648604d$var$Ca = Symbol.for("react.context"), $866ae7eda648604d$var$Da = Symbol.for("react.forward_ref"), $866ae7eda648604d$var$Ea = Symbol.for("react.suspense"), $866ae7eda648604d$var$Fa = Symbol.for("react.suspense_list"), $866ae7eda648604d$var$Ga = Symbol.for("react.memo"), $866ae7eda648604d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $866ae7eda648604d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $866ae7eda648604d$var$Ja = Symbol.iterator;
function $866ae7eda648604d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $866ae7eda648604d$var$Ja && a[$866ae7eda648604d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $866ae7eda648604d$var$A = Object.assign, $866ae7eda648604d$var$La;
function $866ae7eda648604d$var$Ma(a) {
    if (void 0 === $866ae7eda648604d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $866ae7eda648604d$var$La = b && b[1] || "";
    }
    return "\n" + $866ae7eda648604d$var$La + a;
}
var $866ae7eda648604d$var$Na = !1;
function $866ae7eda648604d$var$Oa(a, b) {
    if (!a || $866ae7eda648604d$var$Na) return "";
    $866ae7eda648604d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $866ae7eda648604d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $866ae7eda648604d$var$Ma(a) : "";
}
function $866ae7eda648604d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $866ae7eda648604d$var$Ma(a.type);
        case 16:
            return $866ae7eda648604d$var$Ma("Lazy");
        case 13:
            return $866ae7eda648604d$var$Ma("Suspense");
        case 19:
            return $866ae7eda648604d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $866ae7eda648604d$var$Oa(a.type, !1), a;
        case 11:
            return a = $866ae7eda648604d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $866ae7eda648604d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $866ae7eda648604d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $866ae7eda648604d$var$ya:
            return "Fragment";
        case $866ae7eda648604d$var$wa:
            return "Portal";
        case $866ae7eda648604d$var$Aa:
            return "Profiler";
        case $866ae7eda648604d$var$za:
            return "StrictMode";
        case $866ae7eda648604d$var$Ea:
            return "Suspense";
        case $866ae7eda648604d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $866ae7eda648604d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $866ae7eda648604d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $866ae7eda648604d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $866ae7eda648604d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $866ae7eda648604d$var$Qa(a.type) || "Memo";
        case $866ae7eda648604d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $866ae7eda648604d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $866ae7eda648604d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $866ae7eda648604d$var$Qa(b);
        case 8:
            return b === $866ae7eda648604d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $866ae7eda648604d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $866ae7eda648604d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $866ae7eda648604d$var$Ua(a) {
    var b = $866ae7eda648604d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $866ae7eda648604d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $866ae7eda648604d$var$Ua(a));
}
function $866ae7eda648604d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $866ae7eda648604d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $866ae7eda648604d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $866ae7eda648604d$var$Ya(a, b) {
    var c = b.checked;
    return $866ae7eda648604d$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $866ae7eda648604d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $866ae7eda648604d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $866ae7eda648604d$var$ab(a, b) {
    b = b.checked;
    null != b && $866ae7eda648604d$var$ta(a, "checked", b, !1);
}
function $866ae7eda648604d$var$bb(a, b) {
    $866ae7eda648604d$var$ab(a, b);
    var c = $866ae7eda648604d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $866ae7eda648604d$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $866ae7eda648604d$var$cb(a, b.type, $866ae7eda648604d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $866ae7eda648604d$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $866ae7eda648604d$var$cb(a, b, c) {
    if ("number" !== b || $866ae7eda648604d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $866ae7eda648604d$var$eb = Array.isArray;
function $866ae7eda648604d$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $866ae7eda648604d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $866ae7eda648604d$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($866ae7eda648604d$var$p(91));
    return $866ae7eda648604d$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $866ae7eda648604d$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($866ae7eda648604d$var$p(92));
            if ($866ae7eda648604d$var$eb(c)) {
                if (1 < c.length) throw Error($866ae7eda648604d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $866ae7eda648604d$var$Sa(c)
    };
}
function $866ae7eda648604d$var$ib(a, b) {
    var c = $866ae7eda648604d$var$Sa(b.value), d = $866ae7eda648604d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $866ae7eda648604d$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $866ae7eda648604d$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $866ae7eda648604d$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $866ae7eda648604d$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $866ae7eda648604d$var$mb, $866ae7eda648604d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $866ae7eda648604d$var$mb = $866ae7eda648604d$var$mb || document.createElement("div");
        $866ae7eda648604d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $866ae7eda648604d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $866ae7eda648604d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $866ae7eda648604d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $866ae7eda648604d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($866ae7eda648604d$var$pb).forEach(function(a) {
    $866ae7eda648604d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $866ae7eda648604d$var$pb[b] = $866ae7eda648604d$var$pb[a];
    });
});
function $866ae7eda648604d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $866ae7eda648604d$var$pb.hasOwnProperty(a) && $866ae7eda648604d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $866ae7eda648604d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $866ae7eda648604d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $866ae7eda648604d$var$tb = $866ae7eda648604d$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $866ae7eda648604d$var$ub(a, b) {
    if (b) {
        if ($866ae7eda648604d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($866ae7eda648604d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($866ae7eda648604d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($866ae7eda648604d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($866ae7eda648604d$var$p(62));
    }
}
function $866ae7eda648604d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $866ae7eda648604d$var$wb = null;
function $866ae7eda648604d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $866ae7eda648604d$var$yb = null, $866ae7eda648604d$var$zb = null, $866ae7eda648604d$var$Ab = null;
function $866ae7eda648604d$var$Bb(a) {
    if (a = $866ae7eda648604d$var$Cb(a)) {
        if ("function" !== typeof $866ae7eda648604d$var$yb) throw Error($866ae7eda648604d$var$p(280));
        var b = a.stateNode;
        b && (b = $866ae7eda648604d$var$Db(b), $866ae7eda648604d$var$yb(a.stateNode, a.type, b));
    }
}
function $866ae7eda648604d$var$Eb(a) {
    $866ae7eda648604d$var$zb ? $866ae7eda648604d$var$Ab ? $866ae7eda648604d$var$Ab.push(a) : $866ae7eda648604d$var$Ab = [
        a
    ] : $866ae7eda648604d$var$zb = a;
}
function $866ae7eda648604d$var$Fb() {
    if ($866ae7eda648604d$var$zb) {
        var a = $866ae7eda648604d$var$zb, b = $866ae7eda648604d$var$Ab;
        $866ae7eda648604d$var$Ab = $866ae7eda648604d$var$zb = null;
        $866ae7eda648604d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$866ae7eda648604d$var$Bb(b[a]);
    }
}
function $866ae7eda648604d$var$Gb(a, b) {
    return a(b);
}
function $866ae7eda648604d$var$Hb() {}
var $866ae7eda648604d$var$Ib = !1;
function $866ae7eda648604d$var$Jb(a, b, c) {
    if ($866ae7eda648604d$var$Ib) return a(b, c);
    $866ae7eda648604d$var$Ib = !0;
    try {
        return $866ae7eda648604d$var$Gb(a, b, c);
    } finally{
        if ($866ae7eda648604d$var$Ib = !1, null !== $866ae7eda648604d$var$zb || null !== $866ae7eda648604d$var$Ab) $866ae7eda648604d$var$Hb(), $866ae7eda648604d$var$Fb();
    }
}
function $866ae7eda648604d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $866ae7eda648604d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($866ae7eda648604d$var$p(231, b, typeof c));
    return c;
}
var $866ae7eda648604d$var$Lb = !1;
if ($866ae7eda648604d$var$ia) try {
    var $866ae7eda648604d$var$Mb = {};
    Object.defineProperty($866ae7eda648604d$var$Mb, "passive", {
        get: function() {
            $866ae7eda648604d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $866ae7eda648604d$var$Mb, $866ae7eda648604d$var$Mb);
    window.removeEventListener("test", $866ae7eda648604d$var$Mb, $866ae7eda648604d$var$Mb);
} catch (a) {
    $866ae7eda648604d$var$Lb = !1;
}
function $866ae7eda648604d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $866ae7eda648604d$var$Ob = !1, $866ae7eda648604d$var$Pb = null, $866ae7eda648604d$var$Qb = !1, $866ae7eda648604d$var$Rb = null, $866ae7eda648604d$var$Sb = {
    onError: function(a) {
        $866ae7eda648604d$var$Ob = !0;
        $866ae7eda648604d$var$Pb = a;
    }
};
function $866ae7eda648604d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $866ae7eda648604d$var$Ob = !1;
    $866ae7eda648604d$var$Pb = null;
    $866ae7eda648604d$var$Nb.apply($866ae7eda648604d$var$Sb, arguments);
}
function $866ae7eda648604d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $866ae7eda648604d$var$Tb.apply(this, arguments);
    if ($866ae7eda648604d$var$Ob) {
        if ($866ae7eda648604d$var$Ob) {
            var l = $866ae7eda648604d$var$Pb;
            $866ae7eda648604d$var$Ob = !1;
            $866ae7eda648604d$var$Pb = null;
        } else throw Error($866ae7eda648604d$var$p(198));
        $866ae7eda648604d$var$Qb || ($866ae7eda648604d$var$Qb = !0, $866ae7eda648604d$var$Rb = l);
    }
}
function $866ae7eda648604d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $866ae7eda648604d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $866ae7eda648604d$var$Xb(a) {
    if ($866ae7eda648604d$var$Vb(a) !== a) throw Error($866ae7eda648604d$var$p(188));
}
function $866ae7eda648604d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $866ae7eda648604d$var$Vb(a);
        if (null === b) throw Error($866ae7eda648604d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $866ae7eda648604d$var$Xb(e), a;
                if (f === d) return $866ae7eda648604d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($866ae7eda648604d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($866ae7eda648604d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($866ae7eda648604d$var$p(190));
    }
    if (3 !== c.tag) throw Error($866ae7eda648604d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $866ae7eda648604d$var$Zb(a) {
    a = $866ae7eda648604d$var$Yb(a);
    return null !== a ? $866ae7eda648604d$var$$b(a) : null;
}
function $866ae7eda648604d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $866ae7eda648604d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $866ae7eda648604d$var$ac = $f65uV.unstable_scheduleCallback, $866ae7eda648604d$var$bc = $f65uV.unstable_cancelCallback, $866ae7eda648604d$var$cc = $f65uV.unstable_shouldYield, $866ae7eda648604d$var$dc = $f65uV.unstable_requestPaint, $866ae7eda648604d$var$B = $f65uV.unstable_now, $866ae7eda648604d$var$ec = $f65uV.unstable_getCurrentPriorityLevel, $866ae7eda648604d$var$fc = $f65uV.unstable_ImmediatePriority, $866ae7eda648604d$var$gc = $f65uV.unstable_UserBlockingPriority, $866ae7eda648604d$var$hc = $f65uV.unstable_NormalPriority, $866ae7eda648604d$var$ic = $f65uV.unstable_LowPriority, $866ae7eda648604d$var$jc = $f65uV.unstable_IdlePriority, $866ae7eda648604d$var$kc = null, $866ae7eda648604d$var$lc = null;
function $866ae7eda648604d$var$mc(a) {
    if ($866ae7eda648604d$var$lc && "function" === typeof $866ae7eda648604d$var$lc.onCommitFiberRoot) try {
        $866ae7eda648604d$var$lc.onCommitFiberRoot($866ae7eda648604d$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $866ae7eda648604d$var$oc = Math.clz32 ? Math.clz32 : $866ae7eda648604d$var$nc, $866ae7eda648604d$var$pc = Math.log, $866ae7eda648604d$var$qc = Math.LN2;
function $866ae7eda648604d$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($866ae7eda648604d$var$pc(a) / $866ae7eda648604d$var$qc | 0) | 0;
}
var $866ae7eda648604d$var$rc = 64, $866ae7eda648604d$var$sc = 4194304;
function $866ae7eda648604d$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $866ae7eda648604d$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $866ae7eda648604d$var$tc(h) : (f &= g, 0 !== f && (d = $866ae7eda648604d$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $866ae7eda648604d$var$tc(g) : 0 !== f && (d = $866ae7eda648604d$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $866ae7eda648604d$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $866ae7eda648604d$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $866ae7eda648604d$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $866ae7eda648604d$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $866ae7eda648604d$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $866ae7eda648604d$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $866ae7eda648604d$var$yc() {
    var a = $866ae7eda648604d$var$rc;
    $866ae7eda648604d$var$rc <<= 1;
    0 === ($866ae7eda648604d$var$rc & 4194240) && ($866ae7eda648604d$var$rc = 64);
    return a;
}
function $866ae7eda648604d$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $866ae7eda648604d$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $866ae7eda648604d$var$oc(b);
    a[b] = c;
}
function $866ae7eda648604d$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $866ae7eda648604d$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $866ae7eda648604d$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $866ae7eda648604d$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $866ae7eda648604d$var$C = 0;
function $866ae7eda648604d$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $866ae7eda648604d$var$Ec, $866ae7eda648604d$var$Fc, $866ae7eda648604d$var$Gc, $866ae7eda648604d$var$Hc, $866ae7eda648604d$var$Ic, $866ae7eda648604d$var$Jc = !1, $866ae7eda648604d$var$Kc = [], $866ae7eda648604d$var$Lc = null, $866ae7eda648604d$var$Mc = null, $866ae7eda648604d$var$Nc = null, $866ae7eda648604d$var$Oc = new Map, $866ae7eda648604d$var$Pc = new Map, $866ae7eda648604d$var$Qc = [], $866ae7eda648604d$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $866ae7eda648604d$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $866ae7eda648604d$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $866ae7eda648604d$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $866ae7eda648604d$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $866ae7eda648604d$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $866ae7eda648604d$var$Pc.delete(b.pointerId);
    }
}
function $866ae7eda648604d$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $866ae7eda648604d$var$Cb(b), null !== b && $866ae7eda648604d$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $866ae7eda648604d$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $866ae7eda648604d$var$Lc = $866ae7eda648604d$var$Tc($866ae7eda648604d$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $866ae7eda648604d$var$Mc = $866ae7eda648604d$var$Tc($866ae7eda648604d$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $866ae7eda648604d$var$Nc = $866ae7eda648604d$var$Tc($866ae7eda648604d$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $866ae7eda648604d$var$Oc.set(f, $866ae7eda648604d$var$Tc($866ae7eda648604d$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $866ae7eda648604d$var$Pc.set(f, $866ae7eda648604d$var$Tc($866ae7eda648604d$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $866ae7eda648604d$var$Vc(a) {
    var b = $866ae7eda648604d$var$Wc(a.target);
    if (null !== b) {
        var c = $866ae7eda648604d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $866ae7eda648604d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $866ae7eda648604d$var$Ic(a.priority, function() {
                        $866ae7eda648604d$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $866ae7eda648604d$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $866ae7eda648604d$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $866ae7eda648604d$var$wb = d;
            c.target.dispatchEvent(d);
            $866ae7eda648604d$var$wb = null;
        } else return b = $866ae7eda648604d$var$Cb(c), null !== b && $866ae7eda648604d$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $866ae7eda648604d$var$Zc(a, b, c) {
    $866ae7eda648604d$var$Xc(a) && c.delete(b);
}
function $866ae7eda648604d$var$$c() {
    $866ae7eda648604d$var$Jc = !1;
    null !== $866ae7eda648604d$var$Lc && $866ae7eda648604d$var$Xc($866ae7eda648604d$var$Lc) && ($866ae7eda648604d$var$Lc = null);
    null !== $866ae7eda648604d$var$Mc && $866ae7eda648604d$var$Xc($866ae7eda648604d$var$Mc) && ($866ae7eda648604d$var$Mc = null);
    null !== $866ae7eda648604d$var$Nc && $866ae7eda648604d$var$Xc($866ae7eda648604d$var$Nc) && ($866ae7eda648604d$var$Nc = null);
    $866ae7eda648604d$var$Oc.forEach($866ae7eda648604d$var$Zc);
    $866ae7eda648604d$var$Pc.forEach($866ae7eda648604d$var$Zc);
}
function $866ae7eda648604d$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $866ae7eda648604d$var$Jc || ($866ae7eda648604d$var$Jc = !0, $f65uV.unstable_scheduleCallback($f65uV.unstable_NormalPriority, $866ae7eda648604d$var$$c)));
}
function $866ae7eda648604d$var$bd(a) {
    function b(b) {
        return $866ae7eda648604d$var$ad(b, a);
    }
    if (0 < $866ae7eda648604d$var$Kc.length) {
        $866ae7eda648604d$var$ad($866ae7eda648604d$var$Kc[0], a);
        for(var c = 1; c < $866ae7eda648604d$var$Kc.length; c++){
            var d = $866ae7eda648604d$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $866ae7eda648604d$var$Lc && $866ae7eda648604d$var$ad($866ae7eda648604d$var$Lc, a);
    null !== $866ae7eda648604d$var$Mc && $866ae7eda648604d$var$ad($866ae7eda648604d$var$Mc, a);
    null !== $866ae7eda648604d$var$Nc && $866ae7eda648604d$var$ad($866ae7eda648604d$var$Nc, a);
    $866ae7eda648604d$var$Oc.forEach(b);
    $866ae7eda648604d$var$Pc.forEach(b);
    for(c = 0; c < $866ae7eda648604d$var$Qc.length; c++)d = $866ae7eda648604d$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $866ae7eda648604d$var$Qc.length && (c = $866ae7eda648604d$var$Qc[0], null === c.blockedOn);)$866ae7eda648604d$var$Vc(c), null === c.blockedOn && $866ae7eda648604d$var$Qc.shift();
}
var $866ae7eda648604d$var$cd = $866ae7eda648604d$var$ua.ReactCurrentBatchConfig, $866ae7eda648604d$var$dd = !0;
function $866ae7eda648604d$var$ed(a, b, c, d) {
    var e = $866ae7eda648604d$var$C, f = $866ae7eda648604d$var$cd.transition;
    $866ae7eda648604d$var$cd.transition = null;
    try {
        $866ae7eda648604d$var$C = 1, $866ae7eda648604d$var$fd(a, b, c, d);
    } finally{
        $866ae7eda648604d$var$C = e, $866ae7eda648604d$var$cd.transition = f;
    }
}
function $866ae7eda648604d$var$gd(a, b, c, d) {
    var e = $866ae7eda648604d$var$C, f = $866ae7eda648604d$var$cd.transition;
    $866ae7eda648604d$var$cd.transition = null;
    try {
        $866ae7eda648604d$var$C = 4, $866ae7eda648604d$var$fd(a, b, c, d);
    } finally{
        $866ae7eda648604d$var$C = e, $866ae7eda648604d$var$cd.transition = f;
    }
}
function $866ae7eda648604d$var$fd(a, b, c, d) {
    if ($866ae7eda648604d$var$dd) {
        var e = $866ae7eda648604d$var$Yc(a, b, c, d);
        if (null === e) $866ae7eda648604d$var$hd(a, b, d, $866ae7eda648604d$var$id, c), $866ae7eda648604d$var$Sc(a, d);
        else if ($866ae7eda648604d$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($866ae7eda648604d$var$Sc(a, d), b & 4 && -1 < $866ae7eda648604d$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $866ae7eda648604d$var$Cb(e);
                null !== f && $866ae7eda648604d$var$Ec(f);
                f = $866ae7eda648604d$var$Yc(a, b, c, d);
                null === f && $866ae7eda648604d$var$hd(a, b, d, $866ae7eda648604d$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $866ae7eda648604d$var$hd(a, b, d, null, c);
    }
}
var $866ae7eda648604d$var$id = null;
function $866ae7eda648604d$var$Yc(a, b, c, d) {
    $866ae7eda648604d$var$id = null;
    a = $866ae7eda648604d$var$xb(d);
    a = $866ae7eda648604d$var$Wc(a);
    if (null !== a) {
        if (b = $866ae7eda648604d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $866ae7eda648604d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $866ae7eda648604d$var$id = a;
    return null;
}
function $866ae7eda648604d$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($866ae7eda648604d$var$ec()){
                case $866ae7eda648604d$var$fc:
                    return 1;
                case $866ae7eda648604d$var$gc:
                    return 4;
                case $866ae7eda648604d$var$hc:
                case $866ae7eda648604d$var$ic:
                    return 16;
                case $866ae7eda648604d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $866ae7eda648604d$var$kd = null, $866ae7eda648604d$var$ld = null, $866ae7eda648604d$var$md = null;
function $866ae7eda648604d$var$nd() {
    if ($866ae7eda648604d$var$md) return $866ae7eda648604d$var$md;
    var a, b = $866ae7eda648604d$var$ld, c = b.length, d, e = "value" in $866ae7eda648604d$var$kd ? $866ae7eda648604d$var$kd.value : $866ae7eda648604d$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $866ae7eda648604d$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $866ae7eda648604d$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $866ae7eda648604d$var$pd() {
    return !0;
}
function $866ae7eda648604d$var$qd() {
    return !1;
}
function $866ae7eda648604d$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $866ae7eda648604d$var$pd : $866ae7eda648604d$var$qd;
        this.isPropagationStopped = $866ae7eda648604d$var$qd;
        return this;
    }
    $866ae7eda648604d$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $866ae7eda648604d$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $866ae7eda648604d$var$pd);
        },
        persist: function() {},
        isPersistent: $866ae7eda648604d$var$pd
    });
    return b;
}
var $866ae7eda648604d$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $866ae7eda648604d$var$td = $866ae7eda648604d$var$rd($866ae7eda648604d$var$sd), $866ae7eda648604d$var$ud = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$sd, {
    view: 0,
    detail: 0
}), $866ae7eda648604d$var$vd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$ud), $866ae7eda648604d$var$wd, $866ae7eda648604d$var$xd, $866ae7eda648604d$var$yd, $866ae7eda648604d$var$Ad = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $866ae7eda648604d$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $866ae7eda648604d$var$yd && ($866ae7eda648604d$var$yd && "mousemove" === a.type ? ($866ae7eda648604d$var$wd = a.screenX - $866ae7eda648604d$var$yd.screenX, $866ae7eda648604d$var$xd = a.screenY - $866ae7eda648604d$var$yd.screenY) : $866ae7eda648604d$var$xd = $866ae7eda648604d$var$wd = 0, $866ae7eda648604d$var$yd = a);
        return $866ae7eda648604d$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $866ae7eda648604d$var$xd;
    }
}), $866ae7eda648604d$var$Bd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Ad), $866ae7eda648604d$var$Cd = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$Ad, {
    dataTransfer: 0
}), $866ae7eda648604d$var$Dd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Cd), $866ae7eda648604d$var$Ed = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$ud, {
    relatedTarget: 0
}), $866ae7eda648604d$var$Fd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Ed), $866ae7eda648604d$var$Gd = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $866ae7eda648604d$var$Hd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Gd), $866ae7eda648604d$var$Id = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $866ae7eda648604d$var$Jd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Id), $866ae7eda648604d$var$Kd = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$sd, {
    data: 0
}), $866ae7eda648604d$var$Ld = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Kd), $866ae7eda648604d$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $866ae7eda648604d$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $866ae7eda648604d$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $866ae7eda648604d$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $866ae7eda648604d$var$Od[a]) ? !!b[a] : !1;
}
function $866ae7eda648604d$var$zd() {
    return $866ae7eda648604d$var$Pd;
}
var $866ae7eda648604d$var$Qd = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $866ae7eda648604d$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $866ae7eda648604d$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $866ae7eda648604d$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $866ae7eda648604d$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $866ae7eda648604d$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $866ae7eda648604d$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $866ae7eda648604d$var$Rd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Qd), $866ae7eda648604d$var$Sd = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $866ae7eda648604d$var$Td = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Sd), $866ae7eda648604d$var$Ud = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $866ae7eda648604d$var$zd
}), $866ae7eda648604d$var$Vd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Ud), $866ae7eda648604d$var$Wd = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $866ae7eda648604d$var$Xd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Wd), $866ae7eda648604d$var$Yd = $866ae7eda648604d$var$A({}, $866ae7eda648604d$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $866ae7eda648604d$var$Zd = $866ae7eda648604d$var$rd($866ae7eda648604d$var$Yd), $866ae7eda648604d$var$$d = [
    9,
    13,
    27,
    32
], $866ae7eda648604d$var$ae = $866ae7eda648604d$var$ia && "CompositionEvent" in window, $866ae7eda648604d$var$be = null;
$866ae7eda648604d$var$ia && "documentMode" in document && ($866ae7eda648604d$var$be = document.documentMode);
var $866ae7eda648604d$var$ce = $866ae7eda648604d$var$ia && "TextEvent" in window && !$866ae7eda648604d$var$be, $866ae7eda648604d$var$de = $866ae7eda648604d$var$ia && (!$866ae7eda648604d$var$ae || $866ae7eda648604d$var$be && 8 < $866ae7eda648604d$var$be && 11 >= $866ae7eda648604d$var$be), $866ae7eda648604d$var$ee = String.fromCharCode(32), $866ae7eda648604d$var$fe = !1;
function $866ae7eda648604d$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $866ae7eda648604d$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $866ae7eda648604d$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $866ae7eda648604d$var$ie = !1;
function $866ae7eda648604d$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $866ae7eda648604d$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $866ae7eda648604d$var$fe = !0;
            return $866ae7eda648604d$var$ee;
        case "textInput":
            return a = b.data, a === $866ae7eda648604d$var$ee && $866ae7eda648604d$var$fe ? null : a;
        default:
            return null;
    }
}
function $866ae7eda648604d$var$ke(a, b) {
    if ($866ae7eda648604d$var$ie) return "compositionend" === a || !$866ae7eda648604d$var$ae && $866ae7eda648604d$var$ge(a, b) ? (a = $866ae7eda648604d$var$nd(), $866ae7eda648604d$var$md = $866ae7eda648604d$var$ld = $866ae7eda648604d$var$kd = null, $866ae7eda648604d$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $866ae7eda648604d$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $866ae7eda648604d$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $866ae7eda648604d$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$866ae7eda648604d$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $866ae7eda648604d$var$ne(a, b, c, d) {
    $866ae7eda648604d$var$Eb(d);
    b = $866ae7eda648604d$var$oe(b, "onChange");
    0 < b.length && (c = new $866ae7eda648604d$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $866ae7eda648604d$var$pe = null, $866ae7eda648604d$var$qe = null;
function $866ae7eda648604d$var$re(a) {
    $866ae7eda648604d$var$se(a, 0);
}
function $866ae7eda648604d$var$te(a) {
    var b = $866ae7eda648604d$var$ue(a);
    if ($866ae7eda648604d$var$Wa(b)) return a;
}
function $866ae7eda648604d$var$ve(a, b) {
    if ("change" === a) return b;
}
var $866ae7eda648604d$var$we = !1;
if ($866ae7eda648604d$var$ia) {
    var $866ae7eda648604d$var$xe;
    if ($866ae7eda648604d$var$ia) {
        var $866ae7eda648604d$var$ye = "oninput" in document;
        if (!$866ae7eda648604d$var$ye) {
            var $866ae7eda648604d$var$ze = document.createElement("div");
            $866ae7eda648604d$var$ze.setAttribute("oninput", "return;");
            $866ae7eda648604d$var$ye = "function" === typeof $866ae7eda648604d$var$ze.oninput;
        }
        $866ae7eda648604d$var$xe = $866ae7eda648604d$var$ye;
    } else $866ae7eda648604d$var$xe = !1;
    $866ae7eda648604d$var$we = $866ae7eda648604d$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $866ae7eda648604d$var$Ae() {
    $866ae7eda648604d$var$pe && ($866ae7eda648604d$var$pe.detachEvent("onpropertychange", $866ae7eda648604d$var$Be), $866ae7eda648604d$var$qe = $866ae7eda648604d$var$pe = null);
}
function $866ae7eda648604d$var$Be(a) {
    if ("value" === a.propertyName && $866ae7eda648604d$var$te($866ae7eda648604d$var$qe)) {
        var b = [];
        $866ae7eda648604d$var$ne(b, $866ae7eda648604d$var$qe, a, $866ae7eda648604d$var$xb(a));
        $866ae7eda648604d$var$Jb($866ae7eda648604d$var$re, b);
    }
}
function $866ae7eda648604d$var$Ce(a, b, c) {
    "focusin" === a ? ($866ae7eda648604d$var$Ae(), $866ae7eda648604d$var$pe = b, $866ae7eda648604d$var$qe = c, $866ae7eda648604d$var$pe.attachEvent("onpropertychange", $866ae7eda648604d$var$Be)) : "focusout" === a && $866ae7eda648604d$var$Ae();
}
function $866ae7eda648604d$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $866ae7eda648604d$var$te($866ae7eda648604d$var$qe);
}
function $866ae7eda648604d$var$Ee(a, b) {
    if ("click" === a) return $866ae7eda648604d$var$te(b);
}
function $866ae7eda648604d$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $866ae7eda648604d$var$te(b);
}
function $866ae7eda648604d$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $866ae7eda648604d$var$He = "function" === typeof Object.is ? Object.is : $866ae7eda648604d$var$Ge;
function $866ae7eda648604d$var$Ie(a, b) {
    if ($866ae7eda648604d$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$866ae7eda648604d$var$ja.call(b, e) || !$866ae7eda648604d$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $866ae7eda648604d$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $866ae7eda648604d$var$Ke(a, b) {
    var c = $866ae7eda648604d$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $866ae7eda648604d$var$Je(c);
    }
}
function $866ae7eda648604d$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $866ae7eda648604d$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $866ae7eda648604d$var$Me() {
    for(var a = window, b = $866ae7eda648604d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $866ae7eda648604d$var$Xa(a.document);
    }
    return b;
}
function $866ae7eda648604d$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $866ae7eda648604d$var$Oe(a) {
    var b = $866ae7eda648604d$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $866ae7eda648604d$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $866ae7eda648604d$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $866ae7eda648604d$var$Ke(c, f);
                var g = $866ae7eda648604d$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $866ae7eda648604d$var$Pe = $866ae7eda648604d$var$ia && "documentMode" in document && 11 >= document.documentMode, $866ae7eda648604d$var$Qe = null, $866ae7eda648604d$var$Re = null, $866ae7eda648604d$var$Se = null, $866ae7eda648604d$var$Te = !1;
function $866ae7eda648604d$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $866ae7eda648604d$var$Te || null == $866ae7eda648604d$var$Qe || $866ae7eda648604d$var$Qe !== $866ae7eda648604d$var$Xa(d) || (d = $866ae7eda648604d$var$Qe, "selectionStart" in d && $866ae7eda648604d$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $866ae7eda648604d$var$Se && $866ae7eda648604d$var$Ie($866ae7eda648604d$var$Se, d) || ($866ae7eda648604d$var$Se = d, d = $866ae7eda648604d$var$oe($866ae7eda648604d$var$Re, "onSelect"), 0 < d.length && (b = new $866ae7eda648604d$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $866ae7eda648604d$var$Qe)));
}
function $866ae7eda648604d$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $866ae7eda648604d$var$We = {
    animationend: $866ae7eda648604d$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $866ae7eda648604d$var$Ve("Animation", "AnimationIteration"),
    animationstart: $866ae7eda648604d$var$Ve("Animation", "AnimationStart"),
    transitionend: $866ae7eda648604d$var$Ve("Transition", "TransitionEnd")
}, $866ae7eda648604d$var$Xe = {}, $866ae7eda648604d$var$Ye = {};
$866ae7eda648604d$var$ia && ($866ae7eda648604d$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $866ae7eda648604d$var$We.animationend.animation, delete $866ae7eda648604d$var$We.animationiteration.animation, delete $866ae7eda648604d$var$We.animationstart.animation), "TransitionEvent" in window || delete $866ae7eda648604d$var$We.transitionend.transition);
function $866ae7eda648604d$var$Ze(a) {
    if ($866ae7eda648604d$var$Xe[a]) return $866ae7eda648604d$var$Xe[a];
    if (!$866ae7eda648604d$var$We[a]) return a;
    var b = $866ae7eda648604d$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $866ae7eda648604d$var$Ye) return $866ae7eda648604d$var$Xe[a] = b[c];
    return a;
}
var $866ae7eda648604d$var$$e = $866ae7eda648604d$var$Ze("animationend"), $866ae7eda648604d$var$af = $866ae7eda648604d$var$Ze("animationiteration"), $866ae7eda648604d$var$bf = $866ae7eda648604d$var$Ze("animationstart"), $866ae7eda648604d$var$cf = $866ae7eda648604d$var$Ze("transitionend"), $866ae7eda648604d$var$df = new Map, $866ae7eda648604d$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $866ae7eda648604d$var$ff(a, b) {
    $866ae7eda648604d$var$df.set(a, b);
    $866ae7eda648604d$var$fa(b, [
        a
    ]);
}
for(var $866ae7eda648604d$var$gf = 0; $866ae7eda648604d$var$gf < $866ae7eda648604d$var$ef.length; $866ae7eda648604d$var$gf++){
    var $866ae7eda648604d$var$hf = $866ae7eda648604d$var$ef[$866ae7eda648604d$var$gf], $866ae7eda648604d$var$jf = $866ae7eda648604d$var$hf.toLowerCase(), $866ae7eda648604d$var$kf = $866ae7eda648604d$var$hf[0].toUpperCase() + $866ae7eda648604d$var$hf.slice(1);
    $866ae7eda648604d$var$ff($866ae7eda648604d$var$jf, "on" + $866ae7eda648604d$var$kf);
}
$866ae7eda648604d$var$ff($866ae7eda648604d$var$$e, "onAnimationEnd");
$866ae7eda648604d$var$ff($866ae7eda648604d$var$af, "onAnimationIteration");
$866ae7eda648604d$var$ff($866ae7eda648604d$var$bf, "onAnimationStart");
$866ae7eda648604d$var$ff("dblclick", "onDoubleClick");
$866ae7eda648604d$var$ff("focusin", "onFocus");
$866ae7eda648604d$var$ff("focusout", "onBlur");
$866ae7eda648604d$var$ff($866ae7eda648604d$var$cf, "onTransitionEnd");
$866ae7eda648604d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$866ae7eda648604d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$866ae7eda648604d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$866ae7eda648604d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$866ae7eda648604d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$866ae7eda648604d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$866ae7eda648604d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$866ae7eda648604d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$866ae7eda648604d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$866ae7eda648604d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $866ae7eda648604d$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $866ae7eda648604d$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($866ae7eda648604d$var$lf));
function $866ae7eda648604d$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $866ae7eda648604d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $866ae7eda648604d$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $866ae7eda648604d$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $866ae7eda648604d$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($866ae7eda648604d$var$Qb) throw a = $866ae7eda648604d$var$Rb, $866ae7eda648604d$var$Qb = !1, $866ae7eda648604d$var$Rb = null, a;
}
function $866ae7eda648604d$var$D(a, b) {
    var c = b[$866ae7eda648604d$var$of];
    void 0 === c && (c = b[$866ae7eda648604d$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($866ae7eda648604d$var$pf(b, a, 2, !1), c.add(d));
}
function $866ae7eda648604d$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $866ae7eda648604d$var$pf(c, a, d, b);
}
var $866ae7eda648604d$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $866ae7eda648604d$var$sf(a) {
    if (!a[$866ae7eda648604d$var$rf]) {
        a[$866ae7eda648604d$var$rf] = !0;
        $866ae7eda648604d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($866ae7eda648604d$var$mf.has(b) || $866ae7eda648604d$var$qf(b, !1, a), $866ae7eda648604d$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$866ae7eda648604d$var$rf] || (b[$866ae7eda648604d$var$rf] = !0, $866ae7eda648604d$var$qf("selectionchange", !1, b));
    }
}
function $866ae7eda648604d$var$pf(a, b, c, d) {
    switch($866ae7eda648604d$var$jd(b)){
        case 1:
            var e = $866ae7eda648604d$var$ed;
            break;
        case 4:
            e = $866ae7eda648604d$var$gd;
            break;
        default:
            e = $866ae7eda648604d$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$866ae7eda648604d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $866ae7eda648604d$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $866ae7eda648604d$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $866ae7eda648604d$var$Jb(function() {
        var d = f, e = $866ae7eda648604d$var$xb(c), g = [];
        a: {
            var h = $866ae7eda648604d$var$df.get(a);
            if (void 0 !== h) {
                var k = $866ae7eda648604d$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $866ae7eda648604d$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $866ae7eda648604d$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $866ae7eda648604d$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $866ae7eda648604d$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $866ae7eda648604d$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $866ae7eda648604d$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $866ae7eda648604d$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $866ae7eda648604d$var$Vd;
                        break;
                    case $866ae7eda648604d$var$$e:
                    case $866ae7eda648604d$var$af:
                    case $866ae7eda648604d$var$bf:
                        k = $866ae7eda648604d$var$Hd;
                        break;
                    case $866ae7eda648604d$var$cf:
                        k = $866ae7eda648604d$var$Xd;
                        break;
                    case "scroll":
                        k = $866ae7eda648604d$var$vd;
                        break;
                    case "wheel":
                        k = $866ae7eda648604d$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $866ae7eda648604d$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $866ae7eda648604d$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $866ae7eda648604d$var$Kb(w, x), null != F && t.push($866ae7eda648604d$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $866ae7eda648604d$var$wb && (n = c.relatedTarget || c.fromElement) && ($866ae7eda648604d$var$Wc(n) || n[$866ae7eda648604d$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $866ae7eda648604d$var$Wc(n) : null, null !== n && (J = $866ae7eda648604d$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $866ae7eda648604d$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $866ae7eda648604d$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $866ae7eda648604d$var$ue(k);
                        u = null == n ? h : $866ae7eda648604d$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $866ae7eda648604d$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $866ae7eda648604d$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $866ae7eda648604d$var$vf(F))u++;
                            for(; 0 < w - u;)t = $866ae7eda648604d$var$vf(t), w--;
                            for(; 0 < u - w;)x = $866ae7eda648604d$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $866ae7eda648604d$var$vf(t);
                                x = $866ae7eda648604d$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $866ae7eda648604d$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $866ae7eda648604d$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $866ae7eda648604d$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $866ae7eda648604d$var$ve;
                else if ($866ae7eda648604d$var$me(h)) {
                    if ($866ae7eda648604d$var$we) na = $866ae7eda648604d$var$Fe;
                    else {
                        na = $866ae7eda648604d$var$De;
                        var xa = $866ae7eda648604d$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $866ae7eda648604d$var$Ee);
                if (na && (na = na(a, d))) {
                    $866ae7eda648604d$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $866ae7eda648604d$var$cb(h, "number", h.value);
            }
            xa = d ? $866ae7eda648604d$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($866ae7eda648604d$var$me(xa) || "true" === xa.contentEditable) $866ae7eda648604d$var$Qe = xa, $866ae7eda648604d$var$Re = d, $866ae7eda648604d$var$Se = null;
                    break;
                case "focusout":
                    $866ae7eda648604d$var$Se = $866ae7eda648604d$var$Re = $866ae7eda648604d$var$Qe = null;
                    break;
                case "mousedown":
                    $866ae7eda648604d$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $866ae7eda648604d$var$Te = !1;
                    $866ae7eda648604d$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($866ae7eda648604d$var$Pe) break;
                case "keydown":
                case "keyup":
                    $866ae7eda648604d$var$Ue(g, c, e);
            }
            var $a;
            if ($866ae7eda648604d$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $866ae7eda648604d$var$ie ? $866ae7eda648604d$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($866ae7eda648604d$var$de && "ko" !== c.locale && ($866ae7eda648604d$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $866ae7eda648604d$var$ie && ($a = $866ae7eda648604d$var$nd()) : ($866ae7eda648604d$var$kd = e, $866ae7eda648604d$var$ld = "value" in $866ae7eda648604d$var$kd ? $866ae7eda648604d$var$kd.value : $866ae7eda648604d$var$kd.textContent, $866ae7eda648604d$var$ie = !0)), xa = $866ae7eda648604d$var$oe(d, ba), 0 < xa.length && (ba = new $866ae7eda648604d$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $866ae7eda648604d$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $866ae7eda648604d$var$ce ? $866ae7eda648604d$var$je(a, c) : $866ae7eda648604d$var$ke(a, c)) d = $866ae7eda648604d$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $866ae7eda648604d$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $866ae7eda648604d$var$se(g, b);
    });
}
function $866ae7eda648604d$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $866ae7eda648604d$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $866ae7eda648604d$var$Kb(a, c), null != f && d.unshift($866ae7eda648604d$var$tf(a, f, e)), f = $866ae7eda648604d$var$Kb(a, b), null != f && d.push($866ae7eda648604d$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $866ae7eda648604d$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $866ae7eda648604d$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $866ae7eda648604d$var$Kb(c, f), null != k && g.unshift($866ae7eda648604d$var$tf(c, k, h))) : e || (k = $866ae7eda648604d$var$Kb(c, f), null != k && g.push($866ae7eda648604d$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $866ae7eda648604d$var$xf = /\r\n?/g, $866ae7eda648604d$var$yf = /\u0000|\uFFFD/g;
function $866ae7eda648604d$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($866ae7eda648604d$var$xf, "\n").replace($866ae7eda648604d$var$yf, "");
}
function $866ae7eda648604d$var$Af(a, b, c) {
    b = $866ae7eda648604d$var$zf(b);
    if ($866ae7eda648604d$var$zf(a) !== b && c) throw Error($866ae7eda648604d$var$p(425));
}
function $866ae7eda648604d$var$Bf() {}
var $866ae7eda648604d$var$Cf = null, $866ae7eda648604d$var$Df = null;
function $866ae7eda648604d$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $866ae7eda648604d$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $866ae7eda648604d$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $866ae7eda648604d$var$Hf = "function" === typeof Promise ? Promise : void 0, $866ae7eda648604d$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $866ae7eda648604d$var$Hf ? function(a) {
    return $866ae7eda648604d$var$Hf.resolve(null).then(a).catch($866ae7eda648604d$var$If);
} : $866ae7eda648604d$var$Ff;
function $866ae7eda648604d$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $866ae7eda648604d$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $866ae7eda648604d$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $866ae7eda648604d$var$bd(b);
}
function $866ae7eda648604d$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $866ae7eda648604d$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $866ae7eda648604d$var$Nf = Math.random().toString(36).slice(2), $866ae7eda648604d$var$Of = "__reactFiber$" + $866ae7eda648604d$var$Nf, $866ae7eda648604d$var$Pf = "__reactProps$" + $866ae7eda648604d$var$Nf, $866ae7eda648604d$var$uf = "__reactContainer$" + $866ae7eda648604d$var$Nf, $866ae7eda648604d$var$of = "__reactEvents$" + $866ae7eda648604d$var$Nf, $866ae7eda648604d$var$Qf = "__reactListeners$" + $866ae7eda648604d$var$Nf, $866ae7eda648604d$var$Rf = "__reactHandles$" + $866ae7eda648604d$var$Nf;
function $866ae7eda648604d$var$Wc(a) {
    var b = a[$866ae7eda648604d$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$866ae7eda648604d$var$uf] || c[$866ae7eda648604d$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $866ae7eda648604d$var$Mf(a); null !== a;){
                if (c = a[$866ae7eda648604d$var$Of]) return c;
                a = $866ae7eda648604d$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $866ae7eda648604d$var$Cb(a) {
    a = a[$866ae7eda648604d$var$Of] || a[$866ae7eda648604d$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $866ae7eda648604d$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($866ae7eda648604d$var$p(33));
}
function $866ae7eda648604d$var$Db(a) {
    return a[$866ae7eda648604d$var$Pf] || null;
}
var $866ae7eda648604d$var$Sf = [], $866ae7eda648604d$var$Tf = -1;
function $866ae7eda648604d$var$Uf(a) {
    return {
        current: a
    };
}
function $866ae7eda648604d$var$E(a) {
    0 > $866ae7eda648604d$var$Tf || (a.current = $866ae7eda648604d$var$Sf[$866ae7eda648604d$var$Tf], $866ae7eda648604d$var$Sf[$866ae7eda648604d$var$Tf] = null, $866ae7eda648604d$var$Tf--);
}
function $866ae7eda648604d$var$G(a, b) {
    $866ae7eda648604d$var$Tf++;
    $866ae7eda648604d$var$Sf[$866ae7eda648604d$var$Tf] = a.current;
    a.current = b;
}
var $866ae7eda648604d$var$Vf = {}, $866ae7eda648604d$var$H = $866ae7eda648604d$var$Uf($866ae7eda648604d$var$Vf), $866ae7eda648604d$var$Wf = $866ae7eda648604d$var$Uf(!1), $866ae7eda648604d$var$Xf = $866ae7eda648604d$var$Vf;
function $866ae7eda648604d$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $866ae7eda648604d$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $866ae7eda648604d$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $866ae7eda648604d$var$$f() {
    $866ae7eda648604d$var$E($866ae7eda648604d$var$Wf);
    $866ae7eda648604d$var$E($866ae7eda648604d$var$H);
}
function $866ae7eda648604d$var$ag(a, b, c) {
    if ($866ae7eda648604d$var$H.current !== $866ae7eda648604d$var$Vf) throw Error($866ae7eda648604d$var$p(168));
    $866ae7eda648604d$var$G($866ae7eda648604d$var$H, b);
    $866ae7eda648604d$var$G($866ae7eda648604d$var$Wf, c);
}
function $866ae7eda648604d$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($866ae7eda648604d$var$p(108, $866ae7eda648604d$var$Ra(a) || "Unknown", e));
    return $866ae7eda648604d$var$A({}, c, d);
}
function $866ae7eda648604d$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $866ae7eda648604d$var$Vf;
    $866ae7eda648604d$var$Xf = $866ae7eda648604d$var$H.current;
    $866ae7eda648604d$var$G($866ae7eda648604d$var$H, a);
    $866ae7eda648604d$var$G($866ae7eda648604d$var$Wf, $866ae7eda648604d$var$Wf.current);
    return !0;
}
function $866ae7eda648604d$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($866ae7eda648604d$var$p(169));
    c ? (a = $866ae7eda648604d$var$bg(a, b, $866ae7eda648604d$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $866ae7eda648604d$var$E($866ae7eda648604d$var$Wf), $866ae7eda648604d$var$E($866ae7eda648604d$var$H), $866ae7eda648604d$var$G($866ae7eda648604d$var$H, a)) : $866ae7eda648604d$var$E($866ae7eda648604d$var$Wf);
    $866ae7eda648604d$var$G($866ae7eda648604d$var$Wf, c);
}
var $866ae7eda648604d$var$eg = null, $866ae7eda648604d$var$fg = !1, $866ae7eda648604d$var$gg = !1;
function $866ae7eda648604d$var$hg(a) {
    null === $866ae7eda648604d$var$eg ? $866ae7eda648604d$var$eg = [
        a
    ] : $866ae7eda648604d$var$eg.push(a);
}
function $866ae7eda648604d$var$ig(a) {
    $866ae7eda648604d$var$fg = !0;
    $866ae7eda648604d$var$hg(a);
}
function $866ae7eda648604d$var$jg() {
    if (!$866ae7eda648604d$var$gg && null !== $866ae7eda648604d$var$eg) {
        $866ae7eda648604d$var$gg = !0;
        var a = 0, b = $866ae7eda648604d$var$C;
        try {
            var c = $866ae7eda648604d$var$eg;
            for($866ae7eda648604d$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $866ae7eda648604d$var$eg = null;
            $866ae7eda648604d$var$fg = !1;
        } catch (e) {
            throw null !== $866ae7eda648604d$var$eg && ($866ae7eda648604d$var$eg = $866ae7eda648604d$var$eg.slice(a + 1)), $866ae7eda648604d$var$ac($866ae7eda648604d$var$fc, $866ae7eda648604d$var$jg), e;
        } finally{
            $866ae7eda648604d$var$C = b, $866ae7eda648604d$var$gg = !1;
        }
    }
    return null;
}
var $866ae7eda648604d$var$kg = [], $866ae7eda648604d$var$lg = 0, $866ae7eda648604d$var$mg = null, $866ae7eda648604d$var$ng = 0, $866ae7eda648604d$var$og = [], $866ae7eda648604d$var$pg = 0, $866ae7eda648604d$var$qg = null, $866ae7eda648604d$var$rg = 1, $866ae7eda648604d$var$sg = "";
function $866ae7eda648604d$var$tg(a, b) {
    $866ae7eda648604d$var$kg[$866ae7eda648604d$var$lg++] = $866ae7eda648604d$var$ng;
    $866ae7eda648604d$var$kg[$866ae7eda648604d$var$lg++] = $866ae7eda648604d$var$mg;
    $866ae7eda648604d$var$mg = a;
    $866ae7eda648604d$var$ng = b;
}
function $866ae7eda648604d$var$ug(a, b, c) {
    $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg++] = $866ae7eda648604d$var$rg;
    $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg++] = $866ae7eda648604d$var$sg;
    $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg++] = $866ae7eda648604d$var$qg;
    $866ae7eda648604d$var$qg = a;
    var d = $866ae7eda648604d$var$rg;
    a = $866ae7eda648604d$var$sg;
    var e = 32 - $866ae7eda648604d$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $866ae7eda648604d$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $866ae7eda648604d$var$rg = 1 << 32 - $866ae7eda648604d$var$oc(b) + e | c << e | d;
        $866ae7eda648604d$var$sg = f + a;
    } else $866ae7eda648604d$var$rg = 1 << f | c << e | d, $866ae7eda648604d$var$sg = a;
}
function $866ae7eda648604d$var$vg(a) {
    null !== a.return && ($866ae7eda648604d$var$tg(a, 1), $866ae7eda648604d$var$ug(a, 1, 0));
}
function $866ae7eda648604d$var$wg(a) {
    for(; a === $866ae7eda648604d$var$mg;)$866ae7eda648604d$var$mg = $866ae7eda648604d$var$kg[--$866ae7eda648604d$var$lg], $866ae7eda648604d$var$kg[$866ae7eda648604d$var$lg] = null, $866ae7eda648604d$var$ng = $866ae7eda648604d$var$kg[--$866ae7eda648604d$var$lg], $866ae7eda648604d$var$kg[$866ae7eda648604d$var$lg] = null;
    for(; a === $866ae7eda648604d$var$qg;)$866ae7eda648604d$var$qg = $866ae7eda648604d$var$og[--$866ae7eda648604d$var$pg], $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg] = null, $866ae7eda648604d$var$sg = $866ae7eda648604d$var$og[--$866ae7eda648604d$var$pg], $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg] = null, $866ae7eda648604d$var$rg = $866ae7eda648604d$var$og[--$866ae7eda648604d$var$pg], $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg] = null;
}
var $866ae7eda648604d$var$xg = null, $866ae7eda648604d$var$yg = null, $866ae7eda648604d$var$I = !1, $866ae7eda648604d$var$zg = null;
function $866ae7eda648604d$var$Ag(a, b) {
    var c = $866ae7eda648604d$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $866ae7eda648604d$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $866ae7eda648604d$var$xg = a, $866ae7eda648604d$var$yg = $866ae7eda648604d$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $866ae7eda648604d$var$xg = a, $866ae7eda648604d$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $866ae7eda648604d$var$qg ? {
                id: $866ae7eda648604d$var$rg,
                overflow: $866ae7eda648604d$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $866ae7eda648604d$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $866ae7eda648604d$var$xg = a, $866ae7eda648604d$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $866ae7eda648604d$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $866ae7eda648604d$var$Eg(a) {
    if ($866ae7eda648604d$var$I) {
        var b = $866ae7eda648604d$var$yg;
        if (b) {
            var c = b;
            if (!$866ae7eda648604d$var$Cg(a, b)) {
                if ($866ae7eda648604d$var$Dg(a)) throw Error($866ae7eda648604d$var$p(418));
                b = $866ae7eda648604d$var$Lf(c.nextSibling);
                var d = $866ae7eda648604d$var$xg;
                b && $866ae7eda648604d$var$Cg(a, b) ? $866ae7eda648604d$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $866ae7eda648604d$var$I = !1, $866ae7eda648604d$var$xg = a);
            }
        } else {
            if ($866ae7eda648604d$var$Dg(a)) throw Error($866ae7eda648604d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $866ae7eda648604d$var$I = !1;
            $866ae7eda648604d$var$xg = a;
        }
    }
}
function $866ae7eda648604d$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $866ae7eda648604d$var$xg = a;
}
function $866ae7eda648604d$var$Gg(a) {
    if (a !== $866ae7eda648604d$var$xg) return !1;
    if (!$866ae7eda648604d$var$I) return $866ae7eda648604d$var$Fg(a), $866ae7eda648604d$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$866ae7eda648604d$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $866ae7eda648604d$var$yg)) {
        if ($866ae7eda648604d$var$Dg(a)) throw $866ae7eda648604d$var$Hg(), Error($866ae7eda648604d$var$p(418));
        for(; b;)$866ae7eda648604d$var$Ag(a, b), b = $866ae7eda648604d$var$Lf(b.nextSibling);
    }
    $866ae7eda648604d$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($866ae7eda648604d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $866ae7eda648604d$var$yg = $866ae7eda648604d$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $866ae7eda648604d$var$yg = null;
        }
    } else $866ae7eda648604d$var$yg = $866ae7eda648604d$var$xg ? $866ae7eda648604d$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $866ae7eda648604d$var$Hg() {
    for(var a = $866ae7eda648604d$var$yg; a;)a = $866ae7eda648604d$var$Lf(a.nextSibling);
}
function $866ae7eda648604d$var$Ig() {
    $866ae7eda648604d$var$yg = $866ae7eda648604d$var$xg = null;
    $866ae7eda648604d$var$I = !1;
}
function $866ae7eda648604d$var$Jg(a) {
    null === $866ae7eda648604d$var$zg ? $866ae7eda648604d$var$zg = [
        a
    ] : $866ae7eda648604d$var$zg.push(a);
}
var $866ae7eda648604d$var$Kg = $866ae7eda648604d$var$ua.ReactCurrentBatchConfig;
function $866ae7eda648604d$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($866ae7eda648604d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($866ae7eda648604d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($866ae7eda648604d$var$p(284));
        if (!c._owner) throw Error($866ae7eda648604d$var$p(290, a));
    }
    return a;
}
function $866ae7eda648604d$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($866ae7eda648604d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $866ae7eda648604d$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $866ae7eda648604d$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $866ae7eda648604d$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $866ae7eda648604d$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $866ae7eda648604d$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $866ae7eda648604d$var$Ha && $866ae7eda648604d$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $866ae7eda648604d$var$Lg(a, b, c), d.return = a, d;
        d = $866ae7eda648604d$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $866ae7eda648604d$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $866ae7eda648604d$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $866ae7eda648604d$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $866ae7eda648604d$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $866ae7eda648604d$var$va:
                    return c = $866ae7eda648604d$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $866ae7eda648604d$var$Lg(a, null, b), c.return = a, c;
                case $866ae7eda648604d$var$wa:
                    return b = $866ae7eda648604d$var$Sg(b, a.mode, c), b.return = a, b;
                case $866ae7eda648604d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($866ae7eda648604d$var$eb(b) || $866ae7eda648604d$var$Ka(b)) return b = $866ae7eda648604d$var$Tg(b, a.mode, c, null), b.return = a, b;
            $866ae7eda648604d$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $866ae7eda648604d$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $866ae7eda648604d$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $866ae7eda648604d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($866ae7eda648604d$var$eb(c) || $866ae7eda648604d$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $866ae7eda648604d$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $866ae7eda648604d$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $866ae7eda648604d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $866ae7eda648604d$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($866ae7eda648604d$var$eb(d) || $866ae7eda648604d$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $866ae7eda648604d$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $866ae7eda648604d$var$I && $866ae7eda648604d$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $866ae7eda648604d$var$I && $866ae7eda648604d$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $866ae7eda648604d$var$I && $866ae7eda648604d$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $866ae7eda648604d$var$Ka(h);
        if ("function" !== typeof l) throw Error($866ae7eda648604d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($866ae7eda648604d$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $866ae7eda648604d$var$I && $866ae7eda648604d$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $866ae7eda648604d$var$I && $866ae7eda648604d$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $866ae7eda648604d$var$I && $866ae7eda648604d$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $866ae7eda648604d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $866ae7eda648604d$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $866ae7eda648604d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $866ae7eda648604d$var$Ha && $866ae7eda648604d$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $866ae7eda648604d$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $866ae7eda648604d$var$ya ? (d = $866ae7eda648604d$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $866ae7eda648604d$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $866ae7eda648604d$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $866ae7eda648604d$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $866ae7eda648604d$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $866ae7eda648604d$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($866ae7eda648604d$var$eb(f)) return n(a, d, f, h);
            if ($866ae7eda648604d$var$Ka(f)) return t(a, d, f, h);
            $866ae7eda648604d$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $866ae7eda648604d$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $866ae7eda648604d$var$Ug = $866ae7eda648604d$var$Og(!0), $866ae7eda648604d$var$Vg = $866ae7eda648604d$var$Og(!1), $866ae7eda648604d$var$Wg = $866ae7eda648604d$var$Uf(null), $866ae7eda648604d$var$Xg = null, $866ae7eda648604d$var$Yg = null, $866ae7eda648604d$var$Zg = null;
function $866ae7eda648604d$var$$g() {
    $866ae7eda648604d$var$Zg = $866ae7eda648604d$var$Yg = $866ae7eda648604d$var$Xg = null;
}
function $866ae7eda648604d$var$ah(a) {
    var b = $866ae7eda648604d$var$Wg.current;
    $866ae7eda648604d$var$E($866ae7eda648604d$var$Wg);
    a._currentValue = b;
}
function $866ae7eda648604d$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $866ae7eda648604d$var$ch(a, b) {
    $866ae7eda648604d$var$Xg = a;
    $866ae7eda648604d$var$Zg = $866ae7eda648604d$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($866ae7eda648604d$var$dh = !0), a.firstContext = null);
}
function $866ae7eda648604d$var$eh(a) {
    var b = a._currentValue;
    if ($866ae7eda648604d$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $866ae7eda648604d$var$Yg) {
            if (null === $866ae7eda648604d$var$Xg) throw Error($866ae7eda648604d$var$p(308));
            $866ae7eda648604d$var$Yg = a;
            $866ae7eda648604d$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $866ae7eda648604d$var$Yg = $866ae7eda648604d$var$Yg.next = a;
    }
    return b;
}
var $866ae7eda648604d$var$fh = null;
function $866ae7eda648604d$var$gh(a) {
    null === $866ae7eda648604d$var$fh ? $866ae7eda648604d$var$fh = [
        a
    ] : $866ae7eda648604d$var$fh.push(a);
}
function $866ae7eda648604d$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $866ae7eda648604d$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $866ae7eda648604d$var$ih(a, d);
}
function $866ae7eda648604d$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $866ae7eda648604d$var$jh = !1;
function $866ae7eda648604d$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $866ae7eda648604d$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $866ae7eda648604d$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $866ae7eda648604d$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($866ae7eda648604d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $866ae7eda648604d$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $866ae7eda648604d$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $866ae7eda648604d$var$ih(a, c);
}
function $866ae7eda648604d$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $866ae7eda648604d$var$Cc(a, c);
    }
}
function $866ae7eda648604d$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $866ae7eda648604d$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $866ae7eda648604d$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $866ae7eda648604d$var$A({}, q, r);
                            break a;
                        case 2:
                            $866ae7eda648604d$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $866ae7eda648604d$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $866ae7eda648604d$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($866ae7eda648604d$var$p(191, e));
            e.call(d);
        }
    }
}
var $866ae7eda648604d$var$th = {}, $866ae7eda648604d$var$uh = $866ae7eda648604d$var$Uf($866ae7eda648604d$var$th), $866ae7eda648604d$var$vh = $866ae7eda648604d$var$Uf($866ae7eda648604d$var$th), $866ae7eda648604d$var$wh = $866ae7eda648604d$var$Uf($866ae7eda648604d$var$th);
function $866ae7eda648604d$var$xh(a) {
    if (a === $866ae7eda648604d$var$th) throw Error($866ae7eda648604d$var$p(174));
    return a;
}
function $866ae7eda648604d$var$yh(a, b) {
    $866ae7eda648604d$var$G($866ae7eda648604d$var$wh, b);
    $866ae7eda648604d$var$G($866ae7eda648604d$var$vh, a);
    $866ae7eda648604d$var$G($866ae7eda648604d$var$uh, $866ae7eda648604d$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $866ae7eda648604d$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $866ae7eda648604d$var$lb(b, a);
    }
    $866ae7eda648604d$var$E($866ae7eda648604d$var$uh);
    $866ae7eda648604d$var$G($866ae7eda648604d$var$uh, b);
}
function $866ae7eda648604d$var$zh() {
    $866ae7eda648604d$var$E($866ae7eda648604d$var$uh);
    $866ae7eda648604d$var$E($866ae7eda648604d$var$vh);
    $866ae7eda648604d$var$E($866ae7eda648604d$var$wh);
}
function $866ae7eda648604d$var$Ah(a) {
    $866ae7eda648604d$var$xh($866ae7eda648604d$var$wh.current);
    var b = $866ae7eda648604d$var$xh($866ae7eda648604d$var$uh.current);
    var c = $866ae7eda648604d$var$lb(b, a.type);
    b !== c && ($866ae7eda648604d$var$G($866ae7eda648604d$var$vh, a), $866ae7eda648604d$var$G($866ae7eda648604d$var$uh, c));
}
function $866ae7eda648604d$var$Bh(a) {
    $866ae7eda648604d$var$vh.current === a && ($866ae7eda648604d$var$E($866ae7eda648604d$var$uh), $866ae7eda648604d$var$E($866ae7eda648604d$var$vh));
}
var $866ae7eda648604d$var$L = $866ae7eda648604d$var$Uf(0);
function $866ae7eda648604d$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $866ae7eda648604d$var$Dh = [];
function $866ae7eda648604d$var$Eh() {
    for(var a = 0; a < $866ae7eda648604d$var$Dh.length; a++)$866ae7eda648604d$var$Dh[a]._workInProgressVersionPrimary = null;
    $866ae7eda648604d$var$Dh.length = 0;
}
var $866ae7eda648604d$var$Fh = $866ae7eda648604d$var$ua.ReactCurrentDispatcher, $866ae7eda648604d$var$Gh = $866ae7eda648604d$var$ua.ReactCurrentBatchConfig, $866ae7eda648604d$var$Hh = 0, $866ae7eda648604d$var$M = null, $866ae7eda648604d$var$N = null, $866ae7eda648604d$var$O = null, $866ae7eda648604d$var$Ih = !1, $866ae7eda648604d$var$Jh = !1, $866ae7eda648604d$var$Kh = 0, $866ae7eda648604d$var$Lh = 0;
function $866ae7eda648604d$var$P() {
    throw Error($866ae7eda648604d$var$p(321));
}
function $866ae7eda648604d$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$866ae7eda648604d$var$He(a[c], b[c])) return !1;
    return !0;
}
function $866ae7eda648604d$var$Nh(a, b, c, d, e, f) {
    $866ae7eda648604d$var$Hh = f;
    $866ae7eda648604d$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $866ae7eda648604d$var$Fh.current = null === a || null === a.memoizedState ? $866ae7eda648604d$var$Oh : $866ae7eda648604d$var$Ph;
    a = c(d, e);
    if ($866ae7eda648604d$var$Jh) {
        f = 0;
        do {
            $866ae7eda648604d$var$Jh = !1;
            $866ae7eda648604d$var$Kh = 0;
            if (25 <= f) throw Error($866ae7eda648604d$var$p(301));
            f += 1;
            $866ae7eda648604d$var$O = $866ae7eda648604d$var$N = null;
            b.updateQueue = null;
            $866ae7eda648604d$var$Fh.current = $866ae7eda648604d$var$Qh;
            a = c(d, e);
        }while ($866ae7eda648604d$var$Jh);
    }
    $866ae7eda648604d$var$Fh.current = $866ae7eda648604d$var$Rh;
    b = null !== $866ae7eda648604d$var$N && null !== $866ae7eda648604d$var$N.next;
    $866ae7eda648604d$var$Hh = 0;
    $866ae7eda648604d$var$O = $866ae7eda648604d$var$N = $866ae7eda648604d$var$M = null;
    $866ae7eda648604d$var$Ih = !1;
    if (b) throw Error($866ae7eda648604d$var$p(300));
    return a;
}
function $866ae7eda648604d$var$Sh() {
    var a = 0 !== $866ae7eda648604d$var$Kh;
    $866ae7eda648604d$var$Kh = 0;
    return a;
}
function $866ae7eda648604d$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $866ae7eda648604d$var$O ? $866ae7eda648604d$var$M.memoizedState = $866ae7eda648604d$var$O = a : $866ae7eda648604d$var$O = $866ae7eda648604d$var$O.next = a;
    return $866ae7eda648604d$var$O;
}
function $866ae7eda648604d$var$Uh() {
    if (null === $866ae7eda648604d$var$N) {
        var a = $866ae7eda648604d$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $866ae7eda648604d$var$N.next;
    var b = null === $866ae7eda648604d$var$O ? $866ae7eda648604d$var$M.memoizedState : $866ae7eda648604d$var$O.next;
    if (null !== b) $866ae7eda648604d$var$O = b, $866ae7eda648604d$var$N = a;
    else {
        if (null === a) throw Error($866ae7eda648604d$var$p(310));
        $866ae7eda648604d$var$N = a;
        a = {
            memoizedState: $866ae7eda648604d$var$N.memoizedState,
            baseState: $866ae7eda648604d$var$N.baseState,
            baseQueue: $866ae7eda648604d$var$N.baseQueue,
            queue: $866ae7eda648604d$var$N.queue,
            next: null
        };
        null === $866ae7eda648604d$var$O ? $866ae7eda648604d$var$M.memoizedState = $866ae7eda648604d$var$O = a : $866ae7eda648604d$var$O = $866ae7eda648604d$var$O.next = a;
    }
    return $866ae7eda648604d$var$O;
}
function $866ae7eda648604d$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $866ae7eda648604d$var$Wh(a) {
    var b = $866ae7eda648604d$var$Uh(), c = b.queue;
    if (null === c) throw Error($866ae7eda648604d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $866ae7eda648604d$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($866ae7eda648604d$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $866ae7eda648604d$var$M.lanes |= m;
                $866ae7eda648604d$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $866ae7eda648604d$var$He(d, b.memoizedState) || ($866ae7eda648604d$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $866ae7eda648604d$var$M.lanes |= f, $866ae7eda648604d$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $866ae7eda648604d$var$Xh(a) {
    var b = $866ae7eda648604d$var$Uh(), c = b.queue;
    if (null === c) throw Error($866ae7eda648604d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $866ae7eda648604d$var$He(f, b.memoizedState) || ($866ae7eda648604d$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $866ae7eda648604d$var$Yh() {}
function $866ae7eda648604d$var$Zh(a, b) {
    var c = $866ae7eda648604d$var$M, d = $866ae7eda648604d$var$Uh(), e = b(), f = !$866ae7eda648604d$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $866ae7eda648604d$var$dh = !0);
    d = d.queue;
    $866ae7eda648604d$var$$h($866ae7eda648604d$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $866ae7eda648604d$var$O && $866ae7eda648604d$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $866ae7eda648604d$var$bi(9, $866ae7eda648604d$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $866ae7eda648604d$var$Q) throw Error($866ae7eda648604d$var$p(349));
        0 !== ($866ae7eda648604d$var$Hh & 30) || $866ae7eda648604d$var$di(c, b, e);
    }
    return e;
}
function $866ae7eda648604d$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $866ae7eda648604d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $866ae7eda648604d$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $866ae7eda648604d$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $866ae7eda648604d$var$ei(b) && $866ae7eda648604d$var$fi(a);
}
function $866ae7eda648604d$var$ai(a, b, c) {
    return c(function() {
        $866ae7eda648604d$var$ei(b) && $866ae7eda648604d$var$fi(a);
    });
}
function $866ae7eda648604d$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$866ae7eda648604d$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $866ae7eda648604d$var$fi(a) {
    var b = $866ae7eda648604d$var$ih(a, 1);
    null !== b && $866ae7eda648604d$var$gi(b, a, 1, -1);
}
function $866ae7eda648604d$var$hi(a) {
    var b = $866ae7eda648604d$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $866ae7eda648604d$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $866ae7eda648604d$var$ii.bind(null, $866ae7eda648604d$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $866ae7eda648604d$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $866ae7eda648604d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $866ae7eda648604d$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $866ae7eda648604d$var$ji() {
    return $866ae7eda648604d$var$Uh().memoizedState;
}
function $866ae7eda648604d$var$ki(a, b, c, d) {
    var e = $866ae7eda648604d$var$Th();
    $866ae7eda648604d$var$M.flags |= a;
    e.memoizedState = $866ae7eda648604d$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $866ae7eda648604d$var$li(a, b, c, d) {
    var e = $866ae7eda648604d$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $866ae7eda648604d$var$N) {
        var g = $866ae7eda648604d$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $866ae7eda648604d$var$Mh(d, g.deps)) {
            e.memoizedState = $866ae7eda648604d$var$bi(b, c, f, d);
            return;
        }
    }
    $866ae7eda648604d$var$M.flags |= a;
    e.memoizedState = $866ae7eda648604d$var$bi(1 | b, c, f, d);
}
function $866ae7eda648604d$var$mi(a, b) {
    return $866ae7eda648604d$var$ki(8390656, 8, a, b);
}
function $866ae7eda648604d$var$$h(a, b) {
    return $866ae7eda648604d$var$li(2048, 8, a, b);
}
function $866ae7eda648604d$var$ni(a, b) {
    return $866ae7eda648604d$var$li(4, 2, a, b);
}
function $866ae7eda648604d$var$oi(a, b) {
    return $866ae7eda648604d$var$li(4, 4, a, b);
}
function $866ae7eda648604d$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $866ae7eda648604d$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $866ae7eda648604d$var$li(4, 4, $866ae7eda648604d$var$pi.bind(null, b, a), c);
}
function $866ae7eda648604d$var$ri() {}
function $866ae7eda648604d$var$si(a, b) {
    var c = $866ae7eda648604d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $866ae7eda648604d$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $866ae7eda648604d$var$ti(a, b) {
    var c = $866ae7eda648604d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $866ae7eda648604d$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $866ae7eda648604d$var$ui(a, b, c) {
    if (0 === ($866ae7eda648604d$var$Hh & 21)) return a.baseState && (a.baseState = !1, $866ae7eda648604d$var$dh = !0), a.memoizedState = c;
    $866ae7eda648604d$var$He(c, b) || (c = $866ae7eda648604d$var$yc(), $866ae7eda648604d$var$M.lanes |= c, $866ae7eda648604d$var$rh |= c, a.baseState = !0);
    return b;
}
function $866ae7eda648604d$var$vi(a, b) {
    var c = $866ae7eda648604d$var$C;
    $866ae7eda648604d$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $866ae7eda648604d$var$Gh.transition;
    $866ae7eda648604d$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $866ae7eda648604d$var$C = c, $866ae7eda648604d$var$Gh.transition = d;
    }
}
function $866ae7eda648604d$var$wi() {
    return $866ae7eda648604d$var$Uh().memoizedState;
}
function $866ae7eda648604d$var$xi(a, b, c) {
    var d = $866ae7eda648604d$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($866ae7eda648604d$var$zi(a)) $866ae7eda648604d$var$Ai(b, c);
    else if (c = $866ae7eda648604d$var$hh(a, b, c, d), null !== c) {
        var e = $866ae7eda648604d$var$R();
        $866ae7eda648604d$var$gi(c, a, d, e);
        $866ae7eda648604d$var$Bi(c, b, d);
    }
}
function $866ae7eda648604d$var$ii(a, b, c) {
    var d = $866ae7eda648604d$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($866ae7eda648604d$var$zi(a)) $866ae7eda648604d$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($866ae7eda648604d$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $866ae7eda648604d$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $866ae7eda648604d$var$hh(a, b, e, d);
        null !== c && (e = $866ae7eda648604d$var$R(), $866ae7eda648604d$var$gi(c, a, d, e), $866ae7eda648604d$var$Bi(c, b, d));
    }
}
function $866ae7eda648604d$var$zi(a) {
    var b = a.alternate;
    return a === $866ae7eda648604d$var$M || null !== b && b === $866ae7eda648604d$var$M;
}
function $866ae7eda648604d$var$Ai(a, b) {
    $866ae7eda648604d$var$Jh = $866ae7eda648604d$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $866ae7eda648604d$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $866ae7eda648604d$var$Cc(a, c);
    }
}
var $866ae7eda648604d$var$Rh = {
    readContext: $866ae7eda648604d$var$eh,
    useCallback: $866ae7eda648604d$var$P,
    useContext: $866ae7eda648604d$var$P,
    useEffect: $866ae7eda648604d$var$P,
    useImperativeHandle: $866ae7eda648604d$var$P,
    useInsertionEffect: $866ae7eda648604d$var$P,
    useLayoutEffect: $866ae7eda648604d$var$P,
    useMemo: $866ae7eda648604d$var$P,
    useReducer: $866ae7eda648604d$var$P,
    useRef: $866ae7eda648604d$var$P,
    useState: $866ae7eda648604d$var$P,
    useDebugValue: $866ae7eda648604d$var$P,
    useDeferredValue: $866ae7eda648604d$var$P,
    useTransition: $866ae7eda648604d$var$P,
    useMutableSource: $866ae7eda648604d$var$P,
    useSyncExternalStore: $866ae7eda648604d$var$P,
    useId: $866ae7eda648604d$var$P,
    unstable_isNewReconciler: !1
}, $866ae7eda648604d$var$Oh = {
    readContext: $866ae7eda648604d$var$eh,
    useCallback: function(a, b) {
        $866ae7eda648604d$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $866ae7eda648604d$var$eh,
    useEffect: $866ae7eda648604d$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $866ae7eda648604d$var$ki(4194308, 4, $866ae7eda648604d$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $866ae7eda648604d$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $866ae7eda648604d$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $866ae7eda648604d$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $866ae7eda648604d$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $866ae7eda648604d$var$xi.bind(null, $866ae7eda648604d$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $866ae7eda648604d$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $866ae7eda648604d$var$hi,
    useDebugValue: $866ae7eda648604d$var$ri,
    useDeferredValue: function(a) {
        return $866ae7eda648604d$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $866ae7eda648604d$var$hi(!1), b = a[0];
        a = $866ae7eda648604d$var$vi.bind(null, a[1]);
        $866ae7eda648604d$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $866ae7eda648604d$var$M, e = $866ae7eda648604d$var$Th();
        if ($866ae7eda648604d$var$I) {
            if (void 0 === c) throw Error($866ae7eda648604d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $866ae7eda648604d$var$Q) throw Error($866ae7eda648604d$var$p(349));
            0 !== ($866ae7eda648604d$var$Hh & 30) || $866ae7eda648604d$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $866ae7eda648604d$var$mi($866ae7eda648604d$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $866ae7eda648604d$var$bi(9, $866ae7eda648604d$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $866ae7eda648604d$var$Th(), b = $866ae7eda648604d$var$Q.identifierPrefix;
        if ($866ae7eda648604d$var$I) {
            var c = $866ae7eda648604d$var$sg;
            var d = $866ae7eda648604d$var$rg;
            c = (d & ~(1 << 32 - $866ae7eda648604d$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $866ae7eda648604d$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $866ae7eda648604d$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $866ae7eda648604d$var$Ph = {
    readContext: $866ae7eda648604d$var$eh,
    useCallback: $866ae7eda648604d$var$si,
    useContext: $866ae7eda648604d$var$eh,
    useEffect: $866ae7eda648604d$var$$h,
    useImperativeHandle: $866ae7eda648604d$var$qi,
    useInsertionEffect: $866ae7eda648604d$var$ni,
    useLayoutEffect: $866ae7eda648604d$var$oi,
    useMemo: $866ae7eda648604d$var$ti,
    useReducer: $866ae7eda648604d$var$Wh,
    useRef: $866ae7eda648604d$var$ji,
    useState: function() {
        return $866ae7eda648604d$var$Wh($866ae7eda648604d$var$Vh);
    },
    useDebugValue: $866ae7eda648604d$var$ri,
    useDeferredValue: function(a) {
        var b = $866ae7eda648604d$var$Uh();
        return $866ae7eda648604d$var$ui(b, $866ae7eda648604d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $866ae7eda648604d$var$Wh($866ae7eda648604d$var$Vh)[0], b = $866ae7eda648604d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $866ae7eda648604d$var$Yh,
    useSyncExternalStore: $866ae7eda648604d$var$Zh,
    useId: $866ae7eda648604d$var$wi,
    unstable_isNewReconciler: !1
}, $866ae7eda648604d$var$Qh = {
    readContext: $866ae7eda648604d$var$eh,
    useCallback: $866ae7eda648604d$var$si,
    useContext: $866ae7eda648604d$var$eh,
    useEffect: $866ae7eda648604d$var$$h,
    useImperativeHandle: $866ae7eda648604d$var$qi,
    useInsertionEffect: $866ae7eda648604d$var$ni,
    useLayoutEffect: $866ae7eda648604d$var$oi,
    useMemo: $866ae7eda648604d$var$ti,
    useReducer: $866ae7eda648604d$var$Xh,
    useRef: $866ae7eda648604d$var$ji,
    useState: function() {
        return $866ae7eda648604d$var$Xh($866ae7eda648604d$var$Vh);
    },
    useDebugValue: $866ae7eda648604d$var$ri,
    useDeferredValue: function(a) {
        var b = $866ae7eda648604d$var$Uh();
        return null === $866ae7eda648604d$var$N ? b.memoizedState = a : $866ae7eda648604d$var$ui(b, $866ae7eda648604d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $866ae7eda648604d$var$Xh($866ae7eda648604d$var$Vh)[0], b = $866ae7eda648604d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $866ae7eda648604d$var$Yh,
    useSyncExternalStore: $866ae7eda648604d$var$Zh,
    useId: $866ae7eda648604d$var$wi,
    unstable_isNewReconciler: !1
};
function $866ae7eda648604d$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $866ae7eda648604d$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $866ae7eda648604d$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $866ae7eda648604d$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $866ae7eda648604d$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $866ae7eda648604d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $866ae7eda648604d$var$R(), e = $866ae7eda648604d$var$yi(a), f = $866ae7eda648604d$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $866ae7eda648604d$var$nh(a, f, e);
        null !== b && ($866ae7eda648604d$var$gi(b, a, e, d), $866ae7eda648604d$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $866ae7eda648604d$var$R(), e = $866ae7eda648604d$var$yi(a), f = $866ae7eda648604d$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $866ae7eda648604d$var$nh(a, f, e);
        null !== b && ($866ae7eda648604d$var$gi(b, a, e, d), $866ae7eda648604d$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $866ae7eda648604d$var$R(), d = $866ae7eda648604d$var$yi(a), e = $866ae7eda648604d$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $866ae7eda648604d$var$nh(a, e, d);
        null !== b && ($866ae7eda648604d$var$gi(b, a, d, c), $866ae7eda648604d$var$oh(b, a, d));
    }
};
function $866ae7eda648604d$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$866ae7eda648604d$var$Ie(c, d) || !$866ae7eda648604d$var$Ie(e, f) : !0;
}
function $866ae7eda648604d$var$Gi(a, b, c) {
    var d = !1, e = $866ae7eda648604d$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $866ae7eda648604d$var$eh(f) : (e = $866ae7eda648604d$var$Zf(b) ? $866ae7eda648604d$var$Xf : $866ae7eda648604d$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $866ae7eda648604d$var$Yf(a, e) : $866ae7eda648604d$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $866ae7eda648604d$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $866ae7eda648604d$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $866ae7eda648604d$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $866ae7eda648604d$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $866ae7eda648604d$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $866ae7eda648604d$var$eh(f) : (f = $866ae7eda648604d$var$Zf(b) ? $866ae7eda648604d$var$Xf : $866ae7eda648604d$var$H.current, e.context = $866ae7eda648604d$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($866ae7eda648604d$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $866ae7eda648604d$var$Ei.enqueueReplaceState(e, e.state, null), $866ae7eda648604d$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $866ae7eda648604d$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $866ae7eda648604d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $866ae7eda648604d$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $866ae7eda648604d$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $866ae7eda648604d$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $866ae7eda648604d$var$Ni(a, b, c) {
    c = $866ae7eda648604d$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $866ae7eda648604d$var$Oi || ($866ae7eda648604d$var$Oi = !0, $866ae7eda648604d$var$Pi = d);
        $866ae7eda648604d$var$Li(a, b);
    };
    return c;
}
function $866ae7eda648604d$var$Qi(a, b, c) {
    c = $866ae7eda648604d$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $866ae7eda648604d$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $866ae7eda648604d$var$Li(a, b);
        "function" !== typeof d && (null === $866ae7eda648604d$var$Ri ? $866ae7eda648604d$var$Ri = new Set([
            this
        ]) : $866ae7eda648604d$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $866ae7eda648604d$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $866ae7eda648604d$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $866ae7eda648604d$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $866ae7eda648604d$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $866ae7eda648604d$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $866ae7eda648604d$var$mh(-1, 1), b.tag = 2, $866ae7eda648604d$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $866ae7eda648604d$var$Wi = $866ae7eda648604d$var$ua.ReactCurrentOwner, $866ae7eda648604d$var$dh = !1;
function $866ae7eda648604d$var$Xi(a, b, c, d) {
    b.child = null === a ? $866ae7eda648604d$var$Vg(b, null, c, d) : $866ae7eda648604d$var$Ug(b, a.child, c, d);
}
function $866ae7eda648604d$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $866ae7eda648604d$var$ch(b, e);
    d = $866ae7eda648604d$var$Nh(a, b, c, d, f, e);
    c = $866ae7eda648604d$var$Sh();
    if (null !== a && !$866ae7eda648604d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $866ae7eda648604d$var$Zi(a, b, e);
    $866ae7eda648604d$var$I && c && $866ae7eda648604d$var$vg(b);
    b.flags |= 1;
    $866ae7eda648604d$var$Xi(a, b, d, e);
    return b.child;
}
function $866ae7eda648604d$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$866ae7eda648604d$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $866ae7eda648604d$var$bj(a, b, f, d, e);
        a = $866ae7eda648604d$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $866ae7eda648604d$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $866ae7eda648604d$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $866ae7eda648604d$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $866ae7eda648604d$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($866ae7eda648604d$var$Ie(f, d) && a.ref === b.ref) {
            if ($866ae7eda648604d$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($866ae7eda648604d$var$dh = !0);
            else return b.lanes = a.lanes, $866ae7eda648604d$var$Zi(a, b, e);
        }
    }
    return $866ae7eda648604d$var$cj(a, b, c, d, e);
}
function $866ae7eda648604d$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $866ae7eda648604d$var$G($866ae7eda648604d$var$ej, $866ae7eda648604d$var$fj), $866ae7eda648604d$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $866ae7eda648604d$var$G($866ae7eda648604d$var$ej, $866ae7eda648604d$var$fj), $866ae7eda648604d$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $866ae7eda648604d$var$G($866ae7eda648604d$var$ej, $866ae7eda648604d$var$fj);
            $866ae7eda648604d$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $866ae7eda648604d$var$G($866ae7eda648604d$var$ej, $866ae7eda648604d$var$fj), $866ae7eda648604d$var$fj |= d;
    $866ae7eda648604d$var$Xi(a, b, e, c);
    return b.child;
}
function $866ae7eda648604d$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $866ae7eda648604d$var$cj(a, b, c, d, e) {
    var f = $866ae7eda648604d$var$Zf(c) ? $866ae7eda648604d$var$Xf : $866ae7eda648604d$var$H.current;
    f = $866ae7eda648604d$var$Yf(b, f);
    $866ae7eda648604d$var$ch(b, e);
    c = $866ae7eda648604d$var$Nh(a, b, c, d, f, e);
    d = $866ae7eda648604d$var$Sh();
    if (null !== a && !$866ae7eda648604d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $866ae7eda648604d$var$Zi(a, b, e);
    $866ae7eda648604d$var$I && d && $866ae7eda648604d$var$vg(b);
    b.flags |= 1;
    $866ae7eda648604d$var$Xi(a, b, c, e);
    return b.child;
}
function $866ae7eda648604d$var$hj(a, b, c, d, e) {
    if ($866ae7eda648604d$var$Zf(c)) {
        var f = !0;
        $866ae7eda648604d$var$cg(b);
    } else f = !1;
    $866ae7eda648604d$var$ch(b, e);
    if (null === b.stateNode) $866ae7eda648604d$var$ij(a, b), $866ae7eda648604d$var$Gi(b, c, d), $866ae7eda648604d$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $866ae7eda648604d$var$eh(l) : (l = $866ae7eda648604d$var$Zf(c) ? $866ae7eda648604d$var$Xf : $866ae7eda648604d$var$H.current, l = $866ae7eda648604d$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $866ae7eda648604d$var$Hi(b, g, d, l);
        $866ae7eda648604d$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $866ae7eda648604d$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $866ae7eda648604d$var$Wf.current || $866ae7eda648604d$var$jh ? ("function" === typeof m && ($866ae7eda648604d$var$Di(b, c, m, d), k = b.memoizedState), (h = $866ae7eda648604d$var$jh || $866ae7eda648604d$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $866ae7eda648604d$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $866ae7eda648604d$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $866ae7eda648604d$var$eh(k) : (k = $866ae7eda648604d$var$Zf(c) ? $866ae7eda648604d$var$Xf : $866ae7eda648604d$var$H.current, k = $866ae7eda648604d$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $866ae7eda648604d$var$Hi(b, g, d, k);
        $866ae7eda648604d$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $866ae7eda648604d$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $866ae7eda648604d$var$Wf.current || $866ae7eda648604d$var$jh ? ("function" === typeof y && ($866ae7eda648604d$var$Di(b, c, y, d), n = b.memoizedState), (l = $866ae7eda648604d$var$jh || $866ae7eda648604d$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $866ae7eda648604d$var$jj(a, b, c, d, f, e);
}
function $866ae7eda648604d$var$jj(a, b, c, d, e, f) {
    $866ae7eda648604d$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $866ae7eda648604d$var$dg(b, c, !1), $866ae7eda648604d$var$Zi(a, b, f);
    d = b.stateNode;
    $866ae7eda648604d$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $866ae7eda648604d$var$Ug(b, a.child, null, f), b.child = $866ae7eda648604d$var$Ug(b, null, h, f)) : $866ae7eda648604d$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $866ae7eda648604d$var$dg(b, c, !0);
    return b.child;
}
function $866ae7eda648604d$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $866ae7eda648604d$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $866ae7eda648604d$var$ag(a, b.context, !1);
    $866ae7eda648604d$var$yh(a, b.containerInfo);
}
function $866ae7eda648604d$var$lj(a, b, c, d, e) {
    $866ae7eda648604d$var$Ig();
    $866ae7eda648604d$var$Jg(e);
    b.flags |= 256;
    $866ae7eda648604d$var$Xi(a, b, c, d);
    return b.child;
}
var $866ae7eda648604d$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $866ae7eda648604d$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $866ae7eda648604d$var$oj(a, b, c) {
    var d = b.pendingProps, e = $866ae7eda648604d$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $866ae7eda648604d$var$G($866ae7eda648604d$var$L, e & 1);
    if (null === a) {
        $866ae7eda648604d$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $866ae7eda648604d$var$pj(g, d, 0, null), a = $866ae7eda648604d$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $866ae7eda648604d$var$nj(c), b.memoizedState = $866ae7eda648604d$var$mj, a) : $866ae7eda648604d$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $866ae7eda648604d$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $866ae7eda648604d$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $866ae7eda648604d$var$Pg(h, f) : (f = $866ae7eda648604d$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $866ae7eda648604d$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $866ae7eda648604d$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $866ae7eda648604d$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $866ae7eda648604d$var$qj(a, b) {
    b = $866ae7eda648604d$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $866ae7eda648604d$var$sj(a, b, c, d) {
    null !== d && $866ae7eda648604d$var$Jg(d);
    $866ae7eda648604d$var$Ug(b, a.child, null, c);
    a = $866ae7eda648604d$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $866ae7eda648604d$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $866ae7eda648604d$var$Ki(Error($866ae7eda648604d$var$p(422))), $866ae7eda648604d$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $866ae7eda648604d$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $866ae7eda648604d$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $866ae7eda648604d$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $866ae7eda648604d$var$nj(g);
        b.memoizedState = $866ae7eda648604d$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $866ae7eda648604d$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($866ae7eda648604d$var$p(419));
        d = $866ae7eda648604d$var$Ki(f, d, void 0);
        return $866ae7eda648604d$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($866ae7eda648604d$var$dh || h) {
        d = $866ae7eda648604d$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $866ae7eda648604d$var$ih(a, e), $866ae7eda648604d$var$gi(d, a, e, -1));
        }
        $866ae7eda648604d$var$tj();
        d = $866ae7eda648604d$var$Ki(Error($866ae7eda648604d$var$p(421)));
        return $866ae7eda648604d$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $866ae7eda648604d$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $866ae7eda648604d$var$yg = $866ae7eda648604d$var$Lf(e.nextSibling);
    $866ae7eda648604d$var$xg = b;
    $866ae7eda648604d$var$I = !0;
    $866ae7eda648604d$var$zg = null;
    null !== a && ($866ae7eda648604d$var$og[$866ae7eda648604d$var$pg++] = $866ae7eda648604d$var$rg, $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg++] = $866ae7eda648604d$var$sg, $866ae7eda648604d$var$og[$866ae7eda648604d$var$pg++] = $866ae7eda648604d$var$qg, $866ae7eda648604d$var$rg = a.id, $866ae7eda648604d$var$sg = a.overflow, $866ae7eda648604d$var$qg = b);
    b = $866ae7eda648604d$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $866ae7eda648604d$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $866ae7eda648604d$var$bh(a.return, b, c);
}
function $866ae7eda648604d$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $866ae7eda648604d$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $866ae7eda648604d$var$Xi(a, b, d.children, c);
    d = $866ae7eda648604d$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $866ae7eda648604d$var$vj(a, c, b);
            else if (19 === a.tag) $866ae7eda648604d$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $866ae7eda648604d$var$G($866ae7eda648604d$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $866ae7eda648604d$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $866ae7eda648604d$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $866ae7eda648604d$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $866ae7eda648604d$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $866ae7eda648604d$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $866ae7eda648604d$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $866ae7eda648604d$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $866ae7eda648604d$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($866ae7eda648604d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $866ae7eda648604d$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $866ae7eda648604d$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $866ae7eda648604d$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $866ae7eda648604d$var$kj(b);
            $866ae7eda648604d$var$Ig();
            break;
        case 5:
            $866ae7eda648604d$var$Ah(b);
            break;
        case 1:
            $866ae7eda648604d$var$Zf(b.type) && $866ae7eda648604d$var$cg(b);
            break;
        case 4:
            $866ae7eda648604d$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $866ae7eda648604d$var$G($866ae7eda648604d$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $866ae7eda648604d$var$G($866ae7eda648604d$var$L, $866ae7eda648604d$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $866ae7eda648604d$var$oj(a, b, c);
                $866ae7eda648604d$var$G($866ae7eda648604d$var$L, $866ae7eda648604d$var$L.current & 1);
                a = $866ae7eda648604d$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $866ae7eda648604d$var$G($866ae7eda648604d$var$L, $866ae7eda648604d$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $866ae7eda648604d$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $866ae7eda648604d$var$G($866ae7eda648604d$var$L, $866ae7eda648604d$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $866ae7eda648604d$var$dj(a, b, c);
    }
    return $866ae7eda648604d$var$Zi(a, b, c);
}
var $866ae7eda648604d$var$zj, $866ae7eda648604d$var$Aj, $866ae7eda648604d$var$Bj, $866ae7eda648604d$var$Cj;
$866ae7eda648604d$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$866ae7eda648604d$var$Aj = function() {};
$866ae7eda648604d$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $866ae7eda648604d$var$xh($866ae7eda648604d$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $866ae7eda648604d$var$Ya(a, e);
                d = $866ae7eda648604d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $866ae7eda648604d$var$A({}, e, {
                    value: void 0
                });
                d = $866ae7eda648604d$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $866ae7eda648604d$var$gb(a, e);
                d = $866ae7eda648604d$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $866ae7eda648604d$var$Bf);
        }
        $866ae7eda648604d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($866ae7eda648604d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($866ae7eda648604d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $866ae7eda648604d$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$866ae7eda648604d$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $866ae7eda648604d$var$Dj(a, b) {
    if (!$866ae7eda648604d$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $866ae7eda648604d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $866ae7eda648604d$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $866ae7eda648604d$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $866ae7eda648604d$var$S(b), null;
        case 1:
            return $866ae7eda648604d$var$Zf(b.type) && $866ae7eda648604d$var$$f(), $866ae7eda648604d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $866ae7eda648604d$var$zh();
            $866ae7eda648604d$var$E($866ae7eda648604d$var$Wf);
            $866ae7eda648604d$var$E($866ae7eda648604d$var$H);
            $866ae7eda648604d$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $866ae7eda648604d$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $866ae7eda648604d$var$zg && ($866ae7eda648604d$var$Fj($866ae7eda648604d$var$zg), $866ae7eda648604d$var$zg = null));
            $866ae7eda648604d$var$Aj(a, b);
            $866ae7eda648604d$var$S(b);
            return null;
        case 5:
            $866ae7eda648604d$var$Bh(b);
            var e = $866ae7eda648604d$var$xh($866ae7eda648604d$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $866ae7eda648604d$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($866ae7eda648604d$var$p(166));
                    $866ae7eda648604d$var$S(b);
                    return null;
                }
                a = $866ae7eda648604d$var$xh($866ae7eda648604d$var$uh.current);
                if ($866ae7eda648604d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$866ae7eda648604d$var$Of] = b;
                    d[$866ae7eda648604d$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $866ae7eda648604d$var$D("cancel", d);
                            $866ae7eda648604d$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $866ae7eda648604d$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $866ae7eda648604d$var$lf.length; e++)$866ae7eda648604d$var$D($866ae7eda648604d$var$lf[e], d);
                            break;
                        case "source":
                            $866ae7eda648604d$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $866ae7eda648604d$var$D("error", d);
                            $866ae7eda648604d$var$D("load", d);
                            break;
                        case "details":
                            $866ae7eda648604d$var$D("toggle", d);
                            break;
                        case "input":
                            $866ae7eda648604d$var$Za(d, f);
                            $866ae7eda648604d$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $866ae7eda648604d$var$D("invalid", d);
                            break;
                        case "textarea":
                            $866ae7eda648604d$var$hb(d, f), $866ae7eda648604d$var$D("invalid", d);
                    }
                    $866ae7eda648604d$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $866ae7eda648604d$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $866ae7eda648604d$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $866ae7eda648604d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $866ae7eda648604d$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $866ae7eda648604d$var$Va(d);
                            $866ae7eda648604d$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $866ae7eda648604d$var$Va(d);
                            $866ae7eda648604d$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $866ae7eda648604d$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $866ae7eda648604d$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$866ae7eda648604d$var$Of] = b;
                    a[$866ae7eda648604d$var$Pf] = d;
                    $866ae7eda648604d$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $866ae7eda648604d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $866ae7eda648604d$var$D("cancel", a);
                                $866ae7eda648604d$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $866ae7eda648604d$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $866ae7eda648604d$var$lf.length; e++)$866ae7eda648604d$var$D($866ae7eda648604d$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $866ae7eda648604d$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $866ae7eda648604d$var$D("error", a);
                                $866ae7eda648604d$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $866ae7eda648604d$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $866ae7eda648604d$var$Za(a, d);
                                e = $866ae7eda648604d$var$Ya(a, d);
                                $866ae7eda648604d$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $866ae7eda648604d$var$A({}, d, {
                                    value: void 0
                                });
                                $866ae7eda648604d$var$D("invalid", a);
                                break;
                            case "textarea":
                                $866ae7eda648604d$var$hb(a, d);
                                e = $866ae7eda648604d$var$gb(a, d);
                                $866ae7eda648604d$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $866ae7eda648604d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $866ae7eda648604d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $866ae7eda648604d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $866ae7eda648604d$var$ob(a, k) : "number" === typeof k && $866ae7eda648604d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($866ae7eda648604d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $866ae7eda648604d$var$D("scroll", a) : null != k && $866ae7eda648604d$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $866ae7eda648604d$var$Va(a);
                                $866ae7eda648604d$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $866ae7eda648604d$var$Va(a);
                                $866ae7eda648604d$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $866ae7eda648604d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $866ae7eda648604d$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $866ae7eda648604d$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $866ae7eda648604d$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $866ae7eda648604d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $866ae7eda648604d$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($866ae7eda648604d$var$p(166));
                c = $866ae7eda648604d$var$xh($866ae7eda648604d$var$wh.current);
                $866ae7eda648604d$var$xh($866ae7eda648604d$var$uh.current);
                if ($866ae7eda648604d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$866ae7eda648604d$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $866ae7eda648604d$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $866ae7eda648604d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $866ae7eda648604d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$866ae7eda648604d$var$Of] = b, b.stateNode = d;
            }
            $866ae7eda648604d$var$S(b);
            return null;
        case 13:
            $866ae7eda648604d$var$E($866ae7eda648604d$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($866ae7eda648604d$var$I && null !== $866ae7eda648604d$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $866ae7eda648604d$var$Hg(), $866ae7eda648604d$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $866ae7eda648604d$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($866ae7eda648604d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($866ae7eda648604d$var$p(317));
                        f[$866ae7eda648604d$var$Of] = b;
                    } else $866ae7eda648604d$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $866ae7eda648604d$var$S(b);
                    f = !1;
                } else null !== $866ae7eda648604d$var$zg && ($866ae7eda648604d$var$Fj($866ae7eda648604d$var$zg), $866ae7eda648604d$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($866ae7eda648604d$var$L.current & 1) ? 0 === $866ae7eda648604d$var$T && ($866ae7eda648604d$var$T = 3) : $866ae7eda648604d$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $866ae7eda648604d$var$S(b);
            return null;
        case 4:
            return $866ae7eda648604d$var$zh(), $866ae7eda648604d$var$Aj(a, b), null === a && $866ae7eda648604d$var$sf(b.stateNode.containerInfo), $866ae7eda648604d$var$S(b), null;
        case 10:
            return $866ae7eda648604d$var$ah(b.type._context), $866ae7eda648604d$var$S(b), null;
        case 17:
            return $866ae7eda648604d$var$Zf(b.type) && $866ae7eda648604d$var$$f(), $866ae7eda648604d$var$S(b), null;
        case 19:
            $866ae7eda648604d$var$E($866ae7eda648604d$var$L);
            f = b.memoizedState;
            if (null === f) return $866ae7eda648604d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $866ae7eda648604d$var$Dj(f, !1);
                else {
                    if (0 !== $866ae7eda648604d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $866ae7eda648604d$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $866ae7eda648604d$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $866ae7eda648604d$var$G($866ae7eda648604d$var$L, $866ae7eda648604d$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $866ae7eda648604d$var$B() > $866ae7eda648604d$var$Gj && (b.flags |= 128, d = !0, $866ae7eda648604d$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $866ae7eda648604d$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $866ae7eda648604d$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$866ae7eda648604d$var$I) return $866ae7eda648604d$var$S(b), null;
                    } else 2 * $866ae7eda648604d$var$B() - f.renderingStartTime > $866ae7eda648604d$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $866ae7eda648604d$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $866ae7eda648604d$var$B(), b.sibling = null, c = $866ae7eda648604d$var$L.current, $866ae7eda648604d$var$G($866ae7eda648604d$var$L, d ? c & 1 | 2 : c & 1), b;
            $866ae7eda648604d$var$S(b);
            return null;
        case 22:
        case 23:
            return $866ae7eda648604d$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($866ae7eda648604d$var$fj & 1073741824) && ($866ae7eda648604d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $866ae7eda648604d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($866ae7eda648604d$var$p(156, b.tag));
}
function $866ae7eda648604d$var$Ij(a, b) {
    $866ae7eda648604d$var$wg(b);
    switch(b.tag){
        case 1:
            return $866ae7eda648604d$var$Zf(b.type) && $866ae7eda648604d$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $866ae7eda648604d$var$zh(), $866ae7eda648604d$var$E($866ae7eda648604d$var$Wf), $866ae7eda648604d$var$E($866ae7eda648604d$var$H), $866ae7eda648604d$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $866ae7eda648604d$var$Bh(b), null;
        case 13:
            $866ae7eda648604d$var$E($866ae7eda648604d$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($866ae7eda648604d$var$p(340));
                $866ae7eda648604d$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $866ae7eda648604d$var$E($866ae7eda648604d$var$L), null;
        case 4:
            return $866ae7eda648604d$var$zh(), null;
        case 10:
            return $866ae7eda648604d$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $866ae7eda648604d$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $866ae7eda648604d$var$Jj = !1, $866ae7eda648604d$var$U = !1, $866ae7eda648604d$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $866ae7eda648604d$var$V = null;
function $866ae7eda648604d$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $866ae7eda648604d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $866ae7eda648604d$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $866ae7eda648604d$var$W(a, b, d);
    }
}
var $866ae7eda648604d$var$Nj = !1;
function $866ae7eda648604d$var$Oj(a, b) {
    $866ae7eda648604d$var$Cf = $866ae7eda648604d$var$dd;
    a = $866ae7eda648604d$var$Me();
    if ($866ae7eda648604d$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $866ae7eda648604d$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $866ae7eda648604d$var$dd = !1;
    for($866ae7eda648604d$var$V = b; null !== $866ae7eda648604d$var$V;)if (b = $866ae7eda648604d$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $866ae7eda648604d$var$V = a;
    else for(; null !== $866ae7eda648604d$var$V;){
        b = $866ae7eda648604d$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $866ae7eda648604d$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($866ae7eda648604d$var$p(163));
            }
        } catch (F) {
            $866ae7eda648604d$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $866ae7eda648604d$var$V = a;
            break;
        }
        $866ae7eda648604d$var$V = b.return;
    }
    n = $866ae7eda648604d$var$Nj;
    $866ae7eda648604d$var$Nj = !1;
    return n;
}
function $866ae7eda648604d$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $866ae7eda648604d$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $866ae7eda648604d$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $866ae7eda648604d$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $866ae7eda648604d$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $866ae7eda648604d$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$866ae7eda648604d$var$Of], delete b[$866ae7eda648604d$var$Pf], delete b[$866ae7eda648604d$var$of], delete b[$866ae7eda648604d$var$Qf], delete b[$866ae7eda648604d$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $866ae7eda648604d$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $866ae7eda648604d$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $866ae7eda648604d$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $866ae7eda648604d$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $866ae7eda648604d$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($866ae7eda648604d$var$Vj(a, b, c), a = a.sibling; null !== a;)$866ae7eda648604d$var$Vj(a, b, c), a = a.sibling;
}
function $866ae7eda648604d$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($866ae7eda648604d$var$Wj(a, b, c), a = a.sibling; null !== a;)$866ae7eda648604d$var$Wj(a, b, c), a = a.sibling;
}
var $866ae7eda648604d$var$X = null, $866ae7eda648604d$var$Xj = !1;
function $866ae7eda648604d$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$866ae7eda648604d$var$Zj(a, b, c), c = c.sibling;
}
function $866ae7eda648604d$var$Zj(a, b, c) {
    if ($866ae7eda648604d$var$lc && "function" === typeof $866ae7eda648604d$var$lc.onCommitFiberUnmount) try {
        $866ae7eda648604d$var$lc.onCommitFiberUnmount($866ae7eda648604d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $866ae7eda648604d$var$U || $866ae7eda648604d$var$Lj(c, b);
        case 6:
            var d = $866ae7eda648604d$var$X, e = $866ae7eda648604d$var$Xj;
            $866ae7eda648604d$var$X = null;
            $866ae7eda648604d$var$Yj(a, b, c);
            $866ae7eda648604d$var$X = d;
            $866ae7eda648604d$var$Xj = e;
            null !== $866ae7eda648604d$var$X && ($866ae7eda648604d$var$Xj ? (a = $866ae7eda648604d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $866ae7eda648604d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $866ae7eda648604d$var$X && ($866ae7eda648604d$var$Xj ? (a = $866ae7eda648604d$var$X, c = c.stateNode, 8 === a.nodeType ? $866ae7eda648604d$var$Kf(a.parentNode, c) : 1 === a.nodeType && $866ae7eda648604d$var$Kf(a, c), $866ae7eda648604d$var$bd(a)) : $866ae7eda648604d$var$Kf($866ae7eda648604d$var$X, c.stateNode));
            break;
        case 4:
            d = $866ae7eda648604d$var$X;
            e = $866ae7eda648604d$var$Xj;
            $866ae7eda648604d$var$X = c.stateNode.containerInfo;
            $866ae7eda648604d$var$Xj = !0;
            $866ae7eda648604d$var$Yj(a, b, c);
            $866ae7eda648604d$var$X = d;
            $866ae7eda648604d$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$866ae7eda648604d$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $866ae7eda648604d$var$Mj(c, b, g) : 0 !== (f & 4) && $866ae7eda648604d$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $866ae7eda648604d$var$Yj(a, b, c);
            break;
        case 1:
            if (!$866ae7eda648604d$var$U && ($866ae7eda648604d$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $866ae7eda648604d$var$W(c, b, h);
            }
            $866ae7eda648604d$var$Yj(a, b, c);
            break;
        case 21:
            $866ae7eda648604d$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($866ae7eda648604d$var$U = (d = $866ae7eda648604d$var$U) || null !== c.memoizedState, $866ae7eda648604d$var$Yj(a, b, c), $866ae7eda648604d$var$U = d) : $866ae7eda648604d$var$Yj(a, b, c);
            break;
        default:
            $866ae7eda648604d$var$Yj(a, b, c);
    }
}
function $866ae7eda648604d$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $866ae7eda648604d$var$Kj);
        b.forEach(function(b) {
            var d = $866ae7eda648604d$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $866ae7eda648604d$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $866ae7eda648604d$var$X = h.stateNode;
                        $866ae7eda648604d$var$Xj = !1;
                        break a;
                    case 3:
                        $866ae7eda648604d$var$X = h.stateNode.containerInfo;
                        $866ae7eda648604d$var$Xj = !0;
                        break a;
                    case 4:
                        $866ae7eda648604d$var$X = h.stateNode.containerInfo;
                        $866ae7eda648604d$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $866ae7eda648604d$var$X) throw Error($866ae7eda648604d$var$p(160));
            $866ae7eda648604d$var$Zj(f, g, e);
            $866ae7eda648604d$var$X = null;
            $866ae7eda648604d$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $866ae7eda648604d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$866ae7eda648604d$var$dk(b, a), b = b.sibling;
}
function $866ae7eda648604d$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            if (d & 4) {
                try {
                    $866ae7eda648604d$var$Pj(3, a, a.return), $866ae7eda648604d$var$Qj(3, a);
                } catch (t) {
                    $866ae7eda648604d$var$W(a, a.return, t);
                }
                try {
                    $866ae7eda648604d$var$Pj(5, a, a.return);
                } catch (t) {
                    $866ae7eda648604d$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            d & 512 && null !== c && $866ae7eda648604d$var$Lj(c, c.return);
            break;
        case 5:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            d & 512 && null !== c && $866ae7eda648604d$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $866ae7eda648604d$var$ob(e, "");
                } catch (t) {
                    $866ae7eda648604d$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $866ae7eda648604d$var$ab(e, f);
                    $866ae7eda648604d$var$vb(h, g);
                    var l = $866ae7eda648604d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $866ae7eda648604d$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $866ae7eda648604d$var$nb(e, q) : "children" === m ? $866ae7eda648604d$var$ob(e, q) : $866ae7eda648604d$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $866ae7eda648604d$var$bb(e, f);
                            break;
                        case "textarea":
                            $866ae7eda648604d$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $866ae7eda648604d$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $866ae7eda648604d$var$fb(e, !!f.multiple, f.defaultValue, !0) : $866ae7eda648604d$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$866ae7eda648604d$var$Pf] = f;
                } catch (t) {
                    $866ae7eda648604d$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($866ae7eda648604d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $866ae7eda648604d$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $866ae7eda648604d$var$bd(b.containerInfo);
            } catch (t) {
                $866ae7eda648604d$var$W(a, a.return, t);
            }
            break;
        case 4:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            break;
        case 13:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($866ae7eda648604d$var$fk = $866ae7eda648604d$var$B()));
            d & 4 && $866ae7eda648604d$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($866ae7eda648604d$var$U = (l = $866ae7eda648604d$var$U) || m, $866ae7eda648604d$var$ck(b, a), $866ae7eda648604d$var$U = l) : $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($866ae7eda648604d$var$V = a, m = a.child; null !== m;){
                    for(q = $866ae7eda648604d$var$V = m; null !== $866ae7eda648604d$var$V;){
                        r = $866ae7eda648604d$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $866ae7eda648604d$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $866ae7eda648604d$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $866ae7eda648604d$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $866ae7eda648604d$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $866ae7eda648604d$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $866ae7eda648604d$var$V = y) : $866ae7eda648604d$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $866ae7eda648604d$var$rb("display", g));
                            } catch (t) {
                                $866ae7eda648604d$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $866ae7eda648604d$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $866ae7eda648604d$var$ck(b, a);
            $866ae7eda648604d$var$ek(a);
            d & 4 && $866ae7eda648604d$var$ak(a);
            break;
        case 21:
            break;
        default:
            $866ae7eda648604d$var$ck(b, a), $866ae7eda648604d$var$ek(a);
    }
}
function $866ae7eda648604d$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($866ae7eda648604d$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($866ae7eda648604d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($866ae7eda648604d$var$ob(e, ""), d.flags &= -33);
                    var f = $866ae7eda648604d$var$Uj(a);
                    $866ae7eda648604d$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $866ae7eda648604d$var$Uj(a);
                    $866ae7eda648604d$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($866ae7eda648604d$var$p(161));
            }
        } catch (k) {
            $866ae7eda648604d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $866ae7eda648604d$var$hk(a, b, c) {
    $866ae7eda648604d$var$V = a;
    $866ae7eda648604d$var$ik(a, b, c);
}
function $866ae7eda648604d$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $866ae7eda648604d$var$V;){
        var e = $866ae7eda648604d$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $866ae7eda648604d$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $866ae7eda648604d$var$U;
                h = $866ae7eda648604d$var$Jj;
                var l = $866ae7eda648604d$var$U;
                $866ae7eda648604d$var$Jj = g;
                if (($866ae7eda648604d$var$U = k) && !l) for($866ae7eda648604d$var$V = e; null !== $866ae7eda648604d$var$V;)g = $866ae7eda648604d$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $866ae7eda648604d$var$jk(e) : null !== k ? (k.return = g, $866ae7eda648604d$var$V = k) : $866ae7eda648604d$var$jk(e);
                for(; null !== f;)$866ae7eda648604d$var$V = f, $866ae7eda648604d$var$ik(f, b, c), f = f.sibling;
                $866ae7eda648604d$var$V = e;
                $866ae7eda648604d$var$Jj = h;
                $866ae7eda648604d$var$U = l;
            }
            $866ae7eda648604d$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $866ae7eda648604d$var$V = f) : $866ae7eda648604d$var$kk(a, b, c);
    }
}
function $866ae7eda648604d$var$kk(a) {
    for(; null !== $866ae7eda648604d$var$V;){
        var b = $866ae7eda648604d$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $866ae7eda648604d$var$U || $866ae7eda648604d$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$866ae7eda648604d$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $866ae7eda648604d$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $866ae7eda648604d$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $866ae7eda648604d$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $866ae7eda648604d$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($866ae7eda648604d$var$p(163));
                }
                $866ae7eda648604d$var$U || b.flags & 512 && $866ae7eda648604d$var$Rj(b);
            } catch (r) {
                $866ae7eda648604d$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $866ae7eda648604d$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $866ae7eda648604d$var$V = c;
            break;
        }
        $866ae7eda648604d$var$V = b.return;
    }
}
function $866ae7eda648604d$var$gk(a) {
    for(; null !== $866ae7eda648604d$var$V;){
        var b = $866ae7eda648604d$var$V;
        if (b === a) {
            $866ae7eda648604d$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $866ae7eda648604d$var$V = c;
            break;
        }
        $866ae7eda648604d$var$V = b.return;
    }
}
function $866ae7eda648604d$var$jk(a) {
    for(; null !== $866ae7eda648604d$var$V;){
        var b = $866ae7eda648604d$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $866ae7eda648604d$var$Qj(4, b);
                    } catch (k) {
                        $866ae7eda648604d$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $866ae7eda648604d$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $866ae7eda648604d$var$Rj(b);
                    } catch (k) {
                        $866ae7eda648604d$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $866ae7eda648604d$var$Rj(b);
                    } catch (k) {
                        $866ae7eda648604d$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $866ae7eda648604d$var$W(b, b.return, k);
        }
        if (b === a) {
            $866ae7eda648604d$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $866ae7eda648604d$var$V = h;
            break;
        }
        $866ae7eda648604d$var$V = b.return;
    }
}
var $866ae7eda648604d$var$lk = Math.ceil, $866ae7eda648604d$var$mk = $866ae7eda648604d$var$ua.ReactCurrentDispatcher, $866ae7eda648604d$var$nk = $866ae7eda648604d$var$ua.ReactCurrentOwner, $866ae7eda648604d$var$ok = $866ae7eda648604d$var$ua.ReactCurrentBatchConfig, $866ae7eda648604d$var$K = 0, $866ae7eda648604d$var$Q = null, $866ae7eda648604d$var$Y = null, $866ae7eda648604d$var$Z = 0, $866ae7eda648604d$var$fj = 0, $866ae7eda648604d$var$ej = $866ae7eda648604d$var$Uf(0), $866ae7eda648604d$var$T = 0, $866ae7eda648604d$var$pk = null, $866ae7eda648604d$var$rh = 0, $866ae7eda648604d$var$qk = 0, $866ae7eda648604d$var$rk = 0, $866ae7eda648604d$var$sk = null, $866ae7eda648604d$var$tk = null, $866ae7eda648604d$var$fk = 0, $866ae7eda648604d$var$Gj = Infinity, $866ae7eda648604d$var$uk = null, $866ae7eda648604d$var$Oi = !1, $866ae7eda648604d$var$Pi = null, $866ae7eda648604d$var$Ri = null, $866ae7eda648604d$var$vk = !1, $866ae7eda648604d$var$wk = null, $866ae7eda648604d$var$xk = 0, $866ae7eda648604d$var$yk = 0, $866ae7eda648604d$var$zk = null, $866ae7eda648604d$var$Ak = -1, $866ae7eda648604d$var$Bk = 0;
function $866ae7eda648604d$var$R() {
    return 0 !== ($866ae7eda648604d$var$K & 6) ? $866ae7eda648604d$var$B() : -1 !== $866ae7eda648604d$var$Ak ? $866ae7eda648604d$var$Ak : $866ae7eda648604d$var$Ak = $866ae7eda648604d$var$B();
}
function $866ae7eda648604d$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($866ae7eda648604d$var$K & 2) && 0 !== $866ae7eda648604d$var$Z) return $866ae7eda648604d$var$Z & -$866ae7eda648604d$var$Z;
    if (null !== $866ae7eda648604d$var$Kg.transition) return 0 === $866ae7eda648604d$var$Bk && ($866ae7eda648604d$var$Bk = $866ae7eda648604d$var$yc()), $866ae7eda648604d$var$Bk;
    a = $866ae7eda648604d$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $866ae7eda648604d$var$jd(a.type);
    return a;
}
function $866ae7eda648604d$var$gi(a, b, c, d) {
    if (50 < $866ae7eda648604d$var$yk) throw $866ae7eda648604d$var$yk = 0, $866ae7eda648604d$var$zk = null, Error($866ae7eda648604d$var$p(185));
    $866ae7eda648604d$var$Ac(a, c, d);
    if (0 === ($866ae7eda648604d$var$K & 2) || a !== $866ae7eda648604d$var$Q) a === $866ae7eda648604d$var$Q && (0 === ($866ae7eda648604d$var$K & 2) && ($866ae7eda648604d$var$qk |= c), 4 === $866ae7eda648604d$var$T && $866ae7eda648604d$var$Ck(a, $866ae7eda648604d$var$Z)), $866ae7eda648604d$var$Dk(a, d), 1 === c && 0 === $866ae7eda648604d$var$K && 0 === (b.mode & 1) && ($866ae7eda648604d$var$Gj = $866ae7eda648604d$var$B() + 500, $866ae7eda648604d$var$fg && $866ae7eda648604d$var$jg());
}
function $866ae7eda648604d$var$Dk(a, b) {
    var c = a.callbackNode;
    $866ae7eda648604d$var$wc(a, b);
    var d = $866ae7eda648604d$var$uc(a, a === $866ae7eda648604d$var$Q ? $866ae7eda648604d$var$Z : 0);
    if (0 === d) null !== c && $866ae7eda648604d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $866ae7eda648604d$var$bc(c);
        if (1 === b) 0 === a.tag ? $866ae7eda648604d$var$ig($866ae7eda648604d$var$Ek.bind(null, a)) : $866ae7eda648604d$var$hg($866ae7eda648604d$var$Ek.bind(null, a)), $866ae7eda648604d$var$Jf(function() {
            0 === ($866ae7eda648604d$var$K & 6) && $866ae7eda648604d$var$jg();
        }), c = null;
        else {
            switch($866ae7eda648604d$var$Dc(d)){
                case 1:
                    c = $866ae7eda648604d$var$fc;
                    break;
                case 4:
                    c = $866ae7eda648604d$var$gc;
                    break;
                case 16:
                    c = $866ae7eda648604d$var$hc;
                    break;
                case 536870912:
                    c = $866ae7eda648604d$var$jc;
                    break;
                default:
                    c = $866ae7eda648604d$var$hc;
            }
            c = $866ae7eda648604d$var$Fk(c, $866ae7eda648604d$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $866ae7eda648604d$var$Gk(a, b) {
    $866ae7eda648604d$var$Ak = -1;
    $866ae7eda648604d$var$Bk = 0;
    if (0 !== ($866ae7eda648604d$var$K & 6)) throw Error($866ae7eda648604d$var$p(327));
    var c = a.callbackNode;
    if ($866ae7eda648604d$var$Hk() && a.callbackNode !== c) return null;
    var d = $866ae7eda648604d$var$uc(a, a === $866ae7eda648604d$var$Q ? $866ae7eda648604d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $866ae7eda648604d$var$Ik(a, d);
    else {
        b = d;
        var e = $866ae7eda648604d$var$K;
        $866ae7eda648604d$var$K |= 2;
        var f = $866ae7eda648604d$var$Jk();
        if ($866ae7eda648604d$var$Q !== a || $866ae7eda648604d$var$Z !== b) $866ae7eda648604d$var$uk = null, $866ae7eda648604d$var$Gj = $866ae7eda648604d$var$B() + 500, $866ae7eda648604d$var$Kk(a, b);
        for(;;)try {
            $866ae7eda648604d$var$Lk();
            break;
        } catch (h) {
            $866ae7eda648604d$var$Mk(a, h);
        }
        $866ae7eda648604d$var$$g();
        $866ae7eda648604d$var$mk.current = f;
        $866ae7eda648604d$var$K = e;
        null !== $866ae7eda648604d$var$Y ? b = 0 : ($866ae7eda648604d$var$Q = null, $866ae7eda648604d$var$Z = 0, b = $866ae7eda648604d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $866ae7eda648604d$var$xc(a), 0 !== e && (d = e, b = $866ae7eda648604d$var$Nk(a, e)));
        if (1 === b) throw c = $866ae7eda648604d$var$pk, $866ae7eda648604d$var$Kk(a, 0), $866ae7eda648604d$var$Ck(a, d), $866ae7eda648604d$var$Dk(a, $866ae7eda648604d$var$B()), c;
        if (6 === b) $866ae7eda648604d$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$866ae7eda648604d$var$Ok(e) && (b = $866ae7eda648604d$var$Ik(a, d), 2 === b && (f = $866ae7eda648604d$var$xc(a), 0 !== f && (d = f, b = $866ae7eda648604d$var$Nk(a, f))), 1 === b)) throw c = $866ae7eda648604d$var$pk, $866ae7eda648604d$var$Kk(a, 0), $866ae7eda648604d$var$Ck(a, d), $866ae7eda648604d$var$Dk(a, $866ae7eda648604d$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($866ae7eda648604d$var$p(345));
                case 2:
                    $866ae7eda648604d$var$Pk(a, $866ae7eda648604d$var$tk, $866ae7eda648604d$var$uk);
                    break;
                case 3:
                    $866ae7eda648604d$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $866ae7eda648604d$var$fk + 500 - $866ae7eda648604d$var$B(), 10 < b)) {
                        if (0 !== $866ae7eda648604d$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $866ae7eda648604d$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $866ae7eda648604d$var$Ff($866ae7eda648604d$var$Pk.bind(null, a, $866ae7eda648604d$var$tk, $866ae7eda648604d$var$uk), b);
                        break;
                    }
                    $866ae7eda648604d$var$Pk(a, $866ae7eda648604d$var$tk, $866ae7eda648604d$var$uk);
                    break;
                case 4:
                    $866ae7eda648604d$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $866ae7eda648604d$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $866ae7eda648604d$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $866ae7eda648604d$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $866ae7eda648604d$var$Ff($866ae7eda648604d$var$Pk.bind(null, a, $866ae7eda648604d$var$tk, $866ae7eda648604d$var$uk), d);
                        break;
                    }
                    $866ae7eda648604d$var$Pk(a, $866ae7eda648604d$var$tk, $866ae7eda648604d$var$uk);
                    break;
                case 5:
                    $866ae7eda648604d$var$Pk(a, $866ae7eda648604d$var$tk, $866ae7eda648604d$var$uk);
                    break;
                default:
                    throw Error($866ae7eda648604d$var$p(329));
            }
        }
    }
    $866ae7eda648604d$var$Dk(a, $866ae7eda648604d$var$B());
    return a.callbackNode === c ? $866ae7eda648604d$var$Gk.bind(null, a) : null;
}
function $866ae7eda648604d$var$Nk(a, b) {
    var c = $866ae7eda648604d$var$sk;
    a.current.memoizedState.isDehydrated && ($866ae7eda648604d$var$Kk(a, b).flags |= 256);
    a = $866ae7eda648604d$var$Ik(a, b);
    2 !== a && (b = $866ae7eda648604d$var$tk, $866ae7eda648604d$var$tk = c, null !== b && $866ae7eda648604d$var$Fj(b));
    return a;
}
function $866ae7eda648604d$var$Fj(a) {
    null === $866ae7eda648604d$var$tk ? $866ae7eda648604d$var$tk = a : $866ae7eda648604d$var$tk.push.apply($866ae7eda648604d$var$tk, a);
}
function $866ae7eda648604d$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$866ae7eda648604d$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $866ae7eda648604d$var$Ck(a, b) {
    b &= ~$866ae7eda648604d$var$rk;
    b &= ~$866ae7eda648604d$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $866ae7eda648604d$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $866ae7eda648604d$var$Ek(a) {
    if (0 !== ($866ae7eda648604d$var$K & 6)) throw Error($866ae7eda648604d$var$p(327));
    $866ae7eda648604d$var$Hk();
    var b = $866ae7eda648604d$var$uc(a, 0);
    if (0 === (b & 1)) return $866ae7eda648604d$var$Dk(a, $866ae7eda648604d$var$B()), null;
    var c = $866ae7eda648604d$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $866ae7eda648604d$var$xc(a);
        0 !== d && (b = d, c = $866ae7eda648604d$var$Nk(a, d));
    }
    if (1 === c) throw c = $866ae7eda648604d$var$pk, $866ae7eda648604d$var$Kk(a, 0), $866ae7eda648604d$var$Ck(a, b), $866ae7eda648604d$var$Dk(a, $866ae7eda648604d$var$B()), c;
    if (6 === c) throw Error($866ae7eda648604d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $866ae7eda648604d$var$Pk(a, $866ae7eda648604d$var$tk, $866ae7eda648604d$var$uk);
    $866ae7eda648604d$var$Dk(a, $866ae7eda648604d$var$B());
    return null;
}
function $866ae7eda648604d$var$Qk(a, b) {
    var c = $866ae7eda648604d$var$K;
    $866ae7eda648604d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $866ae7eda648604d$var$K = c, 0 === $866ae7eda648604d$var$K && ($866ae7eda648604d$var$Gj = $866ae7eda648604d$var$B() + 500, $866ae7eda648604d$var$fg && $866ae7eda648604d$var$jg());
    }
}
function $866ae7eda648604d$var$Rk(a) {
    null !== $866ae7eda648604d$var$wk && 0 === $866ae7eda648604d$var$wk.tag && 0 === ($866ae7eda648604d$var$K & 6) && $866ae7eda648604d$var$Hk();
    var b = $866ae7eda648604d$var$K;
    $866ae7eda648604d$var$K |= 1;
    var c = $866ae7eda648604d$var$ok.transition, d = $866ae7eda648604d$var$C;
    try {
        if ($866ae7eda648604d$var$ok.transition = null, $866ae7eda648604d$var$C = 1, a) return a();
    } finally{
        $866ae7eda648604d$var$C = d, $866ae7eda648604d$var$ok.transition = c, $866ae7eda648604d$var$K = b, 0 === ($866ae7eda648604d$var$K & 6) && $866ae7eda648604d$var$jg();
    }
}
function $866ae7eda648604d$var$Hj() {
    $866ae7eda648604d$var$fj = $866ae7eda648604d$var$ej.current;
    $866ae7eda648604d$var$E($866ae7eda648604d$var$ej);
}
function $866ae7eda648604d$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $866ae7eda648604d$var$Gf(c));
    if (null !== $866ae7eda648604d$var$Y) for(c = $866ae7eda648604d$var$Y.return; null !== c;){
        var d = c;
        $866ae7eda648604d$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $866ae7eda648604d$var$$f();
                break;
            case 3:
                $866ae7eda648604d$var$zh();
                $866ae7eda648604d$var$E($866ae7eda648604d$var$Wf);
                $866ae7eda648604d$var$E($866ae7eda648604d$var$H);
                $866ae7eda648604d$var$Eh();
                break;
            case 5:
                $866ae7eda648604d$var$Bh(d);
                break;
            case 4:
                $866ae7eda648604d$var$zh();
                break;
            case 13:
                $866ae7eda648604d$var$E($866ae7eda648604d$var$L);
                break;
            case 19:
                $866ae7eda648604d$var$E($866ae7eda648604d$var$L);
                break;
            case 10:
                $866ae7eda648604d$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $866ae7eda648604d$var$Hj();
        }
        c = c.return;
    }
    $866ae7eda648604d$var$Q = a;
    $866ae7eda648604d$var$Y = a = $866ae7eda648604d$var$Pg(a.current, null);
    $866ae7eda648604d$var$Z = $866ae7eda648604d$var$fj = b;
    $866ae7eda648604d$var$T = 0;
    $866ae7eda648604d$var$pk = null;
    $866ae7eda648604d$var$rk = $866ae7eda648604d$var$qk = $866ae7eda648604d$var$rh = 0;
    $866ae7eda648604d$var$tk = $866ae7eda648604d$var$sk = null;
    if (null !== $866ae7eda648604d$var$fh) {
        for(b = 0; b < $866ae7eda648604d$var$fh.length; b++)if (c = $866ae7eda648604d$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $866ae7eda648604d$var$fh = null;
    }
    return a;
}
function $866ae7eda648604d$var$Mk(a, b) {
    do {
        var c = $866ae7eda648604d$var$Y;
        try {
            $866ae7eda648604d$var$$g();
            $866ae7eda648604d$var$Fh.current = $866ae7eda648604d$var$Rh;
            if ($866ae7eda648604d$var$Ih) {
                for(var d = $866ae7eda648604d$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $866ae7eda648604d$var$Ih = !1;
            }
            $866ae7eda648604d$var$Hh = 0;
            $866ae7eda648604d$var$O = $866ae7eda648604d$var$N = $866ae7eda648604d$var$M = null;
            $866ae7eda648604d$var$Jh = !1;
            $866ae7eda648604d$var$Kh = 0;
            $866ae7eda648604d$var$nk.current = null;
            if (null === c || null === c.return) {
                $866ae7eda648604d$var$T = 1;
                $866ae7eda648604d$var$pk = b;
                $866ae7eda648604d$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $866ae7eda648604d$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $866ae7eda648604d$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $866ae7eda648604d$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $866ae7eda648604d$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $866ae7eda648604d$var$Si(f, l, b);
                            $866ae7eda648604d$var$tj();
                            break a;
                        }
                        k = Error($866ae7eda648604d$var$p(426));
                    }
                } else if ($866ae7eda648604d$var$I && h.mode & 1) {
                    var J = $866ae7eda648604d$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $866ae7eda648604d$var$Vi(J, g, h, f, b);
                        $866ae7eda648604d$var$Jg($866ae7eda648604d$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $866ae7eda648604d$var$Ji(k, h);
                4 !== $866ae7eda648604d$var$T && ($866ae7eda648604d$var$T = 2);
                null === $866ae7eda648604d$var$sk ? $866ae7eda648604d$var$sk = [
                    f
                ] : $866ae7eda648604d$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $866ae7eda648604d$var$Ni(f, k, b);
                            $866ae7eda648604d$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $866ae7eda648604d$var$Ri || !$866ae7eda648604d$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $866ae7eda648604d$var$Qi(f, h, b);
                                $866ae7eda648604d$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $866ae7eda648604d$var$Sk(c);
        } catch (na) {
            b = na;
            $866ae7eda648604d$var$Y === c && null !== c && ($866ae7eda648604d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $866ae7eda648604d$var$Jk() {
    var a = $866ae7eda648604d$var$mk.current;
    $866ae7eda648604d$var$mk.current = $866ae7eda648604d$var$Rh;
    return null === a ? $866ae7eda648604d$var$Rh : a;
}
function $866ae7eda648604d$var$tj() {
    if (0 === $866ae7eda648604d$var$T || 3 === $866ae7eda648604d$var$T || 2 === $866ae7eda648604d$var$T) $866ae7eda648604d$var$T = 4;
    null === $866ae7eda648604d$var$Q || 0 === ($866ae7eda648604d$var$rh & 268435455) && 0 === ($866ae7eda648604d$var$qk & 268435455) || $866ae7eda648604d$var$Ck($866ae7eda648604d$var$Q, $866ae7eda648604d$var$Z);
}
function $866ae7eda648604d$var$Ik(a, b) {
    var c = $866ae7eda648604d$var$K;
    $866ae7eda648604d$var$K |= 2;
    var d = $866ae7eda648604d$var$Jk();
    if ($866ae7eda648604d$var$Q !== a || $866ae7eda648604d$var$Z !== b) $866ae7eda648604d$var$uk = null, $866ae7eda648604d$var$Kk(a, b);
    for(;;)try {
        $866ae7eda648604d$var$Tk();
        break;
    } catch (e) {
        $866ae7eda648604d$var$Mk(a, e);
    }
    $866ae7eda648604d$var$$g();
    $866ae7eda648604d$var$K = c;
    $866ae7eda648604d$var$mk.current = d;
    if (null !== $866ae7eda648604d$var$Y) throw Error($866ae7eda648604d$var$p(261));
    $866ae7eda648604d$var$Q = null;
    $866ae7eda648604d$var$Z = 0;
    return $866ae7eda648604d$var$T;
}
function $866ae7eda648604d$var$Tk() {
    for(; null !== $866ae7eda648604d$var$Y;)$866ae7eda648604d$var$Uk($866ae7eda648604d$var$Y);
}
function $866ae7eda648604d$var$Lk() {
    for(; null !== $866ae7eda648604d$var$Y && !$866ae7eda648604d$var$cc();)$866ae7eda648604d$var$Uk($866ae7eda648604d$var$Y);
}
function $866ae7eda648604d$var$Uk(a) {
    var b = $866ae7eda648604d$var$Vk(a.alternate, a, $866ae7eda648604d$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $866ae7eda648604d$var$Sk(a) : $866ae7eda648604d$var$Y = b;
    $866ae7eda648604d$var$nk.current = null;
}
function $866ae7eda648604d$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $866ae7eda648604d$var$Ej(c, b, $866ae7eda648604d$var$fj), null !== c) {
                $866ae7eda648604d$var$Y = c;
                return;
            }
        } else {
            c = $866ae7eda648604d$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $866ae7eda648604d$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $866ae7eda648604d$var$T = 6;
                $866ae7eda648604d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $866ae7eda648604d$var$Y = b;
            return;
        }
        $866ae7eda648604d$var$Y = b = a;
    }while (null !== b);
    0 === $866ae7eda648604d$var$T && ($866ae7eda648604d$var$T = 5);
}
function $866ae7eda648604d$var$Pk(a, b, c) {
    var d = $866ae7eda648604d$var$C, e = $866ae7eda648604d$var$ok.transition;
    try {
        $866ae7eda648604d$var$ok.transition = null, $866ae7eda648604d$var$C = 1, $866ae7eda648604d$var$Wk(a, b, c, d);
    } finally{
        $866ae7eda648604d$var$ok.transition = e, $866ae7eda648604d$var$C = d;
    }
    return null;
}
function $866ae7eda648604d$var$Wk(a, b, c, d) {
    do $866ae7eda648604d$var$Hk();
    while (null !== $866ae7eda648604d$var$wk);
    if (0 !== ($866ae7eda648604d$var$K & 6)) throw Error($866ae7eda648604d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($866ae7eda648604d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $866ae7eda648604d$var$Bc(a, f);
    a === $866ae7eda648604d$var$Q && ($866ae7eda648604d$var$Y = $866ae7eda648604d$var$Q = null, $866ae7eda648604d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $866ae7eda648604d$var$vk || ($866ae7eda648604d$var$vk = !0, $866ae7eda648604d$var$Fk($866ae7eda648604d$var$hc, function() {
        $866ae7eda648604d$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $866ae7eda648604d$var$ok.transition;
        $866ae7eda648604d$var$ok.transition = null;
        var g = $866ae7eda648604d$var$C;
        $866ae7eda648604d$var$C = 1;
        var h = $866ae7eda648604d$var$K;
        $866ae7eda648604d$var$K |= 4;
        $866ae7eda648604d$var$nk.current = null;
        $866ae7eda648604d$var$Oj(a, c);
        $866ae7eda648604d$var$dk(c, a);
        $866ae7eda648604d$var$Oe($866ae7eda648604d$var$Df);
        $866ae7eda648604d$var$dd = !!$866ae7eda648604d$var$Cf;
        $866ae7eda648604d$var$Df = $866ae7eda648604d$var$Cf = null;
        a.current = c;
        $866ae7eda648604d$var$hk(c, a, e);
        $866ae7eda648604d$var$dc();
        $866ae7eda648604d$var$K = h;
        $866ae7eda648604d$var$C = g;
        $866ae7eda648604d$var$ok.transition = f;
    } else a.current = c;
    $866ae7eda648604d$var$vk && ($866ae7eda648604d$var$vk = !1, $866ae7eda648604d$var$wk = a, $866ae7eda648604d$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($866ae7eda648604d$var$Ri = null);
    $866ae7eda648604d$var$mc(c.stateNode, d);
    $866ae7eda648604d$var$Dk(a, $866ae7eda648604d$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($866ae7eda648604d$var$Oi) throw $866ae7eda648604d$var$Oi = !1, a = $866ae7eda648604d$var$Pi, $866ae7eda648604d$var$Pi = null, a;
    0 !== ($866ae7eda648604d$var$xk & 1) && 0 !== a.tag && $866ae7eda648604d$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $866ae7eda648604d$var$zk ? $866ae7eda648604d$var$yk++ : ($866ae7eda648604d$var$yk = 0, $866ae7eda648604d$var$zk = a) : $866ae7eda648604d$var$yk = 0;
    $866ae7eda648604d$var$jg();
    return null;
}
function $866ae7eda648604d$var$Hk() {
    if (null !== $866ae7eda648604d$var$wk) {
        var a = $866ae7eda648604d$var$Dc($866ae7eda648604d$var$xk), b = $866ae7eda648604d$var$ok.transition, c = $866ae7eda648604d$var$C;
        try {
            $866ae7eda648604d$var$ok.transition = null;
            $866ae7eda648604d$var$C = 16 > a ? 16 : a;
            if (null === $866ae7eda648604d$var$wk) var d = !1;
            else {
                a = $866ae7eda648604d$var$wk;
                $866ae7eda648604d$var$wk = null;
                $866ae7eda648604d$var$xk = 0;
                if (0 !== ($866ae7eda648604d$var$K & 6)) throw Error($866ae7eda648604d$var$p(331));
                var e = $866ae7eda648604d$var$K;
                $866ae7eda648604d$var$K |= 4;
                for($866ae7eda648604d$var$V = a.current; null !== $866ae7eda648604d$var$V;){
                    var f = $866ae7eda648604d$var$V, g = f.child;
                    if (0 !== ($866ae7eda648604d$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($866ae7eda648604d$var$V = l; null !== $866ae7eda648604d$var$V;){
                                    var m = $866ae7eda648604d$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $866ae7eda648604d$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $866ae7eda648604d$var$V = q;
                                    else for(; null !== $866ae7eda648604d$var$V;){
                                        m = $866ae7eda648604d$var$V;
                                        var r = m.sibling, y = m.return;
                                        $866ae7eda648604d$var$Sj(m);
                                        if (m === l) {
                                            $866ae7eda648604d$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $866ae7eda648604d$var$V = r;
                                            break;
                                        }
                                        $866ae7eda648604d$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $866ae7eda648604d$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $866ae7eda648604d$var$V = g;
                    else b: for(; null !== $866ae7eda648604d$var$V;){
                        f = $866ae7eda648604d$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $866ae7eda648604d$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $866ae7eda648604d$var$V = x;
                            break b;
                        }
                        $866ae7eda648604d$var$V = f.return;
                    }
                }
                var w = a.current;
                for($866ae7eda648604d$var$V = w; null !== $866ae7eda648604d$var$V;){
                    g = $866ae7eda648604d$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $866ae7eda648604d$var$V = u;
                    else b: for(g = w; null !== $866ae7eda648604d$var$V;){
                        h = $866ae7eda648604d$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $866ae7eda648604d$var$Qj(9, h);
                            }
                        } catch (na) {
                            $866ae7eda648604d$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $866ae7eda648604d$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $866ae7eda648604d$var$V = F;
                            break b;
                        }
                        $866ae7eda648604d$var$V = h.return;
                    }
                }
                $866ae7eda648604d$var$K = e;
                $866ae7eda648604d$var$jg();
                if ($866ae7eda648604d$var$lc && "function" === typeof $866ae7eda648604d$var$lc.onPostCommitFiberRoot) try {
                    $866ae7eda648604d$var$lc.onPostCommitFiberRoot($866ae7eda648604d$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $866ae7eda648604d$var$C = c, $866ae7eda648604d$var$ok.transition = b;
        }
    }
    return !1;
}
function $866ae7eda648604d$var$Xk(a, b, c) {
    b = $866ae7eda648604d$var$Ji(c, b);
    b = $866ae7eda648604d$var$Ni(a, b, 1);
    a = $866ae7eda648604d$var$nh(a, b, 1);
    b = $866ae7eda648604d$var$R();
    null !== a && ($866ae7eda648604d$var$Ac(a, 1, b), $866ae7eda648604d$var$Dk(a, b));
}
function $866ae7eda648604d$var$W(a, b, c) {
    if (3 === a.tag) $866ae7eda648604d$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $866ae7eda648604d$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $866ae7eda648604d$var$Ri || !$866ae7eda648604d$var$Ri.has(d))) {
                a = $866ae7eda648604d$var$Ji(c, a);
                a = $866ae7eda648604d$var$Qi(b, a, 1);
                b = $866ae7eda648604d$var$nh(b, a, 1);
                a = $866ae7eda648604d$var$R();
                null !== b && ($866ae7eda648604d$var$Ac(b, 1, a), $866ae7eda648604d$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $866ae7eda648604d$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $866ae7eda648604d$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $866ae7eda648604d$var$Q === a && ($866ae7eda648604d$var$Z & c) === c && (4 === $866ae7eda648604d$var$T || 3 === $866ae7eda648604d$var$T && ($866ae7eda648604d$var$Z & 130023424) === $866ae7eda648604d$var$Z && 500 > $866ae7eda648604d$var$B() - $866ae7eda648604d$var$fk ? $866ae7eda648604d$var$Kk(a, 0) : $866ae7eda648604d$var$rk |= c);
    $866ae7eda648604d$var$Dk(a, b);
}
function $866ae7eda648604d$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $866ae7eda648604d$var$sc, $866ae7eda648604d$var$sc <<= 1, 0 === ($866ae7eda648604d$var$sc & 130023424) && ($866ae7eda648604d$var$sc = 4194304)));
    var c = $866ae7eda648604d$var$R();
    a = $866ae7eda648604d$var$ih(a, b);
    null !== a && ($866ae7eda648604d$var$Ac(a, b, c), $866ae7eda648604d$var$Dk(a, c));
}
function $866ae7eda648604d$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $866ae7eda648604d$var$Yk(a, c);
}
function $866ae7eda648604d$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($866ae7eda648604d$var$p(314));
    }
    null !== d && d.delete(b);
    $866ae7eda648604d$var$Yk(a, c);
}
var $866ae7eda648604d$var$Vk;
$866ae7eda648604d$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $866ae7eda648604d$var$Wf.current) $866ae7eda648604d$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $866ae7eda648604d$var$dh = !1, $866ae7eda648604d$var$yj(a, b, c);
            $866ae7eda648604d$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $866ae7eda648604d$var$dh = !1, $866ae7eda648604d$var$I && 0 !== (b.flags & 1048576) && $866ae7eda648604d$var$ug(b, $866ae7eda648604d$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $866ae7eda648604d$var$ij(a, b);
            a = b.pendingProps;
            var e = $866ae7eda648604d$var$Yf(b, $866ae7eda648604d$var$H.current);
            $866ae7eda648604d$var$ch(b, c);
            e = $866ae7eda648604d$var$Nh(null, b, d, a, e, c);
            var f = $866ae7eda648604d$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $866ae7eda648604d$var$Zf(d) ? (f = !0, $866ae7eda648604d$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $866ae7eda648604d$var$kh(b), e.updater = $866ae7eda648604d$var$Ei, b.stateNode = e, e._reactInternals = b, $866ae7eda648604d$var$Ii(b, d, a, c), b = $866ae7eda648604d$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $866ae7eda648604d$var$I && f && $866ae7eda648604d$var$vg(b), $866ae7eda648604d$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $866ae7eda648604d$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $866ae7eda648604d$var$Zk(d);
                a = $866ae7eda648604d$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $866ae7eda648604d$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $866ae7eda648604d$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $866ae7eda648604d$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $866ae7eda648604d$var$$i(null, b, d, $866ae7eda648604d$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($866ae7eda648604d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $866ae7eda648604d$var$Ci(d, e), $866ae7eda648604d$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $866ae7eda648604d$var$Ci(d, e), $866ae7eda648604d$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $866ae7eda648604d$var$kj(b);
                if (null === a) throw Error($866ae7eda648604d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $866ae7eda648604d$var$lh(a, b);
                $866ae7eda648604d$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $866ae7eda648604d$var$Ji(Error($866ae7eda648604d$var$p(423)), b);
                        b = $866ae7eda648604d$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $866ae7eda648604d$var$Ji(Error($866ae7eda648604d$var$p(424)), b);
                        b = $866ae7eda648604d$var$lj(a, b, d, c, e);
                        break a;
                    } else for($866ae7eda648604d$var$yg = $866ae7eda648604d$var$Lf(b.stateNode.containerInfo.firstChild), $866ae7eda648604d$var$xg = b, $866ae7eda648604d$var$I = !0, $866ae7eda648604d$var$zg = null, c = $866ae7eda648604d$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $866ae7eda648604d$var$Ig();
                    if (d === e) {
                        b = $866ae7eda648604d$var$Zi(a, b, c);
                        break a;
                    }
                    $866ae7eda648604d$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $866ae7eda648604d$var$Ah(b), null === a && $866ae7eda648604d$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $866ae7eda648604d$var$Ef(d, e) ? g = null : null !== f && $866ae7eda648604d$var$Ef(d, f) && (b.flags |= 32), $866ae7eda648604d$var$gj(a, b), $866ae7eda648604d$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $866ae7eda648604d$var$Eg(b), null;
        case 13:
            return $866ae7eda648604d$var$oj(a, b, c);
        case 4:
            return $866ae7eda648604d$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $866ae7eda648604d$var$Ug(b, null, d, c) : $866ae7eda648604d$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $866ae7eda648604d$var$Ci(d, e), $866ae7eda648604d$var$Yi(a, b, d, e, c);
        case 7:
            return $866ae7eda648604d$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $866ae7eda648604d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $866ae7eda648604d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $866ae7eda648604d$var$G($866ae7eda648604d$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($866ae7eda648604d$var$He(f.value, g)) {
                        if (f.children === e.children && !$866ae7eda648604d$var$Wf.current) {
                            b = $866ae7eda648604d$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $866ae7eda648604d$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $866ae7eda648604d$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($866ae7eda648604d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $866ae7eda648604d$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $866ae7eda648604d$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $866ae7eda648604d$var$ch(b, c), e = $866ae7eda648604d$var$eh(e), d = d(e), b.flags |= 1, $866ae7eda648604d$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $866ae7eda648604d$var$Ci(d, b.pendingProps), e = $866ae7eda648604d$var$Ci(d.type, e), $866ae7eda648604d$var$$i(a, b, d, e, c);
        case 15:
            return $866ae7eda648604d$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $866ae7eda648604d$var$Ci(d, e), $866ae7eda648604d$var$ij(a, b), b.tag = 1, $866ae7eda648604d$var$Zf(d) ? (a = !0, $866ae7eda648604d$var$cg(b)) : a = !1, $866ae7eda648604d$var$ch(b, c), $866ae7eda648604d$var$Gi(b, d, e), $866ae7eda648604d$var$Ii(b, d, e, c), $866ae7eda648604d$var$jj(null, b, d, !0, a, c);
        case 19:
            return $866ae7eda648604d$var$xj(a, b, c);
        case 22:
            return $866ae7eda648604d$var$dj(a, b, c);
    }
    throw Error($866ae7eda648604d$var$p(156, b.tag));
};
function $866ae7eda648604d$var$Fk(a, b) {
    return $866ae7eda648604d$var$ac(a, b);
}
function $866ae7eda648604d$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $866ae7eda648604d$var$Bg(a, b, c, d) {
    return new $866ae7eda648604d$var$$k(a, b, c, d);
}
function $866ae7eda648604d$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $866ae7eda648604d$var$Zk(a) {
    if ("function" === typeof a) return $866ae7eda648604d$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $866ae7eda648604d$var$Da) return 11;
        if (a === $866ae7eda648604d$var$Ga) return 14;
    }
    return 2;
}
function $866ae7eda648604d$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $866ae7eda648604d$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $866ae7eda648604d$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $866ae7eda648604d$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $866ae7eda648604d$var$ya:
            return $866ae7eda648604d$var$Tg(c.children, e, f, b);
        case $866ae7eda648604d$var$za:
            g = 8;
            e |= 8;
            break;
        case $866ae7eda648604d$var$Aa:
            return a = $866ae7eda648604d$var$Bg(12, c, b, e | 2), a.elementType = $866ae7eda648604d$var$Aa, a.lanes = f, a;
        case $866ae7eda648604d$var$Ea:
            return a = $866ae7eda648604d$var$Bg(13, c, b, e), a.elementType = $866ae7eda648604d$var$Ea, a.lanes = f, a;
        case $866ae7eda648604d$var$Fa:
            return a = $866ae7eda648604d$var$Bg(19, c, b, e), a.elementType = $866ae7eda648604d$var$Fa, a.lanes = f, a;
        case $866ae7eda648604d$var$Ia:
            return $866ae7eda648604d$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $866ae7eda648604d$var$Ba:
                    g = 10;
                    break a;
                case $866ae7eda648604d$var$Ca:
                    g = 9;
                    break a;
                case $866ae7eda648604d$var$Da:
                    g = 11;
                    break a;
                case $866ae7eda648604d$var$Ga:
                    g = 14;
                    break a;
                case $866ae7eda648604d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($866ae7eda648604d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $866ae7eda648604d$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $866ae7eda648604d$var$Tg(a, b, c, d) {
    a = $866ae7eda648604d$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $866ae7eda648604d$var$pj(a, b, c, d) {
    a = $866ae7eda648604d$var$Bg(22, a, d, b);
    a.elementType = $866ae7eda648604d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $866ae7eda648604d$var$Qg(a, b, c) {
    a = $866ae7eda648604d$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $866ae7eda648604d$var$Sg(a, b, c) {
    b = $866ae7eda648604d$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $866ae7eda648604d$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $866ae7eda648604d$var$zc(0);
    this.expirationTimes = $866ae7eda648604d$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $866ae7eda648604d$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $866ae7eda648604d$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $866ae7eda648604d$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $866ae7eda648604d$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $866ae7eda648604d$var$kh(f);
    return a;
}
function $866ae7eda648604d$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $866ae7eda648604d$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $866ae7eda648604d$var$dl(a) {
    if (!a) return $866ae7eda648604d$var$Vf;
    a = a._reactInternals;
    a: {
        if ($866ae7eda648604d$var$Vb(a) !== a || 1 !== a.tag) throw Error($866ae7eda648604d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($866ae7eda648604d$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($866ae7eda648604d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($866ae7eda648604d$var$Zf(c)) return $866ae7eda648604d$var$bg(a, c, b);
    }
    return b;
}
function $866ae7eda648604d$var$el(a, b, c, d, e, f, g, h, k) {
    a = $866ae7eda648604d$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $866ae7eda648604d$var$dl(null);
    c = a.current;
    d = $866ae7eda648604d$var$R();
    e = $866ae7eda648604d$var$yi(c);
    f = $866ae7eda648604d$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $866ae7eda648604d$var$nh(c, f, e);
    a.current.lanes = e;
    $866ae7eda648604d$var$Ac(a, e, d);
    $866ae7eda648604d$var$Dk(a, d);
    return a;
}
function $866ae7eda648604d$var$fl(a, b, c, d) {
    var e = b.current, f = $866ae7eda648604d$var$R(), g = $866ae7eda648604d$var$yi(e);
    c = $866ae7eda648604d$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $866ae7eda648604d$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $866ae7eda648604d$var$nh(e, b, g);
    null !== a && ($866ae7eda648604d$var$gi(a, e, g, f), $866ae7eda648604d$var$oh(a, e, g));
    return g;
}
function $866ae7eda648604d$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $866ae7eda648604d$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $866ae7eda648604d$var$il(a, b) {
    $866ae7eda648604d$var$hl(a, b);
    (a = a.alternate) && $866ae7eda648604d$var$hl(a, b);
}
function $866ae7eda648604d$var$jl() {
    return null;
}
var $866ae7eda648604d$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $866ae7eda648604d$var$ll(a) {
    this._internalRoot = a;
}
$866ae7eda648604d$var$ml.prototype.render = $866ae7eda648604d$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($866ae7eda648604d$var$p(409));
    $866ae7eda648604d$var$fl(a, b, null, null);
};
$866ae7eda648604d$var$ml.prototype.unmount = $866ae7eda648604d$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $866ae7eda648604d$var$Rk(function() {
            $866ae7eda648604d$var$fl(null, a, null, null);
        });
        b[$866ae7eda648604d$var$uf] = null;
    }
};
function $866ae7eda648604d$var$ml(a) {
    this._internalRoot = a;
}
$866ae7eda648604d$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $866ae7eda648604d$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $866ae7eda648604d$var$Qc.length && 0 !== b && b < $866ae7eda648604d$var$Qc[c].priority; c++);
        $866ae7eda648604d$var$Qc.splice(c, 0, a);
        0 === c && $866ae7eda648604d$var$Vc(a);
    }
};
function $866ae7eda648604d$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $866ae7eda648604d$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $866ae7eda648604d$var$pl() {}
function $866ae7eda648604d$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $866ae7eda648604d$var$gl(g);
                f.call(a);
            };
        }
        var g = $866ae7eda648604d$var$el(b, d, a, 0, null, !1, !1, "", $866ae7eda648604d$var$pl);
        a._reactRootContainer = g;
        a[$866ae7eda648604d$var$uf] = g.current;
        $866ae7eda648604d$var$sf(8 === a.nodeType ? a.parentNode : a);
        $866ae7eda648604d$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $866ae7eda648604d$var$gl(k);
            h.call(a);
        };
    }
    var k = $866ae7eda648604d$var$bl(a, 0, !1, null, null, !1, !1, "", $866ae7eda648604d$var$pl);
    a._reactRootContainer = k;
    a[$866ae7eda648604d$var$uf] = k.current;
    $866ae7eda648604d$var$sf(8 === a.nodeType ? a.parentNode : a);
    $866ae7eda648604d$var$Rk(function() {
        $866ae7eda648604d$var$fl(b, k, c, d);
    });
    return k;
}
function $866ae7eda648604d$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $866ae7eda648604d$var$gl(g);
                h.call(a);
            };
        }
        $866ae7eda648604d$var$fl(b, g, a, e);
    } else g = $866ae7eda648604d$var$ql(c, b, a, e, d);
    return $866ae7eda648604d$var$gl(g);
}
$866ae7eda648604d$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $866ae7eda648604d$var$tc(b.pendingLanes);
                0 !== c && ($866ae7eda648604d$var$Cc(b, c | 1), $866ae7eda648604d$var$Dk(b, $866ae7eda648604d$var$B()), 0 === ($866ae7eda648604d$var$K & 6) && ($866ae7eda648604d$var$Gj = $866ae7eda648604d$var$B() + 500, $866ae7eda648604d$var$jg()));
            }
            break;
        case 13:
            $866ae7eda648604d$var$Rk(function() {
                var b = $866ae7eda648604d$var$ih(a, 1);
                if (null !== b) {
                    var c = $866ae7eda648604d$var$R();
                    $866ae7eda648604d$var$gi(b, a, 1, c);
                }
            }), $866ae7eda648604d$var$il(a, 1);
    }
};
$866ae7eda648604d$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $866ae7eda648604d$var$ih(a, 134217728);
        if (null !== b) {
            var c = $866ae7eda648604d$var$R();
            $866ae7eda648604d$var$gi(b, a, 134217728, c);
        }
        $866ae7eda648604d$var$il(a, 134217728);
    }
};
$866ae7eda648604d$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $866ae7eda648604d$var$yi(a), c = $866ae7eda648604d$var$ih(a, b);
        if (null !== c) {
            var d = $866ae7eda648604d$var$R();
            $866ae7eda648604d$var$gi(c, a, b, d);
        }
        $866ae7eda648604d$var$il(a, b);
    }
};
$866ae7eda648604d$var$Hc = function() {
    return $866ae7eda648604d$var$C;
};
$866ae7eda648604d$var$Ic = function(a, b) {
    var c = $866ae7eda648604d$var$C;
    try {
        return $866ae7eda648604d$var$C = a, b();
    } finally{
        $866ae7eda648604d$var$C = c;
    }
};
$866ae7eda648604d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $866ae7eda648604d$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $866ae7eda648604d$var$Db(d);
                        if (!e) throw Error($866ae7eda648604d$var$p(90));
                        $866ae7eda648604d$var$Wa(d);
                        $866ae7eda648604d$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $866ae7eda648604d$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $866ae7eda648604d$var$fb(a, !!c.multiple, b, !1);
    }
};
$866ae7eda648604d$var$Gb = $866ae7eda648604d$var$Qk;
$866ae7eda648604d$var$Hb = $866ae7eda648604d$var$Rk;
var $866ae7eda648604d$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $866ae7eda648604d$var$Cb,
        $866ae7eda648604d$var$ue,
        $866ae7eda648604d$var$Db,
        $866ae7eda648604d$var$Eb,
        $866ae7eda648604d$var$Fb,
        $866ae7eda648604d$var$Qk
    ]
}, $866ae7eda648604d$var$tl = {
    findFiberByHostInstance: $866ae7eda648604d$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $866ae7eda648604d$var$ul = {
    bundleType: $866ae7eda648604d$var$tl.bundleType,
    version: $866ae7eda648604d$var$tl.version,
    rendererPackageName: $866ae7eda648604d$var$tl.rendererPackageName,
    rendererConfig: $866ae7eda648604d$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $866ae7eda648604d$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $866ae7eda648604d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $866ae7eda648604d$var$tl.findFiberByHostInstance || $866ae7eda648604d$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $866ae7eda648604d$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$866ae7eda648604d$var$vl.isDisabled && $866ae7eda648604d$var$vl.supportsFiber) try {
        $866ae7eda648604d$var$kc = $866ae7eda648604d$var$vl.inject($866ae7eda648604d$var$ul), $866ae7eda648604d$var$lc = $866ae7eda648604d$var$vl;
    } catch (a) {}
}
$866ae7eda648604d$export$ae55be85d98224ed = $866ae7eda648604d$var$sl;
$866ae7eda648604d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$866ae7eda648604d$var$nl(b)) throw Error($866ae7eda648604d$var$p(200));
    return $866ae7eda648604d$var$cl(a, b, null, c);
};
$866ae7eda648604d$export$882461b6382ed46c = function(a, b) {
    if (!$866ae7eda648604d$var$nl(a)) throw Error($866ae7eda648604d$var$p(299));
    var c = !1, d = "", e = $866ae7eda648604d$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $866ae7eda648604d$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$866ae7eda648604d$var$uf] = b.current;
    $866ae7eda648604d$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $866ae7eda648604d$var$ll(b);
};
$866ae7eda648604d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($866ae7eda648604d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($866ae7eda648604d$var$p(268, a));
    }
    a = $866ae7eda648604d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$866ae7eda648604d$export$cd75ccfd720a3cd4 = function(a) {
    return $866ae7eda648604d$var$Rk(a);
};
$866ae7eda648604d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$866ae7eda648604d$var$ol(b)) throw Error($866ae7eda648604d$var$p(200));
    return $866ae7eda648604d$var$rl(null, a, b, !0, c);
};
$866ae7eda648604d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$866ae7eda648604d$var$nl(a)) throw Error($866ae7eda648604d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $866ae7eda648604d$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $866ae7eda648604d$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$866ae7eda648604d$var$uf] = b.current;
    $866ae7eda648604d$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $866ae7eda648604d$var$ml(b);
};
$866ae7eda648604d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$866ae7eda648604d$var$ol(b)) throw Error($866ae7eda648604d$var$p(200));
    return $866ae7eda648604d$var$rl(null, a, b, !1, c);
};
$866ae7eda648604d$export$502457920280e6be = function(a) {
    if (!$866ae7eda648604d$var$ol(a)) throw Error($866ae7eda648604d$var$p(40));
    return a._reactRootContainer ? ($866ae7eda648604d$var$Rk(function() {
        $866ae7eda648604d$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$866ae7eda648604d$var$uf] = null;
        });
    }), !0) : !1;
};
$866ae7eda648604d$export$c78a37762a8d58e1 = $866ae7eda648604d$var$Qk;
$866ae7eda648604d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$866ae7eda648604d$var$ol(c)) throw Error($866ae7eda648604d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($866ae7eda648604d$var$p(38));
    return $866ae7eda648604d$var$rl(a, b, c, !1, d);
};
$866ae7eda648604d$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("f65uV", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8HRnO"));

});
parcelRegister("8HRnO", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $656bbfa77371e655$export$c4744153514ff05d; }, function (v) { return $656bbfa77371e655$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $656bbfa77371e655$export$3e506c1ccc9cc1a7; }, function (v) { return $656bbfa77371e655$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $656bbfa77371e655$export$e26fe2ed2fa76875; }, function (v) { return $656bbfa77371e655$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $656bbfa77371e655$export$502329bbf4b505b1; }, function (v) { return $656bbfa77371e655$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $656bbfa77371e655$export$6e3807111c4874c4; }, function (v) { return $656bbfa77371e655$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $656bbfa77371e655$export$c27134553091fb3a; }, function (v) { return $656bbfa77371e655$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $656bbfa77371e655$export$33ee1acdc04fd2a2; }, function (v) { return $656bbfa77371e655$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $656bbfa77371e655$export$b00a404bbd5edef2; }, function (v) { return $656bbfa77371e655$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $656bbfa77371e655$export$8352ce38b91d0c62; }, function (v) { return $656bbfa77371e655$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $656bbfa77371e655$export$d66a1c1c77bd778b; }, function (v) { return $656bbfa77371e655$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $656bbfa77371e655$export$d3dfb8e4810cb555; }, function (v) { return $656bbfa77371e655$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $656bbfa77371e655$export$839f9183b0465a69; }, function (v) { return $656bbfa77371e655$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $656bbfa77371e655$export$72fdf0e06517287b; }, function (v) { return $656bbfa77371e655$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $656bbfa77371e655$export$4b844e58a3e414b4; }, function (v) { return $656bbfa77371e655$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $656bbfa77371e655$export$816d2913ae6b83b1; }, function (v) { return $656bbfa77371e655$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $656bbfa77371e655$export$61bcfe829111a1d0; }, function (v) { return $656bbfa77371e655$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $656bbfa77371e655$export$7ee8c9beb337bc3f; }, function (v) { return $656bbfa77371e655$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $656bbfa77371e655$export$b5836b71941fa3ed; }, function (v) { return $656bbfa77371e655$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $656bbfa77371e655$export$cf845f2c119da08a; }, function (v) { return $656bbfa77371e655$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $656bbfa77371e655$export$c4744153514ff05d;
var $656bbfa77371e655$export$3e506c1ccc9cc1a7;
var $656bbfa77371e655$export$e26fe2ed2fa76875;
var $656bbfa77371e655$export$502329bbf4b505b1;
var $656bbfa77371e655$export$6e3807111c4874c4;
var $656bbfa77371e655$export$c27134553091fb3a;
var $656bbfa77371e655$export$33ee1acdc04fd2a2;
var $656bbfa77371e655$export$b00a404bbd5edef2;
var $656bbfa77371e655$export$8352ce38b91d0c62;
var $656bbfa77371e655$export$d66a1c1c77bd778b;
var $656bbfa77371e655$export$d3dfb8e4810cb555;
var $656bbfa77371e655$export$839f9183b0465a69;
var $656bbfa77371e655$export$72fdf0e06517287b;
var $656bbfa77371e655$export$4b844e58a3e414b4;
var $656bbfa77371e655$export$816d2913ae6b83b1;
var $656bbfa77371e655$export$61bcfe829111a1d0;
var $656bbfa77371e655$export$7ee8c9beb337bc3f;
var $656bbfa77371e655$export$b5836b71941fa3ed;
var $656bbfa77371e655$export$cf845f2c119da08a;
'use strict';
function $656bbfa77371e655$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $656bbfa77371e655$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $656bbfa77371e655$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $656bbfa77371e655$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $656bbfa77371e655$var$g(C, c)) n < e && 0 > $656bbfa77371e655$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $656bbfa77371e655$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $656bbfa77371e655$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $656bbfa77371e655$var$l = performance;
    $656bbfa77371e655$export$c4744153514ff05d = function() {
        return $656bbfa77371e655$var$l.now();
    };
} else {
    var $656bbfa77371e655$var$p = Date, $656bbfa77371e655$var$q = $656bbfa77371e655$var$p.now();
    $656bbfa77371e655$export$c4744153514ff05d = function() {
        return $656bbfa77371e655$var$p.now() - $656bbfa77371e655$var$q;
    };
}
var $656bbfa77371e655$var$r = [], $656bbfa77371e655$var$t = [], $656bbfa77371e655$var$u = 1, $656bbfa77371e655$var$v = null, $656bbfa77371e655$var$y = 3, $656bbfa77371e655$var$z = !1, $656bbfa77371e655$var$A = !1, $656bbfa77371e655$var$B = !1, $656bbfa77371e655$var$D = "function" === typeof setTimeout ? setTimeout : null, $656bbfa77371e655$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $656bbfa77371e655$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $656bbfa77371e655$var$G(a) {
    for(var b = $656bbfa77371e655$var$h($656bbfa77371e655$var$t); null !== b;){
        if (null === b.callback) $656bbfa77371e655$var$k($656bbfa77371e655$var$t);
        else if (b.startTime <= a) $656bbfa77371e655$var$k($656bbfa77371e655$var$t), b.sortIndex = b.expirationTime, $656bbfa77371e655$var$f($656bbfa77371e655$var$r, b);
        else break;
        b = $656bbfa77371e655$var$h($656bbfa77371e655$var$t);
    }
}
function $656bbfa77371e655$var$H(a) {
    $656bbfa77371e655$var$B = !1;
    $656bbfa77371e655$var$G(a);
    if (!$656bbfa77371e655$var$A) {
        if (null !== $656bbfa77371e655$var$h($656bbfa77371e655$var$r)) $656bbfa77371e655$var$A = !0, $656bbfa77371e655$var$I($656bbfa77371e655$var$J);
        else {
            var b = $656bbfa77371e655$var$h($656bbfa77371e655$var$t);
            null !== b && $656bbfa77371e655$var$K($656bbfa77371e655$var$H, b.startTime - a);
        }
    }
}
function $656bbfa77371e655$var$J(a, b) {
    $656bbfa77371e655$var$A = !1;
    $656bbfa77371e655$var$B && ($656bbfa77371e655$var$B = !1, $656bbfa77371e655$var$E($656bbfa77371e655$var$L), $656bbfa77371e655$var$L = -1);
    $656bbfa77371e655$var$z = !0;
    var c = $656bbfa77371e655$var$y;
    try {
        $656bbfa77371e655$var$G(b);
        for($656bbfa77371e655$var$v = $656bbfa77371e655$var$h($656bbfa77371e655$var$r); null !== $656bbfa77371e655$var$v && (!($656bbfa77371e655$var$v.expirationTime > b) || a && !$656bbfa77371e655$var$M());){
            var d = $656bbfa77371e655$var$v.callback;
            if ("function" === typeof d) {
                $656bbfa77371e655$var$v.callback = null;
                $656bbfa77371e655$var$y = $656bbfa77371e655$var$v.priorityLevel;
                var e = d($656bbfa77371e655$var$v.expirationTime <= b);
                b = $656bbfa77371e655$export$c4744153514ff05d();
                "function" === typeof e ? $656bbfa77371e655$var$v.callback = e : $656bbfa77371e655$var$v === $656bbfa77371e655$var$h($656bbfa77371e655$var$r) && $656bbfa77371e655$var$k($656bbfa77371e655$var$r);
                $656bbfa77371e655$var$G(b);
            } else $656bbfa77371e655$var$k($656bbfa77371e655$var$r);
            $656bbfa77371e655$var$v = $656bbfa77371e655$var$h($656bbfa77371e655$var$r);
        }
        if (null !== $656bbfa77371e655$var$v) var w = !0;
        else {
            var m = $656bbfa77371e655$var$h($656bbfa77371e655$var$t);
            null !== m && $656bbfa77371e655$var$K($656bbfa77371e655$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $656bbfa77371e655$var$v = null, $656bbfa77371e655$var$y = c, $656bbfa77371e655$var$z = !1;
    }
}
var $656bbfa77371e655$var$N = !1, $656bbfa77371e655$var$O = null, $656bbfa77371e655$var$L = -1, $656bbfa77371e655$var$P = 5, $656bbfa77371e655$var$Q = -1;
function $656bbfa77371e655$var$M() {
    return $656bbfa77371e655$export$c4744153514ff05d() - $656bbfa77371e655$var$Q < $656bbfa77371e655$var$P ? !1 : !0;
}
function $656bbfa77371e655$var$R() {
    if (null !== $656bbfa77371e655$var$O) {
        var a = $656bbfa77371e655$export$c4744153514ff05d();
        $656bbfa77371e655$var$Q = a;
        var b = !0;
        try {
            b = $656bbfa77371e655$var$O(!0, a);
        } finally{
            b ? $656bbfa77371e655$var$S() : ($656bbfa77371e655$var$N = !1, $656bbfa77371e655$var$O = null);
        }
    } else $656bbfa77371e655$var$N = !1;
}
var $656bbfa77371e655$var$S;
if ("function" === typeof $656bbfa77371e655$var$F) $656bbfa77371e655$var$S = function() {
    $656bbfa77371e655$var$F($656bbfa77371e655$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $656bbfa77371e655$var$T = new MessageChannel, $656bbfa77371e655$var$U = $656bbfa77371e655$var$T.port2;
    $656bbfa77371e655$var$T.port1.onmessage = $656bbfa77371e655$var$R;
    $656bbfa77371e655$var$S = function() {
        $656bbfa77371e655$var$U.postMessage(null);
    };
} else $656bbfa77371e655$var$S = function() {
    $656bbfa77371e655$var$D($656bbfa77371e655$var$R, 0);
};
function $656bbfa77371e655$var$I(a) {
    $656bbfa77371e655$var$O = a;
    $656bbfa77371e655$var$N || ($656bbfa77371e655$var$N = !0, $656bbfa77371e655$var$S());
}
function $656bbfa77371e655$var$K(a, b) {
    $656bbfa77371e655$var$L = $656bbfa77371e655$var$D(function() {
        a($656bbfa77371e655$export$c4744153514ff05d());
    }, b);
}
$656bbfa77371e655$export$3e506c1ccc9cc1a7 = 5;
$656bbfa77371e655$export$e26fe2ed2fa76875 = 1;
$656bbfa77371e655$export$502329bbf4b505b1 = 4;
$656bbfa77371e655$export$6e3807111c4874c4 = 3;
$656bbfa77371e655$export$c27134553091fb3a = null;
$656bbfa77371e655$export$33ee1acdc04fd2a2 = 2;
$656bbfa77371e655$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$656bbfa77371e655$export$8352ce38b91d0c62 = function() {
    $656bbfa77371e655$var$A || $656bbfa77371e655$var$z || ($656bbfa77371e655$var$A = !0, $656bbfa77371e655$var$I($656bbfa77371e655$var$J));
};
$656bbfa77371e655$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $656bbfa77371e655$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$656bbfa77371e655$export$d3dfb8e4810cb555 = function() {
    return $656bbfa77371e655$var$y;
};
$656bbfa77371e655$export$839f9183b0465a69 = function() {
    return $656bbfa77371e655$var$h($656bbfa77371e655$var$r);
};
$656bbfa77371e655$export$72fdf0e06517287b = function(a) {
    switch($656bbfa77371e655$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $656bbfa77371e655$var$y;
    }
    var c = $656bbfa77371e655$var$y;
    $656bbfa77371e655$var$y = b;
    try {
        return a();
    } finally{
        $656bbfa77371e655$var$y = c;
    }
};
$656bbfa77371e655$export$4b844e58a3e414b4 = function() {};
$656bbfa77371e655$export$816d2913ae6b83b1 = function() {};
$656bbfa77371e655$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $656bbfa77371e655$var$y;
    $656bbfa77371e655$var$y = a;
    try {
        return b();
    } finally{
        $656bbfa77371e655$var$y = c;
    }
};
$656bbfa77371e655$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $656bbfa77371e655$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $656bbfa77371e655$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $656bbfa77371e655$var$f($656bbfa77371e655$var$t, a), null === $656bbfa77371e655$var$h($656bbfa77371e655$var$r) && a === $656bbfa77371e655$var$h($656bbfa77371e655$var$t) && ($656bbfa77371e655$var$B ? ($656bbfa77371e655$var$E($656bbfa77371e655$var$L), $656bbfa77371e655$var$L = -1) : $656bbfa77371e655$var$B = !0, $656bbfa77371e655$var$K($656bbfa77371e655$var$H, c - d))) : (a.sortIndex = e, $656bbfa77371e655$var$f($656bbfa77371e655$var$r, a), $656bbfa77371e655$var$A || $656bbfa77371e655$var$z || ($656bbfa77371e655$var$A = !0, $656bbfa77371e655$var$I($656bbfa77371e655$var$J)));
    return a;
};
$656bbfa77371e655$export$b5836b71941fa3ed = $656bbfa77371e655$var$M;
$656bbfa77371e655$export$cf845f2c119da08a = function(a) {
    var b = $656bbfa77371e655$var$y;
    return function() {
        var c = $656bbfa77371e655$var$y;
        $656bbfa77371e655$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $656bbfa77371e655$var$y = c;
        }
    };
};

});



var $21dd9f177820ff2c$exports = {};
'use strict';

$21dd9f177820ff2c$exports = (parcelRequire("eR31A"));


var $3ce6d4fd7c55125d$export$882461b6382ed46c;
var $3ce6d4fd7c55125d$export$757ceba2d55c277e;
'use strict';
var $2c95611a366aee83$exports = {};
'use strict';
function $2c95611a366aee83$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2c95611a366aee83$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2c95611a366aee83$var$checkDCE();

$2c95611a366aee83$exports = (parcelRequire("bxv6G"));


var $3ce6d4fd7c55125d$var$i;
$3ce6d4fd7c55125d$export$882461b6382ed46c = $2c95611a366aee83$exports.createRoot;
$3ce6d4fd7c55125d$export$757ceba2d55c277e = $2c95611a366aee83$exports.hydrateRoot;




parcelRequire("Oecye");

const $2a0691316587c38e$export$496092b7fd65ab73 = ()=>{
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
        className: "flex items-center flex-shrink-0 px-4 border-b border-gray-200",
        children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("img", {
            className: "mb-5 h-8 w-auto",
            src: "logo.png",
            alt: "Workflow"
        })
    });
};



const $4261b11f25903bd9$export$4fadf7173d176eed = (props)=>{
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
        className: "grid grid-cols-2 gap-2 p-4 border-b border-gray-200",
        children: [
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                className: "add-cube w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none",
                onClick: ()=>props.addShelf({
                        size: 'small'
                    }),
                children: "Add Small Shelf"
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                className: "add-cube w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none",
                onClick: ()=>props.addShelf({
                        size: 'wide'
                    }),
                children: "Add Wide Shelf"
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                className: "add-cube add-cube__tall w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none",
                onClick: ()=>props.addShelf({
                        size: 'tall'
                    }),
                children: "Add Tall Shelf"
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                className: "add-cube w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none",
                onClick: ()=>props.addShelf({
                        size: 'large'
                    }),
                children: "Add Large Shelf"
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                className: "add-cube add-cube__small-corner w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none",
                onClick: ()=>props.addShelf({
                        size: 'small-corner'
                    }),
                children: "Add Small Corner"
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                className: "add-cube add-cube__tall-corner w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none",
                onClick: ()=>props.addShelf({
                        size: 'tall-corner'
                    }),
                children: "Add Tall Corner"
            })
        ]
    });
};




var $298d7f63cb6ef7fd$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($298d7f63cb6ef7fd$exports) {
        classNames.default = classNames;
        $298d7f63cb6ef7fd$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $0135d6f09823399c$export$7e7c270d6968624d = (props)=>{
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($298d7f63cb6ef7fd$exports)))({
            "relative block select-none rounded-lg border border-gray-300 bg-white shadow-sm px-4 py-4 cursor-pointer hover:border-gray-400 sm:justify-between focus-within:ring-1 focus-within:ring-offset-2 focus-within:ring-blue-500 hidden style-button style-button-back": true,
            [props.additionalClass]: true
        }),
        children: [
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("input", {
                onClick: ()=>props.handleClick(),
                type: "checkbox",
                name: "server_size",
                value: "Hobby",
                className: "sr-only",
                "aria-labelledby": "server-size-0-label",
                "aria-describedby": "server-size-0-description-0 server-size-0-description-1"
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "w-full flex items-center",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                    className: "w-full text-sm justify-items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                            className: "style-button-text font-medium text-gray-900",
                            children: props.shelfPart
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                            className: "text-gray-500 text-right"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "toggle border-transparent absolute -inset-px rounded-lg border-4 pointer-events-none",
                "aria-hidden": "true"
            })
        ]
    });
};


const $301cb620d3120f03$export$afb1f38cca327946 = (props)=>{
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("fieldset", {
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                        className: "space-y-1",
                        children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("label", {
                            className: "relative block rounded-lg border border-gray-300 bg-white shadow-sm px-4 py-4 cursor-pointer hover:border-gray-400 sm:justify-between focus-within:ring-1 focus-within:ring-offset-2 focus-within:ring-blue-500 sm:flex style-info",
                            children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("span", {
                                children: "Drag a box to rearrange your layout. Click a box to add drawers, doors, shelves, or a back."
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("legend", {
                            className: "sr-only",
                            children: "Options"
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                    additionalClass: "style-button-back",
                                    shelfPart: "Back",
                                    handleClick: ()=>props.toggleBackVisibility()
                                }),
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                    additionalClass: "style-button-door",
                                    shelfPart: "Door",
                                    handleClick: ()=>props.toggleDoorVisibility()
                                }),
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                    additionalClass: "style-button-shelves",
                                    shelfPart: "Shelves",
                                    handleClick: ()=>props.toggleShelfVisibility()
                                }),
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                    additionalClass: "style-button-cross-divider",
                                    shelfPart: "Cross Divider",
                                    handleClick: ()=>props.toggleCrossDivider()
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "mt-4",
                id: "box-corner",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("legend", {
                            className: "sr-only",
                            children: "Corner"
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                            className: "space-y-1",
                            children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                additionalClass: "style-button-corner",
                                shelfPart: "Corner direction",
                                handleClick: ()=>props.toggleCornerDirection()
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("legend", {
                            className: "sr-only",
                            children: "Drawers"
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                    additionalClass: "style-button-top-drawer",
                                    shelfPart: "Top Drawer",
                                    handleClick: ()=>props.toggleTopDrawerVisibility()
                                }),
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                    additionalClass: "style-button-middle-drawer",
                                    shelfPart: "Middle Drawer",
                                    handleClick: ()=>props.toggleMiddleDrawerVisibility()
                                }),
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                                    additionalClass: "style-button-bottom-drawer",
                                    shelfPart: "Bottom Drawer",
                                    handleClick: ()=>props.toggleBottomDrawerVisibility()
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("fieldset", {
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                        className: "space-y-1",
                        children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $0135d6f09823399c$export$7e7c270d6968624d), {
                            additionalClass: "style-button-delete",
                            shelfPart: "Delete",
                            handleClick: ()=>props.deleteShelf()
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("fieldset", {
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                        className: "space-y-1",
                        children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("label", {
                            className: "relative block rounded-lg border border-gray-300 bg-white shadow-sm px-4 py-4 cursor-pointer hover:border-gray-400 sm:justify-between focus-within:ring-1 focus-within:ring-offset-2 focus-within:ring-blue-500 hidden style-cube-info",
                            children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("span", {
                                children: "Drawers, doors, and shelves are sold in pairs."
                            })
                        })
                    })
                })
            })
        ]
    });
};



parcelRequire("Oecye");
const $33453e2a8d4171e9$export$64369a5f646770e0 = (props)=>{
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)((0, $21dd9f177820ff2c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "flex-shrink-0 flex border-t border-gray-200 p-4",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                    className: "flex-shrink-0 w-full group block",
                    id: "share-config-button",
                    "data-clipboard-text": "Just because you can doesn't mean you should \u2014 clipboard.js",
                    onClick: ()=>props.shareLinkCopied(),
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                        className: "flex items-center text-sm font-medium text-gray-700 group-hover:text-gray-900",
                        children: [
                            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("svg", {
                                className: "mr-3 flex-shrink-0 h-6 w-6",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                                })
                            }),
                            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("span", {
                                children: "Share Your Configuration"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                id: "checkout-button",
                className: "flex-shrink-0 flex border-t border-gray-200 p-4",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("a", {
                    href: "#",
                    className: "flex-shrink-0 w-full group block",
                    onClick: ()=>props.viewCart(true),
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                        className: "flex items-center text-sm font-medium text-gray-700 group-hover:text-gray-900",
                        children: [
                            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("svg", {
                                className: "mr-3 flex-shrink-0 h-6 w-6",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                })
                            }),
                            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("span", {
                                id: "checkout-button-text",
                                children: "View Cart"
                            })
                        ]
                    })
                })
            })
        ]
    });
};


const $4a7bed594a660712$export$d9b273488cd8ce6f = (props)=>{
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
        className: "flex flex-col w-64",
        children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
            className: "flex flex-col h-0 flex-1 border-r border-gray-200 bg-white",
            children: [
                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                    className: "flex-1 flex flex-col pt-5 pb-4 overflow-y-auto",
                    children: [
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $2a0691316587c38e$export$496092b7fd65ab73), {}),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $4261b11f25903bd9$export$4fadf7173d176eed), {
                            addShelf: props.addShelf
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $301cb620d3120f03$export$afb1f38cca327946), {
                            toggleBackVisibility: props.toggleBackVisibility,
                            toggleDoorVisibility: props.toggleDoorVisibility,
                            toggleShelfVisibility: props.toggleShelfVisibility,
                            toggleCrossDivider: props.toggleCrossDivider,
                            toggleCornerDirection: props.toggleCornerDirection,
                            toggleTopDrawerVisibility: props.toggleTopDrawerVisibility,
                            toggleMiddleDrawerVisibility: props.toggleMiddleDrawerVisibility,
                            toggleBottomDrawerVisibility: props.toggleBottomDrawerVisibility,
                            deleteShelf: props.deleteShelf
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $33453e2a8d4171e9$export$64369a5f646770e0), {
                    shareLinkCopied: props.shareLinkCopied,
                    viewCart: props.viewCart
                })
            ]
        })
    });
};


var $ceae686dc723e5bf$exports = {};
"use strict";
Object.defineProperty($ceae686dc723e5bf$exports, "__esModule", {
    value: true
});
var $3eea5e3bd2d7a29a$exports = {};
"use strict";
Object.defineProperty($3eea5e3bd2d7a29a$exports, "__esModule", {
    value: true
});
$3eea5e3bd2d7a29a$exports.Konva = void 0;
var $0da745bb31935f3f$exports = {};
"use strict";
Object.defineProperty($0da745bb31935f3f$exports, "__esModule", {
    value: true
});
$0da745bb31935f3f$exports.Konva = void 0;
var $ab25e7d252931ba2$exports = {};
"use strict";
Object.defineProperty($ab25e7d252931ba2$exports, "__esModule", {
    value: true
});
$ab25e7d252931ba2$exports._registerNode = $ab25e7d252931ba2$exports.Konva = $ab25e7d252931ba2$exports.glob = void 0;
const $ab25e7d252931ba2$var$PI_OVER_180 = Math.PI / 180;
function $ab25e7d252931ba2$var$detectBrowser() {
    return typeof window !== 'undefined' && (({}).toString.call(window) === '[object Window]' || ({}).toString.call(window) === '[object global]');
}
$ab25e7d252931ba2$exports.glob = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : {};
$ab25e7d252931ba2$exports.Konva = {
    _global: $ab25e7d252931ba2$exports.glob,
    version: '9.3.22',
    isBrowser: $ab25e7d252931ba2$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $ab25e7d252931ba2$exports.Konva.angleDeg ? angle * $ab25e7d252931ba2$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    _fixTextRendering: false,
    pixelRatio: typeof window !== 'undefined' && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $ab25e7d252931ba2$exports.Konva['DD'].isDragging;
    },
    isTransforming () {
        var _a;
        return (_a = $ab25e7d252931ba2$exports.Konva['Transformer']) === null || _a === void 0 ? void 0 : _a.isTransforming();
    },
    isDragReady () {
        return !!$ab25e7d252931ba2$exports.Konva['DD'].node;
    },
    releaseCanvasOnDestroy: true,
    document: $ab25e7d252931ba2$exports.glob.document,
    _injectGlobal (Konva) {
        $ab25e7d252931ba2$exports.glob.Konva = Konva;
    }
};
const $ab25e7d252931ba2$var$_registerNode = (NodeClass)=>{
    $ab25e7d252931ba2$exports.Konva[NodeClass.prototype.getClassName()] = NodeClass;
};
$ab25e7d252931ba2$exports._registerNode = $ab25e7d252931ba2$var$_registerNode;
$ab25e7d252931ba2$exports.Konva._injectGlobal($ab25e7d252931ba2$exports.Konva);


var $e18dc6b8d0616da8$exports = {};
"use strict";
Object.defineProperty($e18dc6b8d0616da8$exports, "__esModule", {
    value: true
});
$e18dc6b8d0616da8$exports.Util = $e18dc6b8d0616da8$exports.Transform = void 0;

class $e18dc6b8d0616da8$var$Transform {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $e18dc6b8d0616da8$var$Transform(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        const m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        const c = Math.cos(rad);
        const s = Math.sin(rad);
        const m11 = this.m[0] * c + this.m[2] * s;
        const m12 = this.m[1] * c + this.m[3] * s;
        const m21 = this.m[0] * -s + this.m[2] * c;
        const m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        const m11 = this.m[0] + this.m[2] * sy;
        const m12 = this.m[1] + this.m[3] * sy;
        const m21 = this.m[2] + this.m[0] * sx;
        const m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        const m0 = this.m[3] * d;
        const m1 = -this.m[1] * d;
        const m2 = -this.m[2] * d;
        const m3 = this.m[0] * d;
        const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        const a = this.m[0];
        const b = this.m[1];
        const c = this.m[2];
        const d = this.m[3];
        const e = this.m[4];
        const f = this.m[5];
        const delta = a * d - b * c;
        const result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            const r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            const s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $e18dc6b8d0616da8$exports.Util._getRotation(result.rotation);
        return result;
    }
}
$e18dc6b8d0616da8$exports.Transform = $e18dc6b8d0616da8$var$Transform;
const $e18dc6b8d0616da8$var$OBJECT_ARRAY = '[object Array]', $e18dc6b8d0616da8$var$OBJECT_NUMBER = '[object Number]', $e18dc6b8d0616da8$var$OBJECT_STRING = '[object String]', $e18dc6b8d0616da8$var$OBJECT_BOOLEAN = '[object Boolean]', $e18dc6b8d0616da8$var$PI_OVER_DEG180 = Math.PI / 180, $e18dc6b8d0616da8$var$DEG180_OVER_PI = 180 / Math.PI, $e18dc6b8d0616da8$var$HASH = '#', $e18dc6b8d0616da8$var$EMPTY_STRING = '', $e18dc6b8d0616da8$var$ZERO = '0', $e18dc6b8d0616da8$var$KONVA_WARNING = 'Konva warning: ', $e18dc6b8d0616da8$var$KONVA_ERROR = 'Konva error: ', $e18dc6b8d0616da8$var$RGB_PAREN = 'rgb(', $e18dc6b8d0616da8$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $e18dc6b8d0616da8$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
let $e18dc6b8d0616da8$var$animQueue = [];
const $e18dc6b8d0616da8$var$req = typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
$e18dc6b8d0616da8$exports.Util = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $e18dc6b8d0616da8$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $e18dc6b8d0616da8$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $e18dc6b8d0616da8$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $e18dc6b8d0616da8$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== 'string') return false;
        const firstChar = selector[0];
        return firstChar === '#' || firstChar === '.' || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $e18dc6b8d0616da8$var$animQueue.push(callback);
        if ($e18dc6b8d0616da8$var$animQueue.length === 1) $e18dc6b8d0616da8$var$req(function() {
            const queue = $e18dc6b8d0616da8$var$animQueue;
            $e18dc6b8d0616da8$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        const canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        return document.createElement('img');
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        const imageObj = $e18dc6b8d0616da8$exports.Util.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($e18dc6b8d0616da8$var$HASH, $e18dc6b8d0616da8$var$EMPTY_STRING);
        const bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        let randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $e18dc6b8d0616da8$var$ZERO + randColor;
        return $e18dc6b8d0616da8$var$HASH + randColor;
    },
    getRGB (color) {
        let rgb;
        if (color in $e18dc6b8d0616da8$var$COLORS) {
            rgb = $e18dc6b8d0616da8$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $e18dc6b8d0616da8$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $e18dc6b8d0616da8$var$RGB_PAREN) {
            rgb = $e18dc6b8d0616da8$var$RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || 'black';
        return $e18dc6b8d0616da8$exports.Util._namedColorToRBA(str) || $e18dc6b8d0616da8$exports.Util._hex3ColorToRGBA(str) || $e18dc6b8d0616da8$exports.Util._hex4ColorToRGBA(str) || $e18dc6b8d0616da8$exports.Util._hex6ColorToRGBA(str) || $e18dc6b8d0616da8$exports.Util._hex8ColorToRGBA(str) || $e18dc6b8d0616da8$exports.Util._rgbColorToRGBA(str) || $e18dc6b8d0616da8$exports.Util._rgbaColorToRGBA(str) || $e18dc6b8d0616da8$exports.Util._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        const c = $e18dc6b8d0616da8$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === '%') return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        const retObj = {};
        for(const key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $e18dc6b8d0616da8$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $e18dc6b8d0616da8$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $e18dc6b8d0616da8$exports.Util.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
        return $e18dc6b8d0616da8$exports.Util.degToRad(deg);
    },
    _radToDeg (rad) {
        $e18dc6b8d0616da8$exports.Util.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
        return $e18dc6b8d0616da8$exports.Util.radToDeg(rad);
    },
    _getRotation (radians) {
        return $ab25e7d252931ba2$exports.Konva.angleDeg ? $e18dc6b8d0616da8$exports.Util.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($e18dc6b8d0616da8$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($e18dc6b8d0616da8$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!$ab25e7d252931ba2$exports.Konva.showWarnings) return;
        console.warn($e18dc6b8d0616da8$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(const key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        let x, y, dist;
        const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            const u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        const pc = $e18dc6b8d0616da8$exports.Util.cloneObject(pt);
        let dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            const p2 = line[(i + 1) % line.length];
            const proj = $e18dc6b8d0616da8$exports.Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            const px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        const start = [], end = [];
        if (startArray.length > endArray.length) {
            const temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(let n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(let n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        const newStart = [];
        end.forEach(function(point) {
            const pr = $e18dc6b8d0616da8$exports.Util._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        let desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(const key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $e18dc6b8d0616da8$exports.Util._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($e18dc6b8d0616da8$exports.Util._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(const key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!$ab25e7d252931ba2$exports.Konva.releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(topLeft, 0);
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    }
};


var $9165dcaf5c4d4c7d$exports = {};
"use strict";
Object.defineProperty($9165dcaf5c4d4c7d$exports, "__esModule", {
    value: true
});
$9165dcaf5c4d4c7d$exports.Node = void 0;
var $ba6d4fe86aeb546f$exports = {};
"use strict";
Object.defineProperty($ba6d4fe86aeb546f$exports, "__esModule", {
    value: true
});
$ba6d4fe86aeb546f$exports.HitCanvas = $ba6d4fe86aeb546f$exports.SceneCanvas = $ba6d4fe86aeb546f$exports.Canvas = void 0;

var $763151d76d51961e$exports = {};
"use strict";
Object.defineProperty($763151d76d51961e$exports, "__esModule", {
    value: true
});
$763151d76d51961e$exports.HitContext = $763151d76d51961e$exports.SceneContext = $763151d76d51961e$exports.Context = void 0;


function $763151d76d51961e$var$simplifyArray(arr) {
    const retArr = [], len = arr.length, util = $e18dc6b8d0616da8$exports.Util;
    for(let n = 0; n < len; n++){
        let val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + '';
        retArr.push(val);
    }
    return retArr;
}
const $763151d76d51961e$var$COMMA = ',', $763151d76d51961e$var$OPEN_PAREN = '(', $763151d76d51961e$var$CLOSE_PAREN = ')', $763151d76d51961e$var$OPEN_PAREN_BRACKET = '([', $763151d76d51961e$var$CLOSE_BRACKET_PAREN = '])', $763151d76d51961e$var$SEMICOLON = ';', $763151d76d51961e$var$DOUBLE_PAREN = '()', $763151d76d51961e$var$EQUALS = '=', $763151d76d51961e$var$CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'roundRect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate'
];
const $763151d76d51961e$var$CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'letterSpacing',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'direction',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled'
];
const $763151d76d51961e$var$traceArrMax = 100;
class $763151d76d51961e$var$Context {
    constructor(canvas){
        this.canvas = canvas;
        if ($ab25e7d252931ba2$exports.Konva.enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        let traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $763151d76d51961e$var$DOUBLE_PAREN;
                else if ($e18dc6b8d0616da8$exports.Util._isArray(args[0])) str += $763151d76d51961e$var$OPEN_PAREN_BRACKET + args.join($763151d76d51961e$var$COMMA) + $763151d76d51961e$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === 'number' ? Math.floor(a) : a);
                    str += $763151d76d51961e$var$OPEN_PAREN + args.join($763151d76d51961e$var$COMMA) + $763151d76d51961e$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $763151d76d51961e$var$EQUALS + trace.val;
            }
            str += $763151d76d51961e$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        let traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $763151d76d51961e$var$traceArrMax) traceArr.shift();
    }
    reset() {
        const pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        const canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr('lineCap', lineCap);
    }
    _applyOpacity(shape) {
        const absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr('globalAlpha', absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr('lineJoin', lineJoin);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(x, y, radius, startAngle, endAngle, counterClockwise) {
        this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
    }
    arcTo(x1, y1, x2, y2, radius) {
        this._context.arcTo(x1, y1, x2, y2, radius);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    }
    clearRect(x, y, width, height) {
        this._context.clearRect(x, y, width, height);
    }
    clip(...args) {
        this._context.clip.apply(this._context, args);
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(width, height) {
        const a = arguments;
        if (a.length === 2) return this._context.createImageData(width, height);
        else if (a.length === 1) return this._context.createImageData(width);
    }
    createLinearGradient(x0, y0, x1, y1) {
        return this._context.createLinearGradient(x0, y0, x1, y1);
    }
    createPattern(image, repetition) {
        return this._context.createPattern(image, repetition);
    }
    createRadialGradient(x0, y0, r0, x1, y1, r1) {
        return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
    }
    drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
        const a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(image, sx, sy);
        else if (a.length === 5) _context.drawImage(image, sx, sy, sWidth, sHeight);
        else if (a.length === 9) _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
    }
    ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
        this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(...args) {
        this._context.fill.apply(this._context, args);
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(sx, sy, sw, sh) {
        return this._context.getImageData(sx, sy, sw, sh);
    }
    lineTo(x, y) {
        this._context.lineTo(x, y);
    }
    moveTo(x, y) {
        this._context.moveTo(x, y);
    }
    rect(x, y, width, height) {
        this._context.rect(x, y, width, height);
    }
    roundRect(x, y, width, height, radii) {
        this._context.roundRect(x, y, width, height, radii);
    }
    putImageData(imageData, dx, dy) {
        this._context.putImageData(imageData, dx, dy);
    }
    quadraticCurveTo(cpx, cpy, x, y) {
        this._context.quadraticCurveTo(cpx, cpy, x, y);
    }
    restore() {
        this._context.restore();
    }
    rotate(angle) {
        this._context.rotate(angle);
    }
    save() {
        this._context.save();
    }
    scale(x, y) {
        this._context.scale(x, y);
    }
    setLineDash(segments) {
        if (this._context.setLineDash) this._context.setLineDash(segments);
        else if ('mozDash' in this._context) this._context['mozDash'] = segments;
        else if ('webkitLineDash' in this._context) this._context['webkitLineDash'] = segments;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a, b, c, d, e, f) {
        this._context.setTransform(a, b, c, d, e, f);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(text, x, y, maxWidth) {
        this._context.strokeText(text, x, y, maxWidth);
    }
    transform(a, b, c, d, e, f) {
        this._context.transform(a, b, c, d, e, f);
    }
    translate(x, y) {
        this._context.translate(x, y);
    }
    _enableTrace() {
        let that = this, len = $763151d76d51961e$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        const func = function(methodName) {
            let origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $763151d76d51961e$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($763151d76d51961e$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            const prop = arguments[0];
            let val = arguments[1];
            if (prop === 'shadowOffsetX' || prop === 'shadowOffsetY' || prop === 'shadowBlur') val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        const def = !op || op === 'source-over';
        if (!def) this.setAttr('globalCompositeOperation', op);
    }
}
$763151d76d51961e$exports.Context = $763151d76d51961e$var$Context;
$763151d76d51961e$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($763151d76d51961e$var$Context.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $763151d76d51961e$var$SceneContext extends $763151d76d51961e$var$Context {
    constructor(canvas, { willReadFrequently: willReadFrequently = false } = {}){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: willReadFrequently
        });
    }
    _fillColor(shape) {
        const fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        const grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr('strokeStyle', grd);
        }
    }
    _stroke(shape) {
        const dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            const hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr('strokeStyle', shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
}
$763151d76d51961e$exports.SceneContext = $763151d76d51961e$var$SceneContext;
class $763151d76d51961e$var$HitContext extends $763151d76d51961e$var$Context {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            const hitStrokeWidth = shape.hitStrokeWidth();
            const strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}
$763151d76d51961e$exports.HitContext = $763151d76d51961e$var$HitContext;



let $ba6d4fe86aeb546f$var$_pixelRatio;
function $ba6d4fe86aeb546f$var$getDevicePixelRatio() {
    if ($ba6d4fe86aeb546f$var$_pixelRatio) return $ba6d4fe86aeb546f$var$_pixelRatio;
    const canvas = $e18dc6b8d0616da8$exports.Util.createCanvasElement();
    const context = canvas.getContext('2d');
    $ba6d4fe86aeb546f$var$_pixelRatio = function() {
        const devicePixelRatio = $ab25e7d252931ba2$exports.Konva._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    $e18dc6b8d0616da8$exports.Util.releaseCanvas(canvas);
    return $ba6d4fe86aeb546f$var$_pixelRatio;
}
class $ba6d4fe86aeb546f$var$Canvas {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        const conf = config || {};
        const pixelRatio = conf.pixelRatio || $ab25e7d252931ba2$exports.Konva.pixelRatio || $ba6d4fe86aeb546f$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = $e18dc6b8d0616da8$exports.Util.createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        const previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                $e18dc6b8d0616da8$exports.Util.error('Unable to get data URL. ' + err.message + ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    }
}
$ba6d4fe86aeb546f$exports.Canvas = $ba6d4fe86aeb546f$var$Canvas;
class $ba6d4fe86aeb546f$var$SceneCanvas extends $ba6d4fe86aeb546f$var$Canvas {
    constructor(config = {
        width: 0,
        height: 0,
        willReadFrequently: false
    }){
        super(config);
        this.context = new $763151d76d51961e$exports.SceneContext(this, {
            willReadFrequently: config.willReadFrequently
        });
        this.setSize(config.width, config.height);
    }
}
$ba6d4fe86aeb546f$exports.SceneCanvas = $ba6d4fe86aeb546f$var$SceneCanvas;
class $ba6d4fe86aeb546f$var$HitCanvas extends $ba6d4fe86aeb546f$var$Canvas {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new $763151d76d51961e$exports.HitContext(this);
        this.setSize(config.width, config.height);
    }
}
$ba6d4fe86aeb546f$exports.HitCanvas = $ba6d4fe86aeb546f$var$HitCanvas;


var $5b212d8cfde4575b$exports = {};
"use strict";
Object.defineProperty($5b212d8cfde4575b$exports, "__esModule", {
    value: true
});
$5b212d8cfde4575b$exports.DD = void 0;


$5b212d8cfde4575b$exports.DD = {
    get isDragging () {
        let flag = false;
        $5b212d8cfde4575b$exports.DD._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging') flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        let node;
        $5b212d8cfde4575b$exports.DD._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $5b212d8cfde4575b$exports.DD._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = $e18dc6b8d0616da8$exports.Util._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== 'dragging') {
                const dragDistance = node.dragDistance();
                const distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $5b212d8cfde4575b$exports.DD._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                $5b212d8cfde4575b$exports.DD.justDragged = true;
                $ab25e7d252931ba2$exports.Konva._mouseListenClick = false;
                $ab25e7d252931ba2$exports.Konva._touchListenClick = false;
                $ab25e7d252931ba2$exports.Konva._pointerListenClick = false;
                elem.dragStatus = 'stopped';
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof $ab25e7d252931ba2$exports.Konva['Stage'] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $5b212d8cfde4575b$exports.DD._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === 'stopped') elem.node.fire('dragend', {
                type: 'dragend',
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== 'dragging') $5b212d8cfde4575b$exports.DD._dragElements.delete(key);
        });
    }
};
if ($ab25e7d252931ba2$exports.Konva.isBrowser) {
    window.addEventListener('mouseup', $5b212d8cfde4575b$exports.DD._endDragBefore, true);
    window.addEventListener('touchend', $5b212d8cfde4575b$exports.DD._endDragBefore, true);
    window.addEventListener('touchcancel', $5b212d8cfde4575b$exports.DD._endDragBefore, true);
    window.addEventListener('mousemove', $5b212d8cfde4575b$exports.DD._drag);
    window.addEventListener('touchmove', $5b212d8cfde4575b$exports.DD._drag);
    window.addEventListener('mouseup', $5b212d8cfde4575b$exports.DD._endDragAfter, false);
    window.addEventListener('touchend', $5b212d8cfde4575b$exports.DD._endDragAfter, false);
    window.addEventListener('touchcancel', $5b212d8cfde4575b$exports.DD._endDragAfter, false);
}


var $6f82f2528fae78ce$exports = {};
"use strict";
Object.defineProperty($6f82f2528fae78ce$exports, "__esModule", {
    value: true
});
$6f82f2528fae78ce$exports.Factory = void 0;

var $aae05bbbe3f82503$exports = {};
"use strict";
Object.defineProperty($aae05bbbe3f82503$exports, "__esModule", {
    value: true
});
$aae05bbbe3f82503$exports.RGBComponent = $aae05bbbe3f82503$var$RGBComponent;
$aae05bbbe3f82503$exports.alphaComponent = $aae05bbbe3f82503$var$alphaComponent;
$aae05bbbe3f82503$exports.getNumberValidator = $aae05bbbe3f82503$var$getNumberValidator;
$aae05bbbe3f82503$exports.getNumberOrArrayOfNumbersValidator = $aae05bbbe3f82503$var$getNumberOrArrayOfNumbersValidator;
$aae05bbbe3f82503$exports.getNumberOrAutoValidator = $aae05bbbe3f82503$var$getNumberOrAutoValidator;
$aae05bbbe3f82503$exports.getStringValidator = $aae05bbbe3f82503$var$getStringValidator;
$aae05bbbe3f82503$exports.getStringOrGradientValidator = $aae05bbbe3f82503$var$getStringOrGradientValidator;
$aae05bbbe3f82503$exports.getFunctionValidator = $aae05bbbe3f82503$var$getFunctionValidator;
$aae05bbbe3f82503$exports.getNumberArrayValidator = $aae05bbbe3f82503$var$getNumberArrayValidator;
$aae05bbbe3f82503$exports.getBooleanValidator = $aae05bbbe3f82503$var$getBooleanValidator;
$aae05bbbe3f82503$exports.getComponentValidator = $aae05bbbe3f82503$var$getComponentValidator;


function $aae05bbbe3f82503$var$_formatValue(val) {
    if ($e18dc6b8d0616da8$exports.Util._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === '[object Number]') return val;
    if ($e18dc6b8d0616da8$exports.Util._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $aae05bbbe3f82503$var$RGBComponent(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $aae05bbbe3f82503$var$alphaComponent(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
function $aae05bbbe3f82503$var$getNumberValidator() {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        if (!$e18dc6b8d0616da8$exports.Util._isNumber(val)) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $aae05bbbe3f82503$var$getNumberOrArrayOfNumbersValidator(noOfElements) {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        let isNumber = $e18dc6b8d0616da8$exports.Util._isNumber(val);
        let isValidArray = $e18dc6b8d0616da8$exports.Util._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
        return val;
    };
}
function $aae05bbbe3f82503$var$getNumberOrAutoValidator() {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        const isNumber = $e18dc6b8d0616da8$exports.Util._isNumber(val);
        const isAuto = val === 'auto';
        if (!(isNumber || isAuto)) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $aae05bbbe3f82503$var$getStringValidator() {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        if (!$e18dc6b8d0616da8$exports.Util._isString(val)) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $aae05bbbe3f82503$var$getStringOrGradientValidator() {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        const isString = $e18dc6b8d0616da8$exports.Util._isString(val);
        const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' || val && val['addColorStop'];
        if (!(isString || isGradient)) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $aae05bbbe3f82503$var$getFunctionValidator() {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        if (!$e18dc6b8d0616da8$exports.Util._isFunction(val)) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
function $aae05bbbe3f82503$var$getNumberArrayValidator() {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!$e18dc6b8d0616da8$exports.Util._isArray(val)) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!$e18dc6b8d0616da8$exports.Util._isNumber(item)) $e18dc6b8d0616da8$exports.Util.warn('"' + attr + '" attribute has non numeric element ' + item + '. Make sure that all elements are numbers.');
        });
        return val;
    };
}
function $aae05bbbe3f82503$var$getBooleanValidator() {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        const isBool = val === true || val === false;
        if (!isBool) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $aae05bbbe3f82503$var$getComponentValidator(components) {
    if ($ab25e7d252931ba2$exports.Konva.isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!$e18dc6b8d0616da8$exports.Util.isObject(val)) $e18dc6b8d0616da8$exports.Util.warn($aae05bbbe3f82503$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


const $6f82f2528fae78ce$var$GET = 'get';
const $6f82f2528fae78ce$var$SET = 'set';
$6f82f2528fae78ce$exports.Factory = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $6f82f2528fae78ce$exports.Factory.addGetter(constructor, attr, def);
        $6f82f2528fae78ce$exports.Factory.addSetter(constructor, attr, validator, after);
        $6f82f2528fae78ce$exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        const method = $6f82f2528fae78ce$var$GET + $e18dc6b8d0616da8$exports.Util._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            const val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        const method = $6f82f2528fae78ce$var$SET + $e18dc6b8d0616da8$exports.Util._capitalize(attr);
        if (!constructor.prototype[method]) $6f82f2528fae78ce$exports.Factory.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        const method = $6f82f2528fae78ce$var$SET + $e18dc6b8d0616da8$exports.Util._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        const len = components.length, capitalize = $e18dc6b8d0616da8$exports.Util._capitalize, getter = $6f82f2528fae78ce$var$GET + capitalize(attr), setter = $6f82f2528fae78ce$var$SET + capitalize(attr);
        constructor.prototype[getter] = function() {
            const ret = {};
            for(let n = 0; n < len; n++){
                const component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        const basicValidator = (0, $aae05bbbe3f82503$exports.getComponentValidator)(components);
        constructor.prototype[setter] = function(val) {
            const oldVal = this.attrs[attr];
            if (validator) val = validator.call(this, val, attr);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(const key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $6f82f2528fae78ce$exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        const capitalizedAttr = $e18dc6b8d0616da8$exports.Util._capitalize(attr), setter = $6f82f2528fae78ce$var$SET + capitalizedAttr, getter = $6f82f2528fae78ce$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        $e18dc6b8d0616da8$exports.Util.error('Adding deprecated ' + attr);
        const method = $6f82f2528fae78ce$var$GET + $e18dc6b8d0616da8$exports.Util._capitalize(attr);
        const message = attr + ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function() {
            $e18dc6b8d0616da8$exports.Util.error(message);
            const val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $6f82f2528fae78ce$exports.Factory.addSetter(constructor, attr, validator, function() {
            $e18dc6b8d0616da8$exports.Util.error(message);
        });
        $6f82f2528fae78ce$exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        $e18dc6b8d0616da8$exports.Util.each(methods, function(oldMethodName, newMethodName) {
            const method = constructor.prototype[newMethodName];
            const oldGetter = $6f82f2528fae78ce$var$GET + $e18dc6b8d0616da8$exports.Util._capitalize(oldMethodName);
            const oldSetter = $6f82f2528fae78ce$var$SET + $e18dc6b8d0616da8$exports.Util._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                $e18dc6b8d0616da8$exports.Util.error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





const $9165dcaf5c4d4c7d$var$ABSOLUTE_OPACITY = 'absoluteOpacity', $9165dcaf5c4d4c7d$var$ALL_LISTENERS = 'allEventListeners', $9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM = 'absoluteTransform', $9165dcaf5c4d4c7d$var$ABSOLUTE_SCALE = 'absoluteScale', $9165dcaf5c4d4c7d$var$CANVAS = 'canvas', $9165dcaf5c4d4c7d$var$CHANGE = 'Change', $9165dcaf5c4d4c7d$var$CHILDREN = 'children', $9165dcaf5c4d4c7d$var$KONVA = 'konva', $9165dcaf5c4d4c7d$var$LISTENING = 'listening', $9165dcaf5c4d4c7d$var$MOUSEENTER = 'mouseenter', $9165dcaf5c4d4c7d$var$MOUSELEAVE = 'mouseleave', $9165dcaf5c4d4c7d$var$POINTERENTER = 'pointerenter', $9165dcaf5c4d4c7d$var$POINTERLEAVE = 'pointerleave', $9165dcaf5c4d4c7d$var$TOUCHENTER = 'touchenter', $9165dcaf5c4d4c7d$var$TOUCHLEAVE = 'touchleave', $9165dcaf5c4d4c7d$var$NAME = 'name', $9165dcaf5c4d4c7d$var$SET = 'set', $9165dcaf5c4d4c7d$var$SHAPE = 'Shape', $9165dcaf5c4d4c7d$var$SPACE = ' ', $9165dcaf5c4d4c7d$var$STAGE = 'stage', $9165dcaf5c4d4c7d$var$TRANSFORM = 'transform', $9165dcaf5c4d4c7d$var$UPPER_STAGE = 'Stage', $9165dcaf5c4d4c7d$var$VISIBLE = 'visible', $9165dcaf5c4d4c7d$var$TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
].join($9165dcaf5c4d4c7d$var$SPACE);
let $9165dcaf5c4d4c7d$var$idCounter = 1;
class $9165dcaf5c4d4c7d$var$Node {
    constructor(config){
        this._id = $9165dcaf5c4d4c7d$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $9165dcaf5c4d4c7d$var$TRANSFORM || attr === $9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        let cache = this._cache.get(attr);
        const isTransform = attr === $9165dcaf5c4d4c7d$var$TRANSFORM || attr === $9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM;
        const invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + 'Change.konva').join($9165dcaf5c4d4c7d$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($9165dcaf5c4d4c7d$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM) this.fire('absoluteTransformChange');
    }
    clearCache() {
        if (this._cache.has($9165dcaf5c4d4c7d$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit, buffer: buffer } = this._cache.get($9165dcaf5c4d4c7d$var$CANVAS);
            $e18dc6b8d0616da8$exports.Util.releaseCanvas(scene, filter, hit, buffer);
            this._cache.delete($9165dcaf5c4d4c7d$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        const conf = config || {};
        let rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent() || undefined
        });
        let width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            $e18dc6b8d0616da8$exports.Util.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        const extraPaddingX = Math.abs(Math.round(rect.x) - x) > 0.5 ? 1 : 0;
        const extraPaddingY = Math.abs(Math.round(rect.y) - y) > 0.5 ? 1 : 0;
        width += offset * 2 + extraPaddingX;
        height += offset * 2 + extraPaddingY;
        x -= offset;
        y -= offset;
        const cachedSceneCanvas = new $ba6d4fe86aeb546f$exports.SceneCanvas({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new $ba6d4fe86aeb546f$exports.SceneCanvas({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
        }), cachedHitCanvas = new $ba6d4fe86aeb546f$exports.HitCanvas({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        const bufferCanvas = new $ba6d4fe86aeb546f$exports.SceneCanvas({
            width: cachedSceneCanvas.width / cachedSceneCanvas.pixelRatio + Math.abs(x),
            height: cachedSceneCanvas.height / cachedSceneCanvas.pixelRatio + Math.abs(y),
            pixelRatio: cachedSceneCanvas.pixelRatio
        }), bufferContext = bufferCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($9165dcaf5c4d4c7d$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        bufferContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        bufferContext.translate(-x, -y);
        bufferCanvas.x = x;
        bufferCanvas.y = y;
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this, bufferCanvas);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($9165dcaf5c4d4c7d$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            buffer: bufferCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($9165dcaf5c4d4c7d$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        const points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        const trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            const transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        const cacheCanvas = this._getCachedSceneCanvas();
        const ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        const canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                const ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for(n = 0; n < len; n++){
                        filter = filters[n];
                        if (typeof filter !== 'function') {
                            $e18dc6b8d0616da8$exports.Util.error('Filter should be type of function, but got ' + typeof filter + ' instead. Please check correct filters');
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                } catch (e) {
                    $e18dc6b8d0616da8$exports.Util.error('Unable to apply filter. ' + e.message + ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    }
    on(evtStr, handler) {
        if (this._cache) this._cache.delete($9165dcaf5c4d4c7d$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        const events = evtStr.split($9165dcaf5c4d4c7d$var$SPACE);
        for(let n = 0; n < events.length; n++){
            const event = events[n];
            const parts = event.split('.');
            const baseEvent = parts[0];
            const name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        let events = (evtStr || '').split($9165dcaf5c4d4c7d$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($9165dcaf5c4d4c7d$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        const e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        const stopNode = this;
        this.on(event, function(evt) {
            const targets = evt.target.findAncestors(selector, true, stopNode);
            for(let i = 0; i < targets.length; i++){
                evt = $e18dc6b8d0616da8$exports.Util.cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        $5b212d8cfde4575b$exports.DD._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$STAGE);
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$VISIBLE);
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        const parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        const method = 'get' + $e18dc6b8d0616da8$exports.Util._capitalize(attr);
        if ($e18dc6b8d0616da8$exports.Util._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        let parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            let key, method;
            if (!config) return this;
            for(key in config){
                if (key === $9165dcaf5c4d4c7d$var$CHILDREN) continue;
                method = $9165dcaf5c4d4c7d$var$SET + $e18dc6b8d0616da8$exports.Util._capitalize(key);
                if ($e18dc6b8d0616da8$exports.Util._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($9165dcaf5c4d4c7d$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($9165dcaf5c4d4c7d$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        const layer = this.getLayer();
        let layerUnderDrag = false;
        $5b212d8cfde4575b$exports.DD._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== 'dragging') return;
            else if (elem.node.nodeType === 'Stage') layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        const dragSkip = !skipDragCheck && !$ab25e7d252931ba2$exports.Konva.hitOnDragEnabled && (layerUnderDrag || $ab25e7d252931ba2$exports.Konva.isTransforming());
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $9165dcaf5c4d4c7d$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        const stage = this.getStage();
        if (that.nodeType !== $9165dcaf5c4d4c7d$var$UPPER_STAGE && stage) addChildren(stage.getChildren());
        return index;
    }
    getDepth() {
        let depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($9165dcaf5c4d4c7d$var$TRANSFORM);
            this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        const stage = this.getStage();
        if (!stage) return null;
        const pos = stage.getPointerPosition();
        if (!pos) return null;
        const transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new $e18dc6b8d0616da8$exports.Transform(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        const { x: x, y: y, ...origTrans } = this._clearTransform();
        this.attrs.x = x;
        this.attrs.y = y;
        this._clearCache($9165dcaf5c4d4c7d$var$TRANSFORM);
        const it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($9165dcaf5c4d4c7d$var$TRANSFORM);
        this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        let key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        const trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        let changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        let family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            $e18dc6b8d0616da8$exports.Util.warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            $e18dc6b8d0616da8$exports.Util.warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            $e18dc6b8d0616da8$exports.Util.warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            $e18dc6b8d0616da8$exports.Util.warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            $e18dc6b8d0616da8$exports.Util.warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) $e18dc6b8d0616da8$exports.Util.warn('Unexpected value ' + zIndex + ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' + (this.parent.children.length - 1) + '.');
        const index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($9165dcaf5c4d4c7d$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        let absOpacity = this.opacity();
        const parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        let attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        const obj = {
            attrs: {},
            className: this.getClassName()
        };
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = $e18dc6b8d0616da8$exports.Util.isObject(val) && !$e18dc6b8d0616da8$exports.Util._isPlainObject(val) && !$e18dc6b8d0616da8$exports.Util._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        return $e18dc6b8d0616da8$exports.Util._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        const res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        let ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === 'function') return selector(this);
        let selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!$e18dc6b8d0616da8$exports.Util.isValidSelector(sel)) {
                $e18dc6b8d0616da8$exports.Util.warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                $e18dc6b8d0616da8$exports.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                $e18dc6b8d0616da8$exports.Util.warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        const parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($9165dcaf5c4d4c7d$var$STAGE, this._getStage);
    }
    _getStage() {
        const parent = this.getParent();
        if (parent) return parent.getStage();
        else return null;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        let at;
        if (top) {
            at = new $e18dc6b8d0616da8$exports.Transform();
            this._eachAncestorReverse(function(node) {
                const transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') at.multiply(node.getTransform());
                else if (transformsEnabled === 'position') at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM) || new $e18dc6b8d0616da8$exports.Transform();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            const transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') at.multiply(this.getTransform());
            else if (transformsEnabled === 'position') {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        let parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($9165dcaf5c4d4c7d$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        const m = this._cache.get($9165dcaf5c4d4c7d$var$TRANSFORM) || new $e18dc6b8d0616da8$exports.Transform();
        m.reset();
        const x = this.x(), y = this.y(), rotation = $ab25e7d252931ba2$exports.Konva.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        let attrs = $e18dc6b8d0616da8$exports.Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        const node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($9165dcaf5c4d4c7d$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        const box = this.getClientRect();
        const stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new $ba6d4fe86aeb546f$exports.SceneCanvas({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        const bufferCanvas = new $ba6d4fe86aeb546f$exports.SceneCanvas({
            width: canvas.width / canvas.pixelRatio + Math.abs(x),
            height: canvas.height / canvas.pixelRatio + Math.abs(y),
            pixelRatio: canvas.pixelRatio
        });
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas, undefined, bufferCanvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        const mimeType = config.mimeType || null, quality = config.quality || null;
        const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                $e18dc6b8d0616da8$exports.Util._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return $ab25e7d252931ba2$exports.Konva.dragDistance;
    }
    _off(type, name, callback) {
        let evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $9165dcaf5c4d4c7d$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            const oldName = this.name();
            const newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        const names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        const names = (this.name() || '').split(/\s/g);
        const index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    setAttr(attr, val) {
        const func = this[$9165dcaf5c4d4c7d$var$SET + $e18dc6b8d0616da8$exports.Util._capitalize(attr)];
        if ($e18dc6b8d0616da8$exports.Util._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ($ab25e7d252931ba2$exports.Konva.autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        const oldVal = this.attrs[key];
        if (oldVal === val && !$e18dc6b8d0616da8$exports.Util.isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        let oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $9165dcaf5c4d4c7d$var$SHAPE) evt.target = this;
        const nonBubbling = [
            $9165dcaf5c4d4c7d$var$MOUSEENTER,
            $9165dcaf5c4d4c7d$var$MOUSELEAVE,
            $9165dcaf5c4d4c7d$var$POINTERENTER,
            $9165dcaf5c4d4c7d$var$POINTERLEAVE,
            $9165dcaf5c4d4c7d$var$TOUCHENTER,
            $9165dcaf5c4d4c7d$var$TOUCHLEAVE
        ];
        const shouldStop = nonBubbling.indexOf(eventType) !== -1 && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === 'Stage' && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            const stopBubble = nonBubbling.indexOf(eventType) !== -1 && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        var _a, _b, _c;
        const allListeners = (_a = this._cache.get($9165dcaf5c4d4c7d$var$ALL_LISTENERS)) !== null && _a !== void 0 ? _a : {};
        let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
        if (events === undefined) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while(obj){
                const hierarchyEvents = (_c = (_b = obj.eventListeners) === null || _b === void 0 ? void 0 : _b[eventType]) !== null && _c !== void 0 ? _c : [];
                events.push(...hierarchyEvents);
                obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            this._cache.set($9165dcaf5c4d4c7d$var$ALL_LISTENERS, allListeners);
        }
        return events;
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(let i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(let i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        const pointerId = evt ? evt.pointerId : undefined;
        const stage = this.getStage();
        const ap = this.getAbsolutePosition();
        if (!stage) return;
        const pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        $5b212d8cfde4575b$exports.DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: 'ready',
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!$5b212d8cfde4575b$exports.DD._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = $5b212d8cfde4575b$exports.DD._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        let newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        const dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) $e18dc6b8d0616da8$exports.Util.warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = $5b212d8cfde4575b$exports.DD._dragElements.get(this._id);
        if (elem) elem.dragStatus = 'stopped';
        $5b212d8cfde4575b$exports.DD._endDragBefore(evt);
        $5b212d8cfde4575b$exports.DD._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = $5b212d8cfde4575b$exports.DD._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function(evt) {
            const shouldCheckButton = evt.evt['button'] !== undefined;
            const canDrag = !shouldCheckButton || $ab25e7d252931ba2$exports.Konva.dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            let hasDraggingChild = false;
            $5b212d8cfde4575b$exports.DD._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            const stage = this.getStage();
            if (!stage) return;
            const dragElement = $5b212d8cfde4575b$exports.DD._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) this.stopDrag();
            else if (isReady) $5b212d8cfde4575b$exports.DD._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return $e18dc6b8d0616da8$exports.Util.haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ($e18dc6b8d0616da8$exports.Util._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        let className = $9165dcaf5c4d4c7d$var$Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!$ab25e7d252931ba2$exports.Konva[className]) {
            $e18dc6b8d0616da8$exports.Util.warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = $ab25e7d252931ba2$exports.Konva[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($9165dcaf5c4d4c7d$var$Node._createNode(children[n]));
        }
        return no;
    }
}
$9165dcaf5c4d4c7d$exports.Node = $9165dcaf5c4d4c7d$var$Node;
$9165dcaf5c4d4c7d$var$Node.prototype.nodeType = 'Node';
$9165dcaf5c4d4c7d$var$Node.prototype._attrsAffectingSize = [];
$9165dcaf5c4d4c7d$var$Node.prototype.eventListeners = {};
$9165dcaf5c4d4c7d$var$Node.prototype.on.call($9165dcaf5c4d4c7d$var$Node.prototype, $9165dcaf5c4d4c7d$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($9165dcaf5c4d4c7d$var$TRANSFORM);
    this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_TRANSFORM);
});
$9165dcaf5c4d4c7d$var$Node.prototype.on.call($9165dcaf5c4d4c7d$var$Node.prototype, 'visibleChange.konva', function() {
    this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$VISIBLE);
});
$9165dcaf5c4d4c7d$var$Node.prototype.on.call($9165dcaf5c4d4c7d$var$Node.prototype, 'listeningChange.konva', function() {
    this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$LISTENING);
});
$9165dcaf5c4d4c7d$var$Node.prototype.on.call($9165dcaf5c4d4c7d$var$Node.prototype, 'opacityChange.konva', function() {
    this._clearSelfAndDescendantCache($9165dcaf5c4d4c7d$var$ABSOLUTE_OPACITY);
});
const $9165dcaf5c4d4c7d$var$addGetterSetter = $6f82f2528fae78ce$exports.Factory.addGetterSetter;
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'zIndex');
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'absolutePosition');
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'position');
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'x', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'y', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'globalCompositeOperation', 'source-over', (0, $aae05bbbe3f82503$exports.getStringValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'opacity', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'name', '', (0, $aae05bbbe3f82503$exports.getStringValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'id', '', (0, $aae05bbbe3f82503$exports.getStringValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'rotation', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($9165dcaf5c4d4c7d$var$Node, 'scale', [
    'x',
    'y'
]);
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'scaleX', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'scaleY', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($9165dcaf5c4d4c7d$var$Node, 'skew', [
    'x',
    'y'
]);
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'skewX', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'skewY', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($9165dcaf5c4d4c7d$var$Node, 'offset', [
    'x',
    'y'
]);
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'offsetX', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'offsetY', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'dragDistance', undefined, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'width', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'height', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'listening', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'preventDefault', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'filters', undefined, function(val) {
    this._filterUpToDate = false;
    return val;
});
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'visible', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'transformsEnabled', 'all', (0, $aae05bbbe3f82503$exports.getStringValidator)());
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'size');
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'dragBoundFunc');
$9165dcaf5c4d4c7d$var$addGetterSetter($9165dcaf5c4d4c7d$var$Node, 'draggable', false, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$6f82f2528fae78ce$exports.Factory.backCompat($9165dcaf5c4d4c7d$var$Node, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
});


var $d8907859c4768725$exports = {};
"use strict";
Object.defineProperty($d8907859c4768725$exports, "__esModule", {
    value: true
});
$d8907859c4768725$exports.Container = void 0;



class $d8907859c4768725$var$Container extends $9165dcaf5c4d4c7d$exports.Node {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        const children = this.children || [];
        if (filterFunc) return children.filter(filterFunc);
        return children;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire('add', {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        const result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        const retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        const obj = $9165dcaf5c4d4c7d$exports.Node.prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        let parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        const node = $9165dcaf5c4d4c7d$exports.Node.prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        const arr = [];
        this.find('Shape').forEach((shape)=>{
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        const caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren('drawScene', canvas, top, bufferCanvas);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren('drawHit', canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top, bufferCanvas) {
        var _a;
        const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === 'number' && typeof clipHeight === 'number' || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            const transform = this.getAbsoluteTransform(top);
            let m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) clipArgs = clipFunc.call(this, context, this);
            else {
                const clipX = this.clipX();
                const clipY = this.clipY();
                context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        const hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top, bufferCanvas);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config = {}) {
        var _a;
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        let minX, minY, maxX, maxY;
        let selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        const that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            const rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        const shapes = this.find('Shape');
        let hasVisible = false;
        for(let i = 0; i < shapes.length; i++){
            const shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
$d8907859c4768725$exports.Container = $d8907859c4768725$var$Container;
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($d8907859c4768725$var$Container, 'clip', [
    'x',
    'y',
    'width',
    'height'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8907859c4768725$var$Container, 'clipX', undefined, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8907859c4768725$var$Container, 'clipY', undefined, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8907859c4768725$var$Container, 'clipWidth', undefined, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8907859c4768725$var$Container, 'clipHeight', undefined, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8907859c4768725$var$Container, 'clipFunc');


var $8b5f1def56dcb7c0$exports = {};
"use strict";
Object.defineProperty($8b5f1def56dcb7c0$exports, "__esModule", {
    value: true
});
$8b5f1def56dcb7c0$exports.Stage = $8b5f1def56dcb7c0$exports.stages = void 0;







var $e392a48a7b02cd3d$exports = {};
"use strict";
Object.defineProperty($e392a48a7b02cd3d$exports, "__esModule", {
    value: true
});
$e392a48a7b02cd3d$exports.getCapturedShape = $e392a48a7b02cd3d$var$getCapturedShape;
$e392a48a7b02cd3d$exports.createEvent = $e392a48a7b02cd3d$var$createEvent;
$e392a48a7b02cd3d$exports.hasPointerCapture = $e392a48a7b02cd3d$var$hasPointerCapture;
$e392a48a7b02cd3d$exports.setPointerCapture = $e392a48a7b02cd3d$var$setPointerCapture;
$e392a48a7b02cd3d$exports.releaseCapture = $e392a48a7b02cd3d$var$releaseCapture;

const $e392a48a7b02cd3d$var$Captures = new Map();
const $e392a48a7b02cd3d$var$SUPPORT_POINTER_EVENTS = $ab25e7d252931ba2$exports.Konva._global['PointerEvent'] !== undefined;
function $e392a48a7b02cd3d$var$getCapturedShape(pointerId) {
    return $e392a48a7b02cd3d$var$Captures.get(pointerId);
}
function $e392a48a7b02cd3d$var$createEvent(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
function $e392a48a7b02cd3d$var$hasPointerCapture(pointerId, shape) {
    return $e392a48a7b02cd3d$var$Captures.get(pointerId) === shape;
}
function $e392a48a7b02cd3d$var$setPointerCapture(pointerId, shape) {
    $e392a48a7b02cd3d$var$releaseCapture(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $e392a48a7b02cd3d$var$Captures.set(pointerId, shape);
    if ($e392a48a7b02cd3d$var$SUPPORT_POINTER_EVENTS) shape._fire('gotpointercapture', $e392a48a7b02cd3d$var$createEvent(new PointerEvent('gotpointercapture')));
}
function $e392a48a7b02cd3d$var$releaseCapture(pointerId, target) {
    const shape = $e392a48a7b02cd3d$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $e392a48a7b02cd3d$var$Captures.delete(pointerId);
    if ($e392a48a7b02cd3d$var$SUPPORT_POINTER_EVENTS) shape._fire('lostpointercapture', $e392a48a7b02cd3d$var$createEvent(new PointerEvent('lostpointercapture')));
}


const $8b5f1def56dcb7c0$var$STAGE = 'Stage', $8b5f1def56dcb7c0$var$STRING = 'string', $8b5f1def56dcb7c0$var$PX = 'px', $8b5f1def56dcb7c0$var$MOUSEOUT = 'mouseout', $8b5f1def56dcb7c0$var$MOUSELEAVE = 'mouseleave', $8b5f1def56dcb7c0$var$MOUSEOVER = 'mouseover', $8b5f1def56dcb7c0$var$MOUSEENTER = 'mouseenter', $8b5f1def56dcb7c0$var$MOUSEMOVE = 'mousemove', $8b5f1def56dcb7c0$var$MOUSEDOWN = 'mousedown', $8b5f1def56dcb7c0$var$MOUSEUP = 'mouseup', $8b5f1def56dcb7c0$var$POINTERMOVE = 'pointermove', $8b5f1def56dcb7c0$var$POINTERDOWN = 'pointerdown', $8b5f1def56dcb7c0$var$POINTERUP = 'pointerup', $8b5f1def56dcb7c0$var$POINTERCANCEL = 'pointercancel', $8b5f1def56dcb7c0$var$LOSTPOINTERCAPTURE = 'lostpointercapture', $8b5f1def56dcb7c0$var$POINTEROUT = 'pointerout', $8b5f1def56dcb7c0$var$POINTERLEAVE = 'pointerleave', $8b5f1def56dcb7c0$var$POINTEROVER = 'pointerover', $8b5f1def56dcb7c0$var$POINTERENTER = 'pointerenter', $8b5f1def56dcb7c0$var$CONTEXTMENU = 'contextmenu', $8b5f1def56dcb7c0$var$TOUCHSTART = 'touchstart', $8b5f1def56dcb7c0$var$TOUCHEND = 'touchend', $8b5f1def56dcb7c0$var$TOUCHMOVE = 'touchmove', $8b5f1def56dcb7c0$var$TOUCHCANCEL = 'touchcancel', $8b5f1def56dcb7c0$var$WHEEL = 'wheel', $8b5f1def56dcb7c0$var$MAX_LAYERS_NUMBER = 5, $8b5f1def56dcb7c0$var$EVENTS = [
    [
        $8b5f1def56dcb7c0$var$MOUSEENTER,
        '_pointerenter'
    ],
    [
        $8b5f1def56dcb7c0$var$MOUSEDOWN,
        '_pointerdown'
    ],
    [
        $8b5f1def56dcb7c0$var$MOUSEMOVE,
        '_pointermove'
    ],
    [
        $8b5f1def56dcb7c0$var$MOUSEUP,
        '_pointerup'
    ],
    [
        $8b5f1def56dcb7c0$var$MOUSELEAVE,
        '_pointerleave'
    ],
    [
        $8b5f1def56dcb7c0$var$TOUCHSTART,
        '_pointerdown'
    ],
    [
        $8b5f1def56dcb7c0$var$TOUCHMOVE,
        '_pointermove'
    ],
    [
        $8b5f1def56dcb7c0$var$TOUCHEND,
        '_pointerup'
    ],
    [
        $8b5f1def56dcb7c0$var$TOUCHCANCEL,
        '_pointercancel'
    ],
    [
        $8b5f1def56dcb7c0$var$MOUSEOVER,
        '_pointerover'
    ],
    [
        $8b5f1def56dcb7c0$var$WHEEL,
        '_wheel'
    ],
    [
        $8b5f1def56dcb7c0$var$CONTEXTMENU,
        '_contextmenu'
    ],
    [
        $8b5f1def56dcb7c0$var$POINTERDOWN,
        '_pointerdown'
    ],
    [
        $8b5f1def56dcb7c0$var$POINTERMOVE,
        '_pointermove'
    ],
    [
        $8b5f1def56dcb7c0$var$POINTERUP,
        '_pointerup'
    ],
    [
        $8b5f1def56dcb7c0$var$POINTERCANCEL,
        '_pointercancel'
    ],
    [
        $8b5f1def56dcb7c0$var$POINTERLEAVE,
        '_pointerleave'
    ],
    [
        $8b5f1def56dcb7c0$var$LOSTPOINTERCAPTURE,
        '_lostpointercapture'
    ]
];
const $8b5f1def56dcb7c0$var$EVENTS_MAP = {
    mouse: {
        [$8b5f1def56dcb7c0$var$POINTEROUT]: $8b5f1def56dcb7c0$var$MOUSEOUT,
        [$8b5f1def56dcb7c0$var$POINTERLEAVE]: $8b5f1def56dcb7c0$var$MOUSELEAVE,
        [$8b5f1def56dcb7c0$var$POINTEROVER]: $8b5f1def56dcb7c0$var$MOUSEOVER,
        [$8b5f1def56dcb7c0$var$POINTERENTER]: $8b5f1def56dcb7c0$var$MOUSEENTER,
        [$8b5f1def56dcb7c0$var$POINTERMOVE]: $8b5f1def56dcb7c0$var$MOUSEMOVE,
        [$8b5f1def56dcb7c0$var$POINTERDOWN]: $8b5f1def56dcb7c0$var$MOUSEDOWN,
        [$8b5f1def56dcb7c0$var$POINTERUP]: $8b5f1def56dcb7c0$var$MOUSEUP,
        [$8b5f1def56dcb7c0$var$POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
    },
    touch: {
        [$8b5f1def56dcb7c0$var$POINTEROUT]: 'touchout',
        [$8b5f1def56dcb7c0$var$POINTERLEAVE]: 'touchleave',
        [$8b5f1def56dcb7c0$var$POINTEROVER]: 'touchover',
        [$8b5f1def56dcb7c0$var$POINTERENTER]: 'touchenter',
        [$8b5f1def56dcb7c0$var$POINTERMOVE]: $8b5f1def56dcb7c0$var$TOUCHMOVE,
        [$8b5f1def56dcb7c0$var$POINTERDOWN]: $8b5f1def56dcb7c0$var$TOUCHSTART,
        [$8b5f1def56dcb7c0$var$POINTERUP]: $8b5f1def56dcb7c0$var$TOUCHEND,
        [$8b5f1def56dcb7c0$var$POINTERCANCEL]: $8b5f1def56dcb7c0$var$TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
    },
    pointer: {
        [$8b5f1def56dcb7c0$var$POINTEROUT]: $8b5f1def56dcb7c0$var$POINTEROUT,
        [$8b5f1def56dcb7c0$var$POINTERLEAVE]: $8b5f1def56dcb7c0$var$POINTERLEAVE,
        [$8b5f1def56dcb7c0$var$POINTEROVER]: $8b5f1def56dcb7c0$var$POINTEROVER,
        [$8b5f1def56dcb7c0$var$POINTERENTER]: $8b5f1def56dcb7c0$var$POINTERENTER,
        [$8b5f1def56dcb7c0$var$POINTERMOVE]: $8b5f1def56dcb7c0$var$POINTERMOVE,
        [$8b5f1def56dcb7c0$var$POINTERDOWN]: $8b5f1def56dcb7c0$var$POINTERDOWN,
        [$8b5f1def56dcb7c0$var$POINTERUP]: $8b5f1def56dcb7c0$var$POINTERUP,
        [$8b5f1def56dcb7c0$var$POINTERCANCEL]: $8b5f1def56dcb7c0$var$POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
    }
};
const $8b5f1def56dcb7c0$var$getEventType = (type)=>{
    if (type.indexOf('pointer') >= 0) return 'pointer';
    if (type.indexOf('touch') >= 0) return 'touch';
    return 'mouse';
};
const $8b5f1def56dcb7c0$var$getEventsMap = (eventType)=>{
    const type = $8b5f1def56dcb7c0$var$getEventType(eventType);
    if (type === 'pointer') return $ab25e7d252931ba2$exports.Konva.pointerEventsEnabled && $8b5f1def56dcb7c0$var$EVENTS_MAP.pointer;
    if (type === 'touch') return $8b5f1def56dcb7c0$var$EVENTS_MAP.touch;
    if (type === 'mouse') return $8b5f1def56dcb7c0$var$EVENTS_MAP.mouse;
};
function $8b5f1def56dcb7c0$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) $e18dc6b8d0616da8$exports.Util.warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    return attrs;
}
const $8b5f1def56dcb7c0$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
$8b5f1def56dcb7c0$exports.stages = [];
class $8b5f1def56dcb7c0$var$Stage extends $d8907859c4768725$exports.Container {
    constructor(config){
        super($8b5f1def56dcb7c0$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $8b5f1def56dcb7c0$exports.stages.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', ()=>{
            $8b5f1def56dcb7c0$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) $e18dc6b8d0616da8$exports.Util.throw('You may only add layers to the stage.');
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $8b5f1def56dcb7c0$var$STRING) {
            let id;
            if (container.charAt(0) === '.') {
                const className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                if (container.charAt(0) !== '#') id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw 'Can not find container in document with id ' + id;
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        const layers = this.children, len = layers.length;
        for(let n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== 'undefined' && document.createElement('div');
        return $d8907859c4768725$exports.Container.prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        const content = this.content;
        if (content && $e18dc6b8d0616da8$exports.Util._isInDocument(content)) this.container().removeChild(content);
        const index = $8b5f1def56dcb7c0$exports.stages.indexOf(this);
        if (index > -1) $8b5f1def56dcb7c0$exports.stages.splice(index, 1);
        $e18dc6b8d0616da8$exports.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            $e18dc6b8d0616da8$exports.Util.warn($8b5f1def56dcb7c0$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        const canvas = new $ba6d4fe86aeb546f$exports.SceneCanvas({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        const _context = canvas.getContext()._context;
        const layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            const layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        const layers = this.children, len = layers.length, end = len - 1;
        for(let n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        const width = this.width();
        const height = this.height();
        if (this.content) {
            this.content.style.width = width + $8b5f1def56dcb7c0$var$PX;
            this.content.style.height = height + $8b5f1def56dcb7c0$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        const length = this.children.length;
        if (length > $8b5f1def56dcb7c0$var$MAX_LAYERS_NUMBER) $e18dc6b8d0616da8$exports.Util.warn('The stage has ' + length + ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ($ab25e7d252931ba2$exports.Konva.isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $e392a48a7b02cd3d$exports.hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $e392a48a7b02cd3d$exports.setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        $e392a48a7b02cd3d$exports.releaseCapture(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!$ab25e7d252931ba2$exports.Konva.isBrowser) return;
        $8b5f1def56dcb7c0$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $8b5f1def56dcb7c0$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $8b5f1def56dcb7c0$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + 'targetShape'];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $8b5f1def56dcb7c0$var$getEventsMap(evt.type);
        const eventType = $8b5f1def56dcb7c0$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const targetShape = this._getTargetShape(eventType);
        const eventsEnabled = !($ab25e7d252931ba2$exports.Konva.isDragging() || $ab25e7d252931ba2$exports.Konva.isTransforming()) || $ab25e7d252931ba2$exports.Konva.hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + 'targetShape'] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = null;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $8b5f1def56dcb7c0$var$getEventsMap(evt.type);
        const eventType = $8b5f1def56dcb7c0$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = this.getIntersection(pos);
            $5b212d8cfde4575b$exports.DD.justDragged = false;
            $ab25e7d252931ba2$exports.Konva['_' + eventType + 'ListenClick'] = true;
            if (!shape || !shape.isListening()) {
                this[eventType + 'ClickStartShape'] = undefined;
                return;
            }
            if ($ab25e7d252931ba2$exports.Konva.capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + 'ClickStartShape'] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $8b5f1def56dcb7c0$var$getEventsMap(evt.type);
        const eventType = $8b5f1def56dcb7c0$var$getEventType(evt.type);
        if (!events) return;
        if ($ab25e7d252931ba2$exports.Konva.isDragging() && $5b212d8cfde4575b$exports.DD.node.preventDefault() && evt.cancelable) evt.preventDefault();
        this.setPointersPositions(evt);
        const eventsEnabled = !($ab25e7d252931ba2$exports.Konva.isDragging() || $ab25e7d252931ba2$exports.Konva.isTransforming()) || $ab25e7d252931ba2$exports.Konva.hitOnDragEnabled;
        if (!eventsEnabled) return;
        const processedShapesIds = {};
        let triggeredOnShape = false;
        const targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $e392a48a7b02cd3d$exports.getCapturedShape(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            const differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, {
                    ...event
                }, shape);
                targetShape._fireAndBubble(events.pointerleave, {
                    ...event
                }, shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, {
                        ...event
                    }, targetShape);
                    shape._fireAndBubble(events.pointerenter, {
                        ...event
                    }, targetShape);
                    this[eventType + 'targetShape'] = shape;
                }
                shape._fireAndBubble(events.pointermove, {
                    ...event
                });
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + 'targetShape'] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $8b5f1def56dcb7c0$var$getEventsMap(evt.type);
        const eventType = $8b5f1def56dcb7c0$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + 'ClickStartShape'];
        const clickEndShape = this[eventType + 'ClickEndShape'];
        const processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $e392a48a7b02cd3d$exports.getCapturedShape(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ($ab25e7d252931ba2$exports.Konva['_' + eventType + 'InDblClickWindow']) {
                fireDblClick = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            } else if (!$5b212d8cfde4575b$exports.DD.justDragged) {
                $ab25e7d252931ba2$exports.Konva['_' + eventType + 'InDblClickWindow'] = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            this[eventType + 'DblTimeout'] = setTimeout(function() {
                $ab25e7d252931ba2$exports.Konva['_' + eventType + 'InDblClickWindow'] = false;
            }, $ab25e7d252931ba2$exports.Konva.dblClickWindow);
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                this[eventType + 'ClickEndShape'] = shape;
                shape._fireAndBubble(events.pointerup, {
                    ...event
                });
                if ($ab25e7d252931ba2$exports.Konva['_' + eventType + 'ListenClick'] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, {
                        ...event
                    });
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, {
                        ...event
                    });
                }
            } else {
                this[eventType + 'ClickEndShape'] = null;
                if ($ab25e7d252931ba2$exports.Konva['_' + eventType + 'ListenClick']) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!triggeredOnShape) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        $ab25e7d252931ba2$exports.Konva['_' + eventType + 'ListenClick'] = false;
        if (evt.cancelable && eventType !== 'touch' && eventType !== 'pointer') evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($8b5f1def56dcb7c0$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($8b5f1def56dcb7c0$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($8b5f1def56dcb7c0$var$WHEEL, {
            evt: evt
        });
        else this._fire($8b5f1def56dcb7c0$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $e392a48a7b02cd3d$exports.getCapturedShape(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($8b5f1def56dcb7c0$var$POINTERUP, $e392a48a7b02cd3d$exports.createEvent(evt));
        $e392a48a7b02cd3d$exports.releaseCapture(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $e392a48a7b02cd3d$exports.releaseCapture(evt.pointerId);
    }
    setPointersPositions(evt) {
        const contentPosition = this._getContentPosition();
        let x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: $e18dc6b8d0616da8$exports.Util._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: $e18dc6b8d0616da8$exports.Util._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        $e18dc6b8d0616da8$exports.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        const rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new $ba6d4fe86aeb546f$exports.SceneCanvas({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new $ba6d4fe86aeb546f$exports.HitCanvas({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!$ab25e7d252931ba2$exports.Konva.isBrowser) return;
        const container = this.container();
        if (!container) throw 'Stage has no container. A container is required.';
        container.innerHTML = '';
        this.content = document.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        $e18dc6b8d0616da8$exports.Util.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$8b5f1def56dcb7c0$exports.Stage = $8b5f1def56dcb7c0$var$Stage;
$8b5f1def56dcb7c0$var$Stage.prototype.nodeType = $8b5f1def56dcb7c0$var$STAGE;
(0, $ab25e7d252931ba2$exports._registerNode)($8b5f1def56dcb7c0$var$Stage);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($8b5f1def56dcb7c0$var$Stage, 'container');
if ($ab25e7d252931ba2$exports.Konva.isBrowser) document.addEventListener('visibilitychange', ()=>{
    $8b5f1def56dcb7c0$exports.stages.forEach((stage)=>{
        stage.batchDraw();
    });
});


var $76e786788092e9c1$exports = {};
"use strict";
Object.defineProperty($76e786788092e9c1$exports, "__esModule", {
    value: true
});
$76e786788092e9c1$exports.Layer = void 0;






var $1f300d37bd09701b$exports = {};
"use strict";
Object.defineProperty($1f300d37bd09701b$exports, "__esModule", {
    value: true
});
$1f300d37bd09701b$exports.Shape = $1f300d37bd09701b$exports.shapes = void 0;







const $1f300d37bd09701b$var$HAS_SHADOW = 'hasShadow';
const $1f300d37bd09701b$var$SHADOW_RGBA = 'shadowRGBA';
const $1f300d37bd09701b$var$patternImage = 'patternImage';
const $1f300d37bd09701b$var$linearGradient = 'linearGradient';
const $1f300d37bd09701b$var$radialGradient = 'radialGradient';
let $1f300d37bd09701b$var$dummyContext;
function $1f300d37bd09701b$var$getDummyContext() {
    if ($1f300d37bd09701b$var$dummyContext) return $1f300d37bd09701b$var$dummyContext;
    $1f300d37bd09701b$var$dummyContext = $e18dc6b8d0616da8$exports.Util.createCanvasElement().getContext('2d');
    return $1f300d37bd09701b$var$dummyContext;
}
$1f300d37bd09701b$exports.shapes = {};
function $1f300d37bd09701b$var$_fillFunc(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $1f300d37bd09701b$var$_strokeFunc(context) {
    context.stroke();
}
function $1f300d37bd09701b$var$_fillFuncHit(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $1f300d37bd09701b$var$_strokeFuncHit(context) {
    context.stroke();
}
function $1f300d37bd09701b$var$_clearHasShadowCache() {
    this._clearCache($1f300d37bd09701b$var$HAS_SHADOW);
}
function $1f300d37bd09701b$var$_clearGetShadowRGBACache() {
    this._clearCache($1f300d37bd09701b$var$SHADOW_RGBA);
}
function $1f300d37bd09701b$var$_clearFillPatternCache() {
    this._clearCache($1f300d37bd09701b$var$patternImage);
}
function $1f300d37bd09701b$var$_clearLinearGradientCache() {
    this._clearCache($1f300d37bd09701b$var$linearGradient);
}
function $1f300d37bd09701b$var$_clearRadialGradientCache() {
    this._clearCache($1f300d37bd09701b$var$radialGradient);
}
class $1f300d37bd09701b$var$Shape extends $9165dcaf5c4d4c7d$exports.Node {
    constructor(config){
        super(config);
        let key;
        while(true){
            key = $e18dc6b8d0616da8$exports.Util.getRandomColor();
            if (key && !(key in $1f300d37bd09701b$exports.shapes)) break;
        }
        this.colorKey = key;
        $1f300d37bd09701b$exports.shapes[key] = this;
    }
    getContext() {
        $e18dc6b8d0616da8$exports.Util.warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    getCanvas() {
        $e18dc6b8d0616da8$exports.Util.warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    hasShadow() {
        return this._getCache($1f300d37bd09701b$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($1f300d37bd09701b$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            const ctx = $1f300d37bd09701b$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            if (pattern && pattern.setTransform) {
                const tr = new $e18dc6b8d0616da8$exports.Transform();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate($ab25e7d252931ba2$exports.Konva.getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === 'undefined' ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($1f300d37bd09701b$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        const colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            const ctx = $1f300d37bd09701b$var$getDummyContext();
            const start = this.fillLinearGradientStartPoint();
            const end = this.fillLinearGradientEndPoint();
            const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($1f300d37bd09701b$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        const colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            const ctx = $1f300d37bd09701b$var$getDummyContext();
            const start = this.fillRadialGradientStartPoint();
            const end = this.fillRadialGradientEndPoint();
            const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($1f300d37bd09701b$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        const rgba = $e18dc6b8d0616da8$exports.Util.colorToRGBA(this.shadowColor());
        if (rgba) return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a * (this.shadowOpacity() || 1) + ')';
    }
    hasFill() {
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops'
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops'
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === 'auto') return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        const stage = this.getStage();
        if (!stage) return false;
        const bufferHitCanvas = stage.bufferHitCanvas;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, undefined, true);
        const p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        $9165dcaf5c4d4c7d$exports.Node.prototype.destroy.call(this);
        delete $1f300d37bd09701b$exports.shapes[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        $e18dc6b8d0616da8$exports.Util.warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) this.hitStrokeWidth('auto');
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        const size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        let hasCachedParent = false;
        let parent = this.getParent();
        while(parent){
            if (parent.isCached()) {
                hasCachedParent = true;
                break;
            }
            parent = parent.getParent();
        }
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo || hasCachedParent && this.getStage() || undefined;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer();
        const canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
        let stage;
        const skipBuffer = false;
        const cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            const bc = bufferCanvas || stage.bufferCanvas;
            const bufferContext = bc.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            const o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            const ratio = bc.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bc._canvas, bc.x || 0, bc.y || 0, bc.width / ratio, bc.height / ratio);
        } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                const o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) $e18dc6b8d0616da8$exports.Util.warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        const selfCache = this === top;
        if (!selfCache) {
            const o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        const cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            const hitData = hitImageData.data;
            const len = hitData.length;
            const rgbColorKey = $e18dc6b8d0616da8$exports.Util._hexToRgb(this.colorKey);
            for(let i = 0; i < len; i += 4){
                const alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            $e18dc6b8d0616da8$exports.Util.error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $e392a48a7b02cd3d$exports.hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $e392a48a7b02cd3d$exports.setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        $e392a48a7b02cd3d$exports.releaseCapture(pointerId, this);
    }
}
$1f300d37bd09701b$exports.Shape = $1f300d37bd09701b$var$Shape;
$1f300d37bd09701b$var$Shape.prototype._fillFunc = $1f300d37bd09701b$var$_fillFunc;
$1f300d37bd09701b$var$Shape.prototype._strokeFunc = $1f300d37bd09701b$var$_strokeFunc;
$1f300d37bd09701b$var$Shape.prototype._fillFuncHit = $1f300d37bd09701b$var$_fillFuncHit;
$1f300d37bd09701b$var$Shape.prototype._strokeFuncHit = $1f300d37bd09701b$var$_strokeFuncHit;
$1f300d37bd09701b$var$Shape.prototype._centroid = false;
$1f300d37bd09701b$var$Shape.prototype.nodeType = 'Shape';
(0, $ab25e7d252931ba2$exports._registerNode)($1f300d37bd09701b$var$Shape);
$1f300d37bd09701b$var$Shape.prototype.eventListeners = {};
$1f300d37bd09701b$var$Shape.prototype.on.call($1f300d37bd09701b$var$Shape.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $1f300d37bd09701b$var$_clearHasShadowCache);
$1f300d37bd09701b$var$Shape.prototype.on.call($1f300d37bd09701b$var$Shape.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $1f300d37bd09701b$var$_clearGetShadowRGBACache);
$1f300d37bd09701b$var$Shape.prototype.on.call($1f300d37bd09701b$var$Shape.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', $1f300d37bd09701b$var$_clearFillPatternCache);
$1f300d37bd09701b$var$Shape.prototype.on.call($1f300d37bd09701b$var$Shape.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', $1f300d37bd09701b$var$_clearLinearGradientCache);
$1f300d37bd09701b$var$Shape.prototype.on.call($1f300d37bd09701b$var$Shape.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', $1f300d37bd09701b$var$_clearRadialGradientCache);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'stroke', undefined, (0, $aae05bbbe3f82503$exports.getStringOrGradientValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeWidth', 2, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillAfterStrokeEnabled', false);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'hitStrokeWidth', 'auto', (0, $aae05bbbe3f82503$exports.getNumberOrAutoValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeHitEnabled', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'perfectDrawEnabled', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'shadowForStrokeEnabled', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'lineJoin');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'lineCap');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'sceneFunc');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'hitFunc');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'dash');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'dashOffset', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'shadowColor', undefined, (0, $aae05bbbe3f82503$exports.getStringValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'shadowBlur', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'shadowOpacity', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'shadowOffset', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'shadowOffsetX', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'shadowOffsetY', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternImage');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fill', undefined, (0, $aae05bbbe3f82503$exports.getStringOrGradientValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternX', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternY', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillLinearGradientColorStops');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeLinearGradientColorStops');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientStartRadius', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientEndRadius', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientColorStops');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternRepeat', 'repeat');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'shadowEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'dashEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeScaleEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPriority', 'color');
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternOffset', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternOffsetX', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternOffsetY', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternScale', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternScaleX', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternScaleY', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'fillLinearGradientStartPoint', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'strokeLinearGradientStartPoint', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillLinearGradientStartPointX', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeLinearGradientStartPointX', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillLinearGradientStartPointY', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeLinearGradientStartPointY', 0);
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'fillLinearGradientEndPoint', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'strokeLinearGradientEndPoint', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillLinearGradientEndPointX', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeLinearGradientEndPointX', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillLinearGradientEndPointY', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'strokeLinearGradientEndPointY', 0);
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientStartPoint', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientStartPointX', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientStartPointY', 0);
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientEndPoint', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientEndPointX', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRadialGradientEndPointY', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillPatternRotation', 0);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($1f300d37bd09701b$var$Shape, 'fillRule', undefined, (0, $aae05bbbe3f82503$exports.getStringValidator)());
$6f82f2528fae78ce$exports.Factory.backCompat($1f300d37bd09701b$var$Shape, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
});



const $76e786788092e9c1$var$HASH = '#', $76e786788092e9c1$var$BEFORE_DRAW = 'beforeDraw', $76e786788092e9c1$var$DRAW = 'draw', $76e786788092e9c1$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $76e786788092e9c1$var$INTERSECTION_OFFSETS_LEN = $76e786788092e9c1$var$INTERSECTION_OFFSETS.length;
class $76e786788092e9c1$var$Layer extends $d8907859c4768725$exports.Container {
    constructor(config){
        super(config);
        this.canvas = new $ba6d4fe86aeb546f$exports.SceneCanvas();
        this.hitCanvas = new $ba6d4fe86aeb546f$exports.HitCanvas({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        $9165dcaf5c4d4c7d$exports.Node.prototype.moveToTop.call(this);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        const moved = $9165dcaf5c4d4c7d$exports.Node.prototype.moveUp.call(this);
        if (!moved) return false;
        const stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ($9165dcaf5c4d4c7d$exports.Node.prototype.moveDown.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ($9165dcaf5c4d4c7d$exports.Node.prototype.moveToBottom.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        const _canvas = this.getNativeCanvasElement();
        $9165dcaf5c4d4c7d$exports.Node.prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && $e18dc6b8d0616da8$exports.Util._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') $e18dc6b8d0616da8$exports.Util.throw('You may only add groups and shapes to a layer.');
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return $9165dcaf5c4d4c7d$exports.Node.prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = 'block';
        else this.canvas._canvas.style.display = 'none';
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        $e18dc6b8d0616da8$exports.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        $e18dc6b8d0616da8$exports.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            $e18dc6b8d0616da8$exports.Util.requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        let spiralSearchDistance = 1;
        let continueSearch = false;
        while(true){
            for(let i = 0; i < $76e786788092e9c1$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $76e786788092e9c1$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = $e18dc6b8d0616da8$exports.Util._rgbToHex(p[0], p[1], p[2]);
            const shape = $1f300d37bd09701b$exports.shapes[$76e786788092e9c1$var$HASH + colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($76e786788092e9c1$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        $d8907859c4768725$exports.Container.prototype.drawScene.call(this, canvas, top, bufferCanvas);
        this._fire($76e786788092e9c1$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        $d8907859c4768725$exports.Container.prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        $e18dc6b8d0616da8$exports.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        $e18dc6b8d0616da8$exports.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) return;
        const parent = this.parent;
        const added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        $e18dc6b8d0616da8$exports.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$76e786788092e9c1$exports.Layer = $76e786788092e9c1$var$Layer;
$76e786788092e9c1$var$Layer.prototype.nodeType = 'Layer';
(0, $ab25e7d252931ba2$exports._registerNode)($76e786788092e9c1$var$Layer);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($76e786788092e9c1$var$Layer, 'imageSmoothingEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($76e786788092e9c1$var$Layer, 'clearBeforeDraw', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($76e786788092e9c1$var$Layer, 'hitGraphEnabled', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());


var $8f94422bca9120b3$exports = {};
"use strict";
Object.defineProperty($8f94422bca9120b3$exports, "__esModule", {
    value: true
});
$8f94422bca9120b3$exports.FastLayer = void 0;



class $8f94422bca9120b3$var$FastLayer extends $76e786788092e9c1$exports.Layer {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        $e18dc6b8d0616da8$exports.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$8f94422bca9120b3$exports.FastLayer = $8f94422bca9120b3$var$FastLayer;
$8f94422bca9120b3$var$FastLayer.prototype.nodeType = 'FastLayer';
(0, $ab25e7d252931ba2$exports._registerNode)($8f94422bca9120b3$var$FastLayer);


var $46b926af7f04b04f$exports = {};
"use strict";
Object.defineProperty($46b926af7f04b04f$exports, "__esModule", {
    value: true
});
$46b926af7f04b04f$exports.Group = void 0;



class $46b926af7f04b04f$var$Group extends $d8907859c4768725$exports.Container {
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') $e18dc6b8d0616da8$exports.Util.throw('You may only add groups and shapes to groups.');
    }
}
$46b926af7f04b04f$exports.Group = $46b926af7f04b04f$var$Group;
$46b926af7f04b04f$var$Group.prototype.nodeType = 'Group';
(0, $ab25e7d252931ba2$exports._registerNode)($46b926af7f04b04f$var$Group);




var $d3e33b2b81503d17$exports = {};
"use strict";
Object.defineProperty($d3e33b2b81503d17$exports, "__esModule", {
    value: true
});
$d3e33b2b81503d17$exports.Animation = void 0;


const $d3e33b2b81503d17$var$now = function() {
    if ($ab25e7d252931ba2$exports.glob.performance && $ab25e7d252931ba2$exports.glob.performance.now) return function() {
        return $ab25e7d252931ba2$exports.glob.performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $d3e33b2b81503d17$var$Animation {
    constructor(func, layers){
        this.id = $d3e33b2b81503d17$var$Animation.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $d3e33b2b81503d17$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        let lays = [];
        if (layers) lays = Array.isArray(layers) ? layers : [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        const layers = this.layers;
        const len = layers.length;
        for(let n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        const a = $d3e33b2b81503d17$var$Animation;
        const animations = a.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $d3e33b2b81503d17$var$now();
        $d3e33b2b81503d17$var$Animation._addAnimation(this);
        return this;
    }
    stop() {
        $d3e33b2b81503d17$var$Animation._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        const id = anim.id;
        const animations = this.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        const layerHash = {};
        const animations = this.animations;
        for(let n = 0; n < animations.length; n++){
            const anim = animations[n];
            const layers = anim.layers;
            const func = anim.func;
            anim._updateFrameObject($d3e33b2b81503d17$var$now());
            const layersLen = layers.length;
            let needRedraw;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(let i = 0; i < layersLen; i++){
                const layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(const key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        const Anim = $d3e33b2b81503d17$var$Animation;
        if (Anim.animations.length) {
            Anim._runFrames();
            $e18dc6b8d0616da8$exports.Util.requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            $e18dc6b8d0616da8$exports.Util.requestAnimFrame(this._animationLoop);
        }
    }
}
$d3e33b2b81503d17$exports.Animation = $d3e33b2b81503d17$var$Animation;
$d3e33b2b81503d17$var$Animation.animations = [];
$d3e33b2b81503d17$var$Animation.animIdCounter = 0;
$d3e33b2b81503d17$var$Animation.animRunning = false;


var $ef2bb9b4c3fbc113$exports = {};
"use strict";
Object.defineProperty($ef2bb9b4c3fbc113$exports, "__esModule", {
    value: true
});
$ef2bb9b4c3fbc113$exports.Easings = $ef2bb9b4c3fbc113$exports.Tween = void 0;




const $ef2bb9b4c3fbc113$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $ef2bb9b4c3fbc113$var$PAUSED = 1, $ef2bb9b4c3fbc113$var$PLAYING = 2, $ef2bb9b4c3fbc113$var$REVERSING = 3, $ef2bb9b4c3fbc113$var$colorAttrs = [
    'fill',
    'stroke',
    'shadowColor'
];
let $ef2bb9b4c3fbc113$var$idCounter = 0;
class $ef2bb9b4c3fbc113$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        const handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $ef2bb9b4c3fbc113$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    }
    reverse() {
        this.state = $ef2bb9b4c3fbc113$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        const t = this.getTimer() - this._startTime;
        if (this.state === $ef2bb9b4c3fbc113$var$PLAYING) this.setTime(t);
        else if (this.state === $ef2bb9b4c3fbc113$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $ef2bb9b4c3fbc113$var$PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $ef2bb9b4c3fbc113$var$Tween {
    constructor(config){
        const that = this, node = config.node, nodeId = node._id, easing = config.easing || $ef2bb9b4c3fbc113$exports.Easings.Linear, yoyo = !!config.yoyo;
        let duration, key;
        if (typeof config.duration === 'undefined') duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $ef2bb9b4c3fbc113$var$idCounter++;
        const layers = node.getLayer() || (node instanceof $ab25e7d252931ba2$exports.Konva['Stage'] ? node.getLayers() : null);
        if (!layers) $e18dc6b8d0616da8$exports.Util.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        this.anim = new $d3e33b2b81503d17$exports.Animation(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $ef2bb9b4c3fbc113$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$ef2bb9b4c3fbc113$var$Tween.attrs[nodeId]) $ef2bb9b4c3fbc113$var$Tween.attrs[nodeId] = {};
        if (!$ef2bb9b4c3fbc113$var$Tween.attrs[nodeId][this._id]) $ef2bb9b4c3fbc113$var$Tween.attrs[nodeId][this._id] = {};
        if (!$ef2bb9b4c3fbc113$var$Tween.tweens[nodeId]) $ef2bb9b4c3fbc113$var$Tween.tweens[nodeId] = {};
        for(key in config)if ($ef2bb9b4c3fbc113$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        const node = this.node, nodeId = node._id;
        let diff, len, trueEnd, trueStart, endRGBA;
        const tweenId = $ef2bb9b4c3fbc113$var$Tween.tweens[nodeId][key];
        if (tweenId) delete $ef2bb9b4c3fbc113$var$Tween.attrs[nodeId][tweenId][key];
        let start = node.getAttr(key);
        if ($e18dc6b8d0616da8$exports.Util._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = $e18dc6b8d0616da8$exports.Util._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = $e18dc6b8d0616da8$exports.Util._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for(let n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    const startRGBA = $e18dc6b8d0616da8$exports.Util.colorToRGBA(start[n]);
                    endRGBA = $e18dc6b8d0616da8$exports.Util.colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(let n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($ef2bb9b4c3fbc113$var$colorAttrs.indexOf(key) !== -1) {
            start = $e18dc6b8d0616da8$exports.Util.colorToRGBA(start);
            endRGBA = $e18dc6b8d0616da8$exports.Util.colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $ef2bb9b4c3fbc113$var$Tween.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $ef2bb9b4c3fbc113$var$Tween.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        const node = this.node, attrs = $ef2bb9b4c3fbc113$var$Tween.attrs[node._id][this._id];
        let key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ($e18dc6b8d0616da8$exports.Util._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push('rgba(' + Math.round(start[n].r + diff[n].r * i) + ',' + Math.round(start[n].g + diff[n].g * i) + ',' + Math.round(start[n].b + diff[n].b * i) + ',' + (start[n].a + diff[n].a * i) + ')');
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($ef2bb9b4c3fbc113$var$colorAttrs.indexOf(key) !== -1) newVal = 'rgba(' + Math.round(start.r + diff.r * i) + ',' + Math.round(start.g + diff.g * i) + ',' + Math.round(start.b + diff.b * i) + ',' + (start.a + diff.a * i) + ')';
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            const node = this.node;
            const attrs = $ef2bb9b4c3fbc113$var$Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr('points', attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            const node = this.node;
            const attrs = $ef2bb9b4c3fbc113$var$Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        const nodeId = this.node._id, thisId = this._id, attrs = $ef2bb9b4c3fbc113$var$Tween.tweens[nodeId];
        this.pause();
        if (this.anim) this.anim.stop();
        for(const key in attrs)delete $ef2bb9b4c3fbc113$var$Tween.tweens[nodeId][key];
        delete $ef2bb9b4c3fbc113$var$Tween.attrs[nodeId][thisId];
        if ($ef2bb9b4c3fbc113$var$Tween.tweens[nodeId]) {
            if (Object.keys($ef2bb9b4c3fbc113$var$Tween.tweens[nodeId]).length === 0) delete $ef2bb9b4c3fbc113$var$Tween.tweens[nodeId];
            if (Object.keys($ef2bb9b4c3fbc113$var$Tween.attrs[nodeId]).length === 0) delete $ef2bb9b4c3fbc113$var$Tween.attrs[nodeId];
        }
    }
}
$ef2bb9b4c3fbc113$exports.Tween = $ef2bb9b4c3fbc113$var$Tween;
$ef2bb9b4c3fbc113$var$Tween.attrs = {};
$ef2bb9b4c3fbc113$var$Tween.tweens = {};
$9165dcaf5c4d4c7d$exports.Node.prototype.to = function(params) {
    const onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    const tween = new $ef2bb9b4c3fbc113$var$Tween(params);
    tween.play();
};
$ef2bb9b4c3fbc113$exports.Easings = {
    BackEaseIn (t, b, c, d) {
        const s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        const s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        let s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $ef2bb9b4c3fbc113$exports.Easings.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $ef2bb9b4c3fbc113$exports.Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $ef2bb9b4c3fbc113$exports.Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




$0da745bb31935f3f$exports.Konva = $e18dc6b8d0616da8$exports.Util._assign($ab25e7d252931ba2$exports.Konva, {
    Util: $e18dc6b8d0616da8$exports.Util,
    Transform: $e18dc6b8d0616da8$exports.Transform,
    Node: $9165dcaf5c4d4c7d$exports.Node,
    Container: $d8907859c4768725$exports.Container,
    Stage: $8b5f1def56dcb7c0$exports.Stage,
    stages: $8b5f1def56dcb7c0$exports.stages,
    Layer: $76e786788092e9c1$exports.Layer,
    FastLayer: $8f94422bca9120b3$exports.FastLayer,
    Group: $46b926af7f04b04f$exports.Group,
    DD: $5b212d8cfde4575b$exports.DD,
    Shape: $1f300d37bd09701b$exports.Shape,
    shapes: $1f300d37bd09701b$exports.shapes,
    Animation: $d3e33b2b81503d17$exports.Animation,
    Tween: $ef2bb9b4c3fbc113$exports.Tween,
    Easings: $ef2bb9b4c3fbc113$exports.Easings,
    Context: $763151d76d51961e$exports.Context,
    Canvas: $ba6d4fe86aeb546f$exports.Canvas
});
$0da745bb31935f3f$exports.default = $0da745bb31935f3f$exports.Konva;


var $556478fa6dcccf09$exports = {};
"use strict";
Object.defineProperty($556478fa6dcccf09$exports, "__esModule", {
    value: true
});
$556478fa6dcccf09$exports.Arc = void 0;





class $556478fa6dcccf09$var$Arc extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        const angle = $ab25e7d252931ba2$exports.Konva.getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = $ab25e7d252931ba2$exports.Konva.getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$556478fa6dcccf09$exports.Arc = $556478fa6dcccf09$var$Arc;
$556478fa6dcccf09$var$Arc.prototype._centroid = true;
$556478fa6dcccf09$var$Arc.prototype.className = 'Arc';
$556478fa6dcccf09$var$Arc.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius',
    'angle',
    'clockwise'
];
(0, $ab25e7d252931ba2$exports._registerNode)($556478fa6dcccf09$var$Arc);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($556478fa6dcccf09$var$Arc, 'innerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($556478fa6dcccf09$var$Arc, 'outerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($556478fa6dcccf09$var$Arc, 'angle', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($556478fa6dcccf09$var$Arc, 'clockwise', false, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());


var $cd4e06a27112b36e$exports = {};
"use strict";
Object.defineProperty($cd4e06a27112b36e$exports, "__esModule", {
    value: true
});
$cd4e06a27112b36e$exports.Arrow = void 0;

var $e4102f2dd0dfb187$exports = {};
"use strict";
Object.defineProperty($e4102f2dd0dfb187$exports, "__esModule", {
    value: true
});
$e4102f2dd0dfb187$exports.Line = void 0;




function $e4102f2dd0dfb187$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $e4102f2dd0dfb187$var$expandPoints(p, tension) {
    const len = p.length, allPoints = [];
    for(let n = 2; n < len - 2; n += 2){
        const cp = $e4102f2dd0dfb187$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
class $e4102f2dd0dfb187$var$Line extends $1f300d37bd09701b$exports.Shape {
    constructor(config){
        super(config);
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function() {
            this._clearCache('tensionPoints');
        });
    }
    _sceneFunc(context) {
        const points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier();
        if (!length) return;
        let n = 0;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            const tp = this.getTensionPoints();
            const len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache('tensionPoints', this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $e4102f2dd0dfb187$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        const p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $e4102f2dd0dfb187$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $e4102f2dd0dfb187$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $e4102f2dd0dfb187$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        let points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
$e4102f2dd0dfb187$exports.Line = $e4102f2dd0dfb187$var$Line;
$e4102f2dd0dfb187$var$Line.prototype.className = 'Line';
$e4102f2dd0dfb187$var$Line.prototype._attrsAffectingSize = [
    'points',
    'bezier',
    'tension'
];
(0, $ab25e7d252931ba2$exports._registerNode)($e4102f2dd0dfb187$var$Line);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($e4102f2dd0dfb187$var$Line, 'closed', false);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($e4102f2dd0dfb187$var$Line, 'bezier', false);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($e4102f2dd0dfb187$var$Line, 'tension', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($e4102f2dd0dfb187$var$Line, 'points', [], (0, $aae05bbbe3f82503$exports.getNumberArrayValidator)());




var $7a449f01f12c38e2$exports = {};
"use strict";
Object.defineProperty($7a449f01f12c38e2$exports, "__esModule", {
    value: true
});
$7a449f01f12c38e2$exports.Path = void 0;



var $705db2baf33bf021$exports = {};
"use strict";
Object.defineProperty($705db2baf33bf021$exports, "__esModule", {
    value: true
});
$705db2baf33bf021$exports.t2length = $705db2baf33bf021$exports.getQuadraticArcLength = $705db2baf33bf021$exports.getCubicArcLength = $705db2baf33bf021$exports.binomialCoefficients = $705db2baf33bf021$exports.cValues = $705db2baf33bf021$exports.tValues = void 0;
$705db2baf33bf021$exports.tValues = [
    [],
    [],
    [
        -0.5773502691896257,
        0.5773502691896257645091487805019574556476
    ],
    [
        0,
        -0.7745966692414834,
        0.7745966692414833770358530799564799221665
    ],
    [
        -0.33998104358485626,
        0.3399810435848562648026657591032446872005,
        -0.8611363115940526,
        0.8611363115940525752239464888928095050957
    ],
    [
        0,
        -0.5384693101056831,
        0.5384693101056830910363144207002088049672,
        -0.906179845938664,
        0.9061798459386639927976268782993929651256
    ],
    [
        0.6612093864662645136613995950199053470064,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969086305017216807119354186,
        -0.932469514203152,
        0.9324695142031520278123015544939946091347
    ],
    [
        0,
        0.4058451513773971669066064120769614633473,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993944398638647732807884070741,
        -0.9491079123427585,
        0.9491079123427585245261896840478512624007
    ],
    [
        -0.1834346424956498,
        0.1834346424956498049394761423601839806667,
        -0.525532409916329,
        0.5255324099163289858177390491892463490419,
        -0.7966664774136267,
        0.7966664774136267395915539364758304368371,
        -0.9602898564975363,
        0.9602898564975362316835608685694729904282
    ],
    [
        0,
        -0.8360311073266358,
        0.8360311073266357942994297880697348765441,
        -0.9681602395076261,
        0.9681602395076260898355762029036728700494,
        -0.3242534234038089,
        0.3242534234038089290385380146433366085719,
        -0.6133714327005904,
        0.6133714327005903973087020393414741847857
    ],
    [
        -0.14887433898163122,
        0.1488743389816312108848260011297199846175,
        -0.4333953941292472,
        0.4333953941292471907992659431657841622,
        -0.6794095682990244,
        0.6794095682990244062343273651148735757692,
        -0.8650633666889845,
        0.8650633666889845107320966884234930485275,
        -0.9739065285171717,
        0.9739065285171717200779640120844520534282
    ],
    [
        0,
        -0.26954315595234496,
        0.2695431559523449723315319854008615246796,
        -0.5190961292068118,
        0.5190961292068118159257256694586095544802,
        -0.7301520055740494,
        0.7301520055740493240934162520311534580496,
        -0.8870625997680953,
        0.8870625997680952990751577693039272666316,
        -0.978228658146057,
        0.9782286581460569928039380011228573907714
    ],
    [
        -0.1252334085114689,
        0.1252334085114689154724413694638531299833,
        -0.3678314989981802,
        0.3678314989981801937526915366437175612563,
        -0.5873179542866175,
        0.587317954286617447296702418940534280369,
        -0.7699026741943047,
        0.7699026741943046870368938332128180759849,
        -0.9041172563704749,
        0.9041172563704748566784658661190961925375,
        -0.9815606342467192,
        0.9815606342467192506905490901492808229601
    ],
    [
        0,
        -0.2304583159551348,
        0.2304583159551347940655281210979888352115,
        -0.44849275103644687,
        0.4484927510364468528779128521276398678019,
        -0.6423493394403402,
        0.6423493394403402206439846069955156500716,
        -0.8015780907333099,
        0.8015780907333099127942064895828598903056,
        -0.9175983992229779,
        0.9175983992229779652065478365007195123904,
        -0.9841830547185881,
        0.9841830547185881494728294488071096110649
    ],
    [
        -0.10805494870734367,
        0.1080549487073436620662446502198347476119,
        -0.31911236892788974,
        0.3191123689278897604356718241684754668342,
        -0.5152486363581541,
        0.5152486363581540919652907185511886623088,
        -0.6872929048116855,
        0.6872929048116854701480198030193341375384,
        -0.827201315069765,
        0.8272013150697649931897947426503949610397,
        -0.9284348836635735,
        0.928434883663573517336391139377874264477,
        -0.9862838086968123,
        0.986283808696812338841597266704052801676
    ],
    [
        0,
        -0.20119409399743451,
        0.2011940939974345223006283033945962078128,
        -0.3941513470775634,
        0.3941513470775633698972073709810454683627,
        -0.5709721726085388,
        0.5709721726085388475372267372539106412383,
        -0.7244177313601701,
        0.7244177313601700474161860546139380096308,
        -0.8482065834104272,
        0.8482065834104272162006483207742168513662,
        -0.937273392400706,
        0.9372733924007059043077589477102094712439,
        -0.9879925180204854,
        0.9879925180204854284895657185866125811469
    ],
    [
        -0.09501250983763744,
        0.0950125098376374401853193354249580631303,
        -0.2816035507792589,
        0.281603550779258913230460501460496106486,
        -0.45801677765722737,
        0.45801677765722738634241944298357757354,
        -0.6178762444026438,
        0.6178762444026437484466717640487910189918,
        -0.755404408355003,
        0.7554044083550030338951011948474422683538,
        -0.8656312023878318,
        0.8656312023878317438804678977123931323873,
        -0.9445750230732326,
        0.9445750230732325760779884155346083450911,
        -0.9894009349916499,
        0.9894009349916499325961541734503326274262
    ],
    [
        0,
        -0.17848418149584785,
        0.1784841814958478558506774936540655574754,
        -0.3512317634538763,
        0.3512317634538763152971855170953460050405,
        -0.5126905370864769,
        0.5126905370864769678862465686295518745829,
        -0.6576711592166907,
        0.6576711592166907658503022166430023351478,
        -0.7815140038968014,
        0.7815140038968014069252300555204760502239,
        -0.8802391537269859,
        0.8802391537269859021229556944881556926234,
        -0.9506755217687678,
        0.9506755217687677612227169578958030214433,
        -0.9905754753144174,
        0.9905754753144173356754340199406652765077
    ],
    [
        -0.0847750130417353,
        0.0847750130417353012422618529357838117333,
        -0.2518862256915055,
        0.2518862256915055095889728548779112301628,
        -0.41175116146284263,
        0.4117511614628426460359317938330516370789,
        -0.5597708310739475,
        0.5597708310739475346078715485253291369276,
        -0.6916870430603532,
        0.6916870430603532078748910812888483894522,
        -0.8037049589725231,
        0.8037049589725231156824174550145907971032,
        -0.8926024664975557,
        0.8926024664975557392060605911271455154078,
        -0.9558239495713977,
        0.9558239495713977551811958929297763099728,
        -0.9915651684209309,
        0.9915651684209309467300160047061507702525
    ],
    [
        0,
        -0.16035864564022537,
        0.1603586456402253758680961157407435495048,
        -0.31656409996362983,
        0.3165640999636298319901173288498449178922,
        -0.46457074137596094,
        0.4645707413759609457172671481041023679762,
        -0.600545304661681,
        0.6005453046616810234696381649462392798683,
        -0.7209661773352294,
        0.7209661773352293786170958608237816296571,
        -0.8227146565371428,
        0.8227146565371428249789224867127139017745,
        -0.9031559036148179,
        0.9031559036148179016426609285323124878093,
        -0.96020815213483,
        0.960208152134830030852778840687651526615,
        -0.9924068438435844,
        0.9924068438435844031890176702532604935893
    ],
    [
        -0.07652652113349734,
        0.0765265211334973337546404093988382110047,
        -0.22778585114164507,
        0.227785851141645078080496195368574624743,
        -0.37370608871541955,
        0.3737060887154195606725481770249272373957,
        -0.5108670019508271,
        0.5108670019508270980043640509552509984254,
        -0.636053680726515,
        0.6360536807265150254528366962262859367433,
        -0.7463319064601508,
        0.7463319064601507926143050703556415903107,
        -0.8391169718222188,
        0.8391169718222188233945290617015206853296,
        -0.912234428251326,
        0.9122344282513259058677524412032981130491,
        -0.9639719272779138,
        0.963971927277913791267666131197277221912,
        -0.9931285991850949,
        0.9931285991850949247861223884713202782226
    ],
    [
        0,
        -0.1455618541608951,
        0.1455618541608950909370309823386863301163,
        -0.2880213168024011,
        0.288021316802401096600792516064600319909,
        -0.4243421202074388,
        0.4243421202074387835736688885437880520964,
        -0.5516188358872198,
        0.551618835887219807059018796724313286622,
        -0.6671388041974123,
        0.667138804197412319305966669990339162597,
        -0.7684399634756779,
        0.7684399634756779086158778513062280348209,
        -0.8533633645833173,
        0.8533633645833172836472506385875676702761,
        -0.9200993341504008,
        0.9200993341504008287901871337149688941591,
        -0.9672268385663063,
        0.9672268385663062943166222149076951614246,
        -0.9937521706203895,
        0.9937521706203895002602420359379409291933
    ],
    [
        -0.06973927331972223,
        0.0697392733197222212138417961186280818222,
        -0.20786042668822127,
        0.2078604266882212854788465339195457342156,
        -0.34193582089208424,
        0.3419358208920842251581474204273796195591,
        -0.469355837986757,
        0.4693558379867570264063307109664063460953,
        -0.5876404035069116,
        0.5876404035069115929588769276386473488776,
        -0.6944872631866827,
        0.6944872631866827800506898357622567712673,
        -0.7878168059792081,
        0.7878168059792081620042779554083515213881,
        -0.8658125777203002,
        0.8658125777203001365364256370193787290847,
        -0.926956772187174,
        0.9269567721871740005206929392590531966353,
        -0.9700604978354287,
        0.9700604978354287271239509867652687108059,
        -0.9942945854823992,
        0.994294585482399292073031421161298980393
    ],
    [
        0,
        -0.1332568242984661,
        0.1332568242984661109317426822417661370104,
        -0.26413568097034495,
        0.264135680970344930533869538283309602979,
        -0.3903010380302908,
        0.390301038030290831421488872880605458578,
        -0.5095014778460075,
        0.5095014778460075496897930478668464305448,
        -0.6196098757636461,
        0.6196098757636461563850973116495956533871,
        -0.7186613631319502,
        0.7186613631319501944616244837486188483299,
        -0.8048884016188399,
        0.8048884016188398921511184069967785579414,
        -0.8767523582704416,
        0.8767523582704416673781568859341456716389,
        -0.9329710868260161,
        0.9329710868260161023491969890384229782357,
        -0.9725424712181152,
        0.9725424712181152319560240768207773751816,
        -0.9947693349975522,
        0.9947693349975521235239257154455743605736
    ],
    [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ]
];
$705db2baf33bf021$exports.cValues = [
    [],
    [],
    [
        1.0,
        1.0
    ],
    [
        0.8888888888888888888888888888888888888888,
        0.5555555555555555555555555555555555555555,
        0.5555555555555555555555555555555555555555
    ],
    [
        0.6521451548625461426269360507780005927646,
        0.6521451548625461426269360507780005927646,
        0.3478548451374538573730639492219994072353,
        0.3478548451374538573730639492219994072353
    ],
    [
        0.5688888888888888888888888888888888888888,
        0.4786286704993664680412915148356381929122,
        0.4786286704993664680412915148356381929122,
        0.2369268850561890875142640407199173626432,
        0.2369268850561890875142640407199173626432
    ],
    [
        0.3607615730481386075698335138377161116615,
        0.3607615730481386075698335138377161116615,
        0.4679139345726910473898703439895509948116,
        0.4679139345726910473898703439895509948116,
        0.1713244923791703450402961421727328935268,
        0.1713244923791703450402961421727328935268
    ],
    [
        0.4179591836734693877551020408163265306122,
        0.3818300505051189449503697754889751338783,
        0.3818300505051189449503697754889751338783,
        0.2797053914892766679014677714237795824869,
        0.2797053914892766679014677714237795824869,
        0.1294849661688696932706114326790820183285,
        0.1294849661688696932706114326790820183285
    ],
    [
        0.3626837833783619829651504492771956121941,
        0.3626837833783619829651504492771956121941,
        0.3137066458778872873379622019866013132603,
        0.3137066458778872873379622019866013132603,
        0.2223810344533744705443559944262408844301,
        0.2223810344533744705443559944262408844301,
        0.1012285362903762591525313543099621901153,
        0.1012285362903762591525313543099621901153
    ],
    [
        0.3302393550012597631645250692869740488788,
        0.1806481606948574040584720312429128095143,
        0.1806481606948574040584720312429128095143,
        0.0812743883615744119718921581105236506756,
        0.0812743883615744119718921581105236506756,
        0.3123470770400028400686304065844436655987,
        0.3123470770400028400686304065844436655987,
        0.2606106964029354623187428694186328497718,
        0.2606106964029354623187428694186328497718
    ],
    [
        0.295524224714752870173892994651338329421,
        0.295524224714752870173892994651338329421,
        0.2692667193099963550912269215694693528597,
        0.2692667193099963550912269215694693528597,
        0.2190863625159820439955349342281631924587,
        0.2190863625159820439955349342281631924587,
        0.1494513491505805931457763396576973324025,
        0.1494513491505805931457763396576973324025,
        0.0666713443086881375935688098933317928578,
        0.0666713443086881375935688098933317928578
    ],
    [
        0.272925086777900630714483528336342189156,
        0.2628045445102466621806888698905091953727,
        0.2628045445102466621806888698905091953727,
        0.2331937645919904799185237048431751394317,
        0.2331937645919904799185237048431751394317,
        0.1862902109277342514260976414316558916912,
        0.1862902109277342514260976414316558916912,
        0.1255803694649046246346942992239401001976,
        0.1255803694649046246346942992239401001976,
        0.0556685671161736664827537204425485787285,
        0.0556685671161736664827537204425485787285
    ],
    [
        0.2491470458134027850005624360429512108304,
        0.2491470458134027850005624360429512108304,
        0.2334925365383548087608498989248780562594,
        0.2334925365383548087608498989248780562594,
        0.2031674267230659217490644558097983765065,
        0.2031674267230659217490644558097983765065,
        0.160078328543346226334652529543359071872,
        0.160078328543346226334652529543359071872,
        0.1069393259953184309602547181939962242145,
        0.1069393259953184309602547181939962242145,
        0.047175336386511827194615961485017060317,
        0.047175336386511827194615961485017060317
    ],
    [
        0.2325515532308739101945895152688359481566,
        0.2262831802628972384120901860397766184347,
        0.2262831802628972384120901860397766184347,
        0.2078160475368885023125232193060527633865,
        0.2078160475368885023125232193060527633865,
        0.1781459807619457382800466919960979955128,
        0.1781459807619457382800466919960979955128,
        0.1388735102197872384636017768688714676218,
        0.1388735102197872384636017768688714676218,
        0.0921214998377284479144217759537971209236,
        0.0921214998377284479144217759537971209236,
        0.0404840047653158795200215922009860600419,
        0.0404840047653158795200215922009860600419
    ],
    [
        0.2152638534631577901958764433162600352749,
        0.2152638534631577901958764433162600352749,
        0.2051984637212956039659240656612180557103,
        0.2051984637212956039659240656612180557103,
        0.1855383974779378137417165901251570362489,
        0.1855383974779378137417165901251570362489,
        0.1572031671581935345696019386238421566056,
        0.1572031671581935345696019386238421566056,
        0.1215185706879031846894148090724766259566,
        0.1215185706879031846894148090724766259566,
        0.0801580871597602098056332770628543095836,
        0.0801580871597602098056332770628543095836,
        0.0351194603317518630318328761381917806197,
        0.0351194603317518630318328761381917806197
    ],
    [
        0.2025782419255612728806201999675193148386,
        0.1984314853271115764561183264438393248186,
        0.1984314853271115764561183264438393248186,
        0.1861610000155622110268005618664228245062,
        0.1861610000155622110268005618664228245062,
        0.1662692058169939335532008604812088111309,
        0.1662692058169939335532008604812088111309,
        0.1395706779261543144478047945110283225208,
        0.1395706779261543144478047945110283225208,
        0.1071592204671719350118695466858693034155,
        0.1071592204671719350118695466858693034155,
        0.0703660474881081247092674164506673384667,
        0.0703660474881081247092674164506673384667,
        0.0307532419961172683546283935772044177217,
        0.0307532419961172683546283935772044177217
    ],
    [
        0.1894506104550684962853967232082831051469,
        0.1894506104550684962853967232082831051469,
        0.1826034150449235888667636679692199393835,
        0.1826034150449235888667636679692199393835,
        0.1691565193950025381893120790303599622116,
        0.1691565193950025381893120790303599622116,
        0.1495959888165767320815017305474785489704,
        0.1495959888165767320815017305474785489704,
        0.1246289712555338720524762821920164201448,
        0.1246289712555338720524762821920164201448,
        0.0951585116824927848099251076022462263552,
        0.0951585116824927848099251076022462263552,
        0.0622535239386478928628438369943776942749,
        0.0622535239386478928628438369943776942749,
        0.0271524594117540948517805724560181035122,
        0.0271524594117540948517805724560181035122
    ],
    [
        0.1794464703562065254582656442618856214487,
        0.1765627053669926463252709901131972391509,
        0.1765627053669926463252709901131972391509,
        0.1680041021564500445099706637883231550211,
        0.1680041021564500445099706637883231550211,
        0.1540457610768102880814315948019586119404,
        0.1540457610768102880814315948019586119404,
        0.1351363684685254732863199817023501973721,
        0.1351363684685254732863199817023501973721,
        0.1118838471934039710947883856263559267358,
        0.1118838471934039710947883856263559267358,
        0.0850361483171791808835353701910620738504,
        0.0850361483171791808835353701910620738504,
        0.0554595293739872011294401653582446605128,
        0.0554595293739872011294401653582446605128,
        0.0241483028685479319601100262875653246916,
        0.0241483028685479319601100262875653246916
    ],
    [
        0.1691423829631435918406564701349866103341,
        0.1691423829631435918406564701349866103341,
        0.1642764837458327229860537764659275904123,
        0.1642764837458327229860537764659275904123,
        0.1546846751262652449254180038363747721932,
        0.1546846751262652449254180038363747721932,
        0.1406429146706506512047313037519472280955,
        0.1406429146706506512047313037519472280955,
        0.1225552067114784601845191268002015552281,
        0.1225552067114784601845191268002015552281,
        0.1009420441062871655628139849248346070628,
        0.1009420441062871655628139849248346070628,
        0.0764257302548890565291296776166365256053,
        0.0764257302548890565291296776166365256053,
        0.0497145488949697964533349462026386416808,
        0.0497145488949697964533349462026386416808,
        0.0216160135264833103133427102664524693876,
        0.0216160135264833103133427102664524693876
    ],
    [
        0.1610544498487836959791636253209167350399,
        0.1589688433939543476499564394650472016787,
        0.1589688433939543476499564394650472016787,
        0.152766042065859666778855400897662998461,
        0.152766042065859666778855400897662998461,
        0.1426067021736066117757461094419029724756,
        0.1426067021736066117757461094419029724756,
        0.1287539625393362276755157848568771170558,
        0.1287539625393362276755157848568771170558,
        0.1115666455473339947160239016817659974813,
        0.1115666455473339947160239016817659974813,
        0.0914900216224499994644620941238396526609,
        0.0914900216224499994644620941238396526609,
        0.0690445427376412265807082580060130449618,
        0.0690445427376412265807082580060130449618,
        0.0448142267656996003328381574019942119517,
        0.0448142267656996003328381574019942119517,
        0.0194617882297264770363120414644384357529,
        0.0194617882297264770363120414644384357529
    ],
    [
        0.1527533871307258506980843319550975934919,
        0.1527533871307258506980843319550975934919,
        0.1491729864726037467878287370019694366926,
        0.1491729864726037467878287370019694366926,
        0.1420961093183820513292983250671649330345,
        0.1420961093183820513292983250671649330345,
        0.1316886384491766268984944997481631349161,
        0.1316886384491766268984944997481631349161,
        0.118194531961518417312377377711382287005,
        0.118194531961518417312377377711382287005,
        0.1019301198172404350367501354803498761666,
        0.1019301198172404350367501354803498761666,
        0.0832767415767047487247581432220462061001,
        0.0832767415767047487247581432220462061001,
        0.0626720483341090635695065351870416063516,
        0.0626720483341090635695065351870416063516,
        0.040601429800386941331039952274932109879,
        0.040601429800386941331039952274932109879,
        0.0176140071391521183118619623518528163621,
        0.0176140071391521183118619623518528163621
    ],
    [
        0.1460811336496904271919851476833711882448,
        0.1445244039899700590638271665537525436099,
        0.1445244039899700590638271665537525436099,
        0.1398873947910731547221334238675831108927,
        0.1398873947910731547221334238675831108927,
        0.132268938633337461781052574496775604329,
        0.132268938633337461781052574496775604329,
        0.1218314160537285341953671771257335983563,
        0.1218314160537285341953671771257335983563,
        0.1087972991671483776634745780701056420336,
        0.1087972991671483776634745780701056420336,
        0.0934444234560338615532897411139320884835,
        0.0934444234560338615532897411139320884835,
        0.0761001136283793020170516533001831792261,
        0.0761001136283793020170516533001831792261,
        0.0571344254268572082836358264724479574912,
        0.0571344254268572082836358264724479574912,
        0.0369537897708524937999506682993296661889,
        0.0369537897708524937999506682993296661889,
        0.0160172282577743333242246168584710152658,
        0.0160172282577743333242246168584710152658
    ],
    [
        0.1392518728556319933754102483418099578739,
        0.1392518728556319933754102483418099578739,
        0.1365414983460151713525738312315173965863,
        0.1365414983460151713525738312315173965863,
        0.1311735047870623707329649925303074458757,
        0.1311735047870623707329649925303074458757,
        0.1232523768105124242855609861548144719594,
        0.1232523768105124242855609861548144719594,
        0.1129322960805392183934006074217843191142,
        0.1129322960805392183934006074217843191142,
        0.1004141444428809649320788378305362823508,
        0.1004141444428809649320788378305362823508,
        0.0859416062170677274144436813727028661891,
        0.0859416062170677274144436813727028661891,
        0.0697964684245204880949614189302176573987,
        0.0697964684245204880949614189302176573987,
        0.0522933351526832859403120512732112561121,
        0.0522933351526832859403120512732112561121,
        0.0337749015848141547933022468659129013491,
        0.0337749015848141547933022468659129013491,
        0.0146279952982722006849910980471854451902,
        0.0146279952982722006849910980471854451902
    ],
    [
        0.1336545721861061753514571105458443385831,
        0.132462039404696617371642464703316925805,
        0.132462039404696617371642464703316925805,
        0.1289057221880821499785953393997936532597,
        0.1289057221880821499785953393997936532597,
        0.1230490843067295304675784006720096548158,
        0.1230490843067295304675784006720096548158,
        0.1149966402224113649416435129339613014914,
        0.1149966402224113649416435129339613014914,
        0.1048920914645414100740861850147438548584,
        0.1048920914645414100740861850147438548584,
        0.0929157660600351474770186173697646486034,
        0.0929157660600351474770186173697646486034,
        0.0792814117767189549228925247420432269137,
        0.0792814117767189549228925247420432269137,
        0.0642324214085258521271696151589109980391,
        0.0642324214085258521271696151589109980391,
        0.0480376717310846685716410716320339965612,
        0.0480376717310846685716410716320339965612,
        0.0309880058569794443106942196418845053837,
        0.0309880058569794443106942196418845053837,
        0.0134118594871417720813094934586150649766,
        0.0134118594871417720813094934586150649766
    ],
    [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ]
];
$705db2baf33bf021$exports.binomialCoefficients = [
    [
        1
    ],
    [
        1,
        1
    ],
    [
        1,
        2,
        1
    ],
    [
        1,
        3,
        3,
        1
    ]
];
const $705db2baf33bf021$var$getCubicArcLength = (xs, ys, t)=>{
    let sum;
    let correctedT;
    const n = 20;
    const z = t / 2;
    sum = 0;
    for(let i = 0; i < n; i++){
        correctedT = z * $705db2baf33bf021$exports.tValues[n][i] + z;
        sum += $705db2baf33bf021$exports.cValues[n][i] * $705db2baf33bf021$var$BFunc(xs, ys, correctedT);
    }
    return z * sum;
};
$705db2baf33bf021$exports.getCubicArcLength = $705db2baf33bf021$var$getCubicArcLength;
const $705db2baf33bf021$var$getQuadraticArcLength = (xs, ys, t)=>{
    if (t === undefined) t = 1;
    const ax = xs[0] - 2 * xs[1] + xs[2];
    const ay = ys[0] - 2 * ys[1] + ys[2];
    const bx = 2 * xs[1] - 2 * xs[0];
    const by = 2 * ys[1] - 2 * ys[0];
    const A = 4 * (ax * ax + ay * ay);
    const B = 4 * (ax * bx + ay * by);
    const C = bx * bx + by * by;
    if (A === 0) return t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2));
    const b = B / (2 * A);
    const c = C / A;
    const u = t + b;
    const k = c - b * b;
    const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
    const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
    const term = b + Math.sqrt(b * b + k) !== 0 ? k * Math.log(Math.abs((u + uuk) / (b + bbk))) : 0;
    return Math.sqrt(A) / 2 * (u * uuk - b * bbk + term);
};
$705db2baf33bf021$exports.getQuadraticArcLength = $705db2baf33bf021$var$getQuadraticArcLength;
function $705db2baf33bf021$var$BFunc(xs, ys, t) {
    const xbase = $705db2baf33bf021$var$getDerivative(1, t, xs);
    const ybase = $705db2baf33bf021$var$getDerivative(1, t, ys);
    const combined = xbase * xbase + ybase * ybase;
    return Math.sqrt(combined);
}
const $705db2baf33bf021$var$getDerivative = (derivative, t, vs)=>{
    const n = vs.length - 1;
    let _vs;
    let value;
    if (n === 0) return 0;
    if (derivative === 0) {
        value = 0;
        for(let k = 0; k <= n; k++)value += $705db2baf33bf021$exports.binomialCoefficients[n][k] * Math.pow(1 - t, n - k) * Math.pow(t, k) * vs[k];
        return value;
    } else {
        _vs = new Array(n);
        for(let k = 0; k < n; k++)_vs[k] = n * (vs[k + 1] - vs[k]);
        return $705db2baf33bf021$var$getDerivative(derivative - 1, t, _vs);
    }
};
const $705db2baf33bf021$var$t2length = (length, totalLength, func)=>{
    let error = 1;
    let t = length / totalLength;
    let step = (length - func(t)) / totalLength;
    let numIterations = 0;
    while(error > 0.001){
        const increasedTLength = func(t + step);
        const increasedTError = Math.abs(length - increasedTLength) / totalLength;
        if (increasedTError < error) {
            error = increasedTError;
            t += step;
        } else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
                error = decreasedTError;
                t -= step;
            } else step /= 2;
        }
        numIterations++;
        if (numIterations > 500) break;
    }
    return t;
};
$705db2baf33bf021$exports.t2length = $705db2baf33bf021$var$t2length;


class $7a449f01f12c38e2$var$Path extends $1f300d37bd09701b$exports.Shape {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this._readDataAttribute();
        this.on('dataChange.konva', function() {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = $7a449f01f12c38e2$var$Path.parsePathData(this.data());
        this.pathLength = $7a449f01f12c38e2$var$Path.getPathLength(this.dataArray);
    }
    _sceneFunc(context) {
        const ca = this.dataArray;
        context.beginPath();
        let isClosed = false;
        for(let n = 0; n < ca.length; n++){
            const c = ca[n].command;
            const p = ca[n].points;
            switch(c){
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    const cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    const r = rx > ry ? rx : ry;
                    const scaleX = rx > ry ? 1 : rx / ry;
                    const scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        let points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === 'A') {
                const start = data.points[4];
                const dTheta = data.points[5];
                const end = data.points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $7a449f01f12c38e2$var$Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $7a449f01f12c38e2$var$Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === 'C') for(let t = 0.0; t <= 1; t += 0.01){
                const point = $7a449f01f12c38e2$var$Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        return $7a449f01f12c38e2$var$Path.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPathLength(dataArray) {
        let pathLength = 0;
        for(let i = 0; i < dataArray.length; ++i)pathLength += dataArray[i].pathLength;
        return pathLength;
    }
    static getPointAtLengthOfDataArray(length, dataArray) {
        let points, i = 0, ii = dataArray.length;
        if (!ii) return null;
        while(i < ii && length > dataArray[i].pathLength){
            length -= dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            points = dataArray[i - 1].points.slice(-2);
            return {
                x: points[0],
                y: points[1]
            };
        }
        if (length < 0.01) {
            const cmd = dataArray[i].command;
            if (cmd === 'M') {
                points = dataArray[i].points.slice(0, 2);
                return {
                    x: points[0],
                    y: points[1]
                };
            } else return {
                x: dataArray[i].start.x,
                y: dataArray[i].start.y
            };
        }
        const cp = dataArray[i];
        const p = cp.points;
        switch(cp.command){
            case 'L':
                return $7a449f01f12c38e2$var$Path.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return $7a449f01f12c38e2$var$Path.getPointOnCubicBezier((0, $705db2baf33bf021$exports.t2length)(length, $7a449f01f12c38e2$var$Path.getPathLength(dataArray), (i)=>{
                    return (0, $705db2baf33bf021$exports.getCubicArcLength)([
                        cp.start.x,
                        p[0],
                        p[2],
                        p[4]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3],
                        p[5]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return $7a449f01f12c38e2$var$Path.getPointOnQuadraticBezier((0, $705db2baf33bf021$exports.t2length)(length, $7a449f01f12c38e2$var$Path.getPathLength(dataArray), (i)=>{
                    return (0, $705db2baf33bf021$exports.getQuadraticArcLength)([
                        cp.start.x,
                        p[0],
                        p[2]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                const cx = p[0], cy = p[1], rx = p[2], ry = p[3], dTheta = p[5], psi = p[6];
                let theta = p[4];
                theta += dTheta * length / cp.pathLength;
                return $7a449f01f12c38e2$var$Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        fromX = fromX !== null && fromX !== void 0 ? fromX : P1x;
        fromY = fromY !== null && fromY !== void 0 ? fromY : P1y;
        const len = this.getLineLength(P1x, P1y, P2x, P2y);
        if (len < 1e-10) return {
            x: P1x,
            y: P1y
        };
        if (P2x === P1x) return {
            x: fromX,
            y: fromY + (P2y > P1y ? dist : -dist)
        };
        const m = (P2y - P1y) / (P2x - P1x);
        const run = Math.sqrt(dist * dist / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const rise = m * run;
        if (Math.abs(fromY - P1y - m * (fromX - P1x)) < 1e-10) return {
            x: fromX + run,
            y: fromY + rise
        };
        const u = ((fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y)) / (len * len);
        const ix = P1x + u * (P2x - P1x);
        const iy = P1y + u * (P2y - P1y);
        const pRise = this.getLineLength(fromX, fromY, ix, iy);
        const pRun = Math.sqrt(dist * dist - pRise * pRise);
        const adjustedRun = Math.sqrt(pRun * pRun / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const adjustedRise = m * adjustedRun;
        return {
            x: ix + adjustedRun,
            y: iy + adjustedRise
        };
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        const x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        const y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        const x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        const y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        const cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        const pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        let cs = data;
        const cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for(let n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        const arr = cs.split('|');
        const ca = [];
        const coords = [];
        let cpx = 0;
        let cpy = 0;
        const re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        let match;
        for(let n = 1; n < arr.length; n++){
            let str = arr[n];
            let c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            const p = [];
            for(let j = 0, jlen = coords.length; j < jlen; j++){
                if (coords[j] === '00') {
                    p.push(0, 0);
                    continue;
                }
                const parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) p.push(parsed);
                else p.push(0);
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                let cmd = '';
                let points = [];
                const startX = cpx, startY = cpy;
                let prevCmd, ctlPtx, ctlPty;
                let rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        const dx = p.shift();
                        const dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for(let idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === 'M') {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') ca.push({
                command: 'z',
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        let len, p1, p2, t;
        const path = $7a449f01f12c38e2$var$Path;
        switch(cmd){
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                return (0, $705db2baf33bf021$exports.getCubicArcLength)([
                    x,
                    points[0],
                    points[2],
                    points[4]
                ], [
                    y,
                    points[1],
                    points[3],
                    points[5]
                ], 1);
            case 'Q':
                return (0, $705db2baf33bf021$exports.getQuadraticArcLength)([
                    x,
                    points[0],
                    points[2]
                ], [
                    y,
                    points[1],
                    points[3]
                ], 1);
            case 'A':
                len = 0.0;
                const start = points[4];
                const dTheta = points[5];
                const end = points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        const psi = psiDeg * (Math.PI / 180.0);
        const xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        const yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        const lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        let f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        const cxp = f * rx * yp / ry;
        const cyp = f * -ry * xp / rx;
        const cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        const cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        const vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        const vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        const vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        const theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        const u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        const v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        let dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$7a449f01f12c38e2$exports.Path = $7a449f01f12c38e2$var$Path;
$7a449f01f12c38e2$var$Path.prototype.className = 'Path';
$7a449f01f12c38e2$var$Path.prototype._attrsAffectingSize = [
    'data'
];
(0, $ab25e7d252931ba2$exports._registerNode)($7a449f01f12c38e2$var$Path);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($7a449f01f12c38e2$var$Path, 'data');


class $cd4e06a27112b36e$var$Arrow extends $e4102f2dd0dfb187$exports.Line {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        const PI2 = Math.PI * 2;
        const points = this.points();
        let tp = points;
        const fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        const length = this.pointerLength();
        const n = points.length;
        let dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = $7a449f01f12c38e2$exports.Path.calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
            const previous = $7a449f01f12c38e2$exports.Path.getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        const radians = (Math.atan2(dy, dx) + PI2) % PI2;
        const width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        const isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x,
            y: lineRect.y - offset,
            width: lineRect.width,
            height: lineRect.height + offset * 2
        };
    }
}
$cd4e06a27112b36e$exports.Arrow = $cd4e06a27112b36e$var$Arrow;
$cd4e06a27112b36e$var$Arrow.prototype.className = 'Arrow';
(0, $ab25e7d252931ba2$exports._registerNode)($cd4e06a27112b36e$var$Arrow);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($cd4e06a27112b36e$var$Arrow, 'pointerLength', 10, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($cd4e06a27112b36e$var$Arrow, 'pointerWidth', 10, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($cd4e06a27112b36e$var$Arrow, 'pointerAtBeginning', false);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($cd4e06a27112b36e$var$Arrow, 'pointerAtEnding', true);


var $7e614504cf20f43b$exports = {};
"use strict";
Object.defineProperty($7e614504cf20f43b$exports, "__esModule", {
    value: true
});
$7e614504cf20f43b$exports.Circle = void 0;




class $7e614504cf20f43b$var$Circle extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$7e614504cf20f43b$exports.Circle = $7e614504cf20f43b$var$Circle;
$7e614504cf20f43b$var$Circle.prototype._centroid = true;
$7e614504cf20f43b$var$Circle.prototype.className = 'Circle';
$7e614504cf20f43b$var$Circle.prototype._attrsAffectingSize = [
    'radius'
];
(0, $ab25e7d252931ba2$exports._registerNode)($7e614504cf20f43b$var$Circle);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($7e614504cf20f43b$var$Circle, 'radius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());


var $4cde4a7124609310$exports = {};
"use strict";
Object.defineProperty($4cde4a7124609310$exports, "__esModule", {
    value: true
});
$4cde4a7124609310$exports.Ellipse = void 0;




class $4cde4a7124609310$var$Ellipse extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        const rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$4cde4a7124609310$exports.Ellipse = $4cde4a7124609310$var$Ellipse;
$4cde4a7124609310$var$Ellipse.prototype.className = 'Ellipse';
$4cde4a7124609310$var$Ellipse.prototype._centroid = true;
$4cde4a7124609310$var$Ellipse.prototype._attrsAffectingSize = [
    'radiusX',
    'radiusY'
];
(0, $ab25e7d252931ba2$exports._registerNode)($4cde4a7124609310$var$Ellipse);
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($4cde4a7124609310$var$Ellipse, 'radius', [
    'x',
    'y'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($4cde4a7124609310$var$Ellipse, 'radiusX', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($4cde4a7124609310$var$Ellipse, 'radiusY', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());


var $ddcc49bff44d9afd$exports = {};
"use strict";
Object.defineProperty($ddcc49bff44d9afd$exports, "__esModule", {
    value: true
});
$ddcc49bff44d9afd$exports.Image = void 0;





class $ddcc49bff44d9afd$var$Image extends $1f300d37bd09701b$exports.Shape {
    constructor(attrs){
        super(attrs);
        this._loadListener = ()=>{
            this._requestDraw();
        };
        this.on('imageChange.konva', (props)=>{
            this._removeImageLoad(props.oldVal);
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image['addEventListener']) image['addEventListener']('load', this._loadListener);
    }
    _removeImageLoad(image) {
        if (image && image['removeEventListener']) image['removeEventListener']('load', this._loadListener);
    }
    destroy() {
        this._removeImageLoad(this.image());
        super.destroy();
        return this;
    }
    _useBufferCanvas() {
        const hasCornerRadius = !!this.cornerRadius();
        const hasShadow = this.hasShadow();
        if (hasCornerRadius && hasShadow) return true;
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? $e18dc6b8d0616da8$exports.Util.drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else $e18dc6b8d0616da8$exports.Util.drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
    getHeight() {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
    static fromURL(url, callback, onError = null) {
        const img = $e18dc6b8d0616da8$exports.Util.createImageElement();
        img.onload = function() {
            const image = new $ddcc49bff44d9afd$var$Image({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
}
$ddcc49bff44d9afd$exports.Image = $ddcc49bff44d9afd$var$Image;
$ddcc49bff44d9afd$var$Image.prototype.className = 'Image';
(0, $ab25e7d252931ba2$exports._registerNode)($ddcc49bff44d9afd$var$Image);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($ddcc49bff44d9afd$var$Image, 'cornerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberOrArrayOfNumbersValidator)(4));
$6f82f2528fae78ce$exports.Factory.addGetterSetter($ddcc49bff44d9afd$var$Image, 'image');
$6f82f2528fae78ce$exports.Factory.addComponentsGetterSetter($ddcc49bff44d9afd$var$Image, 'crop', [
    'x',
    'y',
    'width',
    'height'
]);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($ddcc49bff44d9afd$var$Image, 'cropX', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($ddcc49bff44d9afd$var$Image, 'cropY', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($ddcc49bff44d9afd$var$Image, 'cropWidth', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($ddcc49bff44d9afd$var$Image, 'cropHeight', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());


var $2361492a5b2f9e5c$exports = {};
"use strict";
Object.defineProperty($2361492a5b2f9e5c$exports, "__esModule", {
    value: true
});
$2361492a5b2f9e5c$exports.Tag = $2361492a5b2f9e5c$exports.Label = void 0;





const $2361492a5b2f9e5c$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'padding',
    'lineHeight',
    'text',
    'width',
    'height',
    'pointerDirection',
    'pointerWidth',
    'pointerHeight'
], $2361492a5b2f9e5c$var$CHANGE_KONVA = 'Change.konva', $2361492a5b2f9e5c$var$NONE = 'none', $2361492a5b2f9e5c$var$UP = 'up', $2361492a5b2f9e5c$var$RIGHT = 'right', $2361492a5b2f9e5c$var$DOWN = 'down', $2361492a5b2f9e5c$var$LEFT = 'left', $2361492a5b2f9e5c$var$attrChangeListLen = $2361492a5b2f9e5c$var$ATTR_CHANGE_LIST.length;
class $2361492a5b2f9e5c$var$Label extends $46b926af7f04b04f$exports.Group {
    constructor(config){
        super(config);
        this.on('add.konva', function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find('Text')[0];
    }
    getTag() {
        return this.find('Tag')[0];
    }
    _addListeners(text) {
        let that = this, n;
        const func = function() {
            that._sync();
        };
        for(n = 0; n < $2361492a5b2f9e5c$var$attrChangeListLen; n++)text.on($2361492a5b2f9e5c$var$ATTR_CHANGE_LIST[n] + $2361492a5b2f9e5c$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        let text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $2361492a5b2f9e5c$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $2361492a5b2f9e5c$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $2361492a5b2f9e5c$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $2361492a5b2f9e5c$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
$2361492a5b2f9e5c$exports.Label = $2361492a5b2f9e5c$var$Label;
$2361492a5b2f9e5c$var$Label.prototype.className = 'Label';
(0, $ab25e7d252931ba2$exports._registerNode)($2361492a5b2f9e5c$var$Label);
class $2361492a5b2f9e5c$var$Tag extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        const width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $2361492a5b2f9e5c$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $2361492a5b2f9e5c$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $2361492a5b2f9e5c$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $2361492a5b2f9e5c$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        let x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $2361492a5b2f9e5c$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $2361492a5b2f9e5c$var$DOWN) height += pointerHeight;
        else if (direction === $2361492a5b2f9e5c$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $2361492a5b2f9e5c$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
$2361492a5b2f9e5c$exports.Tag = $2361492a5b2f9e5c$var$Tag;
$2361492a5b2f9e5c$var$Tag.prototype.className = 'Tag';
(0, $ab25e7d252931ba2$exports._registerNode)($2361492a5b2f9e5c$var$Tag);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($2361492a5b2f9e5c$var$Tag, 'pointerDirection', $2361492a5b2f9e5c$var$NONE);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($2361492a5b2f9e5c$var$Tag, 'pointerWidth', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($2361492a5b2f9e5c$var$Tag, 'pointerHeight', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($2361492a5b2f9e5c$var$Tag, 'cornerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberOrArrayOfNumbersValidator)(4));




var $c8a3cc0a16e87bd4$exports = {};
"use strict";
Object.defineProperty($c8a3cc0a16e87bd4$exports, "__esModule", {
    value: true
});
$c8a3cc0a16e87bd4$exports.Rect = void 0;





class $c8a3cc0a16e87bd4$var$Rect extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        const cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else $e18dc6b8d0616da8$exports.Util.drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$c8a3cc0a16e87bd4$exports.Rect = $c8a3cc0a16e87bd4$var$Rect;
$c8a3cc0a16e87bd4$var$Rect.prototype.className = 'Rect';
(0, $ab25e7d252931ba2$exports._registerNode)($c8a3cc0a16e87bd4$var$Rect);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($c8a3cc0a16e87bd4$var$Rect, 'cornerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberOrArrayOfNumbersValidator)(4));


var $7b9a025942ce2d88$exports = {};
"use strict";
Object.defineProperty($7b9a025942ce2d88$exports, "__esModule", {
    value: true
});
$7b9a025942ce2d88$exports.RegularPolygon = void 0;




class $7b9a025942ce2d88$var$RegularPolygon extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        const points = this._getPoints();
        context.beginPath();
        context.moveTo(points[0].x, points[0].y);
        for(let n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(let n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        let minX = points[0].x;
        let maxX = points[0].y;
        let minY = points[0].x;
        let maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$7b9a025942ce2d88$exports.RegularPolygon = $7b9a025942ce2d88$var$RegularPolygon;
$7b9a025942ce2d88$var$RegularPolygon.prototype.className = 'RegularPolygon';
$7b9a025942ce2d88$var$RegularPolygon.prototype._centroid = true;
$7b9a025942ce2d88$var$RegularPolygon.prototype._attrsAffectingSize = [
    'radius'
];
(0, $ab25e7d252931ba2$exports._registerNode)($7b9a025942ce2d88$var$RegularPolygon);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($7b9a025942ce2d88$var$RegularPolygon, 'radius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($7b9a025942ce2d88$var$RegularPolygon, 'sides', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());


var $b23824d5fefb75ad$exports = {};
"use strict";
Object.defineProperty($b23824d5fefb75ad$exports, "__esModule", {
    value: true
});
$b23824d5fefb75ad$exports.Ring = void 0;




const $b23824d5fefb75ad$var$PIx2 = Math.PI * 2;
class $b23824d5fefb75ad$var$Ring extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $b23824d5fefb75ad$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $b23824d5fefb75ad$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$b23824d5fefb75ad$exports.Ring = $b23824d5fefb75ad$var$Ring;
$b23824d5fefb75ad$var$Ring.prototype.className = 'Ring';
$b23824d5fefb75ad$var$Ring.prototype._centroid = true;
$b23824d5fefb75ad$var$Ring.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $ab25e7d252931ba2$exports._registerNode)($b23824d5fefb75ad$var$Ring);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($b23824d5fefb75ad$var$Ring, 'innerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($b23824d5fefb75ad$var$Ring, 'outerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());


var $a3af0187cf7e728a$exports = {};
"use strict";
Object.defineProperty($a3af0187cf7e728a$exports, "__esModule", {
    value: true
});
$a3af0187cf7e728a$exports.Sprite = void 0;





class $a3af0187cf7e728a$var$Sprite extends $1f300d37bd09701b$exports.Shape {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new $d3e33b2b81503d17$exports.Animation(()=>{
            const updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on('animationChange.konva', function() {
            this.frameIndex(0);
        });
        this.on('frameIndexChange.konva', function() {
            this._updated = true;
        });
        this.on('frameRateChange.konva', function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                const offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            const offset = offsets[anim];
            const ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        const that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        const layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        const index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
}
$a3af0187cf7e728a$exports.Sprite = $a3af0187cf7e728a$var$Sprite;
$a3af0187cf7e728a$var$Sprite.prototype.className = 'Sprite';
(0, $ab25e7d252931ba2$exports._registerNode)($a3af0187cf7e728a$var$Sprite);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($a3af0187cf7e728a$var$Sprite, 'animation');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($a3af0187cf7e728a$var$Sprite, 'animations');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($a3af0187cf7e728a$var$Sprite, 'frameOffsets');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($a3af0187cf7e728a$var$Sprite, 'image');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($a3af0187cf7e728a$var$Sprite, 'frameIndex', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($a3af0187cf7e728a$var$Sprite, 'frameRate', 17, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.backCompat($a3af0187cf7e728a$var$Sprite, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex'
});


var $4cc1ef08a1a6c4d9$exports = {};
"use strict";
Object.defineProperty($4cc1ef08a1a6c4d9$exports, "__esModule", {
    value: true
});
$4cc1ef08a1a6c4d9$exports.Star = void 0;




class $4cc1ef08a1a6c4d9$var$Star extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        const innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(let n = 1; n < numPoints * 2; n++){
            const radius = n % 2 === 0 ? outerRadius : innerRadius;
            const x = radius * Math.sin(n * Math.PI / numPoints);
            const y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$4cc1ef08a1a6c4d9$exports.Star = $4cc1ef08a1a6c4d9$var$Star;
$4cc1ef08a1a6c4d9$var$Star.prototype.className = 'Star';
$4cc1ef08a1a6c4d9$var$Star.prototype._centroid = true;
$4cc1ef08a1a6c4d9$var$Star.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $ab25e7d252931ba2$exports._registerNode)($4cc1ef08a1a6c4d9$var$Star);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($4cc1ef08a1a6c4d9$var$Star, 'numPoints', 5, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($4cc1ef08a1a6c4d9$var$Star, 'innerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($4cc1ef08a1a6c4d9$var$Star, 'outerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());


var $eceab5aac881d05a$exports = {};
"use strict";
Object.defineProperty($eceab5aac881d05a$exports, "__esModule", {
    value: true
});
$eceab5aac881d05a$exports.Text = void 0;
$eceab5aac881d05a$exports.stringToArray = $eceab5aac881d05a$var$stringToArray;






function $eceab5aac881d05a$var$stringToArray(string) {
    return [
        ...string
    ].reduce((acc, char, index, array)=>{
        if (/\p{Emoji}/u.test(char)) {
            const nextChar = array[index + 1];
            if (nextChar && /\p{Emoji_Modifier}|\u200D/u.test(nextChar)) {
                acc.push(char + nextChar);
                array[index + 1] = '';
            } else acc.push(char);
        } else if (/\p{Regional_Indicator}{2}/u.test(char + (array[index + 1] || ''))) acc.push(char + array[index + 1]);
        else if (index > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(char)) acc[acc.length - 1] += char;
        else if (char) acc.push(char);
        return acc;
    }, []);
}
const $eceab5aac881d05a$var$AUTO = 'auto', $eceab5aac881d05a$var$CENTER = 'center', $eceab5aac881d05a$var$INHERIT = 'inherit', $eceab5aac881d05a$var$JUSTIFY = 'justify', $eceab5aac881d05a$var$CHANGE_KONVA = 'Change.konva', $eceab5aac881d05a$var$CONTEXT_2D = '2d', $eceab5aac881d05a$var$DASH = '-', $eceab5aac881d05a$var$LEFT = 'left', $eceab5aac881d05a$var$TEXT = 'text', $eceab5aac881d05a$var$TEXT_UPPER = 'Text', $eceab5aac881d05a$var$TOP = 'top', $eceab5aac881d05a$var$BOTTOM = 'bottom', $eceab5aac881d05a$var$MIDDLE = 'middle', $eceab5aac881d05a$var$NORMAL = 'normal', $eceab5aac881d05a$var$PX_SPACE = 'px ', $eceab5aac881d05a$var$SPACE = ' ', $eceab5aac881d05a$var$RIGHT = 'right', $eceab5aac881d05a$var$RTL = 'rtl', $eceab5aac881d05a$var$WORD = 'word', $eceab5aac881d05a$var$CHAR = 'char', $eceab5aac881d05a$var$NONE = 'none', $eceab5aac881d05a$var$ELLIPSIS = "\u2026", $eceab5aac881d05a$var$ATTR_CHANGE_LIST = [
    'direction',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing'
], $eceab5aac881d05a$var$attrChangeListLen = $eceab5aac881d05a$var$ATTR_CHANGE_LIST.length;
function $eceab5aac881d05a$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(',').map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(' ') >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(', ');
}
let $eceab5aac881d05a$var$dummyContext;
function $eceab5aac881d05a$var$getDummyContext() {
    if ($eceab5aac881d05a$var$dummyContext) return $eceab5aac881d05a$var$dummyContext;
    $eceab5aac881d05a$var$dummyContext = $e18dc6b8d0616da8$exports.Util.createCanvasElement().getContext($eceab5aac881d05a$var$CONTEXT_2D);
    return $eceab5aac881d05a$var$dummyContext;
}
function $eceab5aac881d05a$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $eceab5aac881d05a$var$_strokeFunc(context) {
    context.setAttr('miterLimit', 2);
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $eceab5aac881d05a$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || 'black';
    return config;
}
class $eceab5aac881d05a$var$Text extends $1f300d37bd09701b$exports.Shape {
    constructor(config){
        super($eceab5aac881d05a$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(let n = 0; n < $eceab5aac881d05a$var$attrChangeListLen; n++)this.on($eceab5aac881d05a$var$ATTR_CHANGE_LIST[n] + $eceab5aac881d05a$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        const textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        let padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        direction = direction === $eceab5aac881d05a$var$INHERIT ? context.direction : direction;
        let translateY = lineHeightPx / 2;
        let baseline = $eceab5aac881d05a$var$MIDDLE;
        if ($ab25e7d252931ba2$exports.Konva._fixTextRendering) {
            const metrics = this.measureSize('M');
            baseline = 'alphabetic';
            translateY = (metrics.fontBoundingBoxAscent - metrics.fontBoundingBoxDescent) / 2 + lineHeightPx / 2;
        }
        if (direction === $eceab5aac881d05a$var$RTL) context.setAttr('direction', direction);
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', baseline);
        context.setAttr('textAlign', $eceab5aac881d05a$var$LEFT);
        if (verticalAlign === $eceab5aac881d05a$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $eceab5aac881d05a$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            let lineTranslateX = 0;
            let lineTranslateY = 0;
            const obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph;
            context.save();
            if (align === $eceab5aac881d05a$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $eceab5aac881d05a$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                const yOffset = $ab25e7d252931ba2$exports.Konva._fixTextRendering ? Math.round(fontSize / 4) : Math.round(fontSize / 2);
                const x = lineTranslateX;
                const y = translateY + lineTranslateY + yOffset;
                context.moveTo(x, y);
                const lineWidth = align === $eceab5aac881d05a$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), y);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                const yOffset = $ab25e7d252931ba2$exports.Konva._fixTextRendering ? -Math.round(fontSize / 4) : 0;
                context.moveTo(lineTranslateX, translateY + lineTranslateY + yOffset);
                const lineWidth = align === $eceab5aac881d05a$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (direction !== $eceab5aac881d05a$var$RTL && (letterSpacing !== 0 || align === $eceab5aac881d05a$var$JUSTIFY)) {
                const spacesNumber = text.split(' ').length - 1;
                const array = $eceab5aac881d05a$var$stringToArray(text);
                for(let li = 0; li < array.length; li++){
                    const letter = array[li];
                    if (letter === ' ' && !lastLine && align === $eceab5aac881d05a$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    context.fillStrokeShape(this);
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                if (letterSpacing !== 0) context.setAttr('letterSpacing', `${letterSpacing}px`);
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        const width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        const str = $e18dc6b8d0616da8$exports.Util._isString(text) ? text : text === null || text === undefined ? '' : text + '';
        this._setAttr($eceab5aac881d05a$var$TEXT, str);
        return this;
    }
    getWidth() {
        const isAuto = this.attrs.width === $eceab5aac881d05a$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        const isAuto = this.attrs.height === $eceab5aac881d05a$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        $e18dc6b8d0616da8$exports.Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    measureSize(text) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let _context = $eceab5aac881d05a$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        const scaleFactor = fontSize / 100;
        return {
            actualBoundingBoxAscent: (_a = metrics.actualBoundingBoxAscent) !== null && _a !== void 0 ? _a : 71.58203125 * scaleFactor,
            actualBoundingBoxDescent: (_b = metrics.actualBoundingBoxDescent) !== null && _b !== void 0 ? _b : 0,
            actualBoundingBoxLeft: (_c = metrics.actualBoundingBoxLeft) !== null && _c !== void 0 ? _c : -7.421875 * scaleFactor,
            actualBoundingBoxRight: (_d = metrics.actualBoundingBoxRight) !== null && _d !== void 0 ? _d : 75.732421875 * scaleFactor,
            alphabeticBaseline: (_e = metrics.alphabeticBaseline) !== null && _e !== void 0 ? _e : 0,
            emHeightAscent: (_f = metrics.emHeightAscent) !== null && _f !== void 0 ? _f : 100 * scaleFactor,
            emHeightDescent: (_g = metrics.emHeightDescent) !== null && _g !== void 0 ? _g : -20 * scaleFactor,
            fontBoundingBoxAscent: (_h = metrics.fontBoundingBoxAscent) !== null && _h !== void 0 ? _h : 91 * scaleFactor,
            fontBoundingBoxDescent: (_j = metrics.fontBoundingBoxDescent) !== null && _j !== void 0 ? _j : 21 * scaleFactor,
            hangingBaseline: (_k = metrics.hangingBaseline) !== null && _k !== void 0 ? _k : 72.80000305175781 * scaleFactor,
            ideographicBaseline: (_l = metrics.ideographicBaseline) !== null && _l !== void 0 ? _l : -21 * scaleFactor,
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $eceab5aac881d05a$var$SPACE + this.fontVariant() + $eceab5aac881d05a$var$SPACE + (this.fontSize() + $eceab5aac881d05a$var$PX_SPACE) + $eceab5aac881d05a$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $eceab5aac881d05a$var$JUSTIFY) line = line.trim();
        const width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        const letterSpacing = this.letterSpacing();
        const length = text.length;
        return $eceab5aac881d05a$var$getDummyContext().measureText(text).width + letterSpacing * length;
    }
    _setTextData() {
        let lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $eceab5aac881d05a$var$AUTO && width !== undefined, fixedHeight = height !== $eceab5aac881d05a$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $eceab5aac881d05a$var$NONE, wrapAtWord = wrap !== $eceab5aac881d05a$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $eceab5aac881d05a$var$getDummyContext().font = this._getContextFont();
        const additionalWidth = shouldAddEllipsis ? this._getTextWidth($eceab5aac881d05a$var$ELLIPSIS) : 0;
        for(let i = 0, max = lines.length; i < max; ++i){
            let line = lines[i];
            let lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                let low = 0, high = $eceab5aac881d05a$var$stringToArray(line).length, match = '', matchWidth = 0;
                while(low < high){
                    const mid = low + high >>> 1, lineArray = $eceab5aac881d05a$var$stringToArray(line), substr = lineArray.slice(0, mid + 1).join(''), substrWidth = this._getTextWidth(substr);
                    const shouldConsiderEllipsis = shouldAddEllipsis && fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
                    const effectiveWidth = shouldConsiderEllipsis ? substrWidth + additionalWidth : substrWidth;
                    if (effectiveWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        const lineArray = $eceab5aac881d05a$var$stringToArray(line);
                        const matchArray = $eceab5aac881d05a$var$stringToArray(match);
                        const nextChar = lineArray[matchArray.length];
                        const nextIsSpaceOrDash = nextChar === $eceab5aac881d05a$var$SPACE || nextChar === $eceab5aac881d05a$var$DASH;
                        let wrapIndex;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = matchArray.length;
                        else {
                            const lastSpaceIndex = matchArray.lastIndexOf($eceab5aac881d05a$var$SPACE);
                            const lastDashIndex = matchArray.lastIndexOf($eceab5aac881d05a$var$DASH);
                            wrapIndex = Math.max(lastSpaceIndex, lastDashIndex) + 1;
                        }
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = lineArray.slice(0, low).join('');
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    const shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    const lineArray = $eceab5aac881d05a$var$stringToArray(line);
                    line = lineArray.slice(low).join('').trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        const fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $eceab5aac881d05a$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $eceab5aac881d05a$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        const width = this.attrs.width, fixedWidth = width !== $eceab5aac881d05a$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        const lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            const haveSpace = this._getTextWidth(lastLine.text + $eceab5aac881d05a$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $eceab5aac881d05a$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
    _useBufferCanvas() {
        const hasLine = this.textDecoration().indexOf('underline') !== -1 || this.textDecoration().indexOf('line-through') !== -1;
        const hasShadow = this.hasShadow();
        if (hasLine && hasShadow) return true;
        return super._useBufferCanvas();
    }
}
$eceab5aac881d05a$exports.Text = $eceab5aac881d05a$var$Text;
$eceab5aac881d05a$var$Text.prototype._fillFunc = $eceab5aac881d05a$var$_fillFunc;
$eceab5aac881d05a$var$Text.prototype._strokeFunc = $eceab5aac881d05a$var$_strokeFunc;
$eceab5aac881d05a$var$Text.prototype.className = $eceab5aac881d05a$var$TEXT_UPPER;
$eceab5aac881d05a$var$Text.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'padding',
    'wrap',
    'lineHeight',
    'letterSpacing'
];
(0, $ab25e7d252931ba2$exports._registerNode)($eceab5aac881d05a$var$Text);
$6f82f2528fae78ce$exports.Factory.overWriteSetter($eceab5aac881d05a$var$Text, 'width', (0, $aae05bbbe3f82503$exports.getNumberOrAutoValidator)());
$6f82f2528fae78ce$exports.Factory.overWriteSetter($eceab5aac881d05a$var$Text, 'height', (0, $aae05bbbe3f82503$exports.getNumberOrAutoValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'direction', $eceab5aac881d05a$var$INHERIT);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'fontFamily', 'Arial');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'fontSize', 12, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'fontStyle', $eceab5aac881d05a$var$NORMAL);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'fontVariant', $eceab5aac881d05a$var$NORMAL);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'padding', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'align', $eceab5aac881d05a$var$LEFT);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'verticalAlign', $eceab5aac881d05a$var$TOP);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'lineHeight', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'wrap', $eceab5aac881d05a$var$WORD);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'ellipsis', false, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'letterSpacing', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'text', '', (0, $aae05bbbe3f82503$exports.getStringValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($eceab5aac881d05a$var$Text, 'textDecoration', '');


var $d8b914e21ea6a7f6$exports = {};
"use strict";
Object.defineProperty($d8b914e21ea6a7f6$exports, "__esModule", {
    value: true
});
$d8b914e21ea6a7f6$exports.TextPath = void 0;







const $d8b914e21ea6a7f6$var$EMPTY_STRING = '', $d8b914e21ea6a7f6$var$NORMAL = 'normal';
function $d8b914e21ea6a7f6$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $d8b914e21ea6a7f6$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $d8b914e21ea6a7f6$var$TextPath extends $1f300d37bd09701b$exports.Shape {
    constructor(config){
        super(config);
        this.dummyCanvas = $e18dc6b8d0616da8$exports.Util.createCanvasElement();
        this.dataArray = [];
        this._readDataAttribute();
        this.on('dataChange.konva', function() {
            this._readDataAttribute();
            this._setTextData();
        });
        this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva', this._setTextData);
        this._setTextData();
    }
    _getTextPathLength() {
        return $7a449f01f12c38e2$exports.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(length) {
        if (!this.attrs.data) return null;
        const totalLength = this.pathLength;
        if (length - 1 > totalLength) return null;
        return $7a449f01f12c38e2$exports.Path.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    _readDataAttribute() {
        this.dataArray = $7a449f01f12c38e2$exports.Path.parsePathData(this.attrs.data);
        this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        const textDecoration = this.textDecoration();
        const fill = this.fill();
        const fontSize = this.fontSize();
        const glyphInfo = this.glyphInfo;
        if (textDecoration === 'underline') context.beginPath();
        for(let i = 0; i < glyphInfo.length; i++){
            context.save();
            const p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (textDecoration === 'underline') {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(fontSize, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (textDecoration === 'underline') {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        const glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            const p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(let i = 0; i < glyphInfo.length; i++){
            const p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        $e18dc6b8d0616da8$exports.Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    setText(text) {
        return $eceab5aac881d05a$exports.Text.prototype.setText.call(this, text);
    }
    _getContextFont() {
        return $eceab5aac881d05a$exports.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        const dummyCanvas = this.dummyCanvas;
        const _context = dummyCanvas.getContext('2d');
        _context.save();
        _context.font = this._getContextFont();
        const metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(`${this.fontSize()}`, 10)
        };
    }
    _setTextData() {
        const { width: width, height: height } = this._getTextSize(this.attrs.text);
        this.textWidth = width;
        this.textHeight = height;
        this.glyphInfo = [];
        if (!this.attrs.data) return null;
        const letterSpacing = this.letterSpacing();
        const align = this.align();
        const kerningFunc = this.kerningFunc();
        const textWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
        let offset = 0;
        if (align === 'center') offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
        if (align === 'right') offset = Math.max(0, this.pathLength - textWidth);
        const charArr = (0, $eceab5aac881d05a$exports.stringToArray)(this.text());
        let offsetToGlyph = offset;
        for(let i = 0; i < charArr.length; i++){
            const charStartPoint = this._getPointAtLength(offsetToGlyph);
            if (!charStartPoint) return;
            let glyphWidth = this._getTextSize(charArr[i]).width + letterSpacing;
            if (charArr[i] === ' ' && align === 'justify') {
                const numberOfSpaces = this.text().split(' ').length - 1;
                glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
            }
            const charEndPoint = this._getPointAtLength(offsetToGlyph + glyphWidth);
            if (!charEndPoint) return;
            const width = $7a449f01f12c38e2$exports.Path.getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            let kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            charStartPoint.x += kern;
            charEndPoint.x += kern;
            this.textWidth += kern;
            const midpoint = $7a449f01f12c38e2$exports.Path.getPointOnLine(kern + width / 2.0, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: charStartPoint,
                p1: charEndPoint
            });
            offsetToGlyph += glyphWidth;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        let minX = points[0] || 0;
        let maxX = points[0] || 0;
        let minY = points[1] || 0;
        let maxY = points[1] || 0;
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        const fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        $e18dc6b8d0616da8$exports.Util.releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
$d8b914e21ea6a7f6$exports.TextPath = $d8b914e21ea6a7f6$var$TextPath;
$d8b914e21ea6a7f6$var$TextPath.prototype._fillFunc = $d8b914e21ea6a7f6$var$_fillFunc;
$d8b914e21ea6a7f6$var$TextPath.prototype._strokeFunc = $d8b914e21ea6a7f6$var$_strokeFunc;
$d8b914e21ea6a7f6$var$TextPath.prototype._fillFuncHit = $d8b914e21ea6a7f6$var$_fillFunc;
$d8b914e21ea6a7f6$var$TextPath.prototype._strokeFuncHit = $d8b914e21ea6a7f6$var$_strokeFunc;
$d8b914e21ea6a7f6$var$TextPath.prototype.className = 'TextPath';
$d8b914e21ea6a7f6$var$TextPath.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'data'
];
(0, $ab25e7d252931ba2$exports._registerNode)($d8b914e21ea6a7f6$var$TextPath);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'data');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'fontFamily', 'Arial');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'fontSize', 12, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'fontStyle', $d8b914e21ea6a7f6$var$NORMAL);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'align', 'left');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'letterSpacing', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'textBaseline', 'middle');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'fontVariant', $d8b914e21ea6a7f6$var$NORMAL);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'text', $d8b914e21ea6a7f6$var$EMPTY_STRING);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'textDecoration', '');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($d8b914e21ea6a7f6$var$TextPath, 'kerningFunc', undefined);


var $bc30e73ebc67a123$exports = {};
"use strict";
Object.defineProperty($bc30e73ebc67a123$exports, "__esModule", {
    value: true
});
$bc30e73ebc67a123$exports.Transformer = void 0;









const $bc30e73ebc67a123$var$EVENTS_NAME = 'tr-konva';
const $bc30e73ebc67a123$var$ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange',
    'anchorStyleFuncChange'
].map((e)=>e + `.${$bc30e73ebc67a123$var$EVENTS_NAME}`).join(' ');
const $bc30e73ebc67a123$var$NODES_RECT = 'nodesRect';
const $bc30e73ebc67a123$var$TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange'
];
const $bc30e73ebc67a123$var$ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135
};
const $bc30e73ebc67a123$var$TOUCH_DEVICE = 'ontouchstart' in $ab25e7d252931ba2$exports.Konva._global;
function $bc30e73ebc67a123$var$getCursor(anchorName, rad, rotateCursor) {
    if (anchorName === 'rotater') return rotateCursor;
    rad += $e18dc6b8d0616da8$exports.Util.degToRad($bc30e73ebc67a123$var$ANGLES[anchorName] || 0);
    const angle = ($e18dc6b8d0616da8$exports.Util.radToDeg(rad) % 360 + 360) % 360;
    if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 337.5, 360) || $e18dc6b8d0616da8$exports.Util._inRange(angle, 0, 22.5)) return 'ns-resize';
    else if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 22.5, 67.5)) return 'nesw-resize';
    else if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 67.5, 112.5)) return 'ew-resize';
    else if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 112.5, 157.5)) return 'nwse-resize';
    else if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 157.5, 202.5)) return 'ns-resize';
    else if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 202.5, 247.5)) return 'nesw-resize';
    else if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 247.5, 292.5)) return 'ew-resize';
    else if ($e18dc6b8d0616da8$exports.Util._inRange(angle, 292.5, 337.5)) return 'nwse-resize';
    else {
        $e18dc6b8d0616da8$exports.Util.error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
const $bc30e73ebc67a123$var$ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
];
const $bc30e73ebc67a123$var$MAX_SAFE_INTEGER = 100000000;
function $bc30e73ebc67a123$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $bc30e73ebc67a123$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return {
        ...shape,
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    };
}
function $bc30e73ebc67a123$var$rotateAroundCenter(shape, deltaRad) {
    const center = $bc30e73ebc67a123$var$getCenter(shape);
    return $bc30e73ebc67a123$var$rotateAroundPoint(shape, deltaRad, center);
}
function $bc30e73ebc67a123$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = $ab25e7d252931ba2$exports.Konva.getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
let $bc30e73ebc67a123$var$activeTransformersCount = 0;
class $bc30e73ebc67a123$var$Transformer extends $46b926af7f04b04f$exports.Group {
    constructor(config){
        super(config);
        this._movingAnchorName = null;
        this._transforming = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($bc30e73ebc67a123$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        $e18dc6b8d0616da8$exports.Util.warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $bc30e73ebc67a123$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const filteredNodes = nodes.filter((node)=>{
            if (node.isAncestorOf(this)) {
                $e18dc6b8d0616da8$exports.Util.error('Konva.Transformer cannot be an a child of the node you are trying to attach');
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            if (node._attrsAffectingSize.length) {
                const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + 'Change.' + this._getEventNamespace()).join(' ');
                node.on(additionalEvents, onChange);
            }
            node.on($bc30e73ebc67a123$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(' '), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        const elementsCreated = !!this.findOne('.top-left');
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne('.back')) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off('.' + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($bc30e73ebc67a123$var$NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    }
    _getNodeRect() {
        return this._getCache($bc30e73ebc67a123$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        const rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        const absScale = node.getAbsoluteScale(relative);
        const absPos = node.getAbsolutePosition(relative);
        const dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        const dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ($ab25e7d252931ba2$exports.Konva.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $bc30e73ebc67a123$var$rotateAroundPoint(box, -$ab25e7d252931ba2$exports.Konva.getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        const node = this.getNode();
        if (!node) return {
            x: -$bc30e73ebc67a123$var$MAX_SAFE_INTEGER,
            y: -$bc30e73ebc67a123$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            const points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            const trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                const transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new $e18dc6b8d0616da8$exports.Transform();
        tr.rotate(-$ab25e7d252931ba2$exports.Konva.getAngle(this.rotation()));
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        totalPoints.forEach(function(point) {
            const transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: $ab25e7d252931ba2$exports.Konva.getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $bc30e73ebc67a123$var$ANCHORS_NAMES.forEach((name)=>{
            this._createAnchor(name);
        });
        this._createAnchor('rotater');
    }
    _createAnchor(name) {
        const anchor = new $c8a3cc0a16e87bd4$exports.Rect({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' _anchor',
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $bc30e73ebc67a123$var$TOUCH_DEVICE ? 10 : 'auto'
        });
        const self = this;
        anchor.on('mousedown touchstart', function(e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        anchor.on('mouseenter', ()=>{
            const rad = $ab25e7d252931ba2$exports.Konva.getAngle(this.rotation());
            const rotateCursor = this.rotateAnchorCursor();
            const cursor = $bc30e73ebc67a123$var$getCursor(name, rad, rotateCursor);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on('mouseout', ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = '');
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        const back = new $1f300d37bd09701b$exports.Shape({
            name: 'back',
            width: 0,
            height: 0,
            draggable: true,
            sceneFunc (ctx, shape) {
                const tr = shape.getParent();
                const padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.moveTo(shape.width() / 2, -padding);
                if (tr.rotateEnabled() && tr.rotateLineVisible()) ctx.lineTo(shape.width() / 2, -tr.rotateAnchorOffset() * $e18dc6b8d0616da8$exports.Util._sign(shape.height()) - padding);
                ctx.fillStrokeShape(shape);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                const padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on('dragstart', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragmove', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        this.on('dragmove', (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        if (this._transforming) return;
        this._movingAnchorName = e.target.name().split(' ')[0];
        const attrs = this._getNodeRect();
        const width = attrs.width;
        const height = attrs.height;
        const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== 'undefined') {
            window.addEventListener('mousemove', this._handleMouseMove);
            window.addEventListener('touchmove', this._handleMouseMove);
            window.addEventListener('mouseup', this._handleMouseUp, true);
            window.addEventListener('touchend', this._handleMouseUp, true);
        }
        this._transforming = true;
        const ap = e.target.getAbsolutePosition();
        const pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        $bc30e73ebc67a123$var$activeTransformersCount++;
        this._fire('transformstart', {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire('transformstart', {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        let x, y, newHypotenuse;
        const anchorNode = this.findOne('.' + this._movingAnchorName);
        const stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === 'rotater') {
            const attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            let delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) delta -= Math.PI;
            const oldRotation = $ab25e7d252931ba2$exports.Konva.getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = $ab25e7d252931ba2$exports.Konva.getAngle(this.rotationSnapTolerance());
            const snappedRot = $bc30e73ebc67a123$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $bc30e73ebc67a123$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        const shiftBehavior = this.shiftBehavior();
        let keepProportion;
        if (shiftBehavior === 'inverted') keepProportion = this.keepRatio() && !e.shiftKey;
        else if (shiftBehavior === 'none') keepProportion = this.keepRatio();
        else keepProportion = this.keepRatio() || e.shiftKey;
        let centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-right').x(),
                    y: this.findOne('.bottom-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-left').x(comparePoint.x - x);
                this.findOne('.top-left').y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === 'top-center') this.findOne('.top-left').y(anchorNode.y());
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-left').x(),
                    y: this.findOne('.bottom-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-right').x(comparePoint.x + x);
                this.findOne('.top-right').y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne('.top-left').y(pos.y);
            this.findOne('.bottom-right').x(pos.x);
        } else if (this._movingAnchorName === 'middle-left') this.findOne('.top-left').x(anchorNode.x());
        else if (this._movingAnchorName === 'middle-right') this.findOne('.bottom-right').x(anchorNode.x());
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-right').x(),
                    y: this.findOne('.top-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                const reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne('.top-left').x(pos.x);
            this.findOne('.bottom-right').y(pos.y);
        } else if (this._movingAnchorName === 'bottom-center') this.findOne('.bottom-right').y(anchorNode.y());
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-left').x(),
                    y: this.findOne('.top-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.bottom-right').x(comparePoint.x + x);
                this.findOne('.bottom-right').y(comparePoint.y + y);
            }
        } else console.error(new Error('Wrong position argument of selection resizer: ' + this._movingAnchorName));
        centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            const topLeft = this.findOne('.top-left');
            const bottomRight = this.findOne('.bottom-right');
            const topOffsetX = topLeft.x();
            const topOffsetY = topLeft.y();
            const bottomOffsetX = this.getWidth() - bottomRight.x();
            const bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        const absPos = this.findOne('.top-left').getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        const width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
        const height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: $ab25e7d252931ba2$exports.Konva.getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        var _a;
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== 'undefined') {
                window.removeEventListener('mousemove', this._handleMouseMove);
                window.removeEventListener('touchmove', this._handleMouseMove);
                window.removeEventListener('mouseup', this._handleMouseUp, true);
                window.removeEventListener('touchend', this._handleMouseUp, true);
            }
            const node = this.getNode();
            $bc30e73ebc67a123$var$activeTransformersCount--;
            this._fire('transformend', {
                evt: e,
                target: node
            });
            (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
            if (node) this._nodes.forEach((target)=>{
                var _a;
                target._fire('transformend', {
                    evt: e,
                    target: target
                });
                (_a = target.getLayer()) === null || _a === void 0 || _a.batchDraw();
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        const oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ($e18dc6b8d0616da8$exports.Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ($e18dc6b8d0616da8$exports.Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const t = new $e18dc6b8d0616da8$exports.Transform();
        t.rotate($ab25e7d252931ba2$exports.Konva.getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('left') >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('right') >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('top') >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('bottom') >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else $e18dc6b8d0616da8$exports.Util.warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
        }
        const baseSize = 10000000;
        const oldTr = new $e18dc6b8d0616da8$exports.Transform();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new $e18dc6b8d0616da8$exports.Transform();
        const newScaleX = newAttrs.width / baseSize;
        const newScaleY = newAttrs.height / baseSize;
        if (this.flipEnabled() === false) {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
            newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
        } else {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.scale(newScaleX, newScaleY);
        }
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new $e18dc6b8d0616da8$exports.Transform();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation($e18dc6b8d0616da8$exports.Util._getRotation(newAttrs.rotation));
        this._nodes.forEach((node)=>{
            this._fire('transform', {
                evt: evt,
                target: node
            });
            node._fire('transform', {
                evt: evt,
                target: node
            });
        });
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        const attrs = this._getNodeRect();
        this.rotation($e18dc6b8d0616da8$exports.Util._getRotation(attrs.rotation));
        const width = attrs.width;
        const height = attrs.height;
        const enabledAnchors = this.enabledAnchors();
        const resizeEnabled = this.resizeEnabled();
        const padding = this.padding();
        const anchorSize = this.anchorSize();
        const anchors = this.find('._anchor');
        anchors.forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild('.top-left', {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0
        });
        this._batchChangeChild('.top-center', {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0
        });
        this._batchChangeChild('.top-right', {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0
        });
        this._batchChangeChild('.middle-left', {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0
        });
        this._batchChangeChild('.middle-right', {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0
        });
        this._batchChangeChild('.bottom-left', {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0
        });
        this._batchChangeChild('.bottom-center', {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0
        });
        this._batchChangeChild('.bottom-right', {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0
        });
        this._batchChangeChild('.rotater', {
            x: width / 2,
            y: -this.rotateAnchorOffset() * $e18dc6b8d0616da8$exports.Util._sign(height) - padding,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild('.back', {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
        const styleFunc = this.anchorStyleFunc();
        if (styleFunc) anchors.forEach((node)=>{
            styleFunc(node);
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            const anchorNode = this.findOne('.' + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = '');
        $46b926af7f04b04f$exports.Group.prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    toObject() {
        return $9165dcaf5c4d4c7d$exports.Node.prototype.toObject.call(this);
    }
    clone(obj) {
        const node = $9165dcaf5c4d4c7d$exports.Node.prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
$bc30e73ebc67a123$exports.Transformer = $bc30e73ebc67a123$var$Transformer;
$bc30e73ebc67a123$var$Transformer.isTransforming = ()=>{
    return $bc30e73ebc67a123$var$activeTransformersCount > 0;
};
function $bc30e73ebc67a123$var$validateAnchors(val) {
    if (!(val instanceof Array)) $e18dc6b8d0616da8$exports.Util.warn('enabledAnchors value should be an array');
    if (val instanceof Array) val.forEach(function(name) {
        if ($bc30e73ebc67a123$var$ANCHORS_NAMES.indexOf(name) === -1) $e18dc6b8d0616da8$exports.Util.warn('Unknown anchor name: ' + name + '. Available names are: ' + $bc30e73ebc67a123$var$ANCHORS_NAMES.join(', '));
    });
    return val || [];
}
$bc30e73ebc67a123$var$Transformer.prototype.className = 'Transformer';
(0, $ab25e7d252931ba2$exports._registerNode)($bc30e73ebc67a123$var$Transformer);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'enabledAnchors', $bc30e73ebc67a123$var$ANCHORS_NAMES, $bc30e73ebc67a123$var$validateAnchors);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'flipEnabled', true, (0, $aae05bbbe3f82503$exports.getBooleanValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'resizeEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'anchorSize', 10, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'rotateEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'rotateLineVisible', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'rotationSnaps', []);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'rotateAnchorOffset', 50, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'rotateAnchorCursor', 'crosshair');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'rotationSnapTolerance', 5, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'borderEnabled', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'anchorStroke', 'rgb(0, 161, 255)');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'anchorStrokeWidth', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'anchorFill', 'white');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'anchorCornerRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'borderStroke', 'rgb(0, 161, 255)');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'borderStrokeWidth', 1, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'borderDash');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'keepRatio', true);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'shiftBehavior', 'default');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'centeredScaling', false);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'ignoreStroke', false);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'padding', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'nodes');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'node');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'boundBoxFunc');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'anchorDragBoundFunc');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'anchorStyleFunc');
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'shouldOverdrawWholeArea', false);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($bc30e73ebc67a123$var$Transformer, 'useSingleNodeRotation', true);
$6f82f2528fae78ce$exports.Factory.backCompat($bc30e73ebc67a123$var$Transformer, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors'
});


var $7e35841fa24fa80c$exports = {};
"use strict";
Object.defineProperty($7e35841fa24fa80c$exports, "__esModule", {
    value: true
});
$7e35841fa24fa80c$exports.Wedge = void 0;





class $7e35841fa24fa80c$var$Wedge extends $1f300d37bd09701b$exports.Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, $ab25e7d252931ba2$exports.Konva.getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$7e35841fa24fa80c$exports.Wedge = $7e35841fa24fa80c$var$Wedge;
$7e35841fa24fa80c$var$Wedge.prototype.className = 'Wedge';
$7e35841fa24fa80c$var$Wedge.prototype._centroid = true;
$7e35841fa24fa80c$var$Wedge.prototype._attrsAffectingSize = [
    'radius'
];
(0, $ab25e7d252931ba2$exports._registerNode)($7e35841fa24fa80c$var$Wedge);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($7e35841fa24fa80c$var$Wedge, 'radius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($7e35841fa24fa80c$var$Wedge, 'angle', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)());
$6f82f2528fae78ce$exports.Factory.addGetterSetter($7e35841fa24fa80c$var$Wedge, 'clockwise', false);
$6f82f2528fae78ce$exports.Factory.backCompat($7e35841fa24fa80c$var$Wedge, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
});


var $f13f3d81e474ac07$exports = {};
"use strict";
Object.defineProperty($f13f3d81e474ac07$exports, "__esModule", {
    value: true
});
$f13f3d81e474ac07$exports.Blur = void 0;



function $f13f3d81e474ac07$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
const $f13f3d81e474ac07$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
const $f13f3d81e474ac07$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $f13f3d81e474ac07$var$filterGaussBlurRGBA(imageData, radius) {
    const pixels = imageData.data, width = imageData.width, height = imageData.height;
    let p, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    const div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $f13f3d81e474ac07$var$BlurStack(), mul_sum = $f13f3d81e474ac07$var$mul_table[radius], shg_sum = $f13f3d81e474ac07$var$shg_table[radius];
    let stackEnd = null, stack = stackStart, stackIn = null, stackOut = null;
    for(let i = 1; i < div; i++){
        stack = stack.next = new $f13f3d81e474ac07$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(let y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(let i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(let x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        let yp = width;
        for(let i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $f13f3d81e474ac07$var$Blur = function Blur(imageData) {
    const radius = Math.round(this.blurRadius());
    if (radius > 0) $f13f3d81e474ac07$var$filterGaussBlurRGBA(imageData, radius);
};
$f13f3d81e474ac07$exports.Blur = $f13f3d81e474ac07$var$Blur;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'blurRadius', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $9cc9e16aa11efd22$exports = {};
"use strict";
Object.defineProperty($9cc9e16aa11efd22$exports, "__esModule", {
    value: true
});
$9cc9e16aa11efd22$exports.Brighten = void 0;



const $9cc9e16aa11efd22$var$Brighten = function(imageData) {
    const brightness = this.brightness() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
$9cc9e16aa11efd22$exports.Brighten = $9cc9e16aa11efd22$var$Brighten;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'brightness', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $bdbcdd3d7eb42f5d$exports = {};
"use strict";
Object.defineProperty($bdbcdd3d7eb42f5d$exports, "__esModule", {
    value: true
});
$bdbcdd3d7eb42f5d$exports.Contrast = void 0;



const $bdbcdd3d7eb42f5d$var$Contrast = function(imageData) {
    const adjust = Math.pow((this.contrast() + 100) / 100, 2);
    const data = imageData.data, nPixels = data.length;
    let red = 150, green = 150, blue = 150;
    for(let i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
$bdbcdd3d7eb42f5d$exports.Contrast = $bdbcdd3d7eb42f5d$var$Contrast;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'contrast', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $17265ba53ce013b4$exports = {};
"use strict";
Object.defineProperty($17265ba53ce013b4$exports, "__esModule", {
    value: true
});
$17265ba53ce013b4$exports.Emboss = void 0;




const $17265ba53ce013b4$var$Emboss = function(imageData) {
    const strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4;
    let dirY = 0, dirX = 0, y = h;
    switch(direction){
        case 'top-left':
            dirY = -1;
            dirX = -1;
            break;
        case 'top':
            dirY = -1;
            dirX = 0;
            break;
        case 'top-right':
            dirY = -1;
            dirX = 1;
            break;
        case 'right':
            dirY = 0;
            dirX = 1;
            break;
        case 'bottom-right':
            dirY = 1;
            dirX = 1;
            break;
        case 'bottom':
            dirY = 1;
            dirX = 0;
            break;
        case 'bottom-left':
            dirY = 1;
            dirX = -1;
            break;
        case 'left':
            dirY = 0;
            dirX = -1;
            break;
        default:
            $e18dc6b8d0616da8$exports.Util.error('Unknown emboss direction: ' + direction);
    }
    do {
        const offsetY = (y - 1) * w4;
        let otherY = dirY;
        if (y + otherY < 1) otherY = 0;
        if (y + otherY > h) otherY = 0;
        const offsetYOther = (y - 1 + otherY) * w * 4;
        let x = w;
        do {
            const offset = offsetY + (x - 1) * 4;
            let otherX = dirX;
            if (x + otherX < 1) otherX = 0;
            if (x + otherX > w) otherX = 0;
            const offsetOther = offsetYOther + (x - 1 + otherX) * 4;
            const dR = data[offset] - data[offsetOther];
            const dG = data[offset + 1] - data[offsetOther + 1];
            const dB = data[offset + 2] - data[offsetOther + 2];
            let dif = dR;
            const absDif = dif > 0 ? dif : -dif;
            const absG = dG > 0 ? dG : -dG;
            const absB = dB > 0 ? dB : -dB;
            if (absG > absDif) dif = dG;
            if (absB > absDif) dif = dB;
            dif *= strength;
            if (blend) {
                const r = data[offset] + dif;
                const g = data[offset + 1] + dif;
                const b = data[offset + 2] + dif;
                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
            } else {
                let grey = greyLevel - dif;
                if (grey < 0) grey = 0;
                else if (grey > 255) grey = 255;
                data[offset] = data[offset + 1] = data[offset + 2] = grey;
            }
        }while (--x);
    }while (--y);
};
$17265ba53ce013b4$exports.Emboss = $17265ba53ce013b4$var$Emboss;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'embossStrength', 0.5, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'embossWhiteLevel', 0.5, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'embossDirection', 'top-left', undefined, $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'embossBlend', false, undefined, $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $9d8fca79e471a495$exports = {};
"use strict";
Object.defineProperty($9d8fca79e471a495$exports, "__esModule", {
    value: true
});
$9d8fca79e471a495$exports.Enhance = void 0;



function $9d8fca79e471a495$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    const fromRange = fromMax - fromMin, toRange = toMax - toMin;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    let toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $9d8fca79e471a495$var$Enhance = function(imageData) {
    const data = imageData.data, nSubPixels = data.length;
    let rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b;
    const enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(let i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    let rGoalMax, rGoalMin, gGoalMax, gGoalMin, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        const rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        const gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        const bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(let i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $9d8fca79e471a495$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $9d8fca79e471a495$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $9d8fca79e471a495$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
$9d8fca79e471a495$exports.Enhance = $9d8fca79e471a495$var$Enhance;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'enhance', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $4f3c5bd2ca2b6293$exports = {};
"use strict";
Object.defineProperty($4f3c5bd2ca2b6293$exports, "__esModule", {
    value: true
});
$4f3c5bd2ca2b6293$exports.Grayscale = void 0;
const $4f3c5bd2ca2b6293$var$Grayscale = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        const brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};
$4f3c5bd2ca2b6293$exports.Grayscale = $4f3c5bd2ca2b6293$var$Grayscale;


var $ec7fb596f1365e63$exports = {};
"use strict";
Object.defineProperty($ec7fb596f1365e63$exports, "__esModule", {
    value: true
});
$ec7fb596f1365e63$exports.HSL = void 0;



$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'hue', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'saturation', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'luminance', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
const $ec7fb596f1365e63$var$HSL = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127;
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    let r, g, b, a;
    for(let i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};
$ec7fb596f1365e63$exports.HSL = $ec7fb596f1365e63$var$HSL;


var $640b54635d6bf20c$exports = {};
"use strict";
Object.defineProperty($640b54635d6bf20c$exports, "__esModule", {
    value: true
});
$640b54635d6bf20c$exports.HSV = void 0;



const $640b54635d6bf20c$var$HSV = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360;
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
$640b54635d6bf20c$exports.HSV = $640b54635d6bf20c$var$HSV;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'hue', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'saturation', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'value', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $f13e7b5112e62c67$exports = {};
"use strict";
Object.defineProperty($f13e7b5112e62c67$exports, "__esModule", {
    value: true
});
$f13e7b5112e62c67$exports.Invert = void 0;
const $f13e7b5112e62c67$var$Invert = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};
$f13e7b5112e62c67$exports.Invert = $f13e7b5112e62c67$var$Invert;


var $35fea3b99e86c6e0$exports = {};
"use strict";
Object.defineProperty($35fea3b99e86c6e0$exports, "__esModule", {
    value: true
});
$35fea3b99e86c6e0$exports.Kaleidoscope = void 0;




const $35fea3b99e86c6e0$var$ToPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize;
    const conversion = 360 / tSize * Math.PI / 180;
    for(let theta = 0; theta < tSize; theta += 1){
        const sin = Math.sin(theta * conversion);
        const cos = Math.cos(theta * conversion);
        for(let radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            let i = (y * xSize + x) * 4;
            const r = srcPixels[i + 0];
            const g = srcPixels[i + 1];
            const b = srcPixels[i + 2];
            const a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
const $35fea3b99e86c6e0$var$FromPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize, phaseShift = opt.polarRotation || 0;
    let x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        const dx = x - xMid;
        const dy = y - yMid;
        const radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        let theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        let i = (y1 * xSize + x1) * 4;
        const r = srcPixels[i + 0];
        const g = srcPixels[i + 1];
        const b = srcPixels[i + 2];
        const a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $35fea3b99e86c6e0$var$Kaleidoscope = function(imageData) {
    const xSize = imageData.width, ySize = imageData.height;
    let x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    let power = Math.round(this.kaleidoscopePower());
    const angle = Math.round(this.kaleidoscopeAngle());
    const offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    const tempCanvas = $e18dc6b8d0616da8$exports.Util.createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    const scratchData = tempCanvas.getContext('2d').getImageData(0, 0, xSize, ySize);
    $e18dc6b8d0616da8$exports.Util.releaseCanvas(tempCanvas);
    $35fea3b99e86c6e0$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    let minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    let sectionSize = minSectionSize;
    let xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $35fea3b99e86c6e0$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
$35fea3b99e86c6e0$exports.Kaleidoscope = $35fea3b99e86c6e0$var$Kaleidoscope;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'kaleidoscopePower', 2, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'kaleidoscopeAngle', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $287a6c114cf6d4d1$exports = {};
"use strict";
Object.defineProperty($287a6c114cf6d4d1$exports, "__esModule", {
    value: true
});
$287a6c114cf6d4d1$exports.Mask = void 0;



function $287a6c114cf6d4d1$var$pixelAt(idata, x, y) {
    let idx = (y * idata.width + x) * 4;
    const d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $287a6c114cf6d4d1$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $287a6c114cf6d4d1$var$rgbMean(pTab) {
    const m = [
        0,
        0,
        0
    ];
    for(let i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $287a6c114cf6d4d1$var$backgroundMask(idata, threshold) {
    const rgbv_no = $287a6c114cf6d4d1$var$pixelAt(idata, 0, 0);
    const rgbv_ne = $287a6c114cf6d4d1$var$pixelAt(idata, idata.width - 1, 0);
    const rgbv_so = $287a6c114cf6d4d1$var$pixelAt(idata, 0, idata.height - 1);
    const rgbv_se = $287a6c114cf6d4d1$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    const thres = threshold || 10;
    if ($287a6c114cf6d4d1$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $287a6c114cf6d4d1$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $287a6c114cf6d4d1$var$rgbDistance(rgbv_se, rgbv_so) < thres && $287a6c114cf6d4d1$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        const mean = $287a6c114cf6d4d1$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        const mask = [];
        for(let i = 0; i < idata.width * idata.height; i++){
            const d = $287a6c114cf6d4d1$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $287a6c114cf6d4d1$var$applyMask(idata, mask) {
    for(let i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $287a6c114cf6d4d1$var$erodeMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $287a6c114cf6d4d1$var$dilateMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $287a6c114cf6d4d1$var$smoothEdgeMask(mask, sw, sh) {
    const weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $287a6c114cf6d4d1$var$Mask = function(imageData) {
    const threshold = this.threshold();
    let mask = $287a6c114cf6d4d1$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $287a6c114cf6d4d1$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $287a6c114cf6d4d1$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $287a6c114cf6d4d1$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $287a6c114cf6d4d1$var$applyMask(imageData, mask);
    }
    return imageData;
};
$287a6c114cf6d4d1$exports.Mask = $287a6c114cf6d4d1$var$Mask;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'threshold', 0, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $b9cc179a2cba525a$exports = {};
"use strict";
Object.defineProperty($b9cc179a2cba525a$exports, "__esModule", {
    value: true
});
$b9cc179a2cba525a$exports.Noise = void 0;



const $b9cc179a2cba525a$var$Noise = function(imageData) {
    const amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2;
    for(let i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
$b9cc179a2cba525a$exports.Noise = $b9cc179a2cba525a$var$Noise;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'noise', 0.2, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $a2cec88e84df9ac5$exports = {};
"use strict";
Object.defineProperty($a2cec88e84df9ac5$exports, "__esModule", {
    value: true
});
$a2cec88e84df9ac5$exports.Pixelate = void 0;




const $a2cec88e84df9ac5$var$Pixelate = function(imageData) {
    let pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), data = imageData.data;
    if (pixelSize <= 0) {
        $e18dc6b8d0616da8$exports.Util.error('pixelSize value can not be <= 0');
        return;
    }
    for(let xBin = 0; xBin < nBinsX; xBin += 1)for(let yBin = 0; yBin < nBinsY; yBin += 1){
        let red = 0;
        let green = 0;
        let blue = 0;
        let alpha = 0;
        const xBinStart = xBin * pixelSize;
        const xBinEnd = xBinStart + pixelSize;
        const yBinStart = yBin * pixelSize;
        const yBinEnd = yBinStart + pixelSize;
        let pixelsInBin = 0;
        for(let x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(let y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                const i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(let x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(let y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                const i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
$a2cec88e84df9ac5$exports.Pixelate = $a2cec88e84df9ac5$var$Pixelate;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'pixelSize', 8, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $f8ab06abee20a00b$exports = {};
"use strict";
Object.defineProperty($f8ab06abee20a00b$exports, "__esModule", {
    value: true
});
$f8ab06abee20a00b$exports.Posterize = void 0;



const $f8ab06abee20a00b$var$Posterize = function(imageData) {
    const levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels;
    for(let i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
$f8ab06abee20a00b$exports.Posterize = $f8ab06abee20a00b$var$Posterize;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'levels', 0.5, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $1734c7957c7933d8$exports = {};
"use strict";
Object.defineProperty($1734c7957c7933d8$exports, "__esModule", {
    value: true
});
$1734c7957c7933d8$exports.RGB = void 0;



const $1734c7957c7933d8$var$RGB = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue();
    for(let i = 0; i < nPixels; i += 4){
        const brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
$1734c7957c7933d8$exports.RGB = $1734c7957c7933d8$var$RGB;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'blue', 0, $aae05bbbe3f82503$exports.RGBComponent, $6f82f2528fae78ce$exports.Factory.afterSetFilter);


var $b34a081b93f0617d$exports = {};
"use strict";
Object.defineProperty($b34a081b93f0617d$exports, "__esModule", {
    value: true
});
$b34a081b93f0617d$exports.RGBA = void 0;



const $b34a081b93f0617d$var$RGBA = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha();
    for(let i = 0; i < nPixels; i += 4){
        const ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
$b34a081b93f0617d$exports.RGBA = $b34a081b93f0617d$var$RGBA;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'blue', 0, $aae05bbbe3f82503$exports.RGBComponent, $6f82f2528fae78ce$exports.Factory.afterSetFilter);
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'alpha', 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});


var $f80ec892e60693d0$exports = {};
"use strict";
Object.defineProperty($f80ec892e60693d0$exports, "__esModule", {
    value: true
});
$f80ec892e60693d0$exports.Sepia = void 0;
const $f80ec892e60693d0$var$Sepia = function(imageData) {
    const data = imageData.data, nPixels = data.length;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};
$f80ec892e60693d0$exports.Sepia = $f80ec892e60693d0$var$Sepia;


var $cd1801129787062e$exports = {};
"use strict";
Object.defineProperty($cd1801129787062e$exports, "__esModule", {
    value: true
});
$cd1801129787062e$exports.Solarize = void 0;
const $cd1801129787062e$var$Solarize = function(imageData) {
    const data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4;
    let y = h;
    do {
        const offsetY = (y - 1) * w4;
        let x = w;
        do {
            const offset = offsetY + (x - 1) * 4;
            let r = data[offset];
            let g = data[offset + 1];
            let b = data[offset + 2];
            if (r > 127) r = 255 - r;
            if (g > 127) g = 255 - g;
            if (b > 127) b = 255 - b;
            data[offset] = r;
            data[offset + 1] = g;
            data[offset + 2] = b;
        }while (--x);
    }while (--y);
};
$cd1801129787062e$exports.Solarize = $cd1801129787062e$var$Solarize;


var $bc38879502ad16df$exports = {};
"use strict";
Object.defineProperty($bc38879502ad16df$exports, "__esModule", {
    value: true
});
$bc38879502ad16df$exports.Threshold = void 0;



const $bc38879502ad16df$var$Threshold = function(imageData) {
    const level = this.threshold() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
$bc38879502ad16df$exports.Threshold = $bc38879502ad16df$var$Threshold;
$6f82f2528fae78ce$exports.Factory.addGetterSetter($9165dcaf5c4d4c7d$exports.Node, 'threshold', 0.5, (0, $aae05bbbe3f82503$exports.getNumberValidator)(), $6f82f2528fae78ce$exports.Factory.afterSetFilter);


$3eea5e3bd2d7a29a$exports.Konva = $0da745bb31935f3f$exports.Konva.Util._assign($0da745bb31935f3f$exports.Konva, {
    Arc: $556478fa6dcccf09$exports.Arc,
    Arrow: $cd4e06a27112b36e$exports.Arrow,
    Circle: $7e614504cf20f43b$exports.Circle,
    Ellipse: $4cde4a7124609310$exports.Ellipse,
    Image: $ddcc49bff44d9afd$exports.Image,
    Label: $2361492a5b2f9e5c$exports.Label,
    Tag: $2361492a5b2f9e5c$exports.Tag,
    Line: $e4102f2dd0dfb187$exports.Line,
    Path: $7a449f01f12c38e2$exports.Path,
    Rect: $c8a3cc0a16e87bd4$exports.Rect,
    RegularPolygon: $7b9a025942ce2d88$exports.RegularPolygon,
    Ring: $b23824d5fefb75ad$exports.Ring,
    Sprite: $a3af0187cf7e728a$exports.Sprite,
    Star: $4cc1ef08a1a6c4d9$exports.Star,
    Text: $eceab5aac881d05a$exports.Text,
    TextPath: $d8b914e21ea6a7f6$exports.TextPath,
    Transformer: $bc30e73ebc67a123$exports.Transformer,
    Wedge: $7e35841fa24fa80c$exports.Wedge,
    Filters: {
        Blur: $f13f3d81e474ac07$exports.Blur,
        Brighten: $9cc9e16aa11efd22$exports.Brighten,
        Contrast: $bdbcdd3d7eb42f5d$exports.Contrast,
        Emboss: $17265ba53ce013b4$exports.Emboss,
        Enhance: $9d8fca79e471a495$exports.Enhance,
        Grayscale: $4f3c5bd2ca2b6293$exports.Grayscale,
        HSL: $ec7fb596f1365e63$exports.HSL,
        HSV: $640b54635d6bf20c$exports.HSV,
        Invert: $f13e7b5112e62c67$exports.Invert,
        Kaleidoscope: $35fea3b99e86c6e0$exports.Kaleidoscope,
        Mask: $287a6c114cf6d4d1$exports.Mask,
        Noise: $b9cc179a2cba525a$exports.Noise,
        Pixelate: $a2cec88e84df9ac5$exports.Pixelate,
        Posterize: $f8ab06abee20a00b$exports.Posterize,
        RGB: $1734c7957c7933d8$exports.RGB,
        RGBA: $b34a081b93f0617d$exports.RGBA,
        Sepia: $f80ec892e60693d0$exports.Sepia,
        Solarize: $cd1801129787062e$exports.Solarize,
        Threshold: $bc38879502ad16df$exports.Threshold
    }
});


$ceae686dc723e5bf$exports = $3eea5e3bd2d7a29a$exports.Konva;


const $0793957906d3daac$export$d6547b117d1dcd45 = 'small';
const $0793957906d3daac$export$878e4a3737c08e85 = 'small-corner';
const $0793957906d3daac$export$63cff6b6d7f669bf = 'tall';
const $0793957906d3daac$export$12b7a355343dd343 = 'tall-corner';
const $0793957906d3daac$export$cb58b2ba04527c22 = 'wide';
const $0793957906d3daac$export$e7aa9ee549f9e84 = 'large';
const $0793957906d3daac$export$f421779aac23045c = 1322;
const $0793957906d3daac$export$d6b441449057984 = 1319;
const $0793957906d3daac$export$142960671d3dc6f5 = 1322;
const $0793957906d3daac$export$4b14f9b014a3c13c = 1730;
const $0793957906d3daac$export$6bfd500da6b6cbc6 = 1698;
const $0793957906d3daac$export$31f240599c3e8939 = 1385;
const $0793957906d3daac$export$b4898baa7c6c0fe7 = 1698;
const $0793957906d3daac$export$75770282914a2a30 = 1796;
const $0793957906d3daac$export$de17a50c252cc740 = 1240;
const $0793957906d3daac$export$e56dc67f1368e1b = 1240;
const $0793957906d3daac$export$ea0179eb6098a50c = 1806;
const $0793957906d3daac$export$7a80096d7171d2c = 1240;
const $0793957906d3daac$export$d1e0c6e204ad8d05 = 1240;
const $0793957906d3daac$export$b004b696ce1a358c = 1806;
const $0793957906d3daac$export$4f60e2783b9b26f5 = 1806;
const $0793957906d3daac$export$659764b2ab65178d = 1806;
const $0793957906d3daac$export$db052f6699d78e91 = 36;
const $0793957906d3daac$export$df4e3742db13505 = {
    width: 1322,
    height: 1319,
    tblX: 497 / 1322,
    tblY: 0,
    tbrX: 1,
    tbrY: 145 / 1319,
    tfrX: 826 / 1322,
    tfrY: 415 / 1319,
    tflX: 0,
    tflY: 271 / 1319,
    bblX: 497 / 1322,
    bblY: 904 / 1319,
    bbrX: 1,
    bbrY: 1049 / 1319,
    bfrX: 826 / 1322,
    bfrY: 1,
    bflX: 0,
    bflY: 1174 / 1319
};
const $0793957906d3daac$export$1b35fd99c98f5dde = {
    width: 1322,
    height: 1730,
    tblX: 497 / 1322,
    tblY: 0,
    tbrX: 1,
    tbrY: 145 / 1730,
    tfrX: 826 / 1322,
    tfrY: 415 / 1730,
    tflX: 0,
    tflY: 271 / 1730,
    bblX: 497 / 1322,
    bblY: 1315 / 1730,
    bbrX: 1,
    bbrY: 1460 / 1730,
    bfrX: 826 / 1322,
    bfrY: 1,
    bflX: 0,
    bflY: 1586 / 1730
};
const $0793957906d3daac$export$afef5481b241cb53 = {
    width: 1698,
    height: 1385,
    tblX: 497 / 1698,
    tblY: 0,
    tbrX: 1,
    tbrY: 211 / 1385,
    tfrX: 1202 / 1698,
    tfrY: 481 / 1385,
    tflX: 0,
    tflY: 271 / 1385,
    bblX: 497 / 1698,
    bblY: 904 / 1385,
    bbrX: 1,
    bbrY: 1114 / 1385,
    bfrX: 1204 / 1698,
    bfrY: 1,
    bflX: 0,
    bflY: 1174 / 1385
};
const $0793957906d3daac$export$95a6bf9bd535c547 = {
    width: 1698,
    height: 1796,
    tblX: 497 / 1698,
    tblY: 0,
    tbrX: 1,
    tbrY: 211 / 1796,
    tfrX: 1202 / 1698,
    tfrY: 481 / 1796,
    tflX: 0,
    tflY: 271 / 1796,
    bblX: 497 / 1698,
    bblY: 1315 / 1796,
    bbrX: 1,
    bbrY: 1527 / 1796,
    bfrX: 1204 / 1698,
    bfrY: 1,
    bflX: 0,
    bflY: 1586 / 1796
};


class $19750a3395ff931f$export$41db2a57e1dcac60 {
    constructor(code){
        this.code = code;
    }
    is(another) {
        if (another === undefined || another === null) return false;
        if (another instanceof $19750a3395ff931f$export$41db2a57e1dcac60) return this.code === another.code;
        if (this.constructor.toString() === another.constructor.toString()) return this.code === another.code;
        return this.code === another;
    }
    isNot(another) {
        return !this.is(another);
    }
    isIn(another) {
        if (another === undefined || another === null) return false;
        const isAny = another.find((a)=>this.is(a));
        return !!isAny;
    }
    isNotIn(another) {
        return !this.isIn(another);
    }
}


class $75d304a8764c2f53$export$1b29cfe187e35100 extends (0, $19750a3395ff931f$export$41db2a57e1dcac60) {
    static{
        this.walnut = new $75d304a8764c2f53$export$1b29cfe187e35100('w');
    }
    static{
        this.natural = new $75d304a8764c2f53$export$1b29cfe187e35100('n');
    }
    constructor(code){
        super(code);
    }
}


const $8f77d098d6a5c866$var$small = "small";
const $8f77d098d6a5c866$var$tall = "tall";
const $8f77d098d6a5c866$var$wide = "wide";
const $8f77d098d6a5c866$var$large = "large";
const $8f77d098d6a5c866$var$smallCorner = "small-corner";
const $8f77d098d6a5c866$var$tallCorner = "tall-corner";
const $8f77d098d6a5c866$var$tallWide = "tall/wide";
const $8f77d098d6a5c866$var$smallTall = "small/tall";
const $8f77d098d6a5c866$var$wideLarge = "wide/large";
class $8f77d098d6a5c866$export$e71c4d32a2263218 {
    constructor(index, color){
        this._color = "n";
        this._size = $8f77d098d6a5c866$var$small;
        this._back = false;
        this._door = false;
        this._drawerTop = false;
        this._drawerMiddle = false;
        this._drawerBottom = false;
        this._crossDivider = false;
        this._shelfCount = 0;
        this._index = index;
        this._color = color;
    }
    canChangeColor(color) {
        if (this._size === $8f77d098d6a5c866$var$tall && color.is((0, $75d304a8764c2f53$export$1b29cfe187e35100).walnut)) return false;
        return true;
    }
    changeColor(color) {
        this._color = color;
    }
    setSize(size) {
        this._size = size;
        if (this.isCorner() && this._direction === undefined) this._direction = "r";
        if (!this.isCorner()) this._direction = undefined;
    }
    hasBack() {
        return this._back;
    }
    supportsBack() {
        // Small backs are not available for order in walnut
        return !(this._size === $8f77d098d6a5c866$var$small && this._color === "w");
    }
    addBack() {
        if (this.supportsBack()) this._back = true;
        else this._back = false;
    }
    removeBack() {
        this._back = false;
    }
    toggleBack() {
        if (this.supportsBack()) {
            if (this._back) this.removeBack();
            else this.addBack();
        } else this.removeBack();
    }
    addDoor() {
        this._door = true;
        this._crossDivider = false;
    }
    removeDoor() {
        this._door = false;
    }
    toggleDoor() {
        if (this._door) this.removeDoor();
        else this.addDoor();
    }
    addDrawerBottom() {
        this._drawerBottom = true;
        this._crossDivider = false;
        if (this.isCubeSizeSmall() || this.isCubeSizeWide()) {
            if (this.hasDrawerTop()) this._shelfCount = 0;
            else this._shelfCount = 1;
        } else {
            if (this.hasDrawerMiddle()) {
                if (this.hasDrawerTop()) this._shelfCount = 0;
                else this._shelfCount = 1;
            } else if (this.hasDrawerTop()) this._shelfCount = 1;
            else {
                if (this.getShelfCount() > 2) this._shelfCount = 2;
                if (this.getShelfCount() < 1) this._shelfCount = 1;
            }
        }
    }
    removeDrawerBottom() {
        this._drawerBottom = false;
    }
    toggleDrawerBottom() {
        if (this._drawerBottom) this.removeDrawerBottom();
        else this.addDrawerBottom();
    }
    addDrawerMiddle() {
        this._crossDivider = false;
        if (this.isCubeSizeSmall() || this.isCubeSizeWide()) this.addDrawerTop();
        else {
            this._drawerMiddle = true;
            if (this.hasDrawerTop()) this._shelfCount = 0;
            else this._shelfCount = 1;
        }
    }
    removeDrawerMiddle() {
        this._drawerMiddle = false;
        if (this.hasDrawerBottom()) this.setShelves(1);
        else if (this.getShelfCount() > 1) this.setShelves(1);
    }
    toggleDrawerMiddle() {
        if (this._drawerMiddle) this.removeDrawerMiddle();
        else this.addDrawerMiddle();
    }
    addDrawerTop() {
        this._drawerTop = true;
        this._crossDivider = false;
        if (this.isCubeSizeSmall() || this.isCubeSizeWide()) this._shelfCount = 0;
        else {
            if (this.hasDrawerMiddle()) this._shelfCount = 0;
            else if (this.getShelfCount() > 1) this._shelfCount = 1;
        }
    }
    removeDrawerTop() {
        this._drawerTop = false;
        if (this.isCubeSizeSmall() || this.isCubeSizeWide()) {
            if (this.hasDrawerBottom()) this.setShelves(1);
            else if (this.getShelfCount() > 1) this.setShelves(1);
        } else {
            if (this.hasDrawerMiddle()) this.setShelves(1);
            else if (this.getShelfCount() > 1) this.setShelves(1);
        }
    }
    toggleDrawerTop() {
        if (this._drawerTop) this.removeDrawerTop();
        else this.addDrawerTop();
    }
    supportsCrossDivider() {
        // Tall and wide X (cross-divider) inserts are not available for order
        return this._size !== $8f77d098d6a5c866$var$tall && this._size !== $8f77d098d6a5c866$var$wide;
    }
    hasCrossDivider() {
        return this._crossDivider;
    }
    addCrossDivider() {
        if (this.supportsCrossDivider()) {
            if (this.isStandard()) {
                this._crossDivider = true;
                this._shelfCount = 0;
                this._drawerBottom = false;
                this._drawerMiddle = false;
                this._drawerTop = false;
                this._door = false;
            } else this.removeCrossDivider();
        } else this.removeCrossDivider();
    }
    removeCrossDivider() {
        if (this.isStandard()) {
            this._crossDivider = false;
            this._shelfCount = 0;
            this._drawerBottom = false;
            this._drawerMiddle = false;
            this._drawerTop = false;
            this._door = false;
        } else this._crossDivider = false;
    }
    toggleCrossDivider() {
        if (this.supportsCrossDivider()) {
            if (this._crossDivider) this.removeCrossDivider();
            else this.addCrossDivider();
        } else this.removeCrossDivider();
    }
    setShelves(count) {
        if (this.isStandard()) {
            this._shelfCount = count;
            if (this._shelfCount >= 1) {
                this._drawerTop = false;
                this._drawerMiddle = false;
                this._drawerBottom = false;
            }
            this._crossDivider = false;
        }
    }
    toggleShelf() {
        if (this.isCorner()) return;
        let max_shelves;
        if (this.isCubeSizeSmall() || this.isCubeSizeWide()) max_shelves = 2;
        else max_shelves = 3;
        const shelfCount = (this._shelfCount + 1) % (max_shelves + 1);
        this.setShelves(shelfCount);
    }
    setDirectionRight() {
        if (this.isCorner()) this._direction = "r";
    }
    setDirectionLeft() {
        if (this.isCorner()) this._direction = "l";
    }
    toggleDirection() {
        if (!this.isCorner()) return;
        if (this._direction === "r") this.setDirectionLeft();
        else this.setDirectionRight();
    }
    getColor() {
        return this._color;
    }
    getSize() {
        return this._size;
    }
    getIndex() {
        return this._index;
    }
    getDrawersCount() {
        let count = 0;
        if (this._drawerBottom) count++;
        if (this._drawerMiddle) count++;
        if (this._drawerTop) count++;
        return count;
    }
    hasDoor() {
        return this._door;
    }
    hasDrawerTop() {
        return this._drawerTop;
    }
    hasDrawerMiddle() {
        return this._drawerMiddle;
    }
    hasDrawerBottom() {
        return this._drawerBottom;
    }
    hasShelves() {
        return this._shelfCount > 0;
    }
    getShelfCount() {
        return this._shelfCount;
    }
    isDirectionRight() {
        return this._direction === undefined ? undefined : this._direction === "r";
    }
    isDirectionLeft() {
        return this._direction === undefined ? undefined : this._direction === "l";
    }
    getDirection() {
        return this._direction;
    }
    isCorner() {
        return this._size === $8f77d098d6a5c866$var$smallCorner || this._size === $8f77d098d6a5c866$var$tallCorner;
    }
    isStandard() {
        return !this.isCorner();
    }
    isCubeSizeSmall() {
        return this._size === $8f77d098d6a5c866$var$small;
    }
    isCubeSizeSmallCorner() {
        return this._size === $8f77d098d6a5c866$var$smallCorner;
    }
    isCubeSizeWide() {
        return this._size === $8f77d098d6a5c866$var$wide;
    }
    isCubeSizeTall() {
        return this._size === $8f77d098d6a5c866$var$tall;
    }
    isCubeSizeTallCorner() {
        return this._size === $8f77d098d6a5c866$var$tallCorner;
    }
    isCubeSizeLarge() {
        return this._size === $8f77d098d6a5c866$var$large;
    }
}



class $57c8ce737201aade$export$d5f710d0ccaeafcf extends (0, $19750a3395ff931f$export$41db2a57e1dcac60) {
    static{
        this.smallCorner = new $57c8ce737201aade$export$d5f710d0ccaeafcf('small-corner');
    }
    static{
        this.tallCorner = new $57c8ce737201aade$export$d5f710d0ccaeafcf('tall-corner');
    }
    constructor(code){
        super(code);
    }
}



class $a327e1edeb34f877$export$d22de27482e7a470 {
    constructor(images, encoder){
        this._color = (0, $75d304a8764c2f53$export$1b29cfe187e35100).walnut;
        this.boxes = [];
        this._images = images;
        this._encoder = encoder;
    }
    createBox(config, konvaBoxFactory) {
        if (config.size === "tall" && !this.isTallBoxAvailable()) return null;
        if (config.size === "tall-corner") {
            if (!this.isCornerAvailable((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).tallCorner)) return null;
        }
        const box = new (0, $8f77d098d6a5c866$export$e71c4d32a2263218)(this.boxes.length + 1, this._color.code);
        box.setSize(config.size);
        if (config.back === "n" || config.back === "w") box.addBack();
        if (config.door === "n" || config.door === "w") {
            if (this.supportsDoor2(box)) box.addDoor();
        }
        if (config.shelf) this._encoder.decodeShelf(config.shelf, box);
        if (config.drawers) this._encoder.decodeDrawers(config.drawers, box);
        if (config.direction) this._encoder.decodeCornerDirection(config.direction, box);
        if (config.crossDivider) this._encoder.decodeCrossDivider(config.crossDivider, box);
        const konvaBoxProps = {
            x: config.x ?? 80,
            y: config.y ?? 80,
            // fill: '#432616',
            // stroke: 'red',
            // strokeWidth: 0,
            fillAfterStrokeEnabled: true,
            draggable: true,
            fillPatternScaleX: config.scaleX,
            fillPatternScaleY: config.scaleY,
            fillPatternRepeat: "no-repeat",
            width: config.width,
            height: config.height
        };
        const konvaBox = konvaBoxFactory(konvaBoxProps);
        const assoc = {
            konva: konvaBox,
            domain: box
        };
        this.boxes.push(assoc);
        this.ensureCompat(assoc);
        return konvaBox;
    }
    deleteBox(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        const index = this.boxes.indexOf(assocMaybe);
        if (index >= 0) {
            this.boxes.splice(index, 1);
            assocMaybe.konva.destroy();
        }
    }
    isCorner(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        const isCorner = assocMaybe.domain.isCorner();
        return isCorner;
    }
    hasBack(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        const has = assocMaybe.domain.hasBack();
        return has;
    }
    supportsDoor(konvaBox) {
        const box = this.getDomainBoxMaybe(konvaBox);
        if (!box) return false;
        return this.supportsDoor2(box);
    }
    supportsDoor2(_box) {
        return true;
    }
    hasDoors(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        const has = assocMaybe.domain.hasDoor();
        return has;
    }
    hasShelves(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        const has = assocMaybe.domain.hasShelves();
        return has;
    }
    hasTopDrawer(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        const has = assocMaybe.domain.hasDrawerTop();
        return has;
    }
    hasMiddleDrawer(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        const has = assocMaybe.domain.hasDrawerMiddle();
        return has;
    }
    hasBottomDrawer(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        const has = assocMaybe.domain.hasDrawerBottom();
        return has;
    }
    supportsBack(konvaBox) {
        return this.getDomainBoxMaybe(konvaBox).supportsBack();
    }
    getColor() {
        return this._color.code;
    }
    getColor2() {
        return this._color;
    }
    setColor(color) {
        if (color === "n") this._color = (0, $75d304a8764c2f53$export$1b29cfe187e35100).natural;
        if (color === "w") this._color = (0, $75d304a8764c2f53$export$1b29cfe187e35100).walnut;
    }
    getShelvesCount(konvaBox) {
        const box = this.getDomainBoxMaybe(konvaBox);
        const count = box?.getShelfCount();
        return count;
    }
    toggleColor() {
        if (this._color.is((0, $75d304a8764c2f53$export$1b29cfe187e35100).natural)) this._color = (0, $75d304a8764c2f53$export$1b29cfe187e35100).walnut;
        else this._color = (0, $75d304a8764c2f53$export$1b29cfe187e35100).natural;
        for (const assoc of [
            ...this.boxes
        ])if (!assoc.domain.canChangeColor(this._color)) this.deleteBox(assoc.konva);
        else {
            assoc.domain.changeColor(this._color.code);
            if (assoc.domain.hasBack() && !this.supportsBack(assoc.konva)) assoc.domain.removeBack();
            if (assoc.domain.hasDoor() && !this.supportsDoor(assoc.konva)) assoc.domain.removeDoor();
            this.ensureCompat(assoc);
        }
    }
    toggleBack(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        if (!this.supportsBack(assocMaybe.konva)) {
            if (assocMaybe.domain.hasBack()) assocMaybe.domain.removeBack();
            return;
        }
        assocMaybe.domain.toggleBack();
        this.ensureCompat(assocMaybe);
    }
    toggleDoor(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        if (!this.supportsDoor(assocMaybe.konva)) {
            if (assocMaybe.domain.hasDoor()) assocMaybe.domain.removeDoor();
            return;
        }
        assocMaybe.domain.toggleDoor();
        this.ensureCompat(assocMaybe);
    }
    toggleShelf(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        assocMaybe.domain.toggleShelf();
        this.ensureCompat(assocMaybe);
    }
    toggleDrawerTop(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        assocMaybe.domain.toggleDrawerTop();
        this.ensureCompat(assocMaybe);
    }
    toggleDrawerMiddle(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        assocMaybe.domain.toggleDrawerMiddle();
        this.ensureCompat(assocMaybe);
    }
    toggleDrawerBottom(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        assocMaybe.domain.toggleDrawerBottom();
        this.ensureCompat(assocMaybe);
    }
    toggleDirection(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        assocMaybe.domain.toggleDirection();
        this.ensureCompat(assocMaybe);
    }
    supportsCrossDivider(konvaBox) {
        return this.getDomainBoxMaybe(konvaBox)?.supportsCrossDivider();
    }
    hasCrossDivider(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return false;
        return assocMaybe.domain.hasCrossDivider();
    }
    toggleCrossDivider(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return;
        assocMaybe.domain.toggleCrossDivider();
        this.ensureCompat(assocMaybe);
    }
    getKonvoBoxes() {
        return this.boxes.map((b)=>b.konva);
    }
    getKonvaBox(box) {
        const assoc = this.boxes.filter((b)=>b.domain === box)[0];
        return assoc?.konva;
    }
    getBoxes() {
        return this.boxes.map((b)=>b.domain);
    }
    getImage(view, konvaCube) {
        const assocMaybe = this.getAssocByKonvaBox(konvaCube);
        if (!assocMaybe) return;
        const box = assocMaybe.domain;
        const imageName = this._encoder.encodeImageName(box);
        const imageMaybe = this._images.getImage(view, imageName);
        return imageMaybe;
    }
    getComponentsCount() {
        const finalCount = {
            small: {
                box: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325915279553,
                        darkWalnut: 40325915246785
                    }
                },
                back: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325980094657,
                        darkWalnut: 40325980061889
                    }
                },
                door: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326000476353,
                        darkWalnut: 40326000410817
                    }
                },
                shelf: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326010175681,
                        darkWalnut: 40326010142913
                    }
                },
                drawer: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326038782145,
                        darkWalnut: 40326038749377
                    }
                },
                right: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                left: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                divider: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 42801173266625,
                        darkWalnut: 42801173233857
                    }
                }
            },
            tall: {
                box: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325915345089,
                        darkWalnut: 40325915312321
                    }
                },
                back: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325980160193,
                        darkWalnut: 40325980127425
                    }
                },
                door: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326000541889,
                        darkWalnut: 40326000509121
                    }
                },
                shelf: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326010175681,
                        darkWalnut: 40326010142913
                    }
                },
                drawer: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326038782145,
                        darkWalnut: 40326038749377
                    }
                },
                right: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                left: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                divider: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 42801173332161,
                        darkWalnut: 42801173299393
                    }
                }
            },
            wide: {
                box: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325915410625,
                        darkWalnut: 40325915377857
                    }
                },
                back: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325980160193,
                        darkWalnut: 40325980127425
                    }
                },
                door: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326000541889,
                        darkWalnut: 40326000509121
                    }
                },
                shelf: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326010241217,
                        darkWalnut: 40326010208449
                    }
                },
                drawer: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326038847681,
                        darkWalnut: 40326038814913
                    }
                },
                right: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                left: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                divider: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 42801173332161,
                        darkWalnut: 42801173299393
                    }
                }
            },
            large: {
                box: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325915476161,
                        darkWalnut: 40325915443393
                    }
                },
                back: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40325980258497,
                        darkWalnut: 40325980192961
                    }
                },
                door: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326000607425,
                        darkWalnut: 40326000574657
                    }
                },
                shelf: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326010241217,
                        darkWalnut: 40326010208449
                    }
                },
                drawer: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 40326038847681,
                        darkWalnut: 40326038814913
                    }
                },
                right: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                left: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                divider: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 42801173397697,
                        darkWalnut: 42801173364929
                    }
                }
            },
            "small-corner": {
                box: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 42801168941249,
                        darkWalnut: 42801168908481
                    }
                },
                back: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                door: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                shelf: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                drawer: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                right: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                left: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                divider: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                }
            },
            "tall-corner": {
                box: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 42801169006785,
                        darkWalnut: 42801168974017
                    }
                },
                back: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                door: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                shelf: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                drawer: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                right: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                left: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                },
                divider: {
                    count: 0,
                    variantIdByFinish: {
                        natural: 0,
                        darkWalnut: 0
                    }
                }
            }
        };
        for (const { domain: box } of this.boxes){
            const size = box.getSize();
            if (box.isCorner()) {
                if (box.isDirectionRight()) finalCount[size].right.count++;
                if (box.isDirectionLeft()) finalCount[size].left.count++;
            } else {
                finalCount[size].box.count++;
                if (box.hasBack()) finalCount[size].back.count++;
                if (box.hasDoor()) finalCount[size].door.count++;
                if (box.hasShelves()) {
                    const shelves = box.getShelfCount();
                    finalCount[size].shelf.count += shelves;
                }
                if (box.hasCrossDivider()) finalCount[size].divider.count++;
                if (box.hasDrawerTop() || box.hasDrawerMiddle() || box.hasDrawerBottom()) {
                    const drawers = box.getDrawersCount();
                    finalCount[size].drawer.count += drawers;
                }
            }
        }
        return finalCount;
    }
    getCartCount() {
        const variantIds = {
            box: {
                small: {
                    n: 40325915279553,
                    w: 40325915246785
                },
                tall: {
                    n: 40325915345089,
                    w: 40325915312321
                },
                wide: {
                    n: 40325915410625,
                    w: 40325915377857
                },
                large: {
                    n: 40325915476161,
                    w: 40325915443393
                }
            },
            back: {
                small: {
                    n: 40325980094657,
                    w: 40325980061889
                },
                tallWide: {
                    n: 40325980160193,
                    w: 40325980127425
                },
                large: {
                    n: 40325980258497,
                    w: 40325980192961
                }
            },
            door: {
                small: {
                    n: 40326000476353,
                    w: 40326000410817
                },
                tallWide: {
                    n: 40326000541889,
                    w: 40326000509121
                },
                large: {
                    n: 40326000607425,
                    w: 40326000574657
                }
            },
            shelf: {
                smallTall: {
                    n: 40326010175681,
                    w: 40326010142913
                },
                wideLarge: {
                    n: 40326010241217,
                    w: 40326010208449
                }
            },
            drawer: {
                smallTall: {
                    n: 40326038782145,
                    w: 40326038749377
                },
                wideLarge: {
                    n: 40326038847681,
                    w: 40326038814913
                }
            },
            divider: {
                small: {
                    n: 42801173266625,
                    w: 42801173233857
                },
                tallWide: {
                    n: 42801173332161,
                    w: 42801173299393
                },
                large: {
                    n: 42801173397697,
                    w: 42801173364929
                }
            },
            corner: {
                small: {
                    n: 42801168941249,
                    w: 42801168908481
                },
                tall: {
                    n: 42801169006785,
                    w: 42801168974017
                }
            }
        };
        const prices = {
            box: {
                small: 69,
                tallWide: 84,
                large: 99
            },
            back: {
                small: 14,
                tallWide: 19,
                large: 24
            },
            door: {
                small: 24,
                tallWide: 29,
                large: 34
            },
            shelf: {
                smallTall: 14,
                wideLarge: 19
            },
            drawer: {
                smallTall: 39,
                wideLarge: 59
            },
            divider: {
                small: 29,
                tallWide: 34,
                large: 39
            },
            corner: {
                small: 69,
                tall: 84
            }
        };
        const cart = {
            boxes: {
                small: {
                    count: 0,
                    pricePerUnit: prices.box.small,
                    variantId: variantIds.box.small[this._color.code]
                },
                tall: {
                    count: 0,
                    pricePerUnit: prices.box.tallWide,
                    variantId: variantIds.box.tall[this._color.code]
                },
                wide: {
                    count: 0,
                    pricePerUnit: prices.box.tallWide,
                    variantId: variantIds.box.wide[this._color.code]
                },
                large: {
                    count: 0,
                    pricePerUnit: prices.box.large,
                    variantId: variantIds.box.large[this._color.code]
                }
            },
            back: {
                small: {
                    count: 0,
                    pricePerUnit: prices.back.small,
                    variantId: variantIds.back.small[this._color.code]
                },
                tallWide: {
                    count: 0,
                    pricePerUnit: prices.back.tallWide,
                    variantId: variantIds.back.tallWide[this._color.code]
                },
                large: {
                    count: 0,
                    pricePerUnit: prices.back.large,
                    variantId: variantIds.back.large[this._color.code]
                }
            },
            door: {
                small: {
                    count: 0,
                    pricePerUnit: prices.door.small,
                    variantId: variantIds.door.small[this._color.code]
                },
                tallWide: {
                    count: 0,
                    pricePerUnit: prices.door.tallWide,
                    variantId: variantIds.door.tallWide[this._color.code]
                },
                large: {
                    count: 0,
                    pricePerUnit: prices.door.large,
                    variantId: variantIds.door.large[this._color.code]
                }
            },
            shelf: {
                smallTall: {
                    count: 0,
                    pricePerUnit: prices.shelf.smallTall,
                    variantId: variantIds.shelf.smallTall[this._color.code]
                },
                wideLarge: {
                    count: 0,
                    pricePerUnit: prices.shelf.wideLarge,
                    variantId: variantIds.shelf.wideLarge[this._color.code]
                }
            },
            drawer: {
                smallTall: {
                    count: 0,
                    pricePerUnit: prices.drawer.smallTall,
                    variantId: variantIds.drawer.smallTall[this._color.code]
                },
                wideLarge: {
                    count: 0,
                    pricePerUnit: prices.drawer.wideLarge,
                    variantId: variantIds.drawer.wideLarge[this._color.code]
                }
            },
            divider: {
                small: {
                    count: 0,
                    pricePerUnit: prices.divider.small,
                    variantId: variantIds.divider.small[this._color.code]
                },
                tallWide: {
                    count: 0,
                    pricePerUnit: prices.divider.tallWide,
                    variantId: variantIds.divider.tallWide[this._color.code]
                },
                large: {
                    count: 0,
                    pricePerUnit: prices.divider.large,
                    variantId: variantIds.divider.large[this._color.code]
                }
            },
            corner: {
                small: {
                    count: 0,
                    pricePerUnit: prices.corner.small,
                    variantId: variantIds.corner.small[this._color.code]
                },
                tall: {
                    count: 0,
                    pricePerUnit: prices.corner.tall,
                    variantId: variantIds.corner.tall[this._color.code]
                }
            }
        };
        for (const { domain: box } of this.boxes){
            const size = box.getSize();
            if (box.isCorner()) switch(size){
                case "small-corner":
                    cart.corner.small.count++;
                    break;
                case "tall-corner":
                    cart.corner.tall.count++;
                    break;
            }
            else {
                switch(size){
                    case "small":
                        cart.boxes.small.count++;
                        break;
                    case "tall":
                        cart.boxes.tall.count++;
                        break;
                    case "wide":
                        cart.boxes.wide.count++;
                        break;
                    case "large":
                        cart.boxes.large.count++;
                        break;
                }
                if (box.hasBack()) switch(size){
                    case "small":
                        cart.back.small.count++;
                        break;
                    case "tall":
                    case "wide":
                        cart.back.tallWide.count++;
                        break;
                    case "large":
                        cart.back.large.count++;
                        break;
                }
                if (box.hasDoor()) switch(size){
                    case "small":
                        cart.door.small.count++;
                        break;
                    case "tall":
                    case "wide":
                        cart.door.tallWide.count++;
                        break;
                    case "large":
                        cart.door.large.count++;
                        break;
                }
                if (box.hasShelves()) {
                    const shelves = box.getShelfCount();
                    switch(size){
                        case "small":
                        case "tall":
                            cart.shelf.smallTall.count += shelves;
                            break;
                        case "wide":
                        case "large":
                            cart.shelf.wideLarge.count += shelves;
                            break;
                    }
                }
                if (box.hasDrawerTop() || box.hasDrawerMiddle() || box.hasDrawerBottom()) {
                    const drawers = box.getDrawersCount();
                    switch(size){
                        case "small":
                        case "tall":
                            cart.drawer.smallTall.count += drawers;
                            break;
                        case "wide":
                        case "large":
                            cart.drawer.wideLarge.count += drawers;
                            break;
                    }
                }
                if (box.hasCrossDivider()) switch(size){
                    case "small":
                        cart.divider.small.count++;
                        break;
                    case "tall":
                    case "wide":
                        cart.divider.tallWide.count++;
                        break;
                    case "large":
                        cart.divider.large.count++;
                        break;
                }
            }
        }
        if (cart.door.small.count % 2 === 1) cart.door.small.count++;
        if (cart.door.tallWide.count % 2 === 1) cart.door.tallWide.count++;
        if (cart.door.large.count % 2 === 1) cart.door.large.count++;
        if (cart.shelf.smallTall.count % 2 === 1) cart.shelf.smallTall.count++;
        if (cart.shelf.wideLarge.count % 2 === 1) cart.shelf.wideLarge.count++;
        if (cart.drawer.smallTall.count % 2 === 1) cart.drawer.smallTall.count++;
        if (cart.drawer.wideLarge.count % 2 === 1) cart.drawer.wideLarge.count++;
        const cartItems = [
            cart.boxes.small,
            cart.boxes.tall,
            cart.boxes.wide,
            cart.boxes.large,
            cart.back.small,
            cart.back.tallWide,
            cart.back.large,
            cart.door.small,
            cart.door.tallWide,
            cart.door.large,
            cart.shelf.smallTall,
            cart.shelf.wideLarge,
            cart.drawer.smallTall,
            cart.drawer.wideLarge,
            cart.divider.small,
            cart.divider.tallWide,
            cart.divider.large,
            cart.corner.small,
            cart.corner.tall
        ].filter((c)=>c.count > 0);
        return cartItems;
    }
    getCartCost() {
        const finalCart = this.getCartCount();
        const total = finalCart.reduce((agg, curr)=>agg + curr.count * curr.pricePerUnit, 0);
        return total;
    }
    getAssocByKonvaBox(konvaBox) {
        const assocMaybe = this.boxes.filter((b)=>b.konva === konvaBox)[0];
        return assocMaybe;
    }
    getDomainBoxMaybe(konvaBox) {
        const assocMaybe = this.getAssocByKonvaBox(konvaBox);
        if (!assocMaybe) return undefined;
        return assocMaybe.domain;
    }
    ensureCompat(assoc) {
        const box = assoc.domain;
        const konvaBox = assoc.konva;
        konvaBox.setAttr("cube_color", this._color);
        konvaBox.setAttr("cube_size", box.getSize());
        konvaBox.setAttr("box_index", box.getIndex());
        konvaBox.setAttr("back", box.hasBack());
        konvaBox.setAttr("door", box.hasDoor());
        konvaBox.setAttr("top_drawer", box.hasDrawerTop());
        konvaBox.setAttr("middle_drawer", box.hasDrawerMiddle());
        konvaBox.setAttr("bottom_drawer", box.hasDrawerBottom());
        konvaBox.setAttr("shelf", box.getShelfCount());
        konvaBox.setAttr("corner_right", box.isDirectionRight());
        konvaBox.setAttr("cross_divider", box.hasCrossDivider());
    }
    isCornerAvailable(type) {
        return true;
    }
    isTallBoxAvailable() {
        return !this._color.is((0, $75d304a8764c2f53$export$1b29cfe187e35100).walnut);
    }
}


class $14b7ee2a6fd8ed76$export$ec7dcaac71d9599d {
    constructor(){
        this.alreadyLoadedImages = 0;
        this.imagesLoaded = false;
        this.images = {};
        this.callbacks = [];
        const validCombos = this.getValidStdCubeCombinations();
        for (let combo of validCombos){
            const components = combo.split(':');
            const size = components[0];
            const color = components[1];
            const door = components[2];
            const back = components[3];
            const drawers = components[4];
            const shelf = components[5];
            this.addImage('iso-' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf, './renders/iso-' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf + '.webp');
            this.addImage('2d-' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf, './renders/' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf + '.webp');
        }
        const stdCubeCross = this.getValidStdCubeCrossDivider();
        for (let combo of stdCubeCross){
            const components = combo.split(':');
            const size = components[0];
            const color = components[1];
            const back = components[2];
            this.addImage(`iso-${size}_${color}-${back}`, `./renders/iso-${size}-${color}-x-${back}.webp`);
            this.addImage(`2d-${size}_${color}-${back}`, `./renders/2d-${size}-${color}-x-${back}.webp` //`./renders/2d-${size}-${color}-x-${back}.webp`
            );
        }
        const cornerCubeCombos = this.getValidCornerCubeCombinations();
        for (let combo of cornerCubeCombos){
            const components = combo.split(':');
            const size = components[0];
            const color = components[1];
            const direction = components[2];
            this.addImage(`iso-${size}_${color}-${direction}`, `./renders/iso-${size}_${color}-${direction}.webp`);
            this.addImage(`2d-${size}_${color}-${direction}`, `./renders/2d-${size}_${color}-${direction}.webp`);
        }
    }
    addImagesLoadedListener(cb) {
        this.callbacks.push(cb);
        if (this.areImagesLoaded()) cb();
    }
    areImagesLoaded() {
        return this.imagesLoaded;
    }
    getImage(view, imageName) {
        if (!this.imagesLoaded) return undefined;
        const imagesMaybe = this.images[`${view}-${imageName}`];
        if (imagesMaybe) return imagesMaybe;
        return undefined;
    }
    getValidStdCubeCombinations() {
        const colors = [
            'n',
            'w'
        ];
        const combos = [];
        for (const color of colors){
            combos.push(`small:${color}:0:0:000:0000`);
            combos.push(`small:${color}:0:0:000:${color}000`);
            combos.push(`small:${color}:0:0:000:${color}${color}00`);
            combos.push(`small:${color}:0:0:${color}00:${color}000`);
            combos.push(`small:${color}:0:0:0${color}0:0000`);
            combos.push(`small:${color}:0:0:${color}${color}0:0000`);
            combos.push(`small:${color}:0:${color}:000:0000`);
            combos.push(`small:${color}:0:${color}:000:${color}000`);
            combos.push(`small:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`small:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`small:${color}:0:${color}:0${color}0:0000`);
            combos.push(`small:${color}:0:${color}:${color}${color}0:0000`);
            combos.push(`small:${color}:${color}:0:000:0000`);
            combos.push(`small:${color}:${color}:${color}:000:0000`);
            combos.push(`wide:${color}:0:0:000:0000`);
            combos.push(`wide:${color}:0:0:000:${color}000`);
            combos.push(`wide:${color}:0:0:000:${color}${color}00`);
            combos.push(`wide:${color}:0:0:${color}00:${color}000`);
            combos.push(`wide:${color}:0:0:0${color}0:0000`);
            combos.push(`wide:${color}:0:0:${color}${color}0:0000`);
            combos.push(`wide:${color}:0:${color}:000:0000`);
            combos.push(`wide:${color}:0:${color}:000:${color}000`);
            combos.push(`wide:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`wide:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`wide:${color}:0:${color}:0${color}0:0000`);
            combos.push(`wide:${color}:0:${color}:${color}${color}0:0000`);
            combos.push(`wide:${color}:${color}:0:000:0000`);
            combos.push(`wide:${color}:${color}:${color}:000:0000`);
            combos.push(`tall:${color}:0:0:000:0000`);
            combos.push(`tall:${color}:0:0:000:${color}000`);
            combos.push(`tall:${color}:0:0:000:${color}${color}00`);
            combos.push(`tall:${color}:0:0:000:${color}${color}${color}0`);
            combos.push(`tall:${color}:0:0:${color}00:${color}000`);
            combos.push(`tall:${color}:0:0:${color}00:${color}${color}00`);
            combos.push(`tall:${color}:0:0:0${color}0:${color}000`);
            combos.push(`tall:${color}:0:0:00${color}:0000`);
            combos.push(`tall:${color}:0:0:00${color}:${color}000`);
            combos.push(`tall:${color}:0:0:${color}${color}0:${color}000`);
            combos.push(`tall:${color}:0:0:${color}0${color}:${color}000`);
            combos.push(`tall:${color}:0:0:0${color}${color}:0000`);
            combos.push(`tall:${color}:0:0:${color}${color}${color}:0000`);
            combos.push(`tall:${color}:0:${color}:000:0000`);
            combos.push(`tall:${color}:0:${color}:000:${color}000`);
            combos.push(`tall:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`tall:${color}:0:${color}:000:${color}${color}${color}0`);
            combos.push(`tall:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`tall:${color}:0:${color}:${color}00:${color}${color}00`);
            combos.push(`tall:${color}:0:${color}:0${color}0:${color}000`);
            combos.push(`tall:${color}:0:${color}:00${color}:0000`);
            combos.push(`tall:${color}:0:${color}:00${color}:${color}000`);
            combos.push(`tall:${color}:0:${color}:${color}${color}0:${color}000`);
            combos.push(`tall:${color}:0:${color}:${color}0${color}:${color}000`);
            combos.push(`tall:${color}:0:${color}:0${color}${color}:0000`);
            combos.push(`tall:${color}:0:${color}:${color}${color}${color}:0000`);
            combos.push(`tall:${color}:${color}:0:000:0000`);
            combos.push(`tall:${color}:${color}:${color}:000:0000`);
            combos.push(`large:${color}:0:0:000:0000`);
            combos.push(`large:${color}:0:0:000:${color}000`);
            combos.push(`large:${color}:0:0:000:${color}${color}00`);
            combos.push(`large:${color}:0:0:000:${color}${color}${color}0`);
            combos.push(`large:${color}:0:0:${color}00:${color}000`);
            combos.push(`large:${color}:0:0:${color}00:${color}${color}00`);
            combos.push(`large:${color}:0:0:0${color}0:${color}000`);
            combos.push(`large:${color}:0:0:00${color}:0000`);
            combos.push(`large:${color}:0:0:00${color}:${color}000`);
            combos.push(`large:${color}:0:0:${color}${color}0:${color}000`);
            combos.push(`large:${color}:0:0:${color}0${color}:${color}000`);
            combos.push(`large:${color}:0:0:0${color}${color}:0000`);
            combos.push(`large:${color}:0:0:${color}${color}${color}:0000`);
            combos.push(`large:${color}:0:${color}:000:0000`);
            combos.push(`large:${color}:0:${color}:000:${color}000`);
            combos.push(`large:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`large:${color}:0:${color}:000:${color}${color}${color}0`);
            combos.push(`large:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`large:${color}:0:${color}:${color}00:${color}${color}00`);
            combos.push(`large:${color}:0:${color}:0${color}0:${color}000`);
            combos.push(`large:${color}:0:${color}:00${color}:0000`);
            combos.push(`large:${color}:0:${color}:00${color}:${color}000`);
            combos.push(`large:${color}:0:${color}:${color}${color}0:${color}000`);
            combos.push(`large:${color}:0:${color}:${color}0${color}:${color}000`);
            combos.push(`large:${color}:0:${color}:0${color}${color}:0000`);
            combos.push(`large:${color}:0:${color}:${color}${color}${color}:0000`);
            combos.push(`large:${color}:${color}:0:000:0000`);
            combos.push(`large:${color}:${color}:${color}:000:0000`);
        }
        return combos;
    }
    getValidStdCubeCrossDivider() {
        const colors = [
            'n',
            'w'
        ];
        const combos = [];
        for (const color of colors){
            combos.push(`small:${color}:0`);
            combos.push(`small:${color}:${color}`);
            combos.push(`tall:${color}:0`);
            combos.push(`tall:${color}:${color}`);
            combos.push(`wide:${color}:0`);
            combos.push(`wide:${color}:${color}`);
            combos.push(`large:${color}:0`);
            combos.push(`large:${color}:${color}`);
        }
        return combos;
    }
    getValidCornerCubeCombinations() {
        const colors = [
            'n',
            'w'
        ];
        const combos = [];
        for (const color of colors){
            combos.push(`small-corner:${color}:r`);
            combos.push(`small-corner:${color}:l`);
            combos.push(`tall-corner:${color}:r`);
            combos.push(`tall-corner:${color}:l`);
        }
        return combos;
    }
    addImage(name, path) {
        const image = new Image();
        image.src = path;
        image.onload = ()=>{
            this.alreadyLoadedImages++;
            if (Object.keys(this.images).length === this.alreadyLoadedImages) this.markImagesLoaded();
        };
        image.onerror = ()=>{
            this.alreadyLoadedImages++;
            if (Object.keys(this.images).length === this.alreadyLoadedImages) this.markImagesLoaded();
        };
        this.images[name] = image;
    }
    markImagesLoaded() {
        this.imagesLoaded = true;
        for (const cb of this.callbacks)cb();
    }
}


class $0d26e10679b3ed4e$export$a50aceb0e02a00aa {
    encodeBack(box) {
        const color = box.getColor();
        const back = box.hasBack() ? color : '0';
        return back;
    }
    decodeBack(encoded, box) {
        if (encoded === 'n' || encoded === 'w') box.addBack();
    }
    encodeDoor(box) {
        const color = box.getColor();
        const door = box.hasDoor() ? color : '0';
        return door;
    }
    decodeDoor(encoded, box) {
        if (encoded === 'n' || encoded === 'w') box.addDoor();
    }
    encodeShelf(box) {
        const color = box.getColor();
        const shelfCount = box.getShelfCount();
        var encoded;
        if (shelfCount == 0) encoded = '0000';
        else if (shelfCount == 1) encoded = `${color}000`;
        else if (shelfCount == 2) encoded = `${color}${color}00`;
        else if (shelfCount == 3) encoded = `${color}${color}${color}0`;
        else if (shelfCount == 4) encoded = `${color}${color}${color}${color}`;
        return encoded;
    }
    encodeNoShelf() {
        return '0000';
    }
    decodeShelf(encoded, box) {
        let shelfCount = 0;
        switch(encoded){
            case 'n000':
            case 'w000':
            case '0n00':
            case '0w00':
                shelfCount = 1;
                break;
            case 'nn00':
            case 'ww00':
                shelfCount = 2;
                break;
            case 'nnn0':
            case 'www0':
                shelfCount = 3;
                break;
            case 'nnnn':
            case 'wwww':
                shelfCount = 4;
                break;
        }
        box.setShelves(shelfCount);
    }
    encodeDrawers(box) {
        const color = box.getColor();
        let encoded = '';
        switch(true){
            case box.isCubeSizeSmall():
            case box.isCubeSizeWide():
                encoded = (box.hasDrawerBottom() ? `${color}` : '0') + (box.hasDrawerTop() ? `${color}0` : '00');
                break;
            case box.isCubeSizeLarge():
            case box.isCubeSizeTall():
                encoded = (box.hasDrawerBottom() ? `${color}` : '0') + (box.hasDrawerMiddle() ? `${color}` : '0') + (box.hasDrawerTop() ? `${color}` : '0');
                break;
            case box.isCubeSizeSmallCorner():
                encoded = `${color}-corner-right`;
                break;
        }
        return encoded;
    }
    encodeNoDrawers() {
        return '000';
    }
    decodeDrawers(encoded, box) {
        if (encoded[0] === 'n' || encoded[0] === 'w') box.addDrawerBottom();
        if (encoded[1] === 'n' || encoded[1] === 'w') box.addDrawerMiddle();
        if (encoded[2] === 'n' || encoded[2] === 'w') box.addDrawerTop();
    }
    encodeCornerDirection(box) {
        const corner = box.isDirectionRight() ? 'r' : 'l';
        return corner;
    }
    decodeCornerDirection(encoded, box) {
        if (encoded === 'r') box.setDirectionRight();
        else box.setDirectionLeft();
    }
    encodeCrossDivider(box) {
        const color = box.getColor();
        if (box.hasCrossDivider()) return color;
        else return '0';
    }
    decodeCrossDivider(encoded, box) {
        if (encoded === 'n' || encoded === 'w') box.addCrossDivider();
    }
    encodeImageName(box) {
        let imageName;
        if (box.isCorner()) imageName = `${box.getSize()}_${box.getColor()}-${box.getDirection()}`;
        else {
            const size = box.getSize();
            const color = box.getColor();
            const back = this.encodeBack(box);
            if (box.hasCrossDivider()) imageName = `${size}_${color}-${back}`;
            else {
                const door = this.encodeDoor(box);
                const shelf = box.hasDoor() ? this.encodeNoShelf() : this.encodeShelf(box);
                const drawers = box.hasDoor() ? this.encodeNoDrawers() : this.encodeDrawers(box);
                imageName = box.getSize() + '_' + box.getColor() + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf;
            }
        }
        return imageName;
    }
}


class $40153e6038aedd8c$export$b8a61e5c71402559 {
    constructor(encoder, boxService){
        this._encoder = encoder;
        this._boxService = boxService;
    }
    encodeBoxes(boxes) {
        let queryString = "";
        for (let box of boxes){
            const konvaBox = this._boxService.getKonvaBox(box);
            if (konvaBox) queryString = queryString + this.getApproximation(konvaBox.attrs.x) + ":" + this.getApproximation(konvaBox.attrs.y) + ":" + box.getSize() + ":" + this._encoder.encodeDoor(box) + ":" + this._encoder.encodeBack(box) + ":" + this._encoder.encodeShelf(box) + ":" + this._encoder.encodeDrawers(box) + ":" + this._encoder.encodeCornerDirection(box) + ":" + this._encoder.encodeCrossDivider(box) + ";";
        }
        return queryString;
    }
    decodeBoxes(queryString) {
        let boxesStrings = queryString.split(";");
        let boxes = [];
        for (let box of boxesStrings){
            let boxProps = box.split(":");
            if (boxProps.length === 7 || boxProps.length === 8 || boxProps.length === 9) {
                let box = {
                    x: Number(boxProps[0]),
                    y: Number(boxProps[1]),
                    size: boxProps[2],
                    door: boxProps[3],
                    back: boxProps[4],
                    shelf: boxProps[5],
                    drawers: boxProps[6],
                    direction: boxProps[7],
                    crossDivider: boxProps[8]
                };
                boxes.push(box);
            }
        }
        return boxes;
    }
    getApproximation(val) {
        //return Math.round(val);
        return +val.toFixed(1);
    }
}


class $f6c3db4ac9f3c8da$export$6d79d6b2b09bac1a {
    showCart() {
        if (this._cartVisible !== true) {
            this._cartVisible = true;
            this.raiseOnChanged();
        }
    }
    hideCart() {
        if (this._cartVisible !== false) {
            this._cartVisible = false;
            this.raiseOnChanged();
        }
    }
    toState() {
        return {
            cartVisible: this._cartVisible
        };
    }
    addEventListener(handler) {
        this._eventHandler.addEventListener('ui-service:on-changed', handler);
    }
    raiseOnChanged() {
        this._eventHandler.dispatchEvent(new Event('ui-service:on-changed'));
    }
    constructor(){
        this._eventHandler = new EventTarget();
        this._cartVisible = false;
    }
}


const $314a4bc86abf4e4b$var$images = new (0, $14b7ee2a6fd8ed76$export$ec7dcaac71d9599d)();
const $314a4bc86abf4e4b$var$encoder = new (0, $0d26e10679b3ed4e$export$a50aceb0e02a00aa)();
const $314a4bc86abf4e4b$var$boxService = new (0, $a327e1edeb34f877$export$d22de27482e7a470)($314a4bc86abf4e4b$var$images, $314a4bc86abf4e4b$var$encoder);
const $314a4bc86abf4e4b$var$navigation = new (0, $40153e6038aedd8c$export$b8a61e5c71402559)($314a4bc86abf4e4b$var$encoder, $314a4bc86abf4e4b$var$boxService);
const $314a4bc86abf4e4b$var$uiService = new (0, $f6c3db4ac9f3c8da$export$6d79d6b2b09bac1a)();
class $314a4bc86abf4e4b$export$6cd6e3ed1512e78f {
    static get images() {
        return $314a4bc86abf4e4b$var$images;
    }
    static get boxService() {
        return $314a4bc86abf4e4b$var$boxService;
    }
    static get navigation() {
        return $314a4bc86abf4e4b$var$navigation;
    }
    static get uiService() {
        return $314a4bc86abf4e4b$var$uiService;
    }
}



var $e8c06130135c6588$exports = {};
$e8c06130135c6588$exports = $e8c06130135c6588$var$robustPointInPolygon;
var $c196312dd3cf148f$exports = {};
"use strict";
var $3f94e2d9d3551106$exports = {};
"use strict";
$3f94e2d9d3551106$exports = $3f94e2d9d3551106$var$twoProduct;
var $3f94e2d9d3551106$var$SPLITTER = +(Math.pow(2, 27) + 1.0);
function $3f94e2d9d3551106$var$twoProduct(a, b, result) {
    var x = a * b;
    var c = $3f94e2d9d3551106$var$SPLITTER * a;
    var abig = c - a;
    var ahi = c - abig;
    var alo = a - ahi;
    var d = $3f94e2d9d3551106$var$SPLITTER * b;
    var bbig = d - b;
    var bhi = d - bbig;
    var blo = b - bhi;
    var err1 = x - ahi * bhi;
    var err2 = err1 - alo * bhi;
    var err3 = err2 - ahi * blo;
    var y = alo * blo - err3;
    if (result) {
        result[0] = y;
        result[1] = x;
        return result;
    }
    return [
        y,
        x
    ];
}


var $d076cca31471b426$exports = {};
"use strict";
$d076cca31471b426$exports = $d076cca31471b426$var$linearExpansionSum;
//Easy case: Add two scalars
function $d076cca31471b426$var$scalarScalar(a, b) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    var y = ar + br;
    if (y) return [
        y,
        x
    ];
    return [
        x
    ];
}
function $d076cca31471b426$var$linearExpansionSum(e, f) {
    var ne = e.length | 0;
    var nf = f.length | 0;
    if (ne === 1 && nf === 1) return $d076cca31471b426$var$scalarScalar(e[0], f[0]);
    var n = ne + nf;
    var g = new Array(n);
    var count = 0;
    var eptr = 0;
    var fptr = 0;
    var abs = Math.abs;
    var ei = e[eptr];
    var ea = abs(ei);
    var fi = f[fptr];
    var fa = abs(fi);
    var a, b;
    if (ea < fa) {
        b = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        b = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = f[fptr];
            fa = abs(fi);
        }
    }
    if (eptr < ne && ea < fa || fptr >= nf) {
        a = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = f[fptr];
            fa = abs(fi);
        }
    }
    var x = a + b;
    var bv = x - a;
    var y = b - bv;
    var q0 = y;
    var q1 = x;
    var _x, _bv, _av, _br, _ar;
    while(eptr < ne && fptr < nf){
        if (ea < fa) {
            a = ei;
            eptr += 1;
            if (eptr < ne) {
                ei = e[eptr];
                ea = abs(ei);
            }
        } else {
            a = fi;
            fptr += 1;
            if (fptr < nf) {
                fi = f[fptr];
                fa = abs(fi);
            }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
    }
    while(eptr < ne){
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        eptr += 1;
        if (eptr < ne) ei = e[eptr];
    }
    while(fptr < nf){
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fptr += 1;
        if (fptr < nf) fi = f[fptr];
    }
    if (q0) g[count++] = q0;
    if (q1) g[count++] = q1;
    if (!count) g[count++] = 0.0;
    g.length = count;
    return g;
}


var $265449ec2d21f49c$exports = {};
"use strict";

var $8ce4e181cdac766d$exports = {};
"use strict";
$8ce4e181cdac766d$exports = $8ce4e181cdac766d$var$fastTwoSum;
function $8ce4e181cdac766d$var$fastTwoSum(a, b, result) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    if (result) {
        result[0] = ar + br;
        result[1] = x;
        return result;
    }
    return [
        ar + br,
        x
    ];
}


$265449ec2d21f49c$exports = $265449ec2d21f49c$var$scaleLinearExpansion;
function $265449ec2d21f49c$var$scaleLinearExpansion(e, scale) {
    var n = e.length;
    if (n === 1) {
        var ts = $3f94e2d9d3551106$exports(e[0], scale);
        if (ts[0]) return ts;
        return [
            ts[1]
        ];
    }
    var g = new Array(2 * n);
    var q = [
        0.1,
        0.1
    ];
    var t = [
        0.1,
        0.1
    ];
    var count = 0;
    $3f94e2d9d3551106$exports(e[0], scale, q);
    if (q[0]) g[count++] = q[0];
    for(var i = 1; i < n; ++i){
        $3f94e2d9d3551106$exports(e[i], scale, t);
        var pq = q[1];
        $8ce4e181cdac766d$exports(pq, t[0], q);
        if (q[0]) g[count++] = q[0];
        var a = t[1];
        var b = q[1];
        var x = a + b;
        var bv = x - a;
        var y = b - bv;
        q[1] = x;
        if (y) g[count++] = y;
    }
    if (q[1]) g[count++] = q[1];
    if (count === 0) g[count++] = 0.0;
    g.length = count;
    return g;
}


var $f79e5bd3bff04cca$exports = {};
"use strict";
$f79e5bd3bff04cca$exports = $f79e5bd3bff04cca$var$robustSubtract;
//Easy case: Add two scalars
function $f79e5bd3bff04cca$var$scalarScalar(a, b) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    var y = ar + br;
    if (y) return [
        y,
        x
    ];
    return [
        x
    ];
}
function $f79e5bd3bff04cca$var$robustSubtract(e, f) {
    var ne = e.length | 0;
    var nf = f.length | 0;
    if (ne === 1 && nf === 1) return $f79e5bd3bff04cca$var$scalarScalar(e[0], -f[0]);
    var n = ne + nf;
    var g = new Array(n);
    var count = 0;
    var eptr = 0;
    var fptr = 0;
    var abs = Math.abs;
    var ei = e[eptr];
    var ea = abs(ei);
    var fi = -f[fptr];
    var fa = abs(fi);
    var a, b;
    if (ea < fa) {
        b = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        b = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = -f[fptr];
            fa = abs(fi);
        }
    }
    if (eptr < ne && ea < fa || fptr >= nf) {
        a = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = -f[fptr];
            fa = abs(fi);
        }
    }
    var x = a + b;
    var bv = x - a;
    var y = b - bv;
    var q0 = y;
    var q1 = x;
    var _x, _bv, _av, _br, _ar;
    while(eptr < ne && fptr < nf){
        if (ea < fa) {
            a = ei;
            eptr += 1;
            if (eptr < ne) {
                ei = e[eptr];
                ea = abs(ei);
            }
        } else {
            a = fi;
            fptr += 1;
            if (fptr < nf) {
                fi = -f[fptr];
                fa = abs(fi);
            }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
    }
    while(eptr < ne){
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        eptr += 1;
        if (eptr < ne) ei = e[eptr];
    }
    while(fptr < nf){
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fptr += 1;
        if (fptr < nf) fi = -f[fptr];
    }
    if (q0) g[count++] = q0;
    if (q1) g[count++] = q1;
    if (!count) g[count++] = 0.0;
    g.length = count;
    return g;
}


var $c196312dd3cf148f$var$NUM_EXPAND = 5;
var $c196312dd3cf148f$var$EPSILON = 1.1102230246251565e-16;
var $c196312dd3cf148f$var$ERRBOUND3 = (3.0 + 16.0 * $c196312dd3cf148f$var$EPSILON) * $c196312dd3cf148f$var$EPSILON;
var $c196312dd3cf148f$var$ERRBOUND4 = (7.0 + 56.0 * $c196312dd3cf148f$var$EPSILON) * $c196312dd3cf148f$var$EPSILON;
function $c196312dd3cf148f$var$cofactor(m, c) {
    var result = new Array(m.length - 1);
    for(var i = 1; i < m.length; ++i){
        var r = result[i - 1] = new Array(m.length - 1);
        for(var j = 0, k = 0; j < m.length; ++j){
            if (j === c) continue;
            r[k++] = m[i][j];
        }
    }
    return result;
}
function $c196312dd3cf148f$var$matrix(n) {
    var result = new Array(n);
    for(var i = 0; i < n; ++i){
        result[i] = new Array(n);
        for(var j = 0; j < n; ++j)result[i][j] = [
            "m",
            j,
            "[",
            n - i - 1,
            "]"
        ].join("");
    }
    return result;
}
function $c196312dd3cf148f$var$sign(n) {
    if (n & 1) return "-";
    return "";
}
function $c196312dd3cf148f$var$generateSum(expr) {
    if (expr.length === 1) return expr[0];
    else if (expr.length === 2) return [
        "sum(",
        expr[0],
        ",",
        expr[1],
        ")"
    ].join("");
    else {
        var m = expr.length >> 1;
        return [
            "sum(",
            $c196312dd3cf148f$var$generateSum(expr.slice(0, m)),
            ",",
            $c196312dd3cf148f$var$generateSum(expr.slice(m)),
            ")"
        ].join("");
    }
}
function $c196312dd3cf148f$var$determinant(m) {
    if (m.length === 2) return [
        [
            "sum(prod(",
            m[0][0],
            ",",
            m[1][1],
            "),prod(-",
            m[0][1],
            ",",
            m[1][0],
            "))"
        ].join("")
    ];
    else {
        var expr = [];
        for(var i = 0; i < m.length; ++i)expr.push([
            "scale(",
            $c196312dd3cf148f$var$generateSum($c196312dd3cf148f$var$determinant($c196312dd3cf148f$var$cofactor(m, i))),
            ",",
            $c196312dd3cf148f$var$sign(i),
            m[0][i],
            ")"
        ].join(""));
        return expr;
    }
}
function $c196312dd3cf148f$var$orientation(n) {
    var pos = [];
    var neg = [];
    var m = $c196312dd3cf148f$var$matrix(n);
    var args = [];
    for(var i = 0; i < n; ++i){
        if ((i & 1) === 0) pos.push.apply(pos, $c196312dd3cf148f$var$determinant($c196312dd3cf148f$var$cofactor(m, i)));
        else neg.push.apply(neg, $c196312dd3cf148f$var$determinant($c196312dd3cf148f$var$cofactor(m, i)));
        args.push("m" + i);
    }
    var posExpr = $c196312dd3cf148f$var$generateSum(pos);
    var negExpr = $c196312dd3cf148f$var$generateSum(neg);
    var funcName = "orientation" + n + "Exact";
    var code = [
        "function ",
        funcName,
        "(",
        args.join(),
        "){var p=",
        posExpr,
        ",n=",
        negExpr,
        ",d=sub(p,n);\
return d[d.length-1];};return ",
        funcName
    ].join("");
    var proc = new Function("sum", "prod", "scale", "sub", code);
    return proc($d076cca31471b426$exports, $3f94e2d9d3551106$exports, $265449ec2d21f49c$exports, $f79e5bd3bff04cca$exports);
}
var $c196312dd3cf148f$var$orientation3Exact = $c196312dd3cf148f$var$orientation(3);
var $c196312dd3cf148f$var$orientation4Exact = $c196312dd3cf148f$var$orientation(4);
var $c196312dd3cf148f$var$CACHED = [
    function orientation0() {
        return 0;
    },
    function orientation1() {
        return 0;
    },
    function orientation2(a, b) {
        return b[0] - a[0];
    },
    function orientation3(a, b, c) {
        var l = (a[1] - c[1]) * (b[0] - c[0]);
        var r = (a[0] - c[0]) * (b[1] - c[1]);
        var det = l - r;
        var s;
        if (l > 0) {
            if (r <= 0) return det;
            else s = l + r;
        } else if (l < 0) {
            if (r >= 0) return det;
            else s = -(l + r);
        } else return det;
        var tol = $c196312dd3cf148f$var$ERRBOUND3 * s;
        if (det >= tol || det <= -tol) return det;
        return $c196312dd3cf148f$var$orientation3Exact(a, b, c);
    },
    function orientation4(a, b, c, d) {
        var adx = a[0] - d[0];
        var bdx = b[0] - d[0];
        var cdx = c[0] - d[0];
        var ady = a[1] - d[1];
        var bdy = b[1] - d[1];
        var cdy = c[1] - d[1];
        var adz = a[2] - d[2];
        var bdz = b[2] - d[2];
        var cdz = c[2] - d[2];
        var bdxcdy = bdx * cdy;
        var cdxbdy = cdx * bdy;
        var cdxady = cdx * ady;
        var adxcdy = adx * cdy;
        var adxbdy = adx * bdy;
        var bdxady = bdx * ady;
        var det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
        var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
        var tol = $c196312dd3cf148f$var$ERRBOUND4 * permanent;
        if (det > tol || -det > tol) return det;
        return $c196312dd3cf148f$var$orientation4Exact(a, b, c, d);
    }
];
function $c196312dd3cf148f$var$slowOrient(args) {
    var proc = $c196312dd3cf148f$var$CACHED[args.length];
    if (!proc) proc = $c196312dd3cf148f$var$CACHED[args.length] = $c196312dd3cf148f$var$orientation(args.length);
    return proc.apply(undefined, args);
}
function $c196312dd3cf148f$var$generateOrientationProc() {
    while($c196312dd3cf148f$var$CACHED.length <= $c196312dd3cf148f$var$NUM_EXPAND)$c196312dd3cf148f$var$CACHED.push($c196312dd3cf148f$var$orientation($c196312dd3cf148f$var$CACHED.length));
    var args = [];
    var procArgs = [
        "slow"
    ];
    for(var i = 0; i <= $c196312dd3cf148f$var$NUM_EXPAND; ++i){
        args.push("a" + i);
        procArgs.push("o" + i);
    }
    var code = [
        "function getOrientation(",
        args.join(),
        "){switch(arguments.length){case 0:case 1:return 0;"
    ];
    for(var i = 2; i <= $c196312dd3cf148f$var$NUM_EXPAND; ++i)code.push("case ", i, ":return o", i, "(", args.slice(0, i).join(), ");");
    code.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation");
    procArgs.push(code.join(""));
    var proc = Function.apply(undefined, procArgs);
    $c196312dd3cf148f$exports = proc.apply(undefined, [
        $c196312dd3cf148f$var$slowOrient
    ].concat($c196312dd3cf148f$var$CACHED));
    for(var i = 0; i <= $c196312dd3cf148f$var$NUM_EXPAND; ++i)$c196312dd3cf148f$exports[i] = $c196312dd3cf148f$var$CACHED[i];
}
$c196312dd3cf148f$var$generateOrientationProc();


function $e8c06130135c6588$var$robustPointInPolygon(vs, point) {
    var x = point[0];
    var y = point[1];
    var n = vs.length;
    var inside = 1;
    var lim = n;
    for(var i = 0, j = n - 1; i < lim; j = i++){
        var a = vs[i];
        var b = vs[j];
        var yi = a[1];
        var yj = b[1];
        if (yj < yi) {
            if (yj < y && y < yi) {
                var s = $c196312dd3cf148f$exports(a, b, point);
                if (s === 0) return 0;
                else inside ^= 0 < s | 0;
            } else if (y === yi) {
                var c = vs[(i + 1) % n];
                var yk = c[1];
                if (yi < yk) {
                    var s = $c196312dd3cf148f$exports(a, b, point);
                    if (s === 0) return 0;
                    else inside ^= 0 < s | 0;
                }
            }
        } else if (yi < yj) {
            if (yi < y && y < yj) {
                var s = $c196312dd3cf148f$exports(a, b, point);
                if (s === 0) return 0;
                else inside ^= s < 0 | 0;
            } else if (y === yi) {
                var c = vs[(i + 1) % n];
                var yk = c[1];
                if (yk < yi) {
                    var s = $c196312dd3cf148f$exports(a, b, point);
                    if (s === 0) return 0;
                    else inside ^= s < 0 | 0;
                }
            }
        } else if (y === yi) {
            var x0 = Math.min(a[0], b[0]);
            var x1 = Math.max(a[0], b[0]);
            if (i === 0) {
                while(j > 0){
                    var k = (j + n - 1) % n;
                    var p = vs[k];
                    if (p[1] !== y) break;
                    var px = p[0];
                    x0 = Math.min(x0, px);
                    x1 = Math.max(x1, px);
                    j = k;
                }
                if (j === 0) {
                    if (x0 <= x && x <= x1) return 0;
                    return 1;
                }
                lim = j + 1;
            }
            var y0 = vs[(j + n - 1) % n][1];
            while(i + 1 < lim){
                var p = vs[i + 1];
                if (p[1] !== y) break;
                var px = p[0];
                x0 = Math.min(x0, px);
                x1 = Math.max(x1, px);
                i += 1;
            }
            if (x0 <= x && x <= x1) return 0;
            var y1 = vs[(i + 1) % n][1];
            if (x < x0 && y0 < y !== y1 < y) inside ^= 1;
        }
    }
    return 2 * inside - 1;
}



class $09f535d0bd749734$export$2eeae5af5390eb78 {
    getCubeSize(cube) {
        const size = cube.getAttr('cube_size');
        return size;
    }
    isPointInsidePolygon(x, y, polygon) {
        // ray-casting algorithm based on
        // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
        let inside = false;
        for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
            const xi = polygon[i].x, yi = polygon[i].y;
            const xj = polygon[j].x, yj = polygon[j].y;
            const intersect = yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    isPointInsidePolygon2(x, y, polygon) {
        const adaptedPoint = [
            x,
            y
        ];
        const adaptedPoly = polygon.map((p)=>[
                p.x,
                p.y
            ]);
        const is = (0, (/*@__PURE__*/$parcel$interopDefault($e8c06130135c6588$exports)))(adaptedPoly, adaptedPoint);
        return is === 0 || is === -1;
    }
    isPointInsideRectangle(x1, y1, x2, y2, x, y) {
        if (x > x1 && x < x2 && y > y1 && y < y2) return true;
        return false;
    }
    isUnderBox(currentBox, box) {
        const safetyCheck = 3;
        const currentCube = this.getCubeCornersFromBox(currentBox);
        const cube = this.getCubeCornersFromBox(box);
        const polygon = [
            {
                x: cube.tfl.x,
                y: cube.tfl.y
            },
            {
                x: cube.tbl.x,
                y: cube.tbl.y
            },
            {
                x: cube.tbr.x,
                y: cube.tbr.y
            },
            {
                x: cube.bbr.x,
                y: cube.bbr.y
            },
            {
                x: cube.bfr.x,
                y: cube.bfr.y
            },
            {
                x: cube.bfl.x,
                y: cube.bfl.y
            }
        ];
        if (this.isPointInsidePolygon2(currentCube.tbl.x + safetyCheck, currentCube.tbl.y + safetyCheck, polygon)) return true;
        if (this.isPointInsidePolygon2(currentCube.tbr.x, currentCube.tbr.y, polygon)) return true;
        if (this.isPointInsidePolygon2(currentCube.bbr.x - safetyCheck, currentCube.bbr.y - safetyCheck, polygon)) return true;
        // const x1 = box.attrs.x, y1 = box.attrs.y;
        // const x2 = box.attrs.x + box.attrs.width, y2 = box.attrs.y + box.attrs.height;
        // if (isPointInsideRectangle(x1, y1, x2, y2, currentCube.tbl.x + safetyCheck, currentCube.tbl.y + safetyCheck)) {
        //     return true;
        // }
        //
        // if (isPointInsideRectangle(x1 - safetyCheck, y1 - safetyCheck, x2 + safetyCheck, y2 + safetyCheck, currentCube.tbr.x, currentCube.tbr.y)) {
        //     return true;
        // }
        //
        // if (isPointInsideRectangle(x1, y1, x2, y2, currentCube.bbr.x - safetyCheck, currentCube.bbr.y - safetyCheck)) {
        //     return true;
        // }
        return false;
    }
    getIsoFa() {
        return this.isoFrontFa;
    }
    getIsoFb(x, y) {
        return y - this.isoFrontFa * x;
    }
    getIsoCos() {
        return this.isoFrontAngleCos;
    }
    getIsoFrontTg() {
        return this.isoFrontAngleTg;
    }
    getIsoSideTg() {
        return this.isoSideAngleTg;
    }
    getIsoFbForCubeTopFrontLine(cube) {
        const fb = cube.tfl.y - this.isoFrontFa * cube.tfl.x;
        return fb;
    }
    getIsoFbForCubeTopBackLine(cube) {
        const fb = cube.tbl.y - this.isoFrontFa * cube.tbl.x;
        return fb;
    }
    getIsoFbForCubeBottomFrontLine(cube) {
        const fb = cube.bfl.y - this.isoFrontFa * cube.bfl.x;
        return fb;
    }
    getIsoFbForCubeBottomBackLine(cube) {
        const fb = cube.bbr.y - this.isoFrontFa * cube.bbr.x;
        return fb;
    }
    getIsoFbForBoxTopFrontLine(box) {
        const cube = this.getCubeCornersFromBox(box);
        const fb = cube.tfl.y - this.isoFrontFa * cube.tfl.x;
        return fb;
    }
    getIsoCubeOriginFrom2DCubeOrigin(box) {
        // const size = exportedBoxUtils.getCubeSize(box);
        const distanceFromOrigin = box.attrs.x;
        const cubeX = distanceFromOrigin * this.isoFrontAngleCos;
        const cubeY = box.attrs.y + distanceFromOrigin * this.isoFrontAngleSin;
        return {
            x: cubeX,
            y: cubeY
        };
    }
    getApproximation(val) {
        //return Math.round(val);
        return +val.toFixed(1);
    }
    get2DCubeOriginFromIsoBox(box) {
        // const fb = exported.getIsoFbForBoxTopFrontLine(box);
        //
        // const x = exported.getApproximation(box.attrs.x);
        // const y = exported.getApproximation(fb);
        const originDistances = this.getIsoDistanceFromOrigin(box);
        const x = originDistances.tfl;
        const y = originDistances.originY;
        return {
            x: x,
            y: y
        };
    }
    getIsoImgOriginFromIsoCubeOrigin(size, x, width, y, height) {
        let imgX = x, imgY;
        switch(size){
            case 0, $0793957906d3daac$export$d6547b117d1dcd45:
            case 0, $0793957906d3daac$export$878e4a3737c08e85:
                imgY = y - (0, $0793957906d3daac$export$df4e3742db13505).tflY * height;
                break;
            case 0, $0793957906d3daac$export$63cff6b6d7f669bf:
            case 0, $0793957906d3daac$export$12b7a355343dd343:
                imgY = y - (0, $0793957906d3daac$export$1b35fd99c98f5dde).tflY * height;
                break;
            case 0, $0793957906d3daac$export$cb58b2ba04527c22:
                imgY = y - (0, $0793957906d3daac$export$afef5481b241cb53).tflY * height;
                break;
            case 0, $0793957906d3daac$export$e7aa9ee549f9e84:
                imgY = y - (0, $0793957906d3daac$export$95a6bf9bd535c547).tflY * height;
                break;
        }
        return {
            x: imgX,
            y: imgY
        };
    }
    getIsoDistanceFromOrigin(box) {
        const cube = this.getCubeCornersFromBox(box);
        const fb = this.getIsoFbForBoxTopFrontLine(box);
        const originX = 0;
        const originY = fb;
        const distances = {
            originX: originX,
            originY: originY,
            tfl: this.getDistanceFromPoint(originX, originY, cube.tfl.x, cube.tfl.y),
            tfr: this.getDistanceFromPoint(originX, originY, cube.tfr.x, cube.tfr.y)
        };
        return distances;
    }
    getCubeCornersFromProps(cubeSize, boxX, boxWidth, boxY, boxHeight) {
        if (cubeSize === (0, $0793957906d3daac$export$d6547b117d1dcd45) || cubeSize === (0, $0793957906d3daac$export$878e4a3737c08e85)) return {
            tfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$df4e3742db13505).tflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$df4e3742db13505).tflY * boxHeight
            },
            tfr: {
                x: boxX + (0, $0793957906d3daac$export$df4e3742db13505).tfrX * boxWidth,
                y: boxY + (0, $0793957906d3daac$export$df4e3742db13505).tfrY * boxHeight
            },
            tbl: {
                x: boxX + (0, $0793957906d3daac$export$df4e3742db13505).tblX * boxWidth,
                y: boxY
            },
            tbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$df4e3742db13505).tbrY * boxHeight
            },
            bfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$df4e3742db13505).bflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$df4e3742db13505).bflY * boxHeight,
                dBottom: (1 - (0, $0793957906d3daac$export$df4e3742db13505).bflY) * boxHeight
            },
            bfr: {
                x: boxX + (0, $0793957906d3daac$export$df4e3742db13505).bfrX * boxWidth,
                y: boxY + boxHeight
            },
            bbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$df4e3742db13505).bbrY * boxHeight
            }
        };
        if (cubeSize === (0, $0793957906d3daac$export$cb58b2ba04527c22)) return {
            tfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$afef5481b241cb53).tflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$afef5481b241cb53).tflY * boxHeight
            },
            tfr: {
                x: boxX + (0, $0793957906d3daac$export$afef5481b241cb53).tfrX * boxWidth,
                y: boxY + (0, $0793957906d3daac$export$afef5481b241cb53).tfrY * boxHeight
            },
            tbl: {
                x: boxX + (0, $0793957906d3daac$export$afef5481b241cb53).tblX * boxWidth,
                y: boxY
            },
            tbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$afef5481b241cb53).tbrY * boxHeight
            },
            bfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$afef5481b241cb53).bflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$afef5481b241cb53).bflY * boxHeight,
                dBottom: (1 - (0, $0793957906d3daac$export$afef5481b241cb53).bflY) * boxHeight
            },
            bfr: {
                x: boxX + (0, $0793957906d3daac$export$afef5481b241cb53).bfrX * boxWidth,
                y: boxY + boxHeight
            },
            bbl: {
                x: boxX + (0, $0793957906d3daac$export$afef5481b241cb53).bblX * boxWidth,
                y: boxY + (0, $0793957906d3daac$export$afef5481b241cb53).bblY * boxHeight
            },
            bbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$afef5481b241cb53).bbrY * boxHeight
            }
        };
        if (cubeSize === (0, $0793957906d3daac$export$63cff6b6d7f669bf) || cubeSize === (0, $0793957906d3daac$export$12b7a355343dd343)) return {
            tfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$1b35fd99c98f5dde).tflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$1b35fd99c98f5dde).tflY * boxHeight
            },
            tfr: {
                x: boxX + (0, $0793957906d3daac$export$1b35fd99c98f5dde).tfrX * boxWidth,
                y: boxY + (0, $0793957906d3daac$export$1b35fd99c98f5dde).tfrY * boxHeight
            },
            tbl: {
                x: boxX + (0, $0793957906d3daac$export$1b35fd99c98f5dde).tblX * boxWidth,
                y: boxY
            },
            tbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$1b35fd99c98f5dde).tbrY * boxHeight
            },
            bfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$1b35fd99c98f5dde).bflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$1b35fd99c98f5dde).bflY * boxHeight,
                dBottom: (1 - (0, $0793957906d3daac$export$1b35fd99c98f5dde).bflY) * boxHeight
            },
            bfr: {
                x: boxX + (0, $0793957906d3daac$export$1b35fd99c98f5dde).bfrX * boxWidth,
                y: boxY + boxHeight
            },
            bbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$1b35fd99c98f5dde).bbrY * boxHeight
            }
        };
        if (cubeSize === (0, $0793957906d3daac$export$e7aa9ee549f9e84)) return {
            tfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$95a6bf9bd535c547).tflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$95a6bf9bd535c547).tflY * boxHeight
            },
            tfr: {
                x: boxX + (0, $0793957906d3daac$export$95a6bf9bd535c547).tfrX * boxWidth,
                y: boxY + (0, $0793957906d3daac$export$95a6bf9bd535c547).tfrY * boxHeight
            },
            tbl: {
                x: boxX + (0, $0793957906d3daac$export$95a6bf9bd535c547).tblX * boxWidth,
                y: boxY
            },
            tbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$95a6bf9bd535c547).tbrY * boxHeight
            },
            bfl: {
                x: boxX,
                y: boxY + (0, $0793957906d3daac$export$95a6bf9bd535c547).bflY * boxHeight,
                dTop: (0, $0793957906d3daac$export$95a6bf9bd535c547).bflY * boxHeight,
                dBottom: (1 - (0, $0793957906d3daac$export$95a6bf9bd535c547).bflY) * boxHeight
            },
            bfr: {
                x: boxX + (0, $0793957906d3daac$export$95a6bf9bd535c547).bfrX * boxWidth,
                y: boxY + boxHeight
            },
            bbr: {
                x: boxX + boxWidth,
                y: boxY + (0, $0793957906d3daac$export$95a6bf9bd535c547).bbrY * boxHeight
            }
        };
        return {};
    }
    getCubeCornersFromBox(box) {
        const otherCubeSize = this.getCubeSize(box);
        const otherBoxWidth = box.attrs.width;
        const otherBoxHeight = box.attrs.height;
        const otherBoxX = box.attrs.x;
        const otherBoxY = box.attrs.y;
        const cube = this.getCubeCornersFromProps(otherCubeSize, otherBoxX, otherBoxWidth, otherBoxY, otherBoxHeight);
        return cube;
    }
    getDistanceFromPoint(x1, y1, x2, y2) {
        const dist = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
        return dist;
    }
    ll_dist(b1, b2) {
        return b1.attrs.x - b2.attrs.x;
    }
    rr_dist(b1, b2) {
        return b1.attrs.x + b1.attrs.width - (b2.attrs.x + b2.attrs.width);
    }
    lr_dist(b1, b2) {
        return b1.attrs.x - (b2.attrs.x + b2.attrs.width);
    }
    rl_dist(b1, b2) {
        return b1.attrs.x + b1.attrs.width - b2.attrs.x;
    }
    tt_dist(b1, b2) {
        return b1.attrs.y - b2.attrs.y;
    }
    bb_dist(b1, b2) {
        return b1.attrs.y + b1.attrs.height - (b2.attrs.y + b2.attrs.height);
    }
    tb_dist(b1, b2) {
        return b1.attrs.y - (b2.attrs.y + b2.attrs.height);
    }
    bt_dist(b1, b2) {
        return b1.attrs.y + b1.attrs.height - b2.attrs.y;
    }
    constructor(){
        this.isoFrontAngleSin = 0.17708474032;
        this.isoFrontAngleCos = 0.98419560796;
        this.isoFrontAngleTg = 0.17992839927;
        this.isoFrontFa = this.isoFrontAngleTg;
        this.isoSideAngleTg = 0.56577277818;
    }
}


class $6863f1a9d0ecbe27$export$441453b5c7d2b21c {
    getBasePrices() {
        return this.prices;
    }
    getCubeSize(cube) {
        const size = cube.getAttr('cube_size');
        return size;
    }
    isCorner(cube) {
        return this.getCubeSize(cube) === (0, $0793957906d3daac$export$878e4a3737c08e85) || this.getCubeSize(cube) === (0, $0793957906d3daac$export$12b7a355343dd343);
    }
    isCornerSize(size) {
        return size === (0, $0793957906d3daac$export$878e4a3737c08e85) || size === (0, $0793957906d3daac$export$12b7a355343dd343);
    }
    isCubeSizeSmall(cube) {
        return this.getCubeSize(cube) === (0, $0793957906d3daac$export$d6547b117d1dcd45);
    }
    isCubeSizeSmallCorner(cube) {
        return this.getCubeSize(cube) === (0, $0793957906d3daac$export$878e4a3737c08e85);
    }
    isCubeSizeWide(cube) {
        return this.getCubeSize(cube) === (0, $0793957906d3daac$export$cb58b2ba04527c22);
    }
    isCubeSizeTall(cube) {
        return this.getCubeSize(cube) === (0, $0793957906d3daac$export$63cff6b6d7f669bf);
    }
    isCubeSizeTallCorner(cube) {
        return this.getCubeSize(cube) === (0, $0793957906d3daac$export$12b7a355343dd343);
    }
    isCubeSizeLarge(cube) {
        return this.getCubeSize(cube) === (0, $0793957906d3daac$export$e7aa9ee549f9e84);
    }
    setPosition(box, x, y) {
        x = this.exportedBoxMath.getApproximation(x);
        y = this.exportedBoxMath.getApproximation(y);
        // x = Math.floor(x);
        // y = Math.floor(y);
        const initialX = box.attrs.x;
        const initialY = box.attrs.y;
        box.position({
            x: x,
            y: y
        });
        if (this.isDebug) console.log(`Box position: (${initialX},${initialY})->(${x},${y})`);
    }
    getCubeColor(box) {
        const color = box.attrs.cube_color;
        return color;
    }
    encodeBack(box) {
        const back = box.getAttr('back') ? this.getCubeColor(box) : '0';
        return back;
    }
    hasBack(box) {
        const has = box.getAttr('back');
        return has;
    }
    encodeDoor(box) {
        const door = box.getAttr('door') ? this.getCubeColor(box) : '0';
        return door;
    }
    hasDoor(box) {
        const has = box.getAttr('door');
        return has;
    }
    getShelfCount(box) {
        return box.getAttr('shelf');
    }
    encodeShelf(box) {
        const shelfCount = box.getAttr('shelf');
        const color = this.getCubeColor(box);
        let encoded;
        if (shelfCount == 0) encoded = '0000';
        else if (shelfCount == 1) encoded = `${color}000`;
        else if (shelfCount == 2) encoded = `${color}${color}00`;
        else if (shelfCount == 3) encoded = `${color}${color}${color}0`;
        else if (shelfCount == 4) encoded = `${color}${color}${color}${color}`;
        return encoded;
    }
    hasShelf(box) {
        const has = box.getAttr('shelf');
        return has;
    }
    getDrawerCount(box) {
        let counter = 0;
        if (this.hasTopDrawer(box)) counter++;
        if (this.hasMiddleDrawer(box)) counter++;
        if (this.hasBottomDrawer(box)) counter++;
        return counter;
    }
    hasTopDrawer(box) {
        return !!box.getAttr('top_drawer');
    }
    hasMiddleDrawer(box) {
        return !!box.getAttr('middle_drawer');
    }
    hasBottomDrawer(box) {
        return !!box.getAttr('bottom_drawer');
    }
    hasCornerRight(box) {
        return !!box.getAttr('corner_right');
    }
    hasCornerLeft(box) {
        return !box.getAttr('corner_right');
    }
    hasCrossDivider(box) {
        return !!box.getAttr('cross_divider');
    }
    encodeDrawers(box) {
        const color = this.getCubeColor(box);
        let encoded = '';
        switch(true){
            case this.isCubeSizeSmall(box):
            case this.isCubeSizeWide(box):
                encoded = (this.hasBottomDrawer(box) ? `${color}` : '0') + (this.hasTopDrawer(box) ? `${color}0` : '00');
                break;
            case this.isCubeSizeLarge(box):
            case this.isCubeSizeTall(box):
                encoded = (this.hasBottomDrawer(box) ? `${color}` : '0') + (this.hasMiddleDrawer(box) ? `${color}` : '0') + (this.hasTopDrawer(box) ? `${color}` : '0');
                break;
        }
        return encoded;
    }
    decodeDrawers(encoded, box) {
        if (encoded[0] === 'n' || encoded[0] === 'w') box.setAttr('bottom_drawer', true);
        else box.setAttr('bottom_drawer', false);
        if (this.isCubeSizeSmall(box) || this.isCubeSizeWide(box)) {
            if (encoded[1] === 'n' || encoded[1] === 'w') box.setAttr('top_drawer', true);
            else box.setAttr('top_drawer', false);
        } else {
            if (encoded[1] === 'n' || encoded[1] === 'w') box.setAttr('middle_drawer', true);
            else box.setAttr('middle_drawer', false);
            if (encoded[2] === 'n' || encoded[2] === 'w') box.setAttr('top_drawer', true);
            else box.setAttr('top_drawer', false);
        }
    }
    encodeCornerDirection(box) {
        const cornerRightMaybe = box.getAttr('corner_right');
        if (!cornerRightMaybe) return '';
        const corner = cornerRightMaybe ? 'r' : 'l';
        return corner;
    }
    changeIsDebug(debug) {
        this.isDebug = debug;
    }
    constructor(){
        this.isDebug = false;
        this.exportedBoxMath = new (0, $09f535d0bd749734$export$2eeae5af5390eb78)();
        this.prices = {
            'small': {
                price: 69,
                backPrice: 14,
                doorPrice: 24,
                shelfPrice: 14,
                drawerPrice: 39,
                crossDivider: 29
            },
            'tall': {
                price: 84,
                backPrice: 19,
                doorPrice: 29,
                shelfPrice: 14,
                drawerPrice: 39,
                crossDivider: 34
            },
            'wide': {
                price: 84,
                backPrice: 19,
                doorPrice: 29,
                shelfPrice: 19,
                drawerPrice: 59,
                crossDivider: 34
            },
            'large': {
                price: 99,
                backPrice: 24,
                doorPrice: 34,
                shelfPrice: 19,
                drawerPrice: 59,
                crossDivider: 39
            },
            'small-corner': {
                price: 69
            },
            'tall-corner': {
                price: 84
            }
        };
    }
}



class $3fc4948ebe2e9d12$export$fc7aaf2dd465e3a8 {
    inToFtAndIn(totalInches) {
        const ft = Math.floor(totalInches / 12);
        const inches = totalInches - ft * 12;
        return {
            ft: ft,
            in: inches
        };
    }
}




class $ef3d34a4ad380339$export$9cdc346d0f00b337 {
    constructor(){
        this.verticalLineSizePxPerIn = 3340 / 211.0236;
        this.horizontalLineSizePxPerIn = 3091.7 / 211.0236;
        this.debugEnabled = false;
        this.dimensionsElements = [];
        this.boxDebugElements = [];
        this.exportedUtils = new (0, $3fc4948ebe2e9d12$export$fc7aaf2dd465e3a8)();
        this.exportedBoxMath = new (0, $09f535d0bd749734$export$2eeae5af5390eb78)();
    }
    clearDimensions() {
        for (const e of this.dimensionsElements)e.destroy();
        this.dimensionsElements.length = 0;
    }
    getDimensionsPoints(boxes) {
        const distanceFromBoxes = 50;
        let topMostBox = boxes[0];
        let bottomMostBox = boxes[0];
        let rightMostBox = boxes[0];
        let leftMostBox = boxes[0];
        for(let i = 1; i < boxes.length; i++){
            const currentBox = boxes[i];
            if (topMostBox.attrs.y > currentBox.attrs.y) topMostBox = currentBox;
            if (bottomMostBox.attrs.y + bottomMostBox.attrs.height < currentBox.attrs.y + currentBox.attrs.height) bottomMostBox = currentBox;
            if (rightMostBox.attrs.x + rightMostBox.attrs.width < currentBox.attrs.x + currentBox.attrs.width) rightMostBox = currentBox;
            if (leftMostBox.attrs.x > currentBox.attrs.x) leftMostBox = currentBox;
        }
        const verticalLineStartX = rightMostBox.attrs.x + rightMostBox.attrs.width + distanceFromBoxes;
        const verticalLineStartY = topMostBox.attrs.y;
        const verticalLineEndX = rightMostBox.attrs.x + rightMostBox.attrs.width + distanceFromBoxes;
        const verticalLineEndY = bottomMostBox.attrs.y + bottomMostBox.attrs.height;
        const verticalLineSize = verticalLineEndY - verticalLineStartY;
        const verticalLineTextIn = verticalLineSize / this.verticalLineSizePxPerIn;
        const verticalLineTextFtIn = this.exportedUtils.inToFtAndIn(verticalLineTextIn);
        const verticalLineTextX = verticalLineStartX + distanceFromBoxes;
        const verticalLineTextY = verticalLineStartY + (verticalLineEndY - verticalLineStartY) / 2;
        const horizontalLineStartX = leftMostBox.attrs.x;
        const horizontalLineStartY = bottomMostBox.attrs.y + bottomMostBox.attrs.height + distanceFromBoxes;
        const horizontalLineEndX = rightMostBox.attrs.x + rightMostBox.attrs.width;
        const horizontalLineEndY = bottomMostBox.attrs.y + bottomMostBox.attrs.height + distanceFromBoxes;
        const horizontalLineSize = horizontalLineEndX - horizontalLineStartX;
        const horizontalLineTextIn = horizontalLineSize / this.horizontalLineSizePxPerIn;
        const horizontalLineTextFtIn = this.exportedUtils.inToFtAndIn(horizontalLineTextIn);
        const horizontalLineTextX = horizontalLineStartX + (horizontalLineEndX - horizontalLineStartX) / 2 - 75;
        const horizontalLineTextY = horizontalLineStartY + distanceFromBoxes;
        return {
            topMostBox: topMostBox,
            bottomMostBox: bottomMostBox,
            rightMostBox: rightMostBox,
            leftMostBox: leftMostBox,
            verticalLineStartX: verticalLineStartX,
            verticalLineStartY: verticalLineStartY,
            verticalLineEndX: verticalLineEndX,
            verticalLineEndY: verticalLineEndY,
            verticalLineTextX: verticalLineTextX,
            verticalLineTextY: verticalLineTextY,
            verticalLineTextIn: verticalLineTextIn,
            verticalLineTextFtIn: verticalLineTextFtIn,
            horizontalLineStartX: horizontalLineStartX,
            horizontalLineStartY: horizontalLineStartY,
            horizontalLineEndX: horizontalLineEndX,
            horizontalLineEndY: horizontalLineEndY,
            horizontalLineTextX: horizontalLineTextX,
            horizontalLineTextY: horizontalLineTextY,
            horizontalLineTextIn: horizontalLineTextIn,
            horizontalLineTextFtIn: horizontalLineTextFtIn
        };
    }
    drawDimensions(layer, boxes) {
        this.clearDimensions();
        if (boxes.length <= 0) return;
        const data = this.getDimensionsPoints(boxes);
        if (this.debugEnabled) {
            this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.topMostBox.attrs.x,
                    data.topMostBox.attrs.y,
                    data.verticalLineStartX,
                    data.verticalLineStartY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            }));
            this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.bottomMostBox.attrs.x,
                    data.bottomMostBox.attrs.y + data.bottomMostBox.attrs.height,
                    data.verticalLineEndX,
                    data.verticalLineEndY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            }));
        }
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
            points: [
                data.verticalLineStartX,
                data.verticalLineStartY,
                data.verticalLineEndX,
                data.verticalLineEndY
            ],
            stroke: 'black',
            strokeWidth: 6,
            lineCap: 'round',
            lineJoin: 'round'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.verticalLineStartX,
            y: data.verticalLineStartY,
            radius: 12,
            fill: 'black'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.verticalLineEndX,
            y: data.verticalLineEndY,
            radius: 12,
            fill: 'black'
        }));
        if (!this.debugEnabled) this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.verticalLineTextX,
            y: data.verticalLineTextY,
            text: (data.verticalLineTextFtIn.ft ? data.verticalLineTextFtIn.ft.toFixed(0) + ' ft ' : '') + data.verticalLineTextFtIn.in.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        else this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.verticalLineTextX,
            y: data.verticalLineTextY,
            text: data.verticalLineTextIn.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        if (this.debugEnabled) {
            this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.leftMostBox.attrs.x,
                    data.leftMostBox.attrs.y,
                    data.horizontalLineStartX,
                    data.horizontalLineStartY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            }));
            this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.rightMostBox.attrs.x + data.rightMostBox.attrs.width,
                    data.rightMostBox.attrs.y,
                    data.horizontalLineEndX,
                    data.horizontalLineEndY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            }));
        }
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
            points: [
                data.horizontalLineStartX,
                data.horizontalLineStartY,
                data.horizontalLineEndX,
                data.horizontalLineEndY
            ],
            stroke: 'black',
            strokeWidth: 6,
            lineCap: 'round',
            lineJoin: 'round'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.horizontalLineStartX,
            y: data.horizontalLineStartY,
            radius: 12,
            fill: 'black'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.horizontalLineEndX,
            y: data.horizontalLineEndY,
            radius: 12,
            fill: 'black'
        }));
        if (this.debugEnabled) this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.horizontalLineTextX,
            y: data.horizontalLineTextY,
            text: data.horizontalLineTextIn.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        else this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.horizontalLineTextX,
            y: data.horizontalLineTextY,
            text: (data.horizontalLineTextFtIn.ft ? data.horizontalLineTextFtIn.ft.toFixed(0) + ' ft ' : '') + data.horizontalLineTextFtIn.in.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        for (const e of this.dimensionsElements)layer.add(e);
    }
    clearBoxDebugElements() {
        for (const g of this.boxDebugElements)for (const el of g.elements)el.destroy();
        this.boxDebugElements.length = 0;
    }
    drawBoxDebugElements(layer, box) {
        if (!this.debugEnabled) {
            this.clearBoxDebugElements();
            return;
        }
        let group = undefined;
        for (const g of this.boxDebugElements)if (g.box === box) {
            group = g;
            break;
        }
        if (group) {
            for (const el of group.elements)el.destroy();
            group.elements.length = 0;
        } else {
            group = {
                box: box,
                elements: []
            };
            this.boxDebugElements.push(group);
        }
        const index = box.attrs.box_index;
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: box.attrs.x,
            y: box.attrs.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: box.attrs.x + box.attrs.width,
            y: box.attrs.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: box.attrs.x + box.attrs.width,
            y: box.attrs.y + box.attrs.height,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: box.attrs.x,
            y: box.attrs.y + box.attrs.height,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: box.attrs.x + box.attrs.width / 2,
            y: box.attrs.y + box.attrs.height / 2 - 20,
            text: `i=${index}`,
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        for (const e of group.elements)layer.add(e);
    }
    getPositionAfterSnaps(box1, box2) {
        const _ll_dist = this.exportedBoxMath.ll_dist(box1, box2);
        const _rr_dist = this.exportedBoxMath.rr_dist(box1, box2);
        const _lr_dist = this.exportedBoxMath.lr_dist(box1, box2);
        const _rl_dist = this.exportedBoxMath.rl_dist(box1, box2);
        const _tt_dist = this.exportedBoxMath.tt_dist(box1, box2);
        const _bb_dist = this.exportedBoxMath.bb_dist(box1, box2);
        const _tb_dist = this.exportedBoxMath.tb_dist(box1, box2);
        const _bt_dist = this.exportedBoxMath.bt_dist(box1, box2);
        let position = {
            x: box1.attrs.x,
            y: box1.attrs.y
        };
        if (Math.abs(_ll_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: box2.attrs.x,
            y: position.y
        };
        if (Math.abs(_rr_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: box2.attrs.x - box1.attrs.width + box2.attrs.width,
            y: position.y
        };
        if (Math.abs(_lr_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: box2.attrs.x + box2.attrs.width,
            y: position.y
        };
        if (Math.abs(_rl_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: box2.attrs.x - box1.attrs.width,
            y: position.y
        };
        if (Math.abs(_tt_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: position.x,
            y: box2.attrs.y
        };
        if (Math.abs(_bb_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: position.x,
            y: box2.attrs.y - box1.attrs.height + box2.attrs.height
        };
        if (Math.abs(_tb_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: position.x,
            y: box2.attrs.y + box2.attrs.height
        };
        if (Math.abs(_bt_dist) < (0, $0793957906d3daac$export$db052f6699d78e91)) position = {
            x: position.x,
            y: box2.attrs.y - box1.attrs.height
        };
        return position;
    }
    changeIsDebug(debug) {
        this.debugEnabled = debug;
    }
}







class $60708be916645dce$export$519b96decaf8bcb9 {
    constructor(){
        this.verticalLineSizePxPerIn = 15.811871842493256;
        this.horizontalLineSizePxPerIn = 14.726467843959004;
        this.debugEnabled = false;
        this.dimensionsElements = [];
        this.exportedBoxMath = new (0, $09f535d0bd749734$export$2eeae5af5390eb78)();
        this.exportedUtils = new (0, $3fc4948ebe2e9d12$export$fc7aaf2dd465e3a8)();
        this.exportedBoxUtils = new (0, $6863f1a9d0ecbe27$export$441453b5c7d2b21c)();
    }
    clearDimensions() {
        for (const e of this.dimensionsElements)e.destroy();
        this.dimensionsElements.length = 0;
    }
    getDimensionsPoints(boxes) {
        const distanceFromBoxes = 50;
        let topMostBox = boxes[0];
        let bottomMostBox = boxes[0];
        let rightMostBox = boxes[0];
        let leftMostBox = boxes[0];
        for(let i = 1; i < boxes.length; i++){
            const currentBox = boxes[i];
            if (topMostBox.attrs.y > currentBox.attrs.y) topMostBox = currentBox;
            if (bottomMostBox.attrs.y + bottomMostBox.attrs.height < currentBox.attrs.y + currentBox.attrs.height) bottomMostBox = currentBox;
            if (rightMostBox.attrs.x + rightMostBox.attrs.width < currentBox.attrs.x + currentBox.attrs.width) rightMostBox = currentBox;
            else if (rightMostBox.attrs.x + rightMostBox.attrs.width === currentBox.attrs.x + currentBox.attrs.width && rightMostBox.attrs.y < currentBox.attrs.y) rightMostBox = currentBox;
            if (leftMostBox.attrs.x > currentBox.attrs.x) leftMostBox = currentBox;
            else if (leftMostBox.attrs.x === currentBox.attrs.x && leftMostBox.attrs.y < currentBox.attrs.y) leftMostBox = currentBox;
        }
        const fa = this.exportedBoxMath.getIsoFa();
        const topMostCube = this.exportedBoxMath.getCubeCornersFromBox(topMostBox);
        const bottomMostCube = this.exportedBoxMath.getCubeCornersFromBox(bottomMostBox);
        const leftMostCube = this.exportedBoxMath.getCubeCornersFromBox(leftMostBox);
        const rightMostCube = this.exportedBoxMath.getCubeCornersFromBox(rightMostBox);
        const topMostCubeBackLineFb = topMostCube.tbr.y - fa * topMostCube.tbr.x;
        const bottomMostCubeBackLineFb = bottomMostCube.bbr.y - fa * bottomMostCube.bbr.x;
        const bottomMostCubeFrontLineFb = bottomMostCube.bfr.y - fa * bottomMostCube.bfr.x;
        const verticalLineStartX = rightMostBox.attrs.x + rightMostBox.attrs.width + distanceFromBoxes;
        const verticalLineStartY = fa * verticalLineStartX + topMostCubeBackLineFb;
        const verticalLineEndX = rightMostBox.attrs.x + rightMostBox.attrs.width + distanceFromBoxes;
        const verticalLineEndY = fa * verticalLineEndX + bottomMostCubeBackLineFb;
        const verticalLineSize = verticalLineEndY - verticalLineStartY;
        const verticalLineTextX = verticalLineStartX + distanceFromBoxes;
        const verticalLineTextY = verticalLineStartY + (verticalLineEndY - verticalLineStartY) / 2;
        const verticalLineTextIn = verticalLineSize / this.verticalLineSizePxPerIn;
        const verticalLineTextFtIn = this.exportedUtils.inToFtAndIn(verticalLineTextIn);
        const horizontalLineStartX = leftMostCube.bfl.x;
        const horizontalLineStartY = fa * horizontalLineStartX + bottomMostCubeFrontLineFb + distanceFromBoxes;
        const horizontalLineEndX = rightMostCube.bfr.x;
        const horizontalLineEndY = fa * horizontalLineEndX + bottomMostCubeFrontLineFb + distanceFromBoxes;
        const horizontalLineSize = this.exportedBoxMath.getDistanceFromPoint(horizontalLineStartX, horizontalLineStartY, horizontalLineEndX, horizontalLineEndY);
        const horizontalLineTextIn = horizontalLineSize / this.horizontalLineSizePxPerIn;
        const horizontalLineTextFtIn = this.exportedUtils.inToFtAndIn(horizontalLineTextIn);
        const horizontalLineTextX = horizontalLineStartX + (horizontalLineEndX - horizontalLineStartX) / 2 - 75;
        const horizontalLineTextY = fa * horizontalLineTextX + bottomMostCubeFrontLineFb + 2 * distanceFromBoxes;
        console.log(`h=${horizontalLineSize}, v=${verticalLineSize}`);
        return {
            topMostCube: topMostCube,
            bottomMostCube: bottomMostCube,
            leftMostCube: leftMostCube,
            rightMostCube: rightMostCube,
            verticalLineStartX: verticalLineStartX,
            verticalLineStartY: verticalLineStartY,
            verticalLineEndX: verticalLineEndX,
            verticalLineEndY: verticalLineEndY,
            verticalLineTextX: verticalLineTextX,
            verticalLineTextY: verticalLineTextY,
            verticalLineTextIn: verticalLineTextIn,
            verticalLineTextFtIn: verticalLineTextFtIn,
            horizontalLineStartX: horizontalLineStartX,
            horizontalLineStartY: horizontalLineStartY,
            horizontalLineEndX: horizontalLineEndX,
            horizontalLineEndY: horizontalLineEndY,
            horizontalLineTextX: horizontalLineTextX,
            horizontalLineTextY: horizontalLineTextY,
            horizontalLineTextIn: horizontalLineTextIn,
            horizontalLineTextFtIn: horizontalLineTextFtIn
        };
    }
    drawDimensions(layer, boxes) {
        this.clearDimensions();
        if (boxes.length <= 0) return;
        const data = this.getDimensionsPoints(boxes);
        if (this.debugEnabled) {
            this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.topMostCube.tbl.x,
                    data.topMostCube.tbl.y,
                    data.verticalLineStartX,
                    data.verticalLineStartY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            }));
            this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.bottomMostCube.bbr.x,
                    data.bottomMostCube.bbr.y,
                    data.verticalLineEndX,
                    data.verticalLineEndY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            }));
        }
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
            points: [
                data.verticalLineStartX,
                data.verticalLineStartY,
                data.verticalLineEndX,
                data.verticalLineEndY
            ],
            stroke: 'black',
            strokeWidth: 6,
            lineCap: 'round',
            lineJoin: 'round'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.verticalLineStartX,
            y: data.verticalLineStartY,
            radius: 12,
            fill: 'black'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.verticalLineEndX,
            y: data.verticalLineEndY,
            radius: 12,
            fill: 'black'
        }));
        if (this.debugEnabled) this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.verticalLineTextX,
            y: data.verticalLineTextY,
            text: data.verticalLineTextIn.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        else this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.verticalLineTextX,
            y: data.verticalLineTextY,
            text: (data.verticalLineTextFtIn.ft ? data.verticalLineTextFtIn.ft.toFixed(0) + ' ft ' : '') + data.verticalLineTextFtIn.in.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        if (this.debugEnabled) {
            var leftMostIsoLine = new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.leftMostCube.tfl.x,
                    data.leftMostCube.tfl.y,
                    data.horizontalLineStartX,
                    data.horizontalLineStartY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            });
            this.dimensionsElements.push(leftMostIsoLine);
            var rightMostIsoLine = new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
                points: [
                    data.rightMostCube.tfr.x,
                    data.rightMostCube.tfr.y,
                    data.horizontalLineEndX,
                    data.horizontalLineEndY
                ],
                stroke: 'black',
                strokeWidth: 6,
                lineCap: 'round',
                lineJoin: 'round',
                dash: [
                    10,
                    10
                ]
            });
            this.dimensionsElements.push(rightMostIsoLine);
        }
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Line({
            points: [
                data.horizontalLineStartX,
                data.horizontalLineStartY,
                data.horizontalLineEndX,
                data.horizontalLineEndY
            ],
            stroke: 'black',
            strokeWidth: 6,
            lineCap: 'round',
            lineJoin: 'round'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.horizontalLineStartX,
            y: data.horizontalLineStartY,
            radius: 12,
            fill: 'black'
        }));
        this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: data.horizontalLineEndX,
            y: data.horizontalLineEndY,
            radius: 12,
            fill: 'black'
        }));
        if (this.debugEnabled) this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.horizontalLineTextX,
            y: data.horizontalLineTextY,
            text: data.horizontalLineTextIn.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        else this.dimensionsElements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: data.horizontalLineTextX,
            y: data.horizontalLineTextY,
            text: (data.horizontalLineTextFtIn.ft ? data.horizontalLineTextFtIn.ft.toFixed(0) + ' ft ' : '') + data.horizontalLineTextFtIn.in.toFixed(1) + ' in',
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        for (const e of this.dimensionsElements)layer.add(e);
    }
    getPositionAfterSnaps(currentBox, otherBox) {
        const additionalSpanDist = 50;
        const isoFa = this.exportedBoxMath.getIsoFa();
        const otherCube = this.exportedBoxMath.getCubeCornersFromBox(otherBox);
        let currentCube = this.exportedBoxMath.getCubeCornersFromBox(currentBox);
        const currentCubeSize = this.exportedBoxUtils.getCubeSize(currentBox);
        const currentBoxWidth = currentBox.attrs.width;
        const currentBoxHeight = currentBox.attrs.height;
        let currentBoxX = currentBox.attrs.x;
        let currentBoxY = currentBox.attrs.y;
        const log = [
            `initial:${currentBoxX},${currentBoxY}`
        ];
        // right line snap, from the right
        if (currentCube.bfl.y + additionalSpanDist > otherCube.tfr.y && currentCube.tfl.y - additionalSpanDist < otherCube.bfr.y) {
            const xDist = currentCube.tfl.x - otherCube.tfr.x;
            if (-(0, $0793957906d3daac$export$db052f6699d78e91) < xDist && xDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxX = currentBoxX - xDist;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`Moved current box (right line, from the right) to: ${currentBoxX},${currentBoxY}`);
            }
        }
        // right line snap, from the left
        if (currentCube.bfr.y + additionalSpanDist > otherCube.tfr.y && currentCube.tfr.y - additionalSpanDist < otherCube.bfr.y) {
            const xDist = otherCube.tfr.x - currentCube.tfr.x;
            if (-(0, $0793957906d3daac$export$db052f6699d78e91) < xDist && xDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxX = currentBoxX + xDist;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`Moved current box (right line, from the left) to: ${currentBoxX},${currentBoxY}`);
            }
        }
        // left line snap, from the left
        if (currentCube.bfr.y + additionalSpanDist > otherCube.tfl.y && currentCube.tfr.y - additionalSpanDist < otherCube.bfl.y) {
            const xDist = otherCube.tfl.x - currentCube.tfr.x;
            if (-(0, $0793957906d3daac$export$db052f6699d78e91) < xDist && xDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxX = currentBoxX + xDist;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`Moved current box (left line, from the left) to: ${currentBoxX},${currentBoxY}`);
            }
        }
        // left line snap, from the right - f1
        if (currentCube.bfl.y + additionalSpanDist > otherCube.tfl.y && currentCube.tfl.y - additionalSpanDist < otherCube.bfl.y) {
            const cubesDist = Math.abs(currentCube.tfl.x - otherCube.tfl.x);
            if (cubesDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxX = otherCube.bfl.x;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`l->r: ${currentBoxX},${currentBoxY}`);
            }
        }
        // top line snap, from the top - f1
        if (currentCube.bfr.x + additionalSpanDist > otherCube.tfl.x && currentCube.bfl.x - additionalSpanDist < otherCube.tfr.x) {
            const fb = otherCube.tfl.y - isoFa * otherCube.tfl.x;
            const currentCubePerpendicularDropY = isoFa * currentCube.bfl.x + fb;
            const currentToOtherDist = Math.abs(currentCubePerpendicularDropY - currentCube.bfl.y);
            if (currentToOtherDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxY = isoFa * currentCube.bfl.x + fb - currentCube.bfl.dTop;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`t->t: ${currentBoxX},${currentBoxY}`);
            }
        }
        // top line snap, from bottom
        if (currentCube.tfr.x + additionalSpanDist > otherCube.tfl.x && currentCube.tfl.x - additionalSpanDist < otherCube.tfr.x) {
            const a = (otherCube.tfl.y - otherCube.tfr.y) / (otherCube.tfl.x - otherCube.tfr.x);
            const b = (otherCube.tfl.x * otherCube.tfr.y - otherCube.tfr.x * otherCube.tfl.y) / (otherCube.tfl.x - otherCube.tfr.x);
            const currentCubePerpendicularDropY = a * currentCube.tfl.x + b;
            const yDist = currentCube.tfl.y - currentCubePerpendicularDropY;
            if (-(0, $0793957906d3daac$export$db052f6699d78e91) < yDist && yDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxY = currentBoxY - yDist;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`Moved current box (top line, from the bottom) to: ${currentBoxX},${currentBoxY}`);
            }
        }
        // bottom line snap, from the bottom
        if (currentCube.tfr.x + additionalSpanDist > otherCube.bfl.x && currentCube.tfl.x - additionalSpanDist < otherCube.bfr.x) {
            const a = (otherCube.bfl.y - otherCube.bfr.y) / (otherCube.bfl.x - otherCube.bfr.x);
            const b = (otherCube.bfl.x * otherCube.bfr.y - otherCube.bfr.x * otherCube.bfl.y) / (otherCube.bfl.x - otherCube.bfr.x);
            const currentCubePerpendicularDropY = a * currentCube.tfl.x + b;
            const yDist = currentCube.tfl.y - currentCubePerpendicularDropY;
            if (-(0, $0793957906d3daac$export$db052f6699d78e91) < yDist && yDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxY = currentBoxY - yDist;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`Moved current box (bottom line, from the bottom) to: ${currentBoxX},${currentBoxY}`);
            }
        }
        // bottom line snap, from the top
        if (currentCube.bfr.x + additionalSpanDist > otherCube.bfl.x && currentCube.bfl.x - additionalSpanDist < otherCube.bfr.x) {
            const a = (otherCube.bfl.y - otherCube.bfr.y) / (otherCube.bfl.x - otherCube.bfr.x);
            const b = (otherCube.bfl.x * otherCube.bfr.y - otherCube.bfr.x * otherCube.bfl.y) / (otherCube.bfl.x - otherCube.bfr.x);
            const currentCubePerpendicularDropY = a * currentCube.bfl.x + b;
            const yDist = currentCubePerpendicularDropY - currentCube.bfl.y;
            if (-(0, $0793957906d3daac$export$db052f6699d78e91) < yDist && yDist < (0, $0793957906d3daac$export$db052f6699d78e91)) {
                currentBoxY = currentBoxY + yDist;
                currentCube = this.exportedBoxMath.getCubeCornersFromProps(currentCubeSize, currentBoxX, currentBoxWidth, currentBoxY, currentBoxHeight);
                log.push(`Moved current box (bottom line, from the top) to: ${currentBoxX},${currentBoxY}`);
            }
        }
        return {
            x: currentBoxX,
            y: currentBoxY
        };
    }
    changeIsDebug(debug) {
        this.debugEnabled = debug;
    }
}





class $f7d5848a7a9e84b0$export$712c29b8a1deb8a4 {
    constructor(){
        this.isDebug = false;
        this.cubeGroups = [];
        this.focusGroups = [];
        this.exportedBoxMath = new (0, $09f535d0bd749734$export$2eeae5af5390eb78)();
    }
    clearAll() {
        for (const g of this.cubeGroups)for (const el of g.elements)el.destroy();
        this.cubeGroups.length = 0;
        for (const g of this.focusGroups)for (const el of g.elements)el.destroy();
        this.focusGroups.length = 0;
    }
    drawFocusOrder(layer, orderedBoxes) {
        if (!this.isDebug) {
            this.clearAll();
            return;
        }
        for(let i = 0; i < orderedBoxes.length; i++){
            const box = orderedBoxes[i];
            let group = undefined;
            for (const g of this.focusGroups)if (g.box === box) {
                group = g;
                break;
            }
            if (group) {
                for (const el of group.elements)el.destroy();
                group.elements.length = 0;
            } else {
                group = {
                    box: box,
                    elements: []
                };
                this.focusGroups.push(group);
            }
            group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
                x: box.attrs.x + box.attrs.width / 2,
                y: box.attrs.y + box.attrs.height / 2 + 20,
                text: `f=${orderedBoxes.length - i}`,
                fontSize: 50,
                fontFamily: 'Calibri',
                fill: 'black'
            }));
        }
        for (const group of this.focusGroups)for (const e of group.elements)layer.add(e);
    }
    drawCube(layer, box) {
        if (!this.isDebug) {
            this.clearAll();
            return;
        }
        let group = undefined;
        for (const g of this.cubeGroups)if (g.box === box) {
            group = g;
            break;
        }
        if (group) {
            for (const el of group.elements)el.destroy();
            group.elements.length = 0;
        } else {
            group = {
                box: box,
                elements: []
            };
            this.cubeGroups.push(group);
        }
        const cube = this.exportedBoxMath.getCubeCornersFromBox(box);
        const index = box.attrs.box_index;
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: cube.tfl.x,
            y: cube.tfl.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: cube.tfr.x,
            y: cube.tfr.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: cube.tbl.x,
            y: cube.tbl.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: cube.tbr.x,
            y: cube.tbr.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: cube.bfl.x,
            y: cube.bfl.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: cube.bfr.x,
            y: cube.bfr.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Circle({
            x: cube.bbr.x,
            y: cube.bbr.y,
            radius: 2,
            fill: 'red'
        }));
        group.elements.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Text({
            x: box.attrs.x + box.attrs.width / 2,
            y: box.attrs.y + box.attrs.height / 2 - 20,
            text: `i=${index}`,
            fontSize: 50,
            fontFamily: 'Calibri',
            fill: 'black'
        }));
        if (box.attrs.strokeWidth <= 1) {
            box.stroke('black');
            box.strokeWidth(1);
        }
        for (const e of group.elements)layer.add(e);
    }
    focus() {
        if (!this.isDebug) {
            this.clearAll();
            return;
        }
        for (const group of this.cubeGroups)for (const e of group.elements)e.moveToTop();
        for (const group of this.focusGroups)for (const e of group.elements)e.moveToTop();
    }
    changeIsDebug(debug) {
        this.isDebug = debug;
    }
}


class $75001462f4ec7917$export$5ba72be27215a2ba {
    constructor(){
        this.viewIso = "iso";
        this.view2D = "2d";
        this.render2dSmallWidth = 212;
        this.render2dWideWidth = 309;
        this.render2dTallWidth = 212;
        this.render2dLargeWidth = 309;
        this.renderIsoSmallWidth = 336;
        this.renderIsoTallWidth = 336;
        this.renderIsoWideWidth = 431.5;
        this.renderIsoLargeWidth = 432;
        this.render2dSmallHeight = 229;
        this.render2dWideHeight = 229;
        this.render2dTallHeight = 334;
        this.render2dLargeHeight = 334;
        this.renderIsoSmallHeight = 336;
        this.renderIsoTallHeight = 439.7;
        this.renderIsoWideHeight = 352;
        this.renderIsoLargeHeight = 456.9;
        this.refocusSetTimeoutId = undefined;
        this.currentView = this.viewIso;
        this.isDebug = false;
        this.stage = undefined;
        this.layer = undefined;
        this.boxService = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).boxService;
        this.imagesService = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).images;
        this.exportedBoxUtils = new (0, $6863f1a9d0ecbe27$export$441453b5c7d2b21c)();
        this.exportedBoxIso = new (0, $60708be916645dce$export$519b96decaf8bcb9)();
        this.exportedBoxIsoDebug = new (0, $f7d5848a7a9e84b0$export$712c29b8a1deb8a4)();
        this.exportedBox2D = new (0, $ef3d34a4ad380339$export$9cdc346d0f00b337)();
        this.exportedBoxMath = new (0, $09f535d0bd749734$export$2eeae5af5390eb78)();
    }
    drawBoxDebug(box) {
        if (this.currentView === this.viewIso) this.exportedBoxIsoDebug.drawCube(this.layer, box);
        else this.exportedBox2D.drawBoxDebugElements(this.layer, box);
    }
    getShelfDimensions(cubeSize) {
        let renderHeight, renderWidth, imgWidth, imgHeight;
        if (this.currentView === this.viewIso) switch(cubeSize){
            case 0, $0793957906d3daac$export$d6547b117d1dcd45:
            case 0, $0793957906d3daac$export$878e4a3737c08e85:
                renderWidth = this.renderIsoSmallWidth;
                renderHeight = this.renderIsoSmallHeight;
                imgWidth = (0, $0793957906d3daac$export$f421779aac23045c);
                imgHeight = (0, $0793957906d3daac$export$d6b441449057984);
                break;
            case 0, $0793957906d3daac$export$63cff6b6d7f669bf:
            case 0, $0793957906d3daac$export$12b7a355343dd343:
                renderWidth = this.renderIsoTallWidth;
                renderHeight = this.renderIsoTallHeight;
                imgWidth = (0, $0793957906d3daac$export$142960671d3dc6f5);
                imgHeight = (0, $0793957906d3daac$export$4b14f9b014a3c13c);
                break;
            case 0, $0793957906d3daac$export$cb58b2ba04527c22:
                renderWidth = this.renderIsoWideWidth;
                renderHeight = this.renderIsoWideHeight;
                imgWidth = (0, $0793957906d3daac$export$6bfd500da6b6cbc6);
                imgHeight = (0, $0793957906d3daac$export$31f240599c3e8939);
                break;
            case 0, $0793957906d3daac$export$e7aa9ee549f9e84:
                renderWidth = this.renderIsoLargeWidth;
                renderHeight = this.renderIsoLargeHeight;
                imgWidth = (0, $0793957906d3daac$export$b4898baa7c6c0fe7);
                imgHeight = (0, $0793957906d3daac$export$75770282914a2a30);
                break;
        }
        else switch(cubeSize){
            case 0, $0793957906d3daac$export$d6547b117d1dcd45:
            case 0, $0793957906d3daac$export$878e4a3737c08e85:
                renderWidth = this.render2dSmallWidth;
                renderHeight = this.render2dSmallHeight;
                imgWidth = (0, $0793957906d3daac$export$de17a50c252cc740);
                imgHeight = (0, $0793957906d3daac$export$e56dc67f1368e1b);
                break;
            case 0, $0793957906d3daac$export$cb58b2ba04527c22:
                renderWidth = this.render2dWideWidth;
                renderHeight = this.render2dWideHeight;
                imgWidth = (0, $0793957906d3daac$export$ea0179eb6098a50c);
                imgHeight = (0, $0793957906d3daac$export$7a80096d7171d2c);
                break;
            case 0, $0793957906d3daac$export$63cff6b6d7f669bf:
            case 0, $0793957906d3daac$export$12b7a355343dd343:
                renderWidth = this.render2dTallWidth;
                renderHeight = this.render2dTallHeight;
                imgWidth = (0, $0793957906d3daac$export$d1e0c6e204ad8d05);
                imgHeight = (0, $0793957906d3daac$export$b004b696ce1a358c);
                break;
            case 0, $0793957906d3daac$export$e7aa9ee549f9e84:
                renderWidth = this.render2dLargeWidth;
                renderHeight = this.render2dLargeHeight;
                imgWidth = (0, $0793957906d3daac$export$4f60e2783b9b26f5);
                imgHeight = (0, $0793957906d3daac$export$659764b2ab65178d);
                break;
        }
        return {
            imgWidth: imgWidth,
            imgHeight: imgHeight,
            renderWidth: renderWidth,
            renderHeight: renderHeight,
            scaleX: renderWidth / (imgWidth + 1),
            scaleY: renderHeight / (imgHeight + 1)
        };
    }
    addShelf(config) {
        const cube_size = config.size;
        const dimensions = this.getShelfDimensions(cube_size);
        const cmd = {
            size: config.size,
            x: config.x || -this.stage.x() / this.stage.scaleX() + 80,
            y: config.y || -this.stage.y() / this.stage.scaleX() + 80,
            scaleX: dimensions.scaleX,
            scaleY: dimensions.scaleY,
            width: dimensions.renderWidth,
            height: dimensions.renderHeight,
            back: config.back,
            door: config.door,
            drawers: config.drawers,
            shelf: config.shelf,
            direction: config.direction,
            crossDivider: config.crossDivider
        };
        const box = this.boxService.createBox(cmd, (boxProps)=>new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Rect(boxProps));
        if (box) {
            box.on("dragstart", ()=>{
                box.moveToTop();
            });
            box.on("dragmove", (event)=>{
                const currentBox = box;
                currentBox.strokeWidth(0);
                this.exportedBoxUtils.setPosition(currentBox, currentBox.attrs.x, currentBox.attrs.y);
                for (const b of this.boxService.getKonvoBoxes()){
                    if (currentBox !== b) {
                        if (!event.evt.shiftKey) {
                            let newPosition;
                            if (this.currentView === this.viewIso) newPosition = this.exportedBoxIso.getPositionAfterSnaps(currentBox, b);
                            else newPosition = this.exportedBox2D.getPositionAfterSnaps(currentBox, b);
                            this.exportedBoxUtils.setPosition(currentBox, newPosition.x, newPosition.y);
                        }
                    }
                }
                this.layer.draw();
                this.refocusBoxes();
            });
            box.on("dragend", ()=>{
                this.drawDimensions();
                this.drawBoxDebug(box);
                this.layer.draw();
            });
            this.layer.add(box);
            this.drawBox(box);
            this.drawDimensions();
            this.drawBoxDebug(box);
        }
        return box;
    }
    toggleColor() {
        this.boxService.toggleColor();
        for (const box of this.boxService.getKonvoBoxes())this.drawBox(box);
    }
    drawDimensions() {
        if (this.currentView === this.viewIso) this.exportedBoxIso.drawDimensions(this.layer, this.boxService.getKonvoBoxes());
        else this.exportedBox2D.drawDimensions(this.layer, this.boxService.getKonvoBoxes());
        this.layer.draw();
    }
    refocusBoxes() {
        if (this.currentView === this.viewIso) {
            if (this.refocusSetTimeoutId) clearTimeout(this.refocusSetTimeoutId);
            this.refocusSetTimeoutId = setTimeout(()=>{
                const focusBoxes = [
                    ...this.boxService.getKonvoBoxes()
                ];
                const orderedBoxes = [];
                while(focusBoxes.length > 0){
                    let frontMostBoxIndex = 0;
                    let attempts = 1, movement = true;
                    while(movement && attempts <= 10){
                        movement = false;
                        for(let i = 0; i < focusBoxes.length; i++)if (frontMostBoxIndex !== i && this.exportedBoxMath.isUnderBox(focusBoxes[frontMostBoxIndex], focusBoxes[i])) {
                            frontMostBoxIndex = i;
                            movement = true;
                        }
                        attempts++;
                    }
                    orderedBoxes.push(focusBoxes[frontMostBoxIndex]);
                    focusBoxes.splice(frontMostBoxIndex, 1);
                }
                this.exportedBoxIsoDebug.drawFocusOrder(this.layer, orderedBoxes);
                for(let i = orderedBoxes.length - 1; i >= 0; i--)orderedBoxes[i].moveToTop();
                this.exportedBoxIsoDebug.focus();
                this.layer.draw();
            }, 50);
        }
    }
    changeIsDebug(debug) {
        this.isDebug = debug;
        this.exportedBoxUtils.changeIsDebug(debug);
        this.exportedBoxIso.changeIsDebug(debug);
        this.exportedBoxIsoDebug.changeIsDebug(debug);
        this.exportedBox2D.changeIsDebug(debug);
    }
    printBoxDebug() {
        for (const box of this.boxService.getKonvoBoxes()){
            const index = box.attrs.box_index;
            const x = box.attrs.x;
            const y = box.attrs.y;
            const width = box.attrs.width;
            const height = box.attrs.height;
            console.log(`box ${index}: (${x},${y}) width=${width} height=${height}`);
        }
    }
    zoom(scaleIn) {
        const scaleBy = 1.1;
        const oldScale = this.stage.scaleX();
        const pointer = {
            x: this.stage.width() / 2,
            y: this.stage.height() / 2
        };
        const mousePointTo = {
            x: (pointer.x - this.stage.x()) / oldScale,
            y: (pointer.y - this.stage.y()) / oldScale
        };
        const newScale = scaleIn ? oldScale * scaleBy : oldScale / scaleBy;
        this.stage.scale({
            x: newScale,
            y: newScale
        });
        const newPos = {
            x: pointer.x - mousePointTo.x * newScale,
            y: pointer.y - mousePointTo.y * newScale
        };
        this.stage.position(newPos);
        this.stage.draw();
    }
    setZoom(zoom) {
        this.stage.scale({
            x: zoom,
            y: zoom
        });
        this.stage.draw();
    }
    getZoom() {
        const zoom = this.stage.scaleX();
        return zoom;
    }
    getStagePosition() {
        const position = {
            x: this.stage.x() / this.stage.scaleX(),
            y: this.stage.y() / this.stage.scaleX()
        };
        return position;
    }
    setStagePosition(x, y) {
        const position = {
            x: x * this.stage.scaleX(),
            y: y * this.stage.scaleX()
        };
        this.stage.position(position);
        this.stage.draw();
    }
    getStage() {
        return this.stage;
    }
    setStage(stage) {
        this.stage = stage;
    }
    getLayer() {
        return this.layer;
    }
    setLayer(layer) {
        this.layer = layer;
    }
    getBoxes() {
        return this.boxService.getKonvoBoxes();
    }
    getColor() {
        return this.boxService.getColor();
    }
    setColor(color) {
        this.boxService.setColor(color);
    }
    getView() {
        return this.currentView;
    }
    setView(view) {
        if (view === this.view2D) this.currentView = this.view2D;
        else this.currentView = this.viewIso;
    }
    isIsoView() {
        return this.currentView === this.viewIso;
    }
    drawBoxes() {
        for (const box of this.boxService.getKonvoBoxes()){
            this.drawBox(box);
            this.drawBoxDebug(box);
        }
        this.drawDimensions();
    }
    drawBox(box) {
        const image = this.boxService.getImage(this.currentView, box);
        box.fillPatternImage(image);
        this.stage.draw();
    }
    toggleView() {
        const boxes = this.boxService.getKonvoBoxes();
        if (this.currentView === this.viewIso) {
            this.currentView = this.view2D;
            this.exportedBoxIso.clearDimensions();
            this.exportedBoxIsoDebug.clearAll();
            for(let i = 0; i < boxes.length; i++){
                const box = boxes[i];
                const cubeSize = this.exportedBoxUtils.getCubeSize(box);
                const renderOrigin = this.exportedBoxMath.get2DCubeOriginFromIsoBox(box);
                const newX = renderOrigin.x;
                const newY = renderOrigin.y;
                const dimensions = this.getShelfDimensions(cubeSize);
                const newWidth = dimensions.renderWidth;
                const newHeight = dimensions.renderHeight;
                this.exportedBoxUtils.setPosition(box, newX, newY);
                box.setWidth(newWidth);
                box.setHeight(newHeight);
                box.setFillPatternScaleX(dimensions.scaleX);
                box.setFillPatternScaleY(dimensions.scaleY);
                this.drawBox(box);
            }
        } else {
            this.currentView = this.viewIso;
            this.exportedBox2D.clearDimensions();
            this.exportedBox2D.clearBoxDebugElements();
            for(let i = 0; i < boxes.length; i++){
                const box = boxes[i];
                const cubeSize = this.exportedBoxUtils.getCubeSize(box);
                const dimensions = this.getShelfDimensions(cubeSize);
                const newWidth = dimensions.renderWidth;
                const newHeight = dimensions.renderHeight;
                const cubeOrigin = this.exportedBoxMath.getIsoCubeOriginFrom2DCubeOrigin(box);
                const imgOrigin = this.exportedBoxMath.getIsoImgOriginFromIsoCubeOrigin(cubeSize, cubeOrigin.x, newWidth, cubeOrigin.y, newHeight);
                this.exportedBoxUtils.setPosition(box, imgOrigin.x, imgOrigin.y);
                box.setWidth(newWidth);
                box.setHeight(newHeight);
                box.setFillPatternScaleX(dimensions.scaleX);
                box.setFillPatternScaleY(dimensions.scaleY);
                this.drawBox(box);
            }
        }
        this.drawDimensions();
        this.refocusBoxes();
    }
    getBoxService() {
        return this.boxService;
    }
    getImagesService() {
        return this.imagesService;
    }
}



var $74c72655ccba3742$exports = {};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $74c72655ccba3742$exports = factory();
})($74c72655ccba3742$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command('cut');
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
                    var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS
                    fakeElement.style.fontSize = '12pt'; // Reset box model
                    fakeElement.style.border = '0';
                    fakeElement.style.padding = '0';
                    fakeElement.style.margin = '0'; // Move element out of screen horizontally
                    fakeElement.style.position = 'absolute';
                    fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute('readonly', '');
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command('copy');
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = '';
                    if (typeof target === 'string') selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        'text',
                        'search',
                        'url',
                        'tel',
                        'password'
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command('copy');
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? 'copy' : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== 'copy' && action !== 'cut') throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
                            if (action === 'copy' && target.hasAttribute('disabled')) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === 'cut' ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, 'click', function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || 'copy';
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? 'success' : 'error', {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue('action', trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue('target', trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue('text', trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    'copy',
                                    'cut'
                                ];
                                var actions = typeof action === 'string' ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== 'undefined' && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === 'function' && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === 'function') return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === 'function') // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === 'string') elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === 'string' || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === '[object Function]';
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error('Missing required arguments');
                    if (!is.string(type)) throw new TypeError('Second argument must be a String');
                    if (!is.fn(callback)) throw new TypeError('Third argument must be a Function');
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === 'SELECT') {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                        var isReadOnly = element.hasAttribute('readonly');
                        if (!isReadOnly) element.setAttribute('readonly', '');
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute('readonly');
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute('contenteditable')) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});



var $Oecye = parcelRequire("Oecye");

class $8c180ab58e07e245$export$27a5bd065ad55220 {
    static enableTallBox() {
        const el = document.querySelector('.add-cube__tall');
        if (el) this.enableCubesMenuItem(el);
    }
    static disableTallBox() {
        const el = document.querySelector('.add-cube__tall');
        if (el) this.disableCubesMenuItem(el);
    }
    static enableCorner(type) {
        if (type.is((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).tallCorner)) {
            const el = document.querySelector('.add-cube__tall-corner');
            this.enableCubesMenuItem(el);
        }
        if (type.is((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).smallCorner)) {
            const el = document.querySelector('.add-cube__small-corner');
            this.enableCubesMenuItem(el);
        }
    }
    static disableCorner(type) {
        if (type.is((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).tallCorner)) {
            const el = document.querySelector('.add-cube__tall-corner');
            this.disableCubesMenuItem(el);
        }
        if (type.is((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).smallCorner)) {
            const el = document.querySelector('.add-cube__small-corner');
            this.disableCubesMenuItem(el);
        }
    }
    static enableDisableCubeOptionInMenu(enable, part) {
        if (enable) {
            const doc = document.querySelector(`.style-button-${part}`);
            this.enableCubeMenuItem(doc);
        } else {
            const doc = document.querySelector(`.style-button-${part}`);
            this.disableCubeMenuItem(doc);
        }
    }
    static showHideCubeMenuItem(show, part) {
        if (show) {
            const doc = document.querySelector(`.style-button-${part}`);
            this.showElement(doc);
        } else {
            const doc = document.querySelector(`.style-button-${part}`);
            this.hideElement(doc);
        }
    }
    static showHideCubeMenuUsageNote(show) {
        if (show) {
            const doc = document.querySelector(`.style-info`);
            this.showElement(doc);
        } else {
            const doc = document.querySelector(`.style-info`);
            this.hideElement(doc);
        }
    }
    static showHideCubeMenuNote(show) {
        if (show) {
            const doc = document.querySelector(`.style-cube-info`);
            this.showElement(doc);
        } else {
            const doc = document.querySelector(`.style-cube-info`);
            this.hideElement(doc);
        }
    }
    static updateCubeSelectionInMenu(enable, part, text) {
        if (enable) {
            const doc = document.querySelector(`.style-button-${part}`);
            if (doc.lastElementChild.classList.contains('border-transparent') && !doc.lastElementChild.classList.contains('border-indigo-500')) {
                doc.lastElementChild.classList.remove('border-transparent');
                doc.lastElementChild.classList.add('border-indigo-500');
            }
            const buttonTextElement = doc.querySelector(".style-button-text");
            if (buttonTextElement && text) buttonTextElement.innerHTML = text;
        } else {
            const doc = document.querySelector(`.style-button-${part}`);
            if (doc.lastElementChild.classList.contains('border-indigo-500') && !doc.lastElementChild.classList.contains('border-transparent')) {
                doc.lastElementChild.classList.remove('border-indigo-500');
                doc.lastElementChild.classList.add('border-transparent');
            }
            const buttonTextElement = doc.querySelector(".style-button-text");
            if (buttonTextElement && text) buttonTextElement.innerHTML = text;
        }
    }
    static updateButtons(color) {
        const toggleButton = document.getElementById('toggle-color-button');
        if (toggleButton) {
            if (color === "n") toggleButton.innerHTML = 'Natural finish';
            else toggleButton.innerHTML = 'Walnut finish';
        }
    }
    static enableCubeMenuItem(element) {
        element.classList.remove('bg-gray-300');
        element.classList.remove('cursor-not-allowed');
        element.classList.add('hover:border-gray-400');
        element.classList.add('cursor-pointer');
    }
    static disableCubeMenuItem(element) {
        element.classList.remove('hover:border-gray-400');
        element.classList.remove('cursor-pointer');
        element.classList.add('bg-gray-300');
        element.classList.add('cursor-not-allowed');
    }
    static disableCubesMenuItem(element) {
        element.classList.add('bg-gray-300');
        element.classList.add('cursor-not-allowed');
        element.classList.remove('bg-blue-600');
        element.classList.remove('hover:bg-blue-700');
        element.classList.remove('cursor-pointer');
        if (element instanceof HTMLButtonElement) element.disabled = true;
    }
    static enableCubesMenuItem(element) {
        element.classList.remove('bg-gray-300');
        element.classList.remove('cursor-not-allowed');
        element.classList.add('bg-blue-600');
        element.classList.add('hover:bg-blue-700');
        element.classList.add('cursor-pointer');
        if (element instanceof HTMLButtonElement) element.disabled = false;
    }
    static showElement(element) {
        if (element.classList.contains('hidden') && !element.classList.contains('sm:flex')) {
            element.classList.remove('hidden');
            element.classList.add('sm:flex');
        }
    }
    static hideElement(element) {
        if (!element.classList.contains('hidden') && element.classList.contains('sm:flex')) {
            element.classList.add('hidden');
            element.classList.remove('sm:flex');
        }
    }
}




class $dc8d4df4579eb854$export$bd0bf19f25da8474 {
    static toggleColor(current_box) {
        const boxService = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).boxService;
        boxService.toggleColor();
        this.updateCubesMenu();
        const selectedStillExists = current_box !== undefined && boxService.getKonvoBoxes().includes(current_box);
        this.updateCubeMenu(selectedStillExists ? current_box : undefined);
        (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateButtons(boxService.getColor());
    }
    static updateCubeMenu(current_box) {
        if (current_box !== undefined) {
            const boxService = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).boxService;
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuUsageNote(false);
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "delete");
            if (boxService.isCorner(current_box)) {
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "back");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "door");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "shelves");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "top-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "middle-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "bottom-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "cross-divider");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "corner");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuNote(false);
            } else {
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "back");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "door");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "shelves");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "top-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "middle-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "bottom-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(true, "cross-divider");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "corner");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateCubeSelectionInMenu(boxService.hasBack(current_box), "back");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateCubeSelectionInMenu(boxService.hasDoors(current_box), "door");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateCubeSelectionInMenu(boxService.hasShelves(current_box), "shelves", "Shelves (" + boxService.getShelvesCount(current_box) + ")");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateCubeSelectionInMenu(boxService.hasTopDrawer(current_box), "top-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateCubeSelectionInMenu(boxService.hasMiddleDrawer(current_box), "middle-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateCubeSelectionInMenu(boxService.hasBottomDrawer(current_box), "bottom-drawer");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).updateCubeSelectionInMenu(boxService.hasCrossDivider(current_box), "cross-divider");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).enableDisableCubeOptionInMenu(boxService.supportsBack(current_box), "back");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).enableDisableCubeOptionInMenu(boxService.supportsCrossDivider(current_box), "cross-divider");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).enableDisableCubeOptionInMenu(boxService.supportsDoor(current_box), "door");
                (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuNote(true);
            }
        } else {
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuUsageNote(true);
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "delete");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "back");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "door");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "shelves");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "top-drawer");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "middle-drawer");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "bottom-drawer");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "corner");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuItem(false, "cross-divider");
            (0, $8c180ab58e07e245$export$27a5bd065ad55220).showHideCubeMenuNote(false);
        }
    }
    static updateCubesMenu() {
        const boxService = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).boxService;
        if (boxService.isTallBoxAvailable()) (0, $8c180ab58e07e245$export$27a5bd065ad55220).enableTallBox();
        else (0, $8c180ab58e07e245$export$27a5bd065ad55220).disableTallBox();
        if (boxService.isCornerAvailable((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).tallCorner)) (0, $8c180ab58e07e245$export$27a5bd065ad55220).enableCorner((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).tallCorner);
        else (0, $8c180ab58e07e245$export$27a5bd065ad55220).disableCorner((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).tallCorner);
        if (boxService.isCornerAvailable((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).smallCorner)) (0, $8c180ab58e07e245$export$27a5bd065ad55220).enableCorner((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).smallCorner);
        else (0, $8c180ab58e07e245$export$27a5bd065ad55220).disableCorner((0, $57c8ce737201aade$export$d5f710d0ccaeafcf).smallCorner);
    }
}



var $Oecye = parcelRequire("Oecye");
function $4dda62ba91820c29$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4dda62ba91820c29$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4dda62ba91820c29$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4dda62ba91820c29$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4dda62ba91820c29$export$2e2bcd8739ae039 = $4dda62ba91820c29$export$4f5d2d50c9deca37;


"use client";
function $67275d632676f03f$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$67275d632676f03f$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{margin-bottom:0;border-radius:0}}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:0 4px 12px #0000001a;max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $67275d632676f03f$var$L = (t)=>typeof t == "number" && !isNaN(t), $67275d632676f03f$var$N = (t)=>typeof t == "string", $67275d632676f03f$var$P = (t)=>typeof t == "function", $67275d632676f03f$var$mt = (t)=>$67275d632676f03f$var$N(t) || $67275d632676f03f$var$L(t), $67275d632676f03f$var$B = (t)=>$67275d632676f03f$var$N(t) || $67275d632676f03f$var$P(t) ? t : null, $67275d632676f03f$var$pt = (t, o)=>t === !1 || $67275d632676f03f$var$L(t) && t > 0 ? t : o, $67275d632676f03f$var$z = (t)=>(0, $Oecye.isValidElement)(t) || $67275d632676f03f$var$N(t) || $67275d632676f03f$var$P(t) || $67275d632676f03f$var$L(t);
function $67275d632676f03f$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $67275d632676f03f$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $Oecye.useRef)(0);
        return (0, $Oecye.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $Oecye.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $67275d632676f03f$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).Fragment, null, a);
    };
}
function $67275d632676f03f$var$J(t, o) {
    return {
        content: $67275d632676f03f$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $67275d632676f03f$var$tt(t, o, e = !1) {
    return (0, $Oecye.isValidElement)(t) && !$67275d632676f03f$var$N(t.type) ? (0, $Oecye.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $67275d632676f03f$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $67275d632676f03f$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $67275d632676f03f$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $4dda62ba91820c29$export$2e2bcd8739ae039)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $67275d632676f03f$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $4dda62ba91820c29$export$2e2bcd8739ae039)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $67275d632676f03f$var$Xt = 1, $67275d632676f03f$var$at = ()=>`${$67275d632676f03f$var$Xt++}`;
function $67275d632676f03f$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($67275d632676f03f$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([w, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $67275d632676f03f$var$B(n.className || d.toastClassName),
                progressClassName: $67275d632676f03f$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $67275d632676f03f$var$pt(n.autoClose, d.autoClose),
                closeToast (w) {
                    c.get(u).removalReason = w, E(u);
                },
                deleteToast () {
                    let w = c.get(u);
                    if (w != null) {
                        if (e($67275d632676f03f$var$J(w, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $67275d632676f03f$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $67275d632676f03f$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $67275d632676f03f$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $67275d632676f03f$var$I = new Map, $67275d632676f03f$var$F = [], $67275d632676f03f$var$st = new Set, $67275d632676f03f$var$Vt = (t)=>$67275d632676f03f$var$st.forEach((o)=>o(t)), $67275d632676f03f$var$bt = ()=>$67275d632676f03f$var$I.size > 0;
function $67275d632676f03f$var$Qt() {
    $67275d632676f03f$var$F.forEach((t)=>$67275d632676f03f$var$nt(t.content, t.options)), $67275d632676f03f$var$F = [];
}
var $67275d632676f03f$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $67275d632676f03f$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $67275d632676f03f$var$X(t, o) {
    var r;
    if (o) return !!((r = $67275d632676f03f$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $67275d632676f03f$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $67275d632676f03f$var$ht(t) {
    if (!$67275d632676f03f$var$bt()) {
        $67275d632676f03f$var$F = $67275d632676f03f$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $67275d632676f03f$var$mt(t)) $67275d632676f03f$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $67275d632676f03f$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $67275d632676f03f$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $67275d632676f03f$var$Ct = (t = {})=>{
    $67275d632676f03f$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $67275d632676f03f$var$nt(t, o) {
    $67275d632676f03f$var$z(t) && ($67275d632676f03f$var$bt() || $67275d632676f03f$var$F.push({
        content: t,
        options: o
    }), $67275d632676f03f$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $67275d632676f03f$var$xt(t) {
    var o;
    (o = $67275d632676f03f$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $67275d632676f03f$var$rt(t, o) {
    $67275d632676f03f$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $67275d632676f03f$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $67275d632676f03f$var$_t(o, t, $67275d632676f03f$var$Vt);
            $67275d632676f03f$var$I.set(o, r);
            let s = r.observe(e);
            return $67275d632676f03f$var$Qt(), ()=>{
                s(), $67275d632676f03f$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $67275d632676f03f$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $67275d632676f03f$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $67275d632676f03f$var$Pt(t) {
    return $67275d632676f03f$var$st.add(t), ()=>{
        $67275d632676f03f$var$st.delete(t);
    };
}
function $67275d632676f03f$var$Wt(t) {
    return t && ($67275d632676f03f$var$N(t.toastId) || $67275d632676f03f$var$L(t.toastId)) ? t.toastId : $67275d632676f03f$var$at();
}
function $67275d632676f03f$var$U(t, o) {
    return $67275d632676f03f$var$nt(t, o), o.toastId;
}
function $67275d632676f03f$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $67275d632676f03f$var$Wt(o)
    };
}
function $67275d632676f03f$var$Q(t) {
    return (o, e)=>$67275d632676f03f$var$U(o, $67275d632676f03f$var$V(t, e));
}
function $67275d632676f03f$export$b410431fab84fa58(t, o) {
    return $67275d632676f03f$var$U(t, $67275d632676f03f$var$V("default", o));
}
$67275d632676f03f$export$b410431fab84fa58.loading = (t, o)=>$67275d632676f03f$var$U(t, $67275d632676f03f$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $67275d632676f03f$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $67275d632676f03f$var$N(o) ? $67275d632676f03f$export$b410431fab84fa58.loading(o, s) : $67275d632676f03f$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $67275d632676f03f$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $67275d632676f03f$var$N(g) ? {
            render: g
        } : g;
        return l ? $67275d632676f03f$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $67275d632676f03f$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $67275d632676f03f$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$67275d632676f03f$export$b410431fab84fa58.promise = $67275d632676f03f$var$Gt;
$67275d632676f03f$export$b410431fab84fa58.success = $67275d632676f03f$var$Q("success");
$67275d632676f03f$export$b410431fab84fa58.info = $67275d632676f03f$var$Q("info");
$67275d632676f03f$export$b410431fab84fa58.error = $67275d632676f03f$var$Q("error");
$67275d632676f03f$export$b410431fab84fa58.warning = $67275d632676f03f$var$Q("warning");
$67275d632676f03f$export$b410431fab84fa58.warn = $67275d632676f03f$export$b410431fab84fa58.warning;
$67275d632676f03f$export$b410431fab84fa58.dark = (t, o)=>$67275d632676f03f$var$U(t, $67275d632676f03f$var$V("default", {
        theme: "dark",
        ...o
    }));
function $67275d632676f03f$var$qt(t) {
    $67275d632676f03f$var$ht(t);
}
$67275d632676f03f$export$b410431fab84fa58.dismiss = $67275d632676f03f$var$qt;
$67275d632676f03f$export$b410431fab84fa58.clearWaitingQueue = $67275d632676f03f$var$Ct;
$67275d632676f03f$export$b410431fab84fa58.isActive = $67275d632676f03f$var$X;
$67275d632676f03f$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $67275d632676f03f$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $67275d632676f03f$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $67275d632676f03f$var$U(a, l);
    }
};
$67275d632676f03f$export$b410431fab84fa58.done = (t)=>{
    $67275d632676f03f$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$67275d632676f03f$export$b410431fab84fa58.onChange = $67275d632676f03f$var$Pt;
$67275d632676f03f$export$b410431fab84fa58.play = (t)=>$67275d632676f03f$var$rt(!0, t);
$67275d632676f03f$export$b410431fab84fa58.pause = (t)=>$67275d632676f03f$var$rt(!1, t);
function $67275d632676f03f$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $Oecye.useRef)($67275d632676f03f$var$Et(t)).current;
    r(t);
    let s = (a = (0, $Oecye.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $67275d632676f03f$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $67275d632676f03f$var$At(t) {
    let [o, e] = (0, $Oecye.useState)(!1), [r, s] = (0, $Oecye.useState)(!1), l = (0, $Oecye.useRef)(null), a = (0, $Oecye.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $67275d632676f03f$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $Oecye.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $67275d632676f03f$var$Ot = typeof window != "undefined" ? (0, $Oecye.useLayoutEffect) : (0, $Oecye.useEffect);
var $67275d632676f03f$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $67275d632676f03f$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement($67275d632676f03f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $67275d632676f03f$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement($67275d632676f03f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $67275d632676f03f$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement($67275d632676f03f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $67275d632676f03f$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement($67275d632676f03f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $67275d632676f03f$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $67275d632676f03f$export$4f13f83fd8bb1dac = {
    info: $67275d632676f03f$var$so,
    warning: $67275d632676f03f$var$ao,
    success: $67275d632676f03f$var$no,
    error: $67275d632676f03f$var$ro,
    spinner: $67275d632676f03f$var$io
}, $67275d632676f03f$var$lo = (t)=>t in $67275d632676f03f$export$4f13f83fd8bb1dac;
function $67275d632676f03f$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($67275d632676f03f$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $Oecye.isValidElement)(r) ? s = (0, $Oecye.cloneElement)(r, l) : e ? s = $67275d632676f03f$export$4f13f83fd8bb1dac.spinner() : $67275d632676f03f$var$lo(o) && (s = $67275d632676f03f$export$4f13f83fd8bb1dac[o](l))), s;
}
var $67275d632676f03f$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $67275d632676f03f$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, w = (0, $4dda62ba91820c29$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $67275d632676f03f$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: w
    }) : (0, $4dda62ba91820c29$export$2e2bcd8739ae039)(w, E), ft = $67275d632676f03f$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($67275d632676f03f$var$P(a) ? H = a(j) : (0, $Oecye.isValidElement)(a) ? H = (0, $Oecye.cloneElement)(a, j) : H = $67275d632676f03f$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("div", {
        className: (0, $4dda62ba91820c29$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $67275d632676f03f$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement($67275d632676f03f$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $67275d632676f03f$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $67275d632676f03f$export$d20e79fdc3899e95 = $67275d632676f03f$export$3ff7dc44d332d222($67275d632676f03f$var$K("bounce", !0)), $67275d632676f03f$export$d8dc01b5c85a37b9 = $67275d632676f03f$export$3ff7dc44d332d222($67275d632676f03f$var$K("slide", !0)), $67275d632676f03f$export$65cfd44a2050f99 = $67275d632676f03f$export$3ff7dc44d332d222($67275d632676f03f$var$K("zoom")), $67275d632676f03f$export$4d2fae537bd90431 = $67275d632676f03f$export$3ff7dc44d332d222($67275d632676f03f$var$K("flip"));
var $67275d632676f03f$var$_o = {
    position: "top-right",
    transition: $67275d632676f03f$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $67275d632676f03f$export$f2815235e76a62b9(t) {
    let o = {
        ...$67275d632676f03f$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $Oecye.useState)(!0), l = (0, $Oecye.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $67275d632676f03f$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $4dda62ba91820c29$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $67275d632676f03f$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $4dda62ba91820c29$export$2e2bcd8739ae039)(p, $67275d632676f03f$var$B(T));
    }
    function E() {
        e && (s(!0), $67275d632676f03f$export$b410431fab84fa58.play());
    }
    return $67275d632676f03f$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $Oecye.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $67275d632676f03f$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $67275d632676f03f$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $67275d632676f03f$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($Oecye))).createElement($67275d632676f03f$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}



const $5e5d4c2810abd61e$export$2f558b9d3e370342 = (props)=>{
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
        className: "grid grid-cols-2 gap-2 p-4 w-32 fixed z-10",
        children: [
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                style: {
                    right: 265,
                    top: 10,
                    height: 42,
                    width: 80,
                    justifyContent: 'center'
                },
                id: "toggle-view-button",
                className: "fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                onClick: ()=>props.toggleView()
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                style: {
                    right: 140,
                    top: 10,
                    height: 42
                },
                id: "toggle-color-button",
                className: "fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                onClick: ()=>props.toggleColor(),
                children: "Walnut finish"
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                style: {
                    right: 80,
                    top: 10
                },
                className: "fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                onClick: ()=>props.zoomOut(),
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2",
                        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"
                    })
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                type: "button",
                style: {
                    right: 20,
                    top: 10
                },
                className: "fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                onClick: ()=>props.zoomIn(),
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2",
                        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                    })
                })
            })
        ]
    });
};





var $Oecye = parcelRequire("Oecye");

const $a457bb5056d7b90b$export$1c63c439865c1f85 = ()=>{
    const [value, setValue] = (0, $Oecye.useState)((0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).boxService);
    (0, $Oecye.useEffect)(()=>{
        console.log('use-box-service effect executed');
    }, []);
    return value;
};



var $Oecye = parcelRequire("Oecye");

const $d6dd850f424ae1b8$export$a0a9ee2fc0034942 = ()=>{
    const [state, setState] = (0, $Oecye.useState)((0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).uiService.toState());
    (0, $Oecye.useEffect)(()=>{
        console.log('use-ui-service effect executed');
        (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).uiService.addEventListener(()=>{
            setState((0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).uiService.toState());
        });
    }, []);
    return {
        uiService: (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).uiService,
        uiState: state
    };
};




var $Oecye = parcelRequire("Oecye");
class $fc3ebe23f0ee1008$export$592c48e3e17afe1b {
    static{
        this.prices = {
            'small': {
                price: 69,
                backPrice: 14,
                doorPrice: 24,
                shelfPrice: 14,
                drawerPrice: 39,
                crossDivider: 29
            },
            'tall': {
                price: 84,
                backPrice: 19,
                doorPrice: 29,
                shelfPrice: 14,
                drawerPrice: 39,
                crossDivider: 34
            },
            'wide': {
                price: 84,
                backPrice: 19,
                doorPrice: 29,
                shelfPrice: 19,
                drawerPrice: 59,
                crossDivider: 34
            },
            'large': {
                price: 99,
                backPrice: 24,
                doorPrice: 34,
                shelfPrice: 19,
                drawerPrice: 59,
                crossDivider: 39
            },
            'small-corner': {
                price: 69
            },
            'tall-corner': {
                price: 84
            }
        };
    }
}



const $049a0b29557272fd$var$box = "Box";
const $049a0b29557272fd$var$back = "Back";
const $049a0b29557272fd$var$door = "Door";
const $049a0b29557272fd$var$shelf = "Shelf";
const $049a0b29557272fd$var$drawer = "Drawer";
const $049a0b29557272fd$var$corner = "Corner";
const $049a0b29557272fd$var$divider = "Divider";
const $049a0b29557272fd$var$small = "small";
const $049a0b29557272fd$var$tall = "tall";
const $049a0b29557272fd$var$wide = "wide";
const $049a0b29557272fd$var$large = "large";
const $049a0b29557272fd$var$smallCorner = "small-corner";
const $049a0b29557272fd$var$tallCorner = "tall-corner";
const $049a0b29557272fd$var$tallWide = "tall/wide";
const $049a0b29557272fd$var$smallTall = "small/tall";
const $049a0b29557272fd$var$wideLarge = "wide/large";
const $049a0b29557272fd$export$494d083da011ade5 = ()=>{
    const boxService = (0, $a457bb5056d7b90b$export$1c63c439865c1f85)();
    const { uiService: uiService, uiState: uiState } = (0, $d6dd850f424ae1b8$export$a0a9ee2fc0034942)();
    const [shelves, setShelves] = (0, $Oecye.useState)({
        color: "Walnut",
        items: [],
        total: 0,
        discountCode: undefined,
        disclaimer: undefined,
        shipping: undefined,
        checkoutUrl: undefined
    });
    const onClose = (0, $Oecye.useCallback)(()=>{
        uiService.hideCart();
    }, [
        uiService
    ]);
    (0, $Oecye.useEffect)(()=>{
        const existingQueryString = window.location.search;
        const urlParams = new URLSearchParams(existingQueryString);
        if (urlParams.has("discount")) setShelves({
            ...shelves,
            discountCode: urlParams.get("discount"),
            disclaimer: "Kickstarter codes will be automatically added in the next step"
        });
    }, [
        window.location.search
    ]);
    (0, $Oecye.useEffect)(()=>{
        function generateTableDataByProduct(product, finalCount) {
            const items = [];
            switch(product){
                case $049a0b29557272fd$var$box:
                    if (finalCount[$049a0b29557272fd$var$small].box.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$small, product));
                    if (finalCount[$049a0b29557272fd$var$tall].box.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$tall, product));
                    if (finalCount[$049a0b29557272fd$var$wide].box.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$wide, product));
                    if (finalCount[$049a0b29557272fd$var$large].box.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$large, product));
                    break;
                case $049a0b29557272fd$var$back:
                    if (finalCount[$049a0b29557272fd$var$small].back.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$small, product));
                    if (finalCount[$049a0b29557272fd$var$tall].back.count !== 0 || finalCount[$049a0b29557272fd$var$wide].back.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$tallWide, product));
                    if (finalCount[$049a0b29557272fd$var$large].back.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$large, product));
                    break;
                case $049a0b29557272fd$var$door:
                    if (finalCount[$049a0b29557272fd$var$small].door.count !== 0) {
                        if (finalCount[$049a0b29557272fd$var$small].door.count % 2 === 1) finalCount[$049a0b29557272fd$var$small].door.count += 1;
                        items.push(addTableData(finalCount, $049a0b29557272fd$var$small, product));
                    }
                    if (finalCount[$049a0b29557272fd$var$tall].door.count !== 0 || finalCount[$049a0b29557272fd$var$wide].door.count !== 0) {
                        if ((finalCount[$049a0b29557272fd$var$tall].door.count + finalCount[$049a0b29557272fd$var$wide].door.count) % 2 === 1) finalCount[$049a0b29557272fd$var$tall].door.count += 1;
                        items.push(addTableData(finalCount, $049a0b29557272fd$var$tallWide, product));
                    }
                    if (finalCount[$049a0b29557272fd$var$large].door.count !== 0) {
                        if (finalCount[$049a0b29557272fd$var$large].door.count % 2 === 1) finalCount[$049a0b29557272fd$var$large].door.count += 1;
                        items.push(addTableData(finalCount, $049a0b29557272fd$var$large, product));
                    }
                    break;
                case $049a0b29557272fd$var$shelf:
                    if (finalCount[$049a0b29557272fd$var$small].shelf.count !== 0 || finalCount[$049a0b29557272fd$var$tall].shelf.count !== 0) {
                        if ((finalCount[$049a0b29557272fd$var$small].shelf.count + finalCount[$049a0b29557272fd$var$tall].shelf.count) % 2 === 1) finalCount[$049a0b29557272fd$var$small].shelf.count += 1;
                        items.push(addTableData(finalCount, $049a0b29557272fd$var$smallTall, product));
                    }
                    if (finalCount[$049a0b29557272fd$var$wide].shelf.count !== 0 || finalCount[$049a0b29557272fd$var$large].shelf.count !== 0) {
                        if ((finalCount[$049a0b29557272fd$var$wide].shelf.count + finalCount[$049a0b29557272fd$var$large].shelf.count) % 2 === 1) finalCount[$049a0b29557272fd$var$wide].shelf.count += 1;
                        items.push(addTableData(finalCount, $049a0b29557272fd$var$wideLarge, product));
                    }
                    break;
                case $049a0b29557272fd$var$drawer:
                    if (finalCount[$049a0b29557272fd$var$small].drawer.count !== 0 || finalCount[$049a0b29557272fd$var$tall].drawer.count !== 0) {
                        if ((finalCount[$049a0b29557272fd$var$small].drawer.count + finalCount[$049a0b29557272fd$var$tall].drawer.count) % 2 === 1) finalCount[$049a0b29557272fd$var$small].drawer.count += 1;
                        items.push(addTableData(finalCount, $049a0b29557272fd$var$smallTall, product));
                    }
                    if (finalCount[$049a0b29557272fd$var$wide].drawer.count !== 0 || finalCount[$049a0b29557272fd$var$large].drawer.count !== 0) {
                        if ((finalCount[$049a0b29557272fd$var$wide].drawer.count + finalCount[$049a0b29557272fd$var$large].drawer.count) % 2 === 1) finalCount[$049a0b29557272fd$var$wide].drawer.count += 1;
                        items.push(addTableData(finalCount, $049a0b29557272fd$var$wideLarge, product));
                    }
                    break;
                case $049a0b29557272fd$var$divider:
                    if (finalCount[$049a0b29557272fd$var$small].divider.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$small, product));
                    if (finalCount[$049a0b29557272fd$var$tall].divider.count !== 0 || finalCount[$049a0b29557272fd$var$wide].divider.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$tallWide, product));
                    if (finalCount[$049a0b29557272fd$var$large].divider.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$large, product));
                    break;
                case $049a0b29557272fd$var$corner:
                    if (finalCount[$049a0b29557272fd$var$smallCorner].right.count !== 0 || finalCount[$049a0b29557272fd$var$smallCorner].left.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$smallCorner, product));
                    if (finalCount[$049a0b29557272fd$var$tallCorner].right.count !== 0 || finalCount[$049a0b29557272fd$var$tallCorner].left.count !== 0) items.push(addTableData(finalCount, $049a0b29557272fd$var$tallCorner, product));
                    break;
            }
            return items;
        }
        function addTableData(finalCount, key, product) {
            const basePrices = (0, $fc3ebe23f0ee1008$export$592c48e3e17afe1b).prices;
            let quantity = 0;
            let price = 0;
            switch(product){
                case $049a0b29557272fd$var$box:
                    quantity = finalCount[key].box.count;
                    price = basePrices[key].price;
                    break;
                case $049a0b29557272fd$var$back:
                    if (key === $049a0b29557272fd$var$tallWide || key === $049a0b29557272fd$var$smallTall || key === $049a0b29557272fd$var$wideLarge) {
                        const { firstKey: firstKey, secondKey: secondKey } = getIndividualKeys(key);
                        quantity = finalCount[firstKey].back.count + finalCount[secondKey].back.count;
                        price = basePrices[firstKey].backPrice;
                    } else {
                        quantity = finalCount[key].back.count;
                        price = basePrices[key].backPrice;
                    }
                    break;
                case $049a0b29557272fd$var$door:
                    if (key === $049a0b29557272fd$var$tallWide || key === $049a0b29557272fd$var$smallTall || key === $049a0b29557272fd$var$wideLarge) {
                        const { firstKey: firstKey, secondKey: secondKey } = getIndividualKeys(key);
                        quantity = finalCount[firstKey].door.count + finalCount[secondKey].door.count;
                        price = basePrices[firstKey].doorPrice;
                    } else {
                        quantity = finalCount[key].door.count;
                        price = basePrices[key].doorPrice;
                    }
                    break;
                case $049a0b29557272fd$var$divider:
                    if (key === $049a0b29557272fd$var$tallWide || key === $049a0b29557272fd$var$smallTall || key === $049a0b29557272fd$var$wideLarge) {
                        const { firstKey: firstKey, secondKey: secondKey } = getIndividualKeys(key);
                        quantity = finalCount[firstKey].divider.count + finalCount[secondKey].divider.count;
                        price = basePrices[firstKey].crossDivider;
                    } else {
                        quantity = finalCount[key].divider.count;
                        price = basePrices[key].crossDivider;
                    }
                    break;
                case $049a0b29557272fd$var$shelf:
                    if (key === $049a0b29557272fd$var$tallWide || key === $049a0b29557272fd$var$smallTall || key === $049a0b29557272fd$var$wideLarge) {
                        const { firstKey: firstKey, secondKey: secondKey } = getIndividualKeys(key);
                        quantity = finalCount[firstKey].shelf.count + finalCount[secondKey].shelf.count;
                        price = basePrices[firstKey].shelfPrice;
                    } else {
                        quantity = finalCount[key].shelf.count;
                        price = basePrices[key].shelfPrice;
                    }
                    break;
                case $049a0b29557272fd$var$drawer:
                    if (key === $049a0b29557272fd$var$tallWide || key === $049a0b29557272fd$var$smallTall || key === $049a0b29557272fd$var$wideLarge) {
                        const { firstKey: firstKey, secondKey: secondKey } = getIndividualKeys(key);
                        quantity = finalCount[firstKey].drawer.count + finalCount[secondKey].drawer.count;
                        price = basePrices[firstKey].drawerPrice;
                    } else {
                        quantity = finalCount[key].drawer.count;
                        price = basePrices[key].drawerPrice;
                    }
                    break;
                case $049a0b29557272fd$var$corner:
                    quantity = finalCount[key].right.count + finalCount[key].left.count;
                    price = basePrices[key].price;
                    break;
            }
            const capitalizedKey = capitalizeKey(key);
            return {
                product: product,
                quantity: quantity,
                size: capitalizedKey,
                price: price
            };
        }
        function capitalizeKey(key) {
            const splitIndex = key.indexOf("/");
            if (splitIndex > -1) {
                const { firstKey: firstKey, secondKey: secondKey } = getIndividualKeys(key);
                const firstCapitalizedKey = firstKey.charAt(0).toUpperCase() + firstKey.slice(1);
                const secondCapitalizedKey = secondKey.charAt(0).toUpperCase() + secondKey.slice(1);
                return `${firstCapitalizedKey}/${secondCapitalizedKey}`;
            }
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            return capitalizedKey;
        }
        function getIndividualKeys(key) {
            const splitIndex = key.indexOf("/");
            const firstKey = key.substring(0, splitIndex);
            const secondKey = key.substring(splitIndex + 1, key.length);
            return {
                firstKey: firstKey,
                secondKey: secondKey
            };
        }
        if (uiState.cartVisible && boxService.getKonvoBoxes().length > 0) {
            const finalCount = boxService.getComponentsCount();
            const products = [
                $049a0b29557272fd$var$box,
                $049a0b29557272fd$var$back,
                $049a0b29557272fd$var$door,
                $049a0b29557272fd$var$shelf,
                $049a0b29557272fd$var$drawer,
                $049a0b29557272fd$var$divider,
                $049a0b29557272fd$var$corner
            ];
            const items = [];
            for (const product of products)items.push(...generateTableDataByProduct(product, finalCount));
            const total = boxService.getCartCost();
            const finalCart = boxService.getCartCount();
            const cartItems = finalCart.filter(function(item) {
                return item.variantId !== 0 && item.count !== 0;
            });
            const canCheckout = cartItems.length !== 0;
            let checkoutUrl = undefined;
            if (canCheckout) {
                const queryString = cartItems.map(function(item) {
                    return `${item.variantId}:${item.count}`;
                }).join(",");
                let link = `https://boardgametables.myshopify.com/cart/${queryString}`;
                if (shelves.discountCode) link += "?discount=" + shelves.discountCode;
                checkoutUrl = link;
            }
            const newShelves = {
                ...shelves,
                color: boxService.getColor2().is((0, $75d304a8764c2f53$export$1b29cfe187e35100).walnut) ? "Walnut" : "Natural",
                items: items,
                total: total,
                shipping: "US orders shipping within 1 week. Canada orders shipping within 3-4 weeks.",
                checkoutUrl: checkoutUrl
            };
            setShelves(newShelves);
        } else {
            const newShelves = {
                ...shelves,
                color: boxService.getColor2().is((0, $75d304a8764c2f53$export$1b29cfe187e35100).walnut) ? "Walnut" : "Natural",
                items: [],
                total: 0,
                shipping: "US orders shipping within 1 week. Canada orders shipping within 3-4 weeks.",
                checkoutUrl: undefined
            };
            setShelves(newShelves);
        }
    }, [
        boxService,
        uiState.cartVisible
    ]);
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
        id: "app-cart-popup",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($298d7f63cb6ef7fd$exports)))({
            "wizard-modal fixed bottom-0 inset-x-0 pb-6 sm:inset-0 sm:p-0 sm:items-center sm:justify-center z-40": true,
            hidden: !uiState.cartVisible
        }),
        children: [
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "justify-center items-center flex overflow-x-auto overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                    className: "wizard-modal--step-1 w-96 bg-white rounded-md sm:justify-start flex-col relative sm:flex",
                    children: [
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                            className: "overflow-y-auto h-full shadow overflow-hidden border-b border-gray-200 sm:rounded-lg",
                            children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("table", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("thead", {
                                        className: "bg-gray-50",
                                        children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("tr", {
                                            className: "table table-fixed w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("th", {
                                                    className: "px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider text-right",
                                                    children: "Qty"
                                                }),
                                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("th", {
                                                    className: "px-4 py-3 text-left text- sm font-medium text-gray-500 uppercase tracking-wider",
                                                    children: "Product"
                                                }),
                                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("th", {
                                                    className: "px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider",
                                                    children: "Size"
                                                }),
                                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("th", {
                                                    className: "px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider text-right",
                                                    children: "Price"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("tbody", {
                                        className: "bg-white divide-y divide-gray-200 overflow-y-auto block max-h-custom",
                                        children: shelves.items.map((i)=>/*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("tr", {
                                                className: "table table-fixed w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("td", {
                                                        className: "px-4 py-2 whitespace-nowrap text-md text-gray-500 text-right",
                                                        children: i.quantity
                                                    }),
                                                    /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("td", {
                                                        className: "px-4 py-2 whitespace-nowrap text-md font-medium text-gray-900",
                                                        children: i.product
                                                    }),
                                                    /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("td", {
                                                        className: "px-4 py-2 whitespace-nowrap text-md text-gray-500",
                                                        children: i.size
                                                    }),
                                                    /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("td", {
                                                        className: "px-4 py-2 whitespace-nowrap text-md text-gray-500 text-right",
                                                        children: i.price.toFixed(0)
                                                    })
                                                ]
                                            }))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                            className: "py-2 px-4 bg-gray-50 border-b",
                            children: [
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("p", {
                                    className: "inline-flex items-center text-md",
                                    children: [
                                        "Color: ",
                                        shelves.color
                                    ]
                                }),
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("p", {
                                    className: "inline-flex items-center text-md float-right",
                                    children: [
                                        "Total $",
                                        shelves.total.toFixed(0)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                            className: "py-2 px-4 bg-gray-50 border-b",
                            children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("p", {
                                className: "inline-flex items-center text-md",
                                children: shelves.shipping
                            })
                        }),
                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                            className: "py-2 mt-2 px-4",
                            children: [
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($298d7f63cb6ef7fd$exports)))({
                                                "font-bold text-center": true,
                                                "pb-2": shelves.discountCode
                                            }),
                                            children: shelves.discountCode
                                        }),
                                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($298d7f63cb6ef7fd$exports)))({
                                                "italic text-center": true,
                                                "pb-2": shelves.disclaimer
                                            }),
                                            children: shelves.disclaimer
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("button", {
                                            className: "h-10 px-5 text-blue-700 transition-colors duration-150 border border-blue-500 rounded-lg focus:shadow-outline hover:bg-blue-500 hover:text-blue-100",
                                            onClick: onClose,
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("a", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($298d7f63cb6ef7fd$exports)))({
                                                "h-10 px-5 text-blue-700 transition-colors duration-150 border border-blue-500 rounded-lg focus:shadow-outline hover:bg-blue-500 hover:text-blue-100 float-right flex items-center": true,
                                                hidden: !shelves.checkoutUrl
                                            }),
                                            href: shelves.checkoutUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Checkout"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "absolute inset-0 bg-gray-500 opacity-50"
            })
        ]
    });
};


const $9ef19f0ec60641bc$export$86fbec116b87613f = ()=>{
    const currentBox = (0, $Oecye.useRef)(undefined);
    const stage = new (0, $75001462f4ec7917$export$5ba72be27215a2ba)();
    const images = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).images;
    const navigation = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).navigation;
    const boxService = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).boxService;
    const uiService = (0, $314a4bc86abf4e4b$export$6cd6e3ed1512e78f).uiService;
    const loadConfig = ()=>{
        new $74c72655ccba3742$exports("#share-config-button");
        const queryString = getQuery();
        const debugEnabled = !!queryString["debug"];
        stage.changeIsDebug(debugEnabled);
        images.addImagesLoadedListener(()=>{
            const loadingElement = document.getElementById("loader");
            if (loadingElement) loadingElement.style.display = "none";
            const addCubeElements = document.querySelectorAll(".add-cube");
            addCubeElements.forEach((c)=>{
                if (c.classList.contains("opacity-50") && c.classList.contains("pointer-events-none")) {
                    c.classList.remove("opacity-50");
                    c.classList.remove("pointer-events-none");
                }
            });
        });
    };
    const loadShareLink = ()=>{
        const queryString = getQuery();
        const boxesEncoded = queryString["boxes"];
        const zoomQs = queryString["zoom"];
        const viewQs = queryString["view"];
        const stagePositionXQs = queryString["sx"];
        const stagePositionYQs = queryString["sy"];
        if (queryString["box_color"]) stage.setColor(queryString["box_color"]);
        if (viewQs) stage.setView(viewQs);
        if (boxesEncoded) {
            const boxes = navigation.decodeBoxes(boxesEncoded);
            images.addImagesLoadedListener(()=>{
                for (const box of boxes)addShelf(box);
                stage.refocusBoxes();
            });
        }
        if (stagePositionXQs && stagePositionYQs) stage.setStagePosition(+stagePositionXQs, +stagePositionYQs);
        if (zoomQs) stage.setZoom(+zoomQs);
        setView();
        (0, $dc8d4df4579eb854$export$bd0bf19f25da8474).updateCubesMenu();
    };
    const loadStage = ()=>{
        const PADDING = 0;
        const konvaStage = new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Stage({
            container: "container",
            width: document.getElementById("main").offsetWidth + PADDING * 2,
            height: document.getElementById("main").offsetHeight + PADDING * 2,
            draggable: true
        });
        const konvaLayer = new (0, (/*@__PURE__*/$parcel$interopDefault($ceae686dc723e5bf$exports))).Layer();
        konvaStage.add(konvaLayer);
        konvaLayer.draw();
        konvaStage.scale({
            x: 0.24,
            y: 0.24
        });
        konvaStage.on("dragmove", ()=>{
            let x = konvaStage.x();
            let y = konvaStage.y();
            if (x > -10 || y > -10) {
                if (x > -10) x = -10;
                if (y > -10) y = -10;
                konvaStage.position({
                    x: x,
                    y: y
                });
                konvaStage.draw();
            }
        });
        stage.setStage(konvaStage);
        stage.setLayer(konvaLayer);
    };
    (0, $Oecye.useEffect)(()=>{
        loadStage();
        loadConfig();
        loadShareLink();
    }, []);
    const setView = ()=>{
        const toggleButton = document.getElementById("toggle-view-button");
        if (toggleButton) {
            if (stage.isIsoView()) toggleButton.innerHTML = "3D";
            else toggleButton.innerHTML = "Front";
        }
    };
    const addShelf = (config)=>{
        if (!images.areImagesLoaded()) {
            console.log("Images not loaded yet");
            return;
        }
        const box = stage.addShelf(config);
        if (box) {
            box.on("dragmove", function() {
                document.body.style.cursor = "grabbing";
            });
            box.on("dragend", function() {
                document.body.style.cursor = "pointer";
                if (currentBox.current) currentBox.current.strokeWidth(8);
                updateShareLink();
            });
            box.on("click tap", function() {
                selectShelf(box);
            });
            box.on("mouseover", function() {
                document.body.style.cursor = "pointer";
            });
            box.on("mouseout", function() {
                document.body.style.cursor = "default";
            });
            updateShareLink();
            updateCheckout();
        }
    };
    const updateShareLink = ()=>{
        const boxesQs = navigation.encodeBoxes(boxService.getBoxes());
        const zoomQs = stage.getZoom().toFixed(2);
        const viewQs = stage.getView();
        const stagePosition = stage.getStagePosition();
        const currentQueryString = getQuery(window.location.search);
        currentQueryString["boxes"] = boxesQs;
        currentQueryString["zoom"] = zoomQs;
        currentQueryString["view"] = viewQs;
        currentQueryString["box_color"] = stage.getColor();
        currentQueryString["sx"] = stagePosition.x.toFixed(2);
        currentQueryString["sy"] = stagePosition.y.toFixed(2);
        const newQueryString = "?" + Object.entries(currentQueryString).filter((qs)=>!!qs[0] && qs[1] !== undefined).map((qs)=>qs[0] + "=" + qs[1]).join("&");
        const shareElement = document.getElementById("share-config-button");
        if (shareElement) shareElement.setAttribute("data-clipboard-text", window.location.origin + window.location.pathname + newQueryString);
    };
    const updateCheckout = ()=>{
        const total = boxService.getCartCost();
        const checkoutButtonText = document.querySelector("#checkout-button-text");
        if (checkoutButtonText) checkoutButtonText.innerHTML = "View Cart ($ " + total.toFixed(0) + ")";
    };
    const getQuery = (url = window.location.search)=>{
        const queryParams = {};
        const queryString = url.substring(url.indexOf("?") + 1);
        const pairs = queryString.split("&");
        for (const pair of pairs){
            const [key, value] = pair.split("=");
            if (key) queryParams[key] = decodeURIComponent(value || "");
        }
        return queryParams;
    };
    const selectShelf = (box)=>{
        if (currentBox.current) {
            currentBox.current.strokeWidth(0);
            currentBox.current = undefined;
        } else {
            currentBox.current = box;
            currentBox.current.stroke("blue");
            currentBox.current.strokeWidth(8);
        }
        updateCubeMenu();
    };
    const updateCubeMenu = ()=>{
        (0, $dc8d4df4579eb854$export$bd0bf19f25da8474).updateCubeMenu(currentBox.current);
    };
    const changeAccessory = (action)=>{
        if (!currentBox.current) return;
        action();
        drawCurrentBox();
        updateCubeMenu();
        updateShareLink();
        updateCheckout();
    };
    const drawCurrentBox = ()=>{
        if (currentBox.current) stage.drawBox(currentBox.current);
    };
    const toggleBackVisibility = ()=>{
        changeAccessory(()=>boxService.toggleBack(currentBox.current));
    };
    const toggleDoorVisibility = ()=>{
        changeAccessory(()=>boxService.toggleDoor(currentBox.current));
    };
    const toggleShelfVisibility = ()=>{
        changeAccessory(()=>boxService.toggleShelf(currentBox.current));
    };
    const toggleTopDrawerVisibility = ()=>{
        changeAccessory(()=>boxService.toggleDrawerTop(currentBox.current));
    };
    const toggleMiddleDrawerVisibility = ()=>{
        changeAccessory(()=>boxService.toggleDrawerMiddle(currentBox.current));
    };
    const toggleBottomDrawerVisibility = ()=>{
        changeAccessory(()=>boxService.toggleDrawerBottom(currentBox.current));
    };
    const toggleCornerDirection = ()=>{
        changeAccessory(()=>boxService.toggleDirection(currentBox.current));
    };
    const toggleCrossDivider = ()=>{
        changeAccessory(()=>boxService.toggleCrossDivider(currentBox.current));
    };
    const deleteShelf = ()=>{
        if (currentBox.current) {
            currentBox.current.destroy();
            const konvaStage = stage.getStage();
            konvaStage.draw();
            boxService.deleteBox(currentBox.current);
            currentBox.current = undefined;
            updateCubeMenu();
            updateShareLink();
            updateCheckout();
            stage.drawDimensions();
        }
    };
    const shareLinkCopied = ()=>{
        (0, $67275d632676f03f$export$b410431fab84fa58).success("Sharing url copied to your clipboard. Paste it somewhere to share.");
    };
    const viewCart = (view)=>{
        if (view) uiService.showCart();
        else uiService.hideCart();
    };
    const toggleView = ()=>{
        stage.toggleView();
        setView();
        updateShareLink();
    };
    const toggleColor = ()=>{
        const selected = currentBox.current;
        (0, $dc8d4df4579eb854$export$bd0bf19f25da8474).toggleColor(selected);
        if (selected && !boxService.getKonvoBoxes().includes(selected)) currentBox.current = undefined;
        stage.drawBoxes();
        updateShareLink();
        updateCheckout();
    };
    const zoomIn = ()=>{
        stage.zoom(true);
        updateShareLink();
    };
    const zoomOut = ()=>{
        stage.zoom(false);
        updateShareLink();
    };
    return /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
        className: "h-full flex overflow-hidden bg-gray-100",
        children: [
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "hidden md:flex md:flex-shrink-0",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $4a7bed594a660712$export$d9b273488cd8ce6f), {
                    addShelf: addShelf,
                    toggleBackVisibility: toggleBackVisibility,
                    toggleDoorVisibility: toggleDoorVisibility,
                    toggleShelfVisibility: toggleShelfVisibility,
                    toggleCrossDivider: toggleCrossDivider,
                    toggleCornerDirection: toggleCornerDirection,
                    toggleTopDrawerVisibility: toggleTopDrawerVisibility,
                    toggleMiddleDrawerVisibility: toggleMiddleDrawerVisibility,
                    toggleBottomDrawerVisibility: toggleBottomDrawerVisibility,
                    deleteShelf: deleteShelf,
                    shareLinkCopied: shareLinkCopied,
                    viewCart: viewCart
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                className: "flex flex-col w-0 flex-1",
                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("main", {
                    id: "main",
                    className: "flex-1 relative z-0 focus:outline-none overflow-hidden",
                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsxs)("div", {
                        className: "max-w-7xl",
                        children: [
                            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $5e5d4c2810abd61e$export$2f558b9d3e370342), {
                                toggleView: toggleView,
                                toggleColor: toggleColor,
                                zoomOut: zoomOut,
                                zoomIn: zoomIn
                            }),
                            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                                id: "scroll-container",
                                className: "pt-16",
                                children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                                    id: "large-container",
                                    children: /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)("div", {
                                        id: "container"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $049a0b29557272fd$export$494d083da011ade5), {}),
            /*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $67275d632676f03f$export$f2815235e76a62b9), {
                newestOnTop: false,
                autoClose: 5000,
                position: "bottom-right",
                closeButton: false,
                hideProgressBar: true,
                closeOnClick: true,
                theme: "colored",
                transition: (0, $67275d632676f03f$export$65cfd44a2050f99)
            })
        ]
    });
};


// Render your React component instead
const $62c047d2814c6317$var$root = (0, $3ce6d4fd7c55125d$export$882461b6382ed46c)(document.getElementById('app'));
$62c047d2814c6317$var$root.render(/*#__PURE__*/ (0, $21dd9f177820ff2c$exports.jsx)((0, $9ef19f0ec60641bc$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=layout.js.map
